import { jsx as d, jsxs as C, Fragment as q } from "react/jsx-runtime";
import * as s from "react";
import io, { forwardRef as W, useState as j, useRef as ue, useCallback as ao, cloneElement as Lp, useEffect as le, isValidElement as jp, useLayoutEffect as Cu, useId as Ft, createContext as Ip, useContext as Vp, Children as zp } from "react";
import * as jo from "react-dom";
import Ru from "react-dom";
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function Zx() {
  return {
    accessor: (e, n) => typeof e == "function" ? {
      ...n,
      accessorFn: e
    } : {
      ...n,
      accessorKey: e
    },
    display: (e) => e,
    group: (e) => e
  };
}
function Ve(e, n) {
  return typeof e == "function" ? e(n) : e;
}
function oe(e, n) {
  return (r) => {
    n.setState((o) => ({
      ...o,
      [e]: Ve(r, o[e])
    }));
  };
}
function tn(e) {
  return e instanceof Function;
}
function qp(e) {
  return Array.isArray(e) && e.every((n) => typeof n == "number");
}
function Hp(e, n) {
  const r = [], o = (i) => {
    i.forEach((t) => {
      r.push(t);
      const a = n(t);
      a != null && a.length && o(a);
    });
  };
  return o(e), r;
}
function N(e, n, r) {
  let o = [], i;
  return (t) => {
    let a;
    r.key && r.debug && (a = Date.now());
    const l = e(t);
    if (!(l.length !== o.length || l.some((p, _) => o[_] !== p)))
      return i;
    o = l;
    let c;
    if (r.key && r.debug && (c = Date.now()), i = n(...l), r == null || r.onChange == null || r.onChange(i), r.key && r.debug && r != null && r.debug()) {
      const p = Math.round((Date.now() - a) * 100) / 100, _ = Math.round((Date.now() - c) * 100) / 100, g = _ / 16, f = (m, h) => {
        for (m = String(m); m.length < h; )
          m = " " + m;
        return m;
      };
      console.info(`%c⏱ ${f(_, 5)} /${f(p, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * g, 120))}deg 100% 31%);`, r == null ? void 0 : r.key);
    }
    return i;
  };
}
function P(e, n, r, o) {
  return {
    debug: () => {
      var i;
      return (i = e == null ? void 0 : e.debugAll) != null ? i : e[n];
    },
    key: process.env.NODE_ENV === "development" && r,
    onChange: o
  };
}
function Bp(e, n, r, o) {
  const i = () => {
    var a;
    return (a = t.getValue()) != null ? a : e.options.renderFallbackValue;
  }, t = {
    id: `${n.id}_${r.id}`,
    row: n,
    column: r,
    getValue: () => n.getValue(o),
    renderValue: i,
    getContext: N(() => [e, r, n, t], (a, l, u, c) => ({
      table: a,
      column: l,
      row: u,
      cell: c,
      getValue: c.getValue,
      renderValue: c.renderValue
    }), P(e.options, "debugCells", "cell.getContext"))
  };
  return e._features.forEach((a) => {
    a.createCell == null || a.createCell(t, r, n, e);
  }, {}), t;
}
function Wp(e, n, r, o) {
  var i, t;
  const l = {
    ...e._getDefaultColumnDef(),
    ...n
  }, u = l.accessorKey;
  let c = (i = (t = l.id) != null ? t : u ? typeof String.prototype.replaceAll == "function" ? u.replaceAll(".", "_") : u.replace(/\./g, "_") : void 0) != null ? i : typeof l.header == "string" ? l.header : void 0, p;
  if (l.accessorFn ? p = l.accessorFn : u && (u.includes(".") ? p = (g) => {
    let f = g;
    for (const h of u.split(".")) {
      var m;
      f = (m = f) == null ? void 0 : m[h], process.env.NODE_ENV !== "production" && f === void 0 && console.warn(`"${h}" in deeply nested key "${u}" returned undefined.`);
    }
    return f;
  } : p = (g) => g[l.accessorKey]), !c)
    throw process.env.NODE_ENV !== "production" ? new Error(l.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header") : new Error();
  let _ = {
    id: `${String(c)}`,
    accessorFn: p,
    parent: o,
    depth: r,
    columnDef: l,
    columns: [],
    getFlatColumns: N(() => [!0], () => {
      var g;
      return [_, ...(g = _.columns) == null ? void 0 : g.flatMap((f) => f.getFlatColumns())];
    }, P(e.options, "debugColumns", "column.getFlatColumns")),
    getLeafColumns: N(() => [e._getOrderColumnsFn()], (g) => {
      var f;
      if ((f = _.columns) != null && f.length) {
        let m = _.columns.flatMap((h) => h.getLeafColumns());
        return g(m);
      }
      return [_];
    }, P(e.options, "debugColumns", "column.getLeafColumns"))
  };
  for (const g of e._features)
    g.createColumn == null || g.createColumn(_, e);
  return _;
}
const U = "debugHeaders";
function hi(e, n, r) {
  var o;
  let t = {
    id: (o = r.id) != null ? o : n.id,
    column: n,
    index: r.index,
    isPlaceholder: !!r.isPlaceholder,
    placeholderId: r.placeholderId,
    depth: r.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const a = [], l = (u) => {
        u.subHeaders && u.subHeaders.length && u.subHeaders.map(l), a.push(u);
      };
      return l(t), a;
    },
    getContext: () => ({
      table: e,
      header: t,
      column: n
    })
  };
  return e._features.forEach((a) => {
    a.createHeader == null || a.createHeader(t, e);
  }), t;
}
const Gp = {
  createTable: (e) => {
    e.getHeaderGroups = N(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (n, r, o, i) => {
      var t, a;
      const l = (t = o == null ? void 0 : o.map((_) => r.find((g) => g.id === _)).filter(Boolean)) != null ? t : [], u = (a = i == null ? void 0 : i.map((_) => r.find((g) => g.id === _)).filter(Boolean)) != null ? a : [], c = r.filter((_) => !(o != null && o.includes(_.id)) && !(i != null && i.includes(_.id)));
      return Rr(n, [...l, ...c, ...u], e);
    }, P(e.options, U, "getHeaderGroups")), e.getCenterHeaderGroups = N(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (n, r, o, i) => (r = r.filter((t) => !(o != null && o.includes(t.id)) && !(i != null && i.includes(t.id))), Rr(n, r, e, "center")), P(e.options, U, "getCenterHeaderGroups")), e.getLeftHeaderGroups = N(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left], (n, r, o) => {
      var i;
      const t = (i = o == null ? void 0 : o.map((a) => r.find((l) => l.id === a)).filter(Boolean)) != null ? i : [];
      return Rr(n, t, e, "left");
    }, P(e.options, U, "getLeftHeaderGroups")), e.getRightHeaderGroups = N(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.right], (n, r, o) => {
      var i;
      const t = (i = o == null ? void 0 : o.map((a) => r.find((l) => l.id === a)).filter(Boolean)) != null ? i : [];
      return Rr(n, t, e, "right");
    }, P(e.options, U, "getRightHeaderGroups")), e.getFooterGroups = N(() => [e.getHeaderGroups()], (n) => [...n].reverse(), P(e.options, U, "getFooterGroups")), e.getLeftFooterGroups = N(() => [e.getLeftHeaderGroups()], (n) => [...n].reverse(), P(e.options, U, "getLeftFooterGroups")), e.getCenterFooterGroups = N(() => [e.getCenterHeaderGroups()], (n) => [...n].reverse(), P(e.options, U, "getCenterFooterGroups")), e.getRightFooterGroups = N(() => [e.getRightHeaderGroups()], (n) => [...n].reverse(), P(e.options, U, "getRightFooterGroups")), e.getFlatHeaders = N(() => [e.getHeaderGroups()], (n) => n.map((r) => r.headers).flat(), P(e.options, U, "getFlatHeaders")), e.getLeftFlatHeaders = N(() => [e.getLeftHeaderGroups()], (n) => n.map((r) => r.headers).flat(), P(e.options, U, "getLeftFlatHeaders")), e.getCenterFlatHeaders = N(() => [e.getCenterHeaderGroups()], (n) => n.map((r) => r.headers).flat(), P(e.options, U, "getCenterFlatHeaders")), e.getRightFlatHeaders = N(() => [e.getRightHeaderGroups()], (n) => n.map((r) => r.headers).flat(), P(e.options, U, "getRightFlatHeaders")), e.getCenterLeafHeaders = N(() => [e.getCenterFlatHeaders()], (n) => n.filter((r) => {
      var o;
      return !((o = r.subHeaders) != null && o.length);
    }), P(e.options, U, "getCenterLeafHeaders")), e.getLeftLeafHeaders = N(() => [e.getLeftFlatHeaders()], (n) => n.filter((r) => {
      var o;
      return !((o = r.subHeaders) != null && o.length);
    }), P(e.options, U, "getLeftLeafHeaders")), e.getRightLeafHeaders = N(() => [e.getRightFlatHeaders()], (n) => n.filter((r) => {
      var o;
      return !((o = r.subHeaders) != null && o.length);
    }), P(e.options, U, "getRightLeafHeaders")), e.getLeafHeaders = N(() => [e.getLeftHeaderGroups(), e.getCenterHeaderGroups(), e.getRightHeaderGroups()], (n, r, o) => {
      var i, t, a, l, u, c;
      return [...(i = (t = n[0]) == null ? void 0 : t.headers) != null ? i : [], ...(a = (l = r[0]) == null ? void 0 : l.headers) != null ? a : [], ...(u = (c = o[0]) == null ? void 0 : c.headers) != null ? u : []].map((p) => p.getLeafHeaders()).flat();
    }, P(e.options, U, "getLeafHeaders"));
  }
};
function Rr(e, n, r, o) {
  var i, t;
  let a = 0;
  const l = function(g, f) {
    f === void 0 && (f = 1), a = Math.max(a, f), g.filter((m) => m.getIsVisible()).forEach((m) => {
      var h;
      (h = m.columns) != null && h.length && l(m.columns, f + 1);
    }, 0);
  };
  l(e);
  let u = [];
  const c = (g, f) => {
    const m = {
      depth: f,
      id: [o, `${f}`].filter(Boolean).join("_"),
      headers: []
    }, h = [];
    g.forEach((v) => {
      const w = [...h].reverse()[0], y = v.column.depth === m.depth;
      let b, $ = !1;
      if (y && v.column.parent ? b = v.column.parent : (b = v.column, $ = !0), w && (w == null ? void 0 : w.column) === b)
        w.subHeaders.push(v);
      else {
        const x = hi(r, b, {
          id: [o, f, b.id, v == null ? void 0 : v.id].filter(Boolean).join("_"),
          isPlaceholder: $,
          placeholderId: $ ? `${h.filter((R) => R.column === b).length}` : void 0,
          depth: f,
          index: h.length
        });
        x.subHeaders.push(v), h.push(x);
      }
      m.headers.push(v), v.headerGroup = m;
    }), u.push(m), f > 0 && c(h, f - 1);
  }, p = n.map((g, f) => hi(r, g, {
    depth: a,
    index: f
  }));
  c(p, a - 1), u.reverse();
  const _ = (g) => g.filter((m) => m.column.getIsVisible()).map((m) => {
    let h = 0, v = 0, w = [0];
    m.subHeaders && m.subHeaders.length ? (w = [], _(m.subHeaders).forEach((b) => {
      let {
        colSpan: $,
        rowSpan: x
      } = b;
      h += $, w.push(x);
    })) : h = 1;
    const y = Math.min(...w);
    return v = v + y, m.colSpan = h, m.rowSpan = v, {
      colSpan: h,
      rowSpan: v
    };
  });
  return _((i = (t = u[0]) == null ? void 0 : t.headers) != null ? i : []), u;
}
const Io = (e, n, r, o, i, t, a) => {
  let l = {
    id: n,
    index: o,
    original: r,
    depth: i,
    parentId: a,
    _valuesCache: {},
    _uniqueValuesCache: {},
    getValue: (u) => {
      if (l._valuesCache.hasOwnProperty(u))
        return l._valuesCache[u];
      const c = e.getColumn(u);
      if (c != null && c.accessorFn)
        return l._valuesCache[u] = c.accessorFn(l.original, o), l._valuesCache[u];
    },
    getUniqueValues: (u) => {
      if (l._uniqueValuesCache.hasOwnProperty(u))
        return l._uniqueValuesCache[u];
      const c = e.getColumn(u);
      if (c != null && c.accessorFn)
        return c.columnDef.getUniqueValues ? (l._uniqueValuesCache[u] = c.columnDef.getUniqueValues(l.original, o), l._uniqueValuesCache[u]) : (l._uniqueValuesCache[u] = [l.getValue(u)], l._uniqueValuesCache[u]);
    },
    renderValue: (u) => {
      var c;
      return (c = l.getValue(u)) != null ? c : e.options.renderFallbackValue;
    },
    subRows: [],
    getLeafRows: () => Hp(l.subRows, (u) => u.subRows),
    getParentRow: () => l.parentId ? e.getRow(l.parentId, !0) : void 0,
    getParentRows: () => {
      let u = [], c = l;
      for (; ; ) {
        const p = c.getParentRow();
        if (!p) break;
        u.push(p), c = p;
      }
      return u.reverse();
    },
    getAllCells: N(() => [e.getAllLeafColumns()], (u) => u.map((c) => Bp(e, l, c, c.id)), P(e.options, "debugRows", "getAllCells")),
    _getAllCellsByColumnId: N(() => [l.getAllCells()], (u) => u.reduce((c, p) => (c[p.column.id] = p, c), {}), P(e.options, "debugRows", "getAllCellsByColumnId"))
  };
  for (let u = 0; u < e._features.length; u++) {
    const c = e._features[u];
    c == null || c.createRow == null || c.createRow(l, e);
  }
  return l;
}, Zp = {
  createColumn: (e, n) => {
    e._getFacetedRowModel = n.options.getFacetedRowModel && n.options.getFacetedRowModel(n, e.id), e.getFacetedRowModel = () => e._getFacetedRowModel ? e._getFacetedRowModel() : n.getPreFilteredRowModel(), e._getFacetedUniqueValues = n.options.getFacetedUniqueValues && n.options.getFacetedUniqueValues(n, e.id), e.getFacetedUniqueValues = () => e._getFacetedUniqueValues ? e._getFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getFacetedMinMaxValues = n.options.getFacetedMinMaxValues && n.options.getFacetedMinMaxValues(n, e.id), e.getFacetedMinMaxValues = () => {
      if (e._getFacetedMinMaxValues)
        return e._getFacetedMinMaxValues();
    };
  }
}, Eu = (e, n, r) => {
  var o, i;
  const t = r == null || (o = r.toString()) == null ? void 0 : o.toLowerCase();
  return !!(!((i = e.getValue(n)) == null || (i = i.toString()) == null || (i = i.toLowerCase()) == null) && i.includes(t));
};
Eu.autoRemove = (e) => fe(e);
const Nu = (e, n, r) => {
  var o;
  return !!(!((o = e.getValue(n)) == null || (o = o.toString()) == null) && o.includes(r));
};
Nu.autoRemove = (e) => fe(e);
const Pu = (e, n, r) => {
  var o;
  return ((o = e.getValue(n)) == null || (o = o.toString()) == null ? void 0 : o.toLowerCase()) === (r == null ? void 0 : r.toLowerCase());
};
Pu.autoRemove = (e) => fe(e);
const ku = (e, n, r) => {
  var o;
  return (o = e.getValue(n)) == null ? void 0 : o.includes(r);
};
ku.autoRemove = (e) => fe(e);
const Ou = (e, n, r) => !r.some((o) => {
  var i;
  return !((i = e.getValue(n)) != null && i.includes(o));
});
Ou.autoRemove = (e) => fe(e) || !(e != null && e.length);
const Au = (e, n, r) => r.some((o) => {
  var i;
  return (i = e.getValue(n)) == null ? void 0 : i.includes(o);
});
Au.autoRemove = (e) => fe(e) || !(e != null && e.length);
const Mu = (e, n, r) => e.getValue(n) === r;
Mu.autoRemove = (e) => fe(e);
const Fu = (e, n, r) => e.getValue(n) == r;
Fu.autoRemove = (e) => fe(e);
const Vo = (e, n, r) => {
  let [o, i] = r;
  const t = e.getValue(n);
  return t >= o && t <= i;
};
Vo.resolveFilterValue = (e) => {
  let [n, r] = e, o = typeof n != "number" ? parseFloat(n) : n, i = typeof r != "number" ? parseFloat(r) : r, t = n === null || Number.isNaN(o) ? -1 / 0 : o, a = r === null || Number.isNaN(i) ? 1 / 0 : i;
  if (t > a) {
    const l = t;
    t = a, a = l;
  }
  return [t, a];
};
Vo.autoRemove = (e) => fe(e) || fe(e[0]) && fe(e[1]);
const ke = {
  includesString: Eu,
  includesStringSensitive: Nu,
  equalsString: Pu,
  arrIncludes: ku,
  arrIncludesAll: Ou,
  arrIncludesSome: Au,
  equals: Mu,
  weakEquals: Fu,
  inNumberRange: Vo
};
function fe(e) {
  return e == null || e === "";
}
const Up = {
  getDefaultColumnDef: () => ({
    filterFn: "auto"
  }),
  getInitialState: (e) => ({
    columnFilters: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnFiltersChange: oe("columnFilters", e),
    filterFromLeafRows: !1,
    maxLeafRowFilterDepth: 100
  }),
  createColumn: (e, n) => {
    e.getAutoFilterFn = () => {
      const r = n.getCoreRowModel().flatRows[0], o = r == null ? void 0 : r.getValue(e.id);
      return typeof o == "string" ? ke.includesString : typeof o == "number" ? ke.inNumberRange : typeof o == "boolean" || o !== null && typeof o == "object" ? ke.equals : Array.isArray(o) ? ke.arrIncludes : ke.weakEquals;
    }, e.getFilterFn = () => {
      var r, o;
      return tn(e.columnDef.filterFn) ? e.columnDef.filterFn : e.columnDef.filterFn === "auto" ? e.getAutoFilterFn() : (
        // @ts-ignore
        (r = (o = n.options.filterFns) == null ? void 0 : o[e.columnDef.filterFn]) != null ? r : ke[e.columnDef.filterFn]
      );
    }, e.getCanFilter = () => {
      var r, o, i;
      return ((r = e.columnDef.enableColumnFilter) != null ? r : !0) && ((o = n.options.enableColumnFilters) != null ? o : !0) && ((i = n.options.enableFilters) != null ? i : !0) && !!e.accessorFn;
    }, e.getIsFiltered = () => e.getFilterIndex() > -1, e.getFilterValue = () => {
      var r;
      return (r = n.getState().columnFilters) == null || (r = r.find((o) => o.id === e.id)) == null ? void 0 : r.value;
    }, e.getFilterIndex = () => {
      var r, o;
      return (r = (o = n.getState().columnFilters) == null ? void 0 : o.findIndex((i) => i.id === e.id)) != null ? r : -1;
    }, e.setFilterValue = (r) => {
      n.setColumnFilters((o) => {
        const i = e.getFilterFn(), t = o == null ? void 0 : o.find((p) => p.id === e.id), a = Ve(r, t ? t.value : void 0);
        if (mi(i, a, e)) {
          var l;
          return (l = o == null ? void 0 : o.filter((p) => p.id !== e.id)) != null ? l : [];
        }
        const u = {
          id: e.id,
          value: a
        };
        if (t) {
          var c;
          return (c = o == null ? void 0 : o.map((p) => p.id === e.id ? u : p)) != null ? c : [];
        }
        return o != null && o.length ? [...o, u] : [u];
      });
    };
  },
  createRow: (e, n) => {
    e.columnFilters = {}, e.columnFiltersMeta = {};
  },
  createTable: (e) => {
    e.setColumnFilters = (n) => {
      const r = e.getAllLeafColumns(), o = (i) => {
        var t;
        return (t = Ve(n, i)) == null ? void 0 : t.filter((a) => {
          const l = r.find((u) => u.id === a.id);
          if (l) {
            const u = l.getFilterFn();
            if (mi(u, a.value, l))
              return !1;
          }
          return !0;
        });
      };
      e.options.onColumnFiltersChange == null || e.options.onColumnFiltersChange(o);
    }, e.resetColumnFilters = (n) => {
      var r, o;
      e.setColumnFilters(n ? [] : (r = (o = e.initialState) == null ? void 0 : o.columnFilters) != null ? r : []);
    }, e.getPreFilteredRowModel = () => e.getCoreRowModel(), e.getFilteredRowModel = () => (!e._getFilteredRowModel && e.options.getFilteredRowModel && (e._getFilteredRowModel = e.options.getFilteredRowModel(e)), e.options.manualFiltering || !e._getFilteredRowModel ? e.getPreFilteredRowModel() : e._getFilteredRowModel());
  }
};
function mi(e, n, r) {
  return (e && e.autoRemove ? e.autoRemove(n, r) : !1) || typeof n > "u" || typeof n == "string" && !n;
}
const Xp = (e, n, r) => r.reduce((o, i) => {
  const t = i.getValue(e);
  return o + (typeof t == "number" ? t : 0);
}, 0), Yp = (e, n, r) => {
  let o;
  return r.forEach((i) => {
    const t = i.getValue(e);
    t != null && (o > t || o === void 0 && t >= t) && (o = t);
  }), o;
}, Kp = (e, n, r) => {
  let o;
  return r.forEach((i) => {
    const t = i.getValue(e);
    t != null && (o < t || o === void 0 && t >= t) && (o = t);
  }), o;
}, Jp = (e, n, r) => {
  let o, i;
  return r.forEach((t) => {
    const a = t.getValue(e);
    a != null && (o === void 0 ? a >= a && (o = i = a) : (o > a && (o = a), i < a && (i = a)));
  }), [o, i];
}, Qp = (e, n) => {
  let r = 0, o = 0;
  if (n.forEach((i) => {
    let t = i.getValue(e);
    t != null && (t = +t) >= t && (++r, o += t);
  }), r) return o / r;
}, ed = (e, n) => {
  if (!n.length)
    return;
  const r = n.map((t) => t.getValue(e));
  if (!qp(r))
    return;
  if (r.length === 1)
    return r[0];
  const o = Math.floor(r.length / 2), i = r.sort((t, a) => t - a);
  return r.length % 2 !== 0 ? i[o] : (i[o - 1] + i[o]) / 2;
}, td = (e, n) => Array.from(new Set(n.map((r) => r.getValue(e))).values()), rd = (e, n) => new Set(n.map((r) => r.getValue(e))).size, nd = (e, n) => n.length, bn = {
  sum: Xp,
  min: Yp,
  max: Kp,
  extent: Jp,
  mean: Qp,
  median: ed,
  unique: td,
  uniqueCount: rd,
  count: nd
}, od = {
  getDefaultColumnDef: () => ({
    aggregatedCell: (e) => {
      var n, r;
      return (n = (r = e.getValue()) == null || r.toString == null ? void 0 : r.toString()) != null ? n : null;
    },
    aggregationFn: "auto"
  }),
  getInitialState: (e) => ({
    grouping: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGroupingChange: oe("grouping", e),
    groupedColumnMode: "reorder"
  }),
  createColumn: (e, n) => {
    e.toggleGrouping = () => {
      n.setGrouping((r) => r != null && r.includes(e.id) ? r.filter((o) => o !== e.id) : [...r ?? [], e.id]);
    }, e.getCanGroup = () => {
      var r, o;
      return ((r = e.columnDef.enableGrouping) != null ? r : !0) && ((o = n.options.enableGrouping) != null ? o : !0) && (!!e.accessorFn || !!e.columnDef.getGroupingValue);
    }, e.getIsGrouped = () => {
      var r;
      return (r = n.getState().grouping) == null ? void 0 : r.includes(e.id);
    }, e.getGroupedIndex = () => {
      var r;
      return (r = n.getState().grouping) == null ? void 0 : r.indexOf(e.id);
    }, e.getToggleGroupingHandler = () => {
      const r = e.getCanGroup();
      return () => {
        r && e.toggleGrouping();
      };
    }, e.getAutoAggregationFn = () => {
      const r = n.getCoreRowModel().flatRows[0], o = r == null ? void 0 : r.getValue(e.id);
      if (typeof o == "number")
        return bn.sum;
      if (Object.prototype.toString.call(o) === "[object Date]")
        return bn.extent;
    }, e.getAggregationFn = () => {
      var r, o;
      if (!e)
        throw new Error();
      return tn(e.columnDef.aggregationFn) ? e.columnDef.aggregationFn : e.columnDef.aggregationFn === "auto" ? e.getAutoAggregationFn() : (r = (o = n.options.aggregationFns) == null ? void 0 : o[e.columnDef.aggregationFn]) != null ? r : bn[e.columnDef.aggregationFn];
    };
  },
  createTable: (e) => {
    e.setGrouping = (n) => e.options.onGroupingChange == null ? void 0 : e.options.onGroupingChange(n), e.resetGrouping = (n) => {
      var r, o;
      e.setGrouping(n ? [] : (r = (o = e.initialState) == null ? void 0 : o.grouping) != null ? r : []);
    }, e.getPreGroupedRowModel = () => e.getFilteredRowModel(), e.getGroupedRowModel = () => (!e._getGroupedRowModel && e.options.getGroupedRowModel && (e._getGroupedRowModel = e.options.getGroupedRowModel(e)), e.options.manualGrouping || !e._getGroupedRowModel ? e.getPreGroupedRowModel() : e._getGroupedRowModel());
  },
  createRow: (e, n) => {
    e.getIsGrouped = () => !!e.groupingColumnId, e.getGroupingValue = (r) => {
      if (e._groupingValuesCache.hasOwnProperty(r))
        return e._groupingValuesCache[r];
      const o = n.getColumn(r);
      return o != null && o.columnDef.getGroupingValue ? (e._groupingValuesCache[r] = o.columnDef.getGroupingValue(e.original), e._groupingValuesCache[r]) : e.getValue(r);
    }, e._groupingValuesCache = {};
  },
  createCell: (e, n, r, o) => {
    e.getIsGrouped = () => n.getIsGrouped() && n.id === r.groupingColumnId, e.getIsPlaceholder = () => !e.getIsGrouped() && n.getIsGrouped(), e.getIsAggregated = () => {
      var i;
      return !e.getIsGrouped() && !e.getIsPlaceholder() && !!((i = r.subRows) != null && i.length);
    };
  }
};
function id(e, n, r) {
  if (!(n != null && n.length) || !r)
    return e;
  const o = e.filter((t) => !n.includes(t.id));
  return r === "remove" ? o : [...n.map((t) => e.find((a) => a.id === t)).filter(Boolean), ...o];
}
const ad = {
  getInitialState: (e) => ({
    columnOrder: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnOrderChange: oe("columnOrder", e)
  }),
  createColumn: (e, n) => {
    e.getIndex = N((r) => [fr(n, r)], (r) => r.findIndex((o) => o.id === e.id), P(n.options, "debugColumns", "getIndex")), e.getIsFirstColumn = (r) => {
      var o;
      return ((o = fr(n, r)[0]) == null ? void 0 : o.id) === e.id;
    }, e.getIsLastColumn = (r) => {
      var o;
      const i = fr(n, r);
      return ((o = i[i.length - 1]) == null ? void 0 : o.id) === e.id;
    };
  },
  createTable: (e) => {
    e.setColumnOrder = (n) => e.options.onColumnOrderChange == null ? void 0 : e.options.onColumnOrderChange(n), e.resetColumnOrder = (n) => {
      var r;
      e.setColumnOrder(n ? [] : (r = e.initialState.columnOrder) != null ? r : []);
    }, e._getOrderColumnsFn = N(() => [e.getState().columnOrder, e.getState().grouping, e.options.groupedColumnMode], (n, r, o) => (i) => {
      let t = [];
      if (!(n != null && n.length))
        t = i;
      else {
        const a = [...n], l = [...i];
        for (; l.length && a.length; ) {
          const u = a.shift(), c = l.findIndex((p) => p.id === u);
          c > -1 && t.push(l.splice(c, 1)[0]);
        }
        t = [...t, ...l];
      }
      return id(t, r, o);
    }, P(e.options, "debugTable", "_getOrderColumnsFn"));
  }
}, $n = () => ({
  left: [],
  right: []
}), ld = {
  getInitialState: (e) => ({
    columnPinning: $n(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnPinningChange: oe("columnPinning", e)
  }),
  createColumn: (e, n) => {
    e.pin = (r) => {
      const o = e.getLeafColumns().map((i) => i.id).filter(Boolean);
      n.setColumnPinning((i) => {
        var t, a;
        if (r === "right") {
          var l, u;
          return {
            left: ((l = i == null ? void 0 : i.left) != null ? l : []).filter((_) => !(o != null && o.includes(_))),
            right: [...((u = i == null ? void 0 : i.right) != null ? u : []).filter((_) => !(o != null && o.includes(_))), ...o]
          };
        }
        if (r === "left") {
          var c, p;
          return {
            left: [...((c = i == null ? void 0 : i.left) != null ? c : []).filter((_) => !(o != null && o.includes(_))), ...o],
            right: ((p = i == null ? void 0 : i.right) != null ? p : []).filter((_) => !(o != null && o.includes(_)))
          };
        }
        return {
          left: ((t = i == null ? void 0 : i.left) != null ? t : []).filter((_) => !(o != null && o.includes(_))),
          right: ((a = i == null ? void 0 : i.right) != null ? a : []).filter((_) => !(o != null && o.includes(_)))
        };
      });
    }, e.getCanPin = () => e.getLeafColumns().some((o) => {
      var i, t, a;
      return ((i = o.columnDef.enablePinning) != null ? i : !0) && ((t = (a = n.options.enableColumnPinning) != null ? a : n.options.enablePinning) != null ? t : !0);
    }), e.getIsPinned = () => {
      const r = e.getLeafColumns().map((l) => l.id), {
        left: o,
        right: i
      } = n.getState().columnPinning, t = r.some((l) => o == null ? void 0 : o.includes(l)), a = r.some((l) => i == null ? void 0 : i.includes(l));
      return t ? "left" : a ? "right" : !1;
    }, e.getPinnedIndex = () => {
      var r, o;
      const i = e.getIsPinned();
      return i ? (r = (o = n.getState().columnPinning) == null || (o = o[i]) == null ? void 0 : o.indexOf(e.id)) != null ? r : -1 : 0;
    };
  },
  createRow: (e, n) => {
    e.getCenterVisibleCells = N(() => [e._getAllVisibleCells(), n.getState().columnPinning.left, n.getState().columnPinning.right], (r, o, i) => {
      const t = [...o ?? [], ...i ?? []];
      return r.filter((a) => !t.includes(a.column.id));
    }, P(n.options, "debugRows", "getCenterVisibleCells")), e.getLeftVisibleCells = N(() => [e._getAllVisibleCells(), n.getState().columnPinning.left], (r, o) => (o ?? []).map((t) => r.find((a) => a.column.id === t)).filter(Boolean).map((t) => ({
      ...t,
      position: "left"
    })), P(n.options, "debugRows", "getLeftVisibleCells")), e.getRightVisibleCells = N(() => [e._getAllVisibleCells(), n.getState().columnPinning.right], (r, o) => (o ?? []).map((t) => r.find((a) => a.column.id === t)).filter(Boolean).map((t) => ({
      ...t,
      position: "right"
    })), P(n.options, "debugRows", "getRightVisibleCells"));
  },
  createTable: (e) => {
    e.setColumnPinning = (n) => e.options.onColumnPinningChange == null ? void 0 : e.options.onColumnPinningChange(n), e.resetColumnPinning = (n) => {
      var r, o;
      return e.setColumnPinning(n ? $n() : (r = (o = e.initialState) == null ? void 0 : o.columnPinning) != null ? r : $n());
    }, e.getIsSomeColumnsPinned = (n) => {
      var r;
      const o = e.getState().columnPinning;
      if (!n) {
        var i, t;
        return !!((i = o.left) != null && i.length || (t = o.right) != null && t.length);
      }
      return !!((r = o[n]) != null && r.length);
    }, e.getLeftLeafColumns = N(() => [e.getAllLeafColumns(), e.getState().columnPinning.left], (n, r) => (r ?? []).map((o) => n.find((i) => i.id === o)).filter(Boolean), P(e.options, "debugColumns", "getLeftLeafColumns")), e.getRightLeafColumns = N(() => [e.getAllLeafColumns(), e.getState().columnPinning.right], (n, r) => (r ?? []).map((o) => n.find((i) => i.id === o)).filter(Boolean), P(e.options, "debugColumns", "getRightLeafColumns")), e.getCenterLeafColumns = N(() => [e.getAllLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (n, r, o) => {
      const i = [...r ?? [], ...o ?? []];
      return n.filter((t) => !i.includes(t.id));
    }, P(e.options, "debugColumns", "getCenterLeafColumns"));
  }
};
function ud(e) {
  return e || (typeof document < "u" ? document : null);
}
const Er = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
}, xn = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: !1,
  columnSizingStart: []
}), sd = {
  getDefaultColumnDef: () => Er,
  getInitialState: (e) => ({
    columnSizing: {},
    columnSizingInfo: xn(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    columnResizeMode: "onEnd",
    columnResizeDirection: "ltr",
    onColumnSizingChange: oe("columnSizing", e),
    onColumnSizingInfoChange: oe("columnSizingInfo", e)
  }),
  createColumn: (e, n) => {
    e.getSize = () => {
      var r, o, i;
      const t = n.getState().columnSizing[e.id];
      return Math.min(Math.max((r = e.columnDef.minSize) != null ? r : Er.minSize, (o = t ?? e.columnDef.size) != null ? o : Er.size), (i = e.columnDef.maxSize) != null ? i : Er.maxSize);
    }, e.getStart = N((r) => [r, fr(n, r), n.getState().columnSizing], (r, o) => o.slice(0, e.getIndex(r)).reduce((i, t) => i + t.getSize(), 0), P(n.options, "debugColumns", "getStart")), e.getAfter = N((r) => [r, fr(n, r), n.getState().columnSizing], (r, o) => o.slice(e.getIndex(r) + 1).reduce((i, t) => i + t.getSize(), 0), P(n.options, "debugColumns", "getAfter")), e.resetSize = () => {
      n.setColumnSizing((r) => {
        let {
          [e.id]: o,
          ...i
        } = r;
        return i;
      });
    }, e.getCanResize = () => {
      var r, o;
      return ((r = e.columnDef.enableResizing) != null ? r : !0) && ((o = n.options.enableColumnResizing) != null ? o : !0);
    }, e.getIsResizing = () => n.getState().columnSizingInfo.isResizingColumn === e.id;
  },
  createHeader: (e, n) => {
    e.getSize = () => {
      let r = 0;
      const o = (i) => {
        if (i.subHeaders.length)
          i.subHeaders.forEach(o);
        else {
          var t;
          r += (t = i.column.getSize()) != null ? t : 0;
        }
      };
      return o(e), r;
    }, e.getStart = () => {
      if (e.index > 0) {
        const r = e.headerGroup.headers[e.index - 1];
        return r.getStart() + r.getSize();
      }
      return 0;
    }, e.getResizeHandler = (r) => {
      const o = n.getColumn(e.column.id), i = o == null ? void 0 : o.getCanResize();
      return (t) => {
        if (!o || !i || (t.persist == null || t.persist(), Sn(t) && t.touches && t.touches.length > 1))
          return;
        const a = e.getSize(), l = e ? e.getLeafHeaders().map((w) => [w.column.id, w.column.getSize()]) : [[o.id, o.getSize()]], u = Sn(t) ? Math.round(t.touches[0].clientX) : t.clientX, c = {}, p = (w, y) => {
          typeof y == "number" && (n.setColumnSizingInfo((b) => {
            var $, x;
            const R = n.options.columnResizeDirection === "rtl" ? -1 : 1, S = (y - (($ = b == null ? void 0 : b.startOffset) != null ? $ : 0)) * R, O = Math.max(S / ((x = b == null ? void 0 : b.startSize) != null ? x : 0), -0.999999);
            return b.columnSizingStart.forEach((E) => {
              let [k, D] = E;
              c[k] = Math.round(Math.max(D + D * O, 0) * 100) / 100;
            }), {
              ...b,
              deltaOffset: S,
              deltaPercentage: O
            };
          }), (n.options.columnResizeMode === "onChange" || w === "end") && n.setColumnSizing((b) => ({
            ...b,
            ...c
          })));
        }, _ = (w) => p("move", w), g = (w) => {
          p("end", w), n.setColumnSizingInfo((y) => ({
            ...y,
            isResizingColumn: !1,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: []
          }));
        }, f = ud(r), m = {
          moveHandler: (w) => _(w.clientX),
          upHandler: (w) => {
            f == null || f.removeEventListener("mousemove", m.moveHandler), f == null || f.removeEventListener("mouseup", m.upHandler), g(w.clientX);
          }
        }, h = {
          moveHandler: (w) => (w.cancelable && (w.preventDefault(), w.stopPropagation()), _(w.touches[0].clientX), !1),
          upHandler: (w) => {
            var y;
            f == null || f.removeEventListener("touchmove", h.moveHandler), f == null || f.removeEventListener("touchend", h.upHandler), w.cancelable && (w.preventDefault(), w.stopPropagation()), g((y = w.touches[0]) == null ? void 0 : y.clientX);
          }
        }, v = cd() ? {
          passive: !1
        } : !1;
        Sn(t) ? (f == null || f.addEventListener("touchmove", h.moveHandler, v), f == null || f.addEventListener("touchend", h.upHandler, v)) : (f == null || f.addEventListener("mousemove", m.moveHandler, v), f == null || f.addEventListener("mouseup", m.upHandler, v)), n.setColumnSizingInfo((w) => ({
          ...w,
          startOffset: u,
          startSize: a,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart: l,
          isResizingColumn: o.id
        }));
      };
    };
  },
  createTable: (e) => {
    e.setColumnSizing = (n) => e.options.onColumnSizingChange == null ? void 0 : e.options.onColumnSizingChange(n), e.setColumnSizingInfo = (n) => e.options.onColumnSizingInfoChange == null ? void 0 : e.options.onColumnSizingInfoChange(n), e.resetColumnSizing = (n) => {
      var r;
      e.setColumnSizing(n ? {} : (r = e.initialState.columnSizing) != null ? r : {});
    }, e.resetHeaderSizeInfo = (n) => {
      var r;
      e.setColumnSizingInfo(n ? xn() : (r = e.initialState.columnSizingInfo) != null ? r : xn());
    }, e.getTotalSize = () => {
      var n, r;
      return (n = (r = e.getHeaderGroups()[0]) == null ? void 0 : r.headers.reduce((o, i) => o + i.getSize(), 0)) != null ? n : 0;
    }, e.getLeftTotalSize = () => {
      var n, r;
      return (n = (r = e.getLeftHeaderGroups()[0]) == null ? void 0 : r.headers.reduce((o, i) => o + i.getSize(), 0)) != null ? n : 0;
    }, e.getCenterTotalSize = () => {
      var n, r;
      return (n = (r = e.getCenterHeaderGroups()[0]) == null ? void 0 : r.headers.reduce((o, i) => o + i.getSize(), 0)) != null ? n : 0;
    }, e.getRightTotalSize = () => {
      var n, r;
      return (n = (r = e.getRightHeaderGroups()[0]) == null ? void 0 : r.headers.reduce((o, i) => o + i.getSize(), 0)) != null ? n : 0;
    };
  }
};
let Nr = null;
function cd() {
  if (typeof Nr == "boolean") return Nr;
  let e = !1;
  try {
    const n = {
      get passive() {
        return e = !0, !1;
      }
    }, r = () => {
    };
    window.addEventListener("test", r, n), window.removeEventListener("test", r);
  } catch {
    e = !1;
  }
  return Nr = e, Nr;
}
function Sn(e) {
  return e.type === "touchstart";
}
const pd = {
  getInitialState: (e) => ({
    columnVisibility: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnVisibilityChange: oe("columnVisibility", e)
  }),
  createColumn: (e, n) => {
    e.toggleVisibility = (r) => {
      e.getCanHide() && n.setColumnVisibility((o) => ({
        ...o,
        [e.id]: r ?? !e.getIsVisible()
      }));
    }, e.getIsVisible = () => {
      var r, o;
      const i = e.columns;
      return (r = i.length ? i.some((t) => t.getIsVisible()) : (o = n.getState().columnVisibility) == null ? void 0 : o[e.id]) != null ? r : !0;
    }, e.getCanHide = () => {
      var r, o;
      return ((r = e.columnDef.enableHiding) != null ? r : !0) && ((o = n.options.enableHiding) != null ? o : !0);
    }, e.getToggleVisibilityHandler = () => (r) => {
      e.toggleVisibility == null || e.toggleVisibility(r.target.checked);
    };
  },
  createRow: (e, n) => {
    e._getAllVisibleCells = N(() => [e.getAllCells(), n.getState().columnVisibility], (r) => r.filter((o) => o.column.getIsVisible()), P(n.options, "debugRows", "_getAllVisibleCells")), e.getVisibleCells = N(() => [e.getLeftVisibleCells(), e.getCenterVisibleCells(), e.getRightVisibleCells()], (r, o, i) => [...r, ...o, ...i], P(n.options, "debugRows", "getVisibleCells"));
  },
  createTable: (e) => {
    const n = (r, o) => N(() => [o(), o().filter((i) => i.getIsVisible()).map((i) => i.id).join("_")], (i) => i.filter((t) => t.getIsVisible == null ? void 0 : t.getIsVisible()), P(e.options, "debugColumns", r));
    e.getVisibleFlatColumns = n("getVisibleFlatColumns", () => e.getAllFlatColumns()), e.getVisibleLeafColumns = n("getVisibleLeafColumns", () => e.getAllLeafColumns()), e.getLeftVisibleLeafColumns = n("getLeftVisibleLeafColumns", () => e.getLeftLeafColumns()), e.getRightVisibleLeafColumns = n("getRightVisibleLeafColumns", () => e.getRightLeafColumns()), e.getCenterVisibleLeafColumns = n("getCenterVisibleLeafColumns", () => e.getCenterLeafColumns()), e.setColumnVisibility = (r) => e.options.onColumnVisibilityChange == null ? void 0 : e.options.onColumnVisibilityChange(r), e.resetColumnVisibility = (r) => {
      var o;
      e.setColumnVisibility(r ? {} : (o = e.initialState.columnVisibility) != null ? o : {});
    }, e.toggleAllColumnsVisible = (r) => {
      var o;
      r = (o = r) != null ? o : !e.getIsAllColumnsVisible(), e.setColumnVisibility(e.getAllLeafColumns().reduce((i, t) => ({
        ...i,
        [t.id]: r || !(t.getCanHide != null && t.getCanHide())
      }), {}));
    }, e.getIsAllColumnsVisible = () => !e.getAllLeafColumns().some((r) => !(r.getIsVisible != null && r.getIsVisible())), e.getIsSomeColumnsVisible = () => e.getAllLeafColumns().some((r) => r.getIsVisible == null ? void 0 : r.getIsVisible()), e.getToggleAllColumnsVisibilityHandler = () => (r) => {
      var o;
      e.toggleAllColumnsVisible((o = r.target) == null ? void 0 : o.checked);
    };
  }
};
function fr(e, n) {
  return n ? n === "center" ? e.getCenterVisibleLeafColumns() : n === "left" ? e.getLeftVisibleLeafColumns() : e.getRightVisibleLeafColumns() : e.getVisibleLeafColumns();
}
const dd = {
  createTable: (e) => {
    e._getGlobalFacetedRowModel = e.options.getFacetedRowModel && e.options.getFacetedRowModel(e, "__global__"), e.getGlobalFacetedRowModel = () => e.options.manualFiltering || !e._getGlobalFacetedRowModel ? e.getPreFilteredRowModel() : e._getGlobalFacetedRowModel(), e._getGlobalFacetedUniqueValues = e.options.getFacetedUniqueValues && e.options.getFacetedUniqueValues(e, "__global__"), e.getGlobalFacetedUniqueValues = () => e._getGlobalFacetedUniqueValues ? e._getGlobalFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getGlobalFacetedMinMaxValues = e.options.getFacetedMinMaxValues && e.options.getFacetedMinMaxValues(e, "__global__"), e.getGlobalFacetedMinMaxValues = () => {
      if (e._getGlobalFacetedMinMaxValues)
        return e._getGlobalFacetedMinMaxValues();
    };
  }
}, fd = {
  getInitialState: (e) => ({
    globalFilter: void 0,
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGlobalFilterChange: oe("globalFilter", e),
    globalFilterFn: "auto",
    getColumnCanGlobalFilter: (n) => {
      var r;
      const o = (r = e.getCoreRowModel().flatRows[0]) == null || (r = r._getAllCellsByColumnId()[n.id]) == null ? void 0 : r.getValue();
      return typeof o == "string" || typeof o == "number";
    }
  }),
  createColumn: (e, n) => {
    e.getCanGlobalFilter = () => {
      var r, o, i, t;
      return ((r = e.columnDef.enableGlobalFilter) != null ? r : !0) && ((o = n.options.enableGlobalFilter) != null ? o : !0) && ((i = n.options.enableFilters) != null ? i : !0) && ((t = n.options.getColumnCanGlobalFilter == null ? void 0 : n.options.getColumnCanGlobalFilter(e)) != null ? t : !0) && !!e.accessorFn;
    };
  },
  createTable: (e) => {
    e.getGlobalAutoFilterFn = () => ke.includesString, e.getGlobalFilterFn = () => {
      var n, r;
      const {
        globalFilterFn: o
      } = e.options;
      return tn(o) ? o : o === "auto" ? e.getGlobalAutoFilterFn() : (n = (r = e.options.filterFns) == null ? void 0 : r[o]) != null ? n : ke[o];
    }, e.setGlobalFilter = (n) => {
      e.options.onGlobalFilterChange == null || e.options.onGlobalFilterChange(n);
    }, e.resetGlobalFilter = (n) => {
      e.setGlobalFilter(n ? void 0 : e.initialState.globalFilter);
    };
  }
}, gd = {
  getInitialState: (e) => ({
    expanded: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onExpandedChange: oe("expanded", e),
    paginateExpandedRows: !0
  }),
  createTable: (e) => {
    let n = !1, r = !1;
    e._autoResetExpanded = () => {
      var o, i;
      if (!n) {
        e._queue(() => {
          n = !0;
        });
        return;
      }
      if ((o = (i = e.options.autoResetAll) != null ? i : e.options.autoResetExpanded) != null ? o : !e.options.manualExpanding) {
        if (r) return;
        r = !0, e._queue(() => {
          e.resetExpanded(), r = !1;
        });
      }
    }, e.setExpanded = (o) => e.options.onExpandedChange == null ? void 0 : e.options.onExpandedChange(o), e.toggleAllRowsExpanded = (o) => {
      o ?? !e.getIsAllRowsExpanded() ? e.setExpanded(!0) : e.setExpanded({});
    }, e.resetExpanded = (o) => {
      var i, t;
      e.setExpanded(o ? {} : (i = (t = e.initialState) == null ? void 0 : t.expanded) != null ? i : {});
    }, e.getCanSomeRowsExpand = () => e.getPrePaginationRowModel().flatRows.some((o) => o.getCanExpand()), e.getToggleAllRowsExpandedHandler = () => (o) => {
      o.persist == null || o.persist(), e.toggleAllRowsExpanded();
    }, e.getIsSomeRowsExpanded = () => {
      const o = e.getState().expanded;
      return o === !0 || Object.values(o).some(Boolean);
    }, e.getIsAllRowsExpanded = () => {
      const o = e.getState().expanded;
      return typeof o == "boolean" ? o === !0 : !(!Object.keys(o).length || e.getRowModel().flatRows.some((i) => !i.getIsExpanded()));
    }, e.getExpandedDepth = () => {
      let o = 0;
      return (e.getState().expanded === !0 ? Object.keys(e.getRowModel().rowsById) : Object.keys(e.getState().expanded)).forEach((t) => {
        const a = t.split(".");
        o = Math.max(o, a.length);
      }), o;
    }, e.getPreExpandedRowModel = () => e.getSortedRowModel(), e.getExpandedRowModel = () => (!e._getExpandedRowModel && e.options.getExpandedRowModel && (e._getExpandedRowModel = e.options.getExpandedRowModel(e)), e.options.manualExpanding || !e._getExpandedRowModel ? e.getPreExpandedRowModel() : e._getExpandedRowModel());
  },
  createRow: (e, n) => {
    e.toggleExpanded = (r) => {
      n.setExpanded((o) => {
        var i;
        const t = o === !0 ? !0 : !!(o != null && o[e.id]);
        let a = {};
        if (o === !0 ? Object.keys(n.getRowModel().rowsById).forEach((l) => {
          a[l] = !0;
        }) : a = o, r = (i = r) != null ? i : !t, !t && r)
          return {
            ...a,
            [e.id]: !0
          };
        if (t && !r) {
          const {
            [e.id]: l,
            ...u
          } = a;
          return u;
        }
        return o;
      });
    }, e.getIsExpanded = () => {
      var r;
      const o = n.getState().expanded;
      return !!((r = n.options.getIsRowExpanded == null ? void 0 : n.options.getIsRowExpanded(e)) != null ? r : o === !0 || o != null && o[e.id]);
    }, e.getCanExpand = () => {
      var r, o, i;
      return (r = n.options.getRowCanExpand == null ? void 0 : n.options.getRowCanExpand(e)) != null ? r : ((o = n.options.enableExpanding) != null ? o : !0) && !!((i = e.subRows) != null && i.length);
    }, e.getIsAllParentsExpanded = () => {
      let r = !0, o = e;
      for (; r && o.parentId; )
        o = n.getRow(o.parentId, !0), r = o.getIsExpanded();
      return r;
    }, e.getToggleExpandedHandler = () => {
      const r = e.getCanExpand();
      return () => {
        r && e.toggleExpanded();
      };
    };
  }
}, lo = 0, uo = 10, Cn = () => ({
  pageIndex: lo,
  pageSize: uo
}), _d = {
  getInitialState: (e) => ({
    ...e,
    pagination: {
      ...Cn(),
      ...e == null ? void 0 : e.pagination
    }
  }),
  getDefaultOptions: (e) => ({
    onPaginationChange: oe("pagination", e)
  }),
  createTable: (e) => {
    let n = !1, r = !1;
    e._autoResetPageIndex = () => {
      var o, i;
      if (!n) {
        e._queue(() => {
          n = !0;
        });
        return;
      }
      if ((o = (i = e.options.autoResetAll) != null ? i : e.options.autoResetPageIndex) != null ? o : !e.options.manualPagination) {
        if (r) return;
        r = !0, e._queue(() => {
          e.resetPageIndex(), r = !1;
        });
      }
    }, e.setPagination = (o) => {
      const i = (t) => Ve(o, t);
      return e.options.onPaginationChange == null ? void 0 : e.options.onPaginationChange(i);
    }, e.resetPagination = (o) => {
      var i;
      e.setPagination(o ? Cn() : (i = e.initialState.pagination) != null ? i : Cn());
    }, e.setPageIndex = (o) => {
      e.setPagination((i) => {
        let t = Ve(o, i.pageIndex);
        const a = typeof e.options.pageCount > "u" || e.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : e.options.pageCount - 1;
        return t = Math.max(0, Math.min(t, a)), {
          ...i,
          pageIndex: t
        };
      });
    }, e.resetPageIndex = (o) => {
      var i, t;
      e.setPageIndex(o ? lo : (i = (t = e.initialState) == null || (t = t.pagination) == null ? void 0 : t.pageIndex) != null ? i : lo);
    }, e.resetPageSize = (o) => {
      var i, t;
      e.setPageSize(o ? uo : (i = (t = e.initialState) == null || (t = t.pagination) == null ? void 0 : t.pageSize) != null ? i : uo);
    }, e.setPageSize = (o) => {
      e.setPagination((i) => {
        const t = Math.max(1, Ve(o, i.pageSize)), a = i.pageSize * i.pageIndex, l = Math.floor(a / t);
        return {
          ...i,
          pageIndex: l,
          pageSize: t
        };
      });
    }, e.setPageCount = (o) => e.setPagination((i) => {
      var t;
      let a = Ve(o, (t = e.options.pageCount) != null ? t : -1);
      return typeof a == "number" && (a = Math.max(-1, a)), {
        ...i,
        pageCount: a
      };
    }), e.getPageOptions = N(() => [e.getPageCount()], (o) => {
      let i = [];
      return o && o > 0 && (i = [...new Array(o)].fill(null).map((t, a) => a)), i;
    }, P(e.options, "debugTable", "getPageOptions")), e.getCanPreviousPage = () => e.getState().pagination.pageIndex > 0, e.getCanNextPage = () => {
      const {
        pageIndex: o
      } = e.getState().pagination, i = e.getPageCount();
      return i === -1 ? !0 : i === 0 ? !1 : o < i - 1;
    }, e.previousPage = () => e.setPageIndex((o) => o - 1), e.nextPage = () => e.setPageIndex((o) => o + 1), e.firstPage = () => e.setPageIndex(0), e.lastPage = () => e.setPageIndex(e.getPageCount() - 1), e.getPrePaginationRowModel = () => e.getExpandedRowModel(), e.getPaginationRowModel = () => (!e._getPaginationRowModel && e.options.getPaginationRowModel && (e._getPaginationRowModel = e.options.getPaginationRowModel(e)), e.options.manualPagination || !e._getPaginationRowModel ? e.getPrePaginationRowModel() : e._getPaginationRowModel()), e.getPageCount = () => {
      var o;
      return (o = e.options.pageCount) != null ? o : Math.ceil(e.getRowCount() / e.getState().pagination.pageSize);
    }, e.getRowCount = () => {
      var o;
      return (o = e.options.rowCount) != null ? o : e.getPrePaginationRowModel().rows.length;
    };
  }
}, Rn = () => ({
  top: [],
  bottom: []
}), hd = {
  getInitialState: (e) => ({
    rowPinning: Rn(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowPinningChange: oe("rowPinning", e)
  }),
  createRow: (e, n) => {
    e.pin = (r, o, i) => {
      const t = o ? e.getLeafRows().map((u) => {
        let {
          id: c
        } = u;
        return c;
      }) : [], a = i ? e.getParentRows().map((u) => {
        let {
          id: c
        } = u;
        return c;
      }) : [], l = /* @__PURE__ */ new Set([...a, e.id, ...t]);
      n.setRowPinning((u) => {
        var c, p;
        if (r === "bottom") {
          var _, g;
          return {
            top: ((_ = u == null ? void 0 : u.top) != null ? _ : []).filter((h) => !(l != null && l.has(h))),
            bottom: [...((g = u == null ? void 0 : u.bottom) != null ? g : []).filter((h) => !(l != null && l.has(h))), ...Array.from(l)]
          };
        }
        if (r === "top") {
          var f, m;
          return {
            top: [...((f = u == null ? void 0 : u.top) != null ? f : []).filter((h) => !(l != null && l.has(h))), ...Array.from(l)],
            bottom: ((m = u == null ? void 0 : u.bottom) != null ? m : []).filter((h) => !(l != null && l.has(h)))
          };
        }
        return {
          top: ((c = u == null ? void 0 : u.top) != null ? c : []).filter((h) => !(l != null && l.has(h))),
          bottom: ((p = u == null ? void 0 : u.bottom) != null ? p : []).filter((h) => !(l != null && l.has(h)))
        };
      });
    }, e.getCanPin = () => {
      var r;
      const {
        enableRowPinning: o,
        enablePinning: i
      } = n.options;
      return typeof o == "function" ? o(e) : (r = o ?? i) != null ? r : !0;
    }, e.getIsPinned = () => {
      const r = [e.id], {
        top: o,
        bottom: i
      } = n.getState().rowPinning, t = r.some((l) => o == null ? void 0 : o.includes(l)), a = r.some((l) => i == null ? void 0 : i.includes(l));
      return t ? "top" : a ? "bottom" : !1;
    }, e.getPinnedIndex = () => {
      var r, o;
      const i = e.getIsPinned();
      if (!i) return -1;
      const t = (r = i === "top" ? n.getTopRows() : n.getBottomRows()) == null ? void 0 : r.map((a) => {
        let {
          id: l
        } = a;
        return l;
      });
      return (o = t == null ? void 0 : t.indexOf(e.id)) != null ? o : -1;
    };
  },
  createTable: (e) => {
    e.setRowPinning = (n) => e.options.onRowPinningChange == null ? void 0 : e.options.onRowPinningChange(n), e.resetRowPinning = (n) => {
      var r, o;
      return e.setRowPinning(n ? Rn() : (r = (o = e.initialState) == null ? void 0 : o.rowPinning) != null ? r : Rn());
    }, e.getIsSomeRowsPinned = (n) => {
      var r;
      const o = e.getState().rowPinning;
      if (!n) {
        var i, t;
        return !!((i = o.top) != null && i.length || (t = o.bottom) != null && t.length);
      }
      return !!((r = o[n]) != null && r.length);
    }, e._getPinnedRows = (n, r, o) => {
      var i;
      return ((i = e.options.keepPinnedRows) == null || i ? (
        //get all rows that are pinned even if they would not be otherwise visible
        //account for expanded parent rows, but not pagination or filtering
        (r ?? []).map((a) => {
          const l = e.getRow(a, !0);
          return l.getIsAllParentsExpanded() ? l : null;
        })
      ) : (
        //else get only visible rows that are pinned
        (r ?? []).map((a) => n.find((l) => l.id === a))
      )).filter(Boolean).map((a) => ({
        ...a,
        position: o
      }));
    }, e.getTopRows = N(() => [e.getRowModel().rows, e.getState().rowPinning.top], (n, r) => e._getPinnedRows(n, r, "top"), P(e.options, "debugRows", "getTopRows")), e.getBottomRows = N(() => [e.getRowModel().rows, e.getState().rowPinning.bottom], (n, r) => e._getPinnedRows(n, r, "bottom"), P(e.options, "debugRows", "getBottomRows")), e.getCenterRows = N(() => [e.getRowModel().rows, e.getState().rowPinning.top, e.getState().rowPinning.bottom], (n, r, o) => {
      const i = /* @__PURE__ */ new Set([...r ?? [], ...o ?? []]);
      return n.filter((t) => !i.has(t.id));
    }, P(e.options, "debugRows", "getCenterRows"));
  }
}, md = {
  getInitialState: (e) => ({
    rowSelection: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowSelectionChange: oe("rowSelection", e),
    enableRowSelection: !0,
    enableMultiRowSelection: !0,
    enableSubRowSelection: !0
    // enableGroupingRowSelection: false,
    // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
    // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,
  }),
  createTable: (e) => {
    e.setRowSelection = (n) => e.options.onRowSelectionChange == null ? void 0 : e.options.onRowSelectionChange(n), e.resetRowSelection = (n) => {
      var r;
      return e.setRowSelection(n ? {} : (r = e.initialState.rowSelection) != null ? r : {});
    }, e.toggleAllRowsSelected = (n) => {
      e.setRowSelection((r) => {
        n = typeof n < "u" ? n : !e.getIsAllRowsSelected();
        const o = {
          ...r
        }, i = e.getPreGroupedRowModel().flatRows;
        return n ? i.forEach((t) => {
          t.getCanSelect() && (o[t.id] = !0);
        }) : i.forEach((t) => {
          delete o[t.id];
        }), o;
      });
    }, e.toggleAllPageRowsSelected = (n) => e.setRowSelection((r) => {
      const o = typeof n < "u" ? n : !e.getIsAllPageRowsSelected(), i = {
        ...r
      };
      return e.getRowModel().rows.forEach((t) => {
        so(i, t.id, o, !0, e);
      }), i;
    }), e.getPreSelectedRowModel = () => e.getCoreRowModel(), e.getSelectedRowModel = N(() => [e.getState().rowSelection, e.getCoreRowModel()], (n, r) => Object.keys(n).length ? En(e, r) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, P(e.options, "debugTable", "getSelectedRowModel")), e.getFilteredSelectedRowModel = N(() => [e.getState().rowSelection, e.getFilteredRowModel()], (n, r) => Object.keys(n).length ? En(e, r) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, P(e.options, "debugTable", "getFilteredSelectedRowModel")), e.getGroupedSelectedRowModel = N(() => [e.getState().rowSelection, e.getSortedRowModel()], (n, r) => Object.keys(n).length ? En(e, r) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, P(e.options, "debugTable", "getGroupedSelectedRowModel")), e.getIsAllRowsSelected = () => {
      const n = e.getFilteredRowModel().flatRows, {
        rowSelection: r
      } = e.getState();
      let o = !!(n.length && Object.keys(r).length);
      return o && n.some((i) => i.getCanSelect() && !r[i.id]) && (o = !1), o;
    }, e.getIsAllPageRowsSelected = () => {
      const n = e.getPaginationRowModel().flatRows.filter((i) => i.getCanSelect()), {
        rowSelection: r
      } = e.getState();
      let o = !!n.length;
      return o && n.some((i) => !r[i.id]) && (o = !1), o;
    }, e.getIsSomeRowsSelected = () => {
      var n;
      const r = Object.keys((n = e.getState().rowSelection) != null ? n : {}).length;
      return r > 0 && r < e.getFilteredRowModel().flatRows.length;
    }, e.getIsSomePageRowsSelected = () => {
      const n = e.getPaginationRowModel().flatRows;
      return e.getIsAllPageRowsSelected() ? !1 : n.filter((r) => r.getCanSelect()).some((r) => r.getIsSelected() || r.getIsSomeSelected());
    }, e.getToggleAllRowsSelectedHandler = () => (n) => {
      e.toggleAllRowsSelected(n.target.checked);
    }, e.getToggleAllPageRowsSelectedHandler = () => (n) => {
      e.toggleAllPageRowsSelected(n.target.checked);
    };
  },
  createRow: (e, n) => {
    e.toggleSelected = (r, o) => {
      const i = e.getIsSelected();
      n.setRowSelection((t) => {
        var a;
        if (r = typeof r < "u" ? r : !i, e.getCanSelect() && i === r)
          return t;
        const l = {
          ...t
        };
        return so(l, e.id, r, (a = o == null ? void 0 : o.selectChildren) != null ? a : !0, n), l;
      });
    }, e.getIsSelected = () => {
      const {
        rowSelection: r
      } = n.getState();
      return zo(e, r);
    }, e.getIsSomeSelected = () => {
      const {
        rowSelection: r
      } = n.getState();
      return co(e, r) === "some";
    }, e.getIsAllSubRowsSelected = () => {
      const {
        rowSelection: r
      } = n.getState();
      return co(e, r) === "all";
    }, e.getCanSelect = () => {
      var r;
      return typeof n.options.enableRowSelection == "function" ? n.options.enableRowSelection(e) : (r = n.options.enableRowSelection) != null ? r : !0;
    }, e.getCanSelectSubRows = () => {
      var r;
      return typeof n.options.enableSubRowSelection == "function" ? n.options.enableSubRowSelection(e) : (r = n.options.enableSubRowSelection) != null ? r : !0;
    }, e.getCanMultiSelect = () => {
      var r;
      return typeof n.options.enableMultiRowSelection == "function" ? n.options.enableMultiRowSelection(e) : (r = n.options.enableMultiRowSelection) != null ? r : !0;
    }, e.getToggleSelectedHandler = () => {
      const r = e.getCanSelect();
      return (o) => {
        var i;
        r && e.toggleSelected((i = o.target) == null ? void 0 : i.checked);
      };
    };
  }
}, so = (e, n, r, o, i) => {
  var t;
  const a = i.getRow(n, !0);
  r ? (a.getCanMultiSelect() || Object.keys(e).forEach((l) => delete e[l]), a.getCanSelect() && (e[n] = !0)) : delete e[n], o && (t = a.subRows) != null && t.length && a.getCanSelectSubRows() && a.subRows.forEach((l) => so(e, l.id, r, o, i));
};
function En(e, n) {
  const r = e.getState().rowSelection, o = [], i = {}, t = function(a, l) {
    return a.map((u) => {
      var c;
      const p = zo(u, r);
      if (p && (o.push(u), i[u.id] = u), (c = u.subRows) != null && c.length && (u = {
        ...u,
        subRows: t(u.subRows)
      }), p)
        return u;
    }).filter(Boolean);
  };
  return {
    rows: t(n.rows),
    flatRows: o,
    rowsById: i
  };
}
function zo(e, n) {
  var r;
  return (r = n[e.id]) != null ? r : !1;
}
function co(e, n, r) {
  var o;
  if (!((o = e.subRows) != null && o.length)) return !1;
  let i = !0, t = !1;
  return e.subRows.forEach((a) => {
    if (!(t && !i) && (a.getCanSelect() && (zo(a, n) ? t = !0 : i = !1), a.subRows && a.subRows.length)) {
      const l = co(a, n);
      l === "all" ? t = !0 : (l === "some" && (t = !0), i = !1);
    }
  }), i ? "all" : t ? "some" : !1;
}
const po = /([0-9]+)/gm, vd = (e, n, r) => Du(qe(e.getValue(r)).toLowerCase(), qe(n.getValue(r)).toLowerCase()), wd = (e, n, r) => Du(qe(e.getValue(r)), qe(n.getValue(r))), yd = (e, n, r) => qo(qe(e.getValue(r)).toLowerCase(), qe(n.getValue(r)).toLowerCase()), bd = (e, n, r) => qo(qe(e.getValue(r)), qe(n.getValue(r))), $d = (e, n, r) => {
  const o = e.getValue(r), i = n.getValue(r);
  return o > i ? 1 : o < i ? -1 : 0;
}, xd = (e, n, r) => qo(e.getValue(r), n.getValue(r));
function qo(e, n) {
  return e === n ? 0 : e > n ? 1 : -1;
}
function qe(e) {
  return typeof e == "number" ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? "" : String(e) : typeof e == "string" ? e : "";
}
function Du(e, n) {
  const r = e.split(po).filter(Boolean), o = n.split(po).filter(Boolean);
  for (; r.length && o.length; ) {
    const i = r.shift(), t = o.shift(), a = parseInt(i, 10), l = parseInt(t, 10), u = [a, l].sort();
    if (isNaN(u[0])) {
      if (i > t)
        return 1;
      if (t > i)
        return -1;
      continue;
    }
    if (isNaN(u[1]))
      return isNaN(a) ? -1 : 1;
    if (a > l)
      return 1;
    if (l > a)
      return -1;
  }
  return r.length - o.length;
}
const zt = {
  alphanumeric: vd,
  alphanumericCaseSensitive: wd,
  text: yd,
  textCaseSensitive: bd,
  datetime: $d,
  basic: xd
}, Sd = {
  getInitialState: (e) => ({
    sorting: [],
    ...e
  }),
  getDefaultColumnDef: () => ({
    sortingFn: "auto",
    sortUndefined: 1
  }),
  getDefaultOptions: (e) => ({
    onSortingChange: oe("sorting", e),
    isMultiSortEvent: (n) => n.shiftKey
  }),
  createColumn: (e, n) => {
    e.getAutoSortingFn = () => {
      const r = n.getFilteredRowModel().flatRows.slice(10);
      let o = !1;
      for (const i of r) {
        const t = i == null ? void 0 : i.getValue(e.id);
        if (Object.prototype.toString.call(t) === "[object Date]")
          return zt.datetime;
        if (typeof t == "string" && (o = !0, t.split(po).length > 1))
          return zt.alphanumeric;
      }
      return o ? zt.text : zt.basic;
    }, e.getAutoSortDir = () => {
      const r = n.getFilteredRowModel().flatRows[0];
      return typeof (r == null ? void 0 : r.getValue(e.id)) == "string" ? "asc" : "desc";
    }, e.getSortingFn = () => {
      var r, o;
      if (!e)
        throw new Error();
      return tn(e.columnDef.sortingFn) ? e.columnDef.sortingFn : e.columnDef.sortingFn === "auto" ? e.getAutoSortingFn() : (r = (o = n.options.sortingFns) == null ? void 0 : o[e.columnDef.sortingFn]) != null ? r : zt[e.columnDef.sortingFn];
    }, e.toggleSorting = (r, o) => {
      const i = e.getNextSortingOrder(), t = typeof r < "u" && r !== null;
      n.setSorting((a) => {
        const l = a == null ? void 0 : a.find((f) => f.id === e.id), u = a == null ? void 0 : a.findIndex((f) => f.id === e.id);
        let c = [], p, _ = t ? r : i === "desc";
        if (a != null && a.length && e.getCanMultiSort() && o ? l ? p = "toggle" : p = "add" : a != null && a.length && u !== a.length - 1 ? p = "replace" : l ? p = "toggle" : p = "replace", p === "toggle" && (t || i || (p = "remove")), p === "add") {
          var g;
          c = [...a, {
            id: e.id,
            desc: _
          }], c.splice(0, c.length - ((g = n.options.maxMultiSortColCount) != null ? g : Number.MAX_SAFE_INTEGER));
        } else p === "toggle" ? c = a.map((f) => f.id === e.id ? {
          ...f,
          desc: _
        } : f) : p === "remove" ? c = a.filter((f) => f.id !== e.id) : c = [{
          id: e.id,
          desc: _
        }];
        return c;
      });
    }, e.getFirstSortDir = () => {
      var r, o;
      return ((r = (o = e.columnDef.sortDescFirst) != null ? o : n.options.sortDescFirst) != null ? r : e.getAutoSortDir() === "desc") ? "desc" : "asc";
    }, e.getNextSortingOrder = (r) => {
      var o, i;
      const t = e.getFirstSortDir(), a = e.getIsSorted();
      return a ? a !== t && ((o = n.options.enableSortingRemoval) == null || o) && // If enableSortRemove, enable in general
      (!(r && (i = n.options.enableMultiRemove) != null) || i) ? !1 : a === "desc" ? "asc" : "desc" : t;
    }, e.getCanSort = () => {
      var r, o;
      return ((r = e.columnDef.enableSorting) != null ? r : !0) && ((o = n.options.enableSorting) != null ? o : !0) && !!e.accessorFn;
    }, e.getCanMultiSort = () => {
      var r, o;
      return (r = (o = e.columnDef.enableMultiSort) != null ? o : n.options.enableMultiSort) != null ? r : !!e.accessorFn;
    }, e.getIsSorted = () => {
      var r;
      const o = (r = n.getState().sorting) == null ? void 0 : r.find((i) => i.id === e.id);
      return o ? o.desc ? "desc" : "asc" : !1;
    }, e.getSortIndex = () => {
      var r, o;
      return (r = (o = n.getState().sorting) == null ? void 0 : o.findIndex((i) => i.id === e.id)) != null ? r : -1;
    }, e.clearSorting = () => {
      n.setSorting((r) => r != null && r.length ? r.filter((o) => o.id !== e.id) : []);
    }, e.getToggleSortingHandler = () => {
      const r = e.getCanSort();
      return (o) => {
        r && (o.persist == null || o.persist(), e.toggleSorting == null || e.toggleSorting(void 0, e.getCanMultiSort() ? n.options.isMultiSortEvent == null ? void 0 : n.options.isMultiSortEvent(o) : !1));
      };
    };
  },
  createTable: (e) => {
    e.setSorting = (n) => e.options.onSortingChange == null ? void 0 : e.options.onSortingChange(n), e.resetSorting = (n) => {
      var r, o;
      e.setSorting(n ? [] : (r = (o = e.initialState) == null ? void 0 : o.sorting) != null ? r : []);
    }, e.getPreSortedRowModel = () => e.getGroupedRowModel(), e.getSortedRowModel = () => (!e._getSortedRowModel && e.options.getSortedRowModel && (e._getSortedRowModel = e.options.getSortedRowModel(e)), e.options.manualSorting || !e._getSortedRowModel ? e.getPreSortedRowModel() : e._getSortedRowModel());
  }
}, Cd = [
  Gp,
  pd,
  ad,
  ld,
  Zp,
  Up,
  dd,
  //depends on ColumnFaceting
  fd,
  //depends on ColumnFiltering
  Sd,
  od,
  //depends on RowSorting
  gd,
  _d,
  hd,
  md,
  sd
];
function Rd(e) {
  var n, r;
  process.env.NODE_ENV !== "production" && (e.debugAll || e.debugTable) && console.info("Creating Table Instance...");
  const o = [...Cd, ...(n = e._features) != null ? n : []];
  let i = {
    _features: o
  };
  const t = i._features.reduce((g, f) => Object.assign(g, f.getDefaultOptions == null ? void 0 : f.getDefaultOptions(i)), {}), a = (g) => i.options.mergeOptions ? i.options.mergeOptions(t, g) : {
    ...t,
    ...g
  };
  let u = {
    ...{},
    ...(r = e.initialState) != null ? r : {}
  };
  i._features.forEach((g) => {
    var f;
    u = (f = g.getInitialState == null ? void 0 : g.getInitialState(u)) != null ? f : u;
  });
  const c = [];
  let p = !1;
  const _ = {
    _features: o,
    options: {
      ...t,
      ...e
    },
    initialState: u,
    _queue: (g) => {
      c.push(g), p || (p = !0, Promise.resolve().then(() => {
        for (; c.length; )
          c.shift()();
        p = !1;
      }).catch((f) => setTimeout(() => {
        throw f;
      })));
    },
    reset: () => {
      i.setState(i.initialState);
    },
    setOptions: (g) => {
      const f = Ve(g, i.options);
      i.options = a(f);
    },
    getState: () => i.options.state,
    setState: (g) => {
      i.options.onStateChange == null || i.options.onStateChange(g);
    },
    _getRowId: (g, f, m) => {
      var h;
      return (h = i.options.getRowId == null ? void 0 : i.options.getRowId(g, f, m)) != null ? h : `${m ? [m.id, f].join(".") : f}`;
    },
    getCoreRowModel: () => (i._getCoreRowModel || (i._getCoreRowModel = i.options.getCoreRowModel(i)), i._getCoreRowModel()),
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => i.getPaginationRowModel(),
    //in next version, we should just pass in the row model as the optional 2nd arg
    getRow: (g, f) => {
      let m = (f ? i.getPrePaginationRowModel() : i.getRowModel()).rowsById[g];
      if (!m && (m = i.getCoreRowModel().rowsById[g], !m))
        throw process.env.NODE_ENV !== "production" ? new Error(`getRow could not find row with ID: ${g}`) : new Error();
      return m;
    },
    _getDefaultColumnDef: N(() => [i.options.defaultColumn], (g) => {
      var f;
      return g = (f = g) != null ? f : {}, {
        header: (m) => {
          const h = m.header.column.columnDef;
          return h.accessorKey ? h.accessorKey : h.accessorFn ? h.id : null;
        },
        // footer: props => props.header.column.id,
        cell: (m) => {
          var h, v;
          return (h = (v = m.renderValue()) == null || v.toString == null ? void 0 : v.toString()) != null ? h : null;
        },
        ...i._features.reduce((m, h) => Object.assign(m, h.getDefaultColumnDef == null ? void 0 : h.getDefaultColumnDef()), {}),
        ...g
      };
    }, P(e, "debugColumns", "_getDefaultColumnDef")),
    _getColumnDefs: () => i.options.columns,
    getAllColumns: N(() => [i._getColumnDefs()], (g) => {
      const f = function(m, h, v) {
        return v === void 0 && (v = 0), m.map((w) => {
          const y = Wp(i, w, v, h), b = w;
          return y.columns = b.columns ? f(b.columns, y, v + 1) : [], y;
        });
      };
      return f(g);
    }, P(e, "debugColumns", "getAllColumns")),
    getAllFlatColumns: N(() => [i.getAllColumns()], (g) => g.flatMap((f) => f.getFlatColumns()), P(e, "debugColumns", "getAllFlatColumns")),
    _getAllFlatColumnsById: N(() => [i.getAllFlatColumns()], (g) => g.reduce((f, m) => (f[m.id] = m, f), {}), P(e, "debugColumns", "getAllFlatColumnsById")),
    getAllLeafColumns: N(() => [i.getAllColumns(), i._getOrderColumnsFn()], (g, f) => {
      let m = g.flatMap((h) => h.getLeafColumns());
      return f(m);
    }, P(e, "debugColumns", "getAllLeafColumns")),
    getColumn: (g) => {
      const f = i._getAllFlatColumnsById()[g];
      return process.env.NODE_ENV !== "production" && !f && console.error(`[Table] Column with id '${g}' does not exist.`), f;
    }
  };
  Object.assign(i, _);
  for (let g = 0; g < i._features.length; g++) {
    const f = i._features[g];
    f == null || f.createTable == null || f.createTable(i);
  }
  return i;
}
function Ed() {
  return (e) => N(() => [e.options.data], (n) => {
    const r = {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, o = function(i, t, a) {
      t === void 0 && (t = 0);
      const l = [];
      for (let c = 0; c < i.length; c++) {
        const p = Io(e, e._getRowId(i[c], c, a), i[c], c, t, void 0, a == null ? void 0 : a.id);
        if (r.flatRows.push(p), r.rowsById[p.id] = p, l.push(p), e.options.getSubRows) {
          var u;
          p.originalSubRows = e.options.getSubRows(i[c], c), (u = p.originalSubRows) != null && u.length && (p.subRows = o(p.originalSubRows, t + 1, p));
        }
      }
      return l;
    };
    return r.rows = o(n), r;
  }, P(e.options, "debugTable", "getRowModel", () => e._autoResetPageIndex()));
}
function Nd(e) {
  const n = [], r = (o) => {
    var i;
    n.push(o), (i = o.subRows) != null && i.length && o.getIsExpanded() && o.subRows.forEach(r);
  };
  return e.rows.forEach(r), {
    rows: n,
    flatRows: e.flatRows,
    rowsById: e.rowsById
  };
}
function Pd(e, n, r) {
  return r.options.filterFromLeafRows ? kd(e, n, r) : Od(e, n, r);
}
function kd(e, n, r) {
  var o;
  const i = [], t = {}, a = (o = r.options.maxLeafRowFilterDepth) != null ? o : 100, l = function(u, c) {
    c === void 0 && (c = 0);
    const p = [];
    for (let g = 0; g < u.length; g++) {
      var _;
      let f = u[g];
      const m = Io(r, f.id, f.original, f.index, f.depth, void 0, f.parentId);
      if (m.columnFilters = f.columnFilters, (_ = f.subRows) != null && _.length && c < a) {
        if (m.subRows = l(f.subRows, c + 1), f = m, n(f) && !m.subRows.length) {
          p.push(f), t[f.id] = f, i.push(f);
          continue;
        }
        if (n(f) || m.subRows.length) {
          p.push(f), t[f.id] = f, i.push(f);
          continue;
        }
      } else
        f = m, n(f) && (p.push(f), t[f.id] = f, i.push(f));
    }
    return p;
  };
  return {
    rows: l(e),
    flatRows: i,
    rowsById: t
  };
}
function Od(e, n, r) {
  var o;
  const i = [], t = {}, a = (o = r.options.maxLeafRowFilterDepth) != null ? o : 100, l = function(u, c) {
    c === void 0 && (c = 0);
    const p = [];
    for (let g = 0; g < u.length; g++) {
      let f = u[g];
      if (n(f)) {
        var _;
        if ((_ = f.subRows) != null && _.length && c < a) {
          const h = Io(r, f.id, f.original, f.index, f.depth, void 0, f.parentId);
          h.subRows = l(f.subRows, c + 1), f = h;
        }
        p.push(f), i.push(f), t[f.id] = f;
      }
    }
    return p;
  };
  return {
    rows: l(e),
    flatRows: i,
    rowsById: t
  };
}
function Ad() {
  return (e) => N(() => [e.getPreFilteredRowModel(), e.getState().columnFilters, e.getState().globalFilter], (n, r, o) => {
    if (!n.rows.length || !(r != null && r.length) && !o) {
      for (let g = 0; g < n.flatRows.length; g++)
        n.flatRows[g].columnFilters = {}, n.flatRows[g].columnFiltersMeta = {};
      return n;
    }
    const i = [], t = [];
    (r ?? []).forEach((g) => {
      var f;
      const m = e.getColumn(g.id);
      if (!m)
        return;
      const h = m.getFilterFn();
      if (!h) {
        process.env.NODE_ENV !== "production" && console.warn(`Could not find a valid 'column.filterFn' for column with the ID: ${m.id}.`);
        return;
      }
      i.push({
        id: g.id,
        filterFn: h,
        resolvedValue: (f = h.resolveFilterValue == null ? void 0 : h.resolveFilterValue(g.value)) != null ? f : g.value
      });
    });
    const a = (r ?? []).map((g) => g.id), l = e.getGlobalFilterFn(), u = e.getAllLeafColumns().filter((g) => g.getCanGlobalFilter());
    o && l && u.length && (a.push("__global__"), u.forEach((g) => {
      var f;
      t.push({
        id: g.id,
        filterFn: l,
        resolvedValue: (f = l.resolveFilterValue == null ? void 0 : l.resolveFilterValue(o)) != null ? f : o
      });
    }));
    let c, p;
    for (let g = 0; g < n.flatRows.length; g++) {
      const f = n.flatRows[g];
      if (f.columnFilters = {}, i.length)
        for (let m = 0; m < i.length; m++) {
          c = i[m];
          const h = c.id;
          f.columnFilters[h] = c.filterFn(f, h, c.resolvedValue, (v) => {
            f.columnFiltersMeta[h] = v;
          });
        }
      if (t.length) {
        for (let m = 0; m < t.length; m++) {
          p = t[m];
          const h = p.id;
          if (p.filterFn(f, h, p.resolvedValue, (v) => {
            f.columnFiltersMeta[h] = v;
          })) {
            f.columnFilters.__global__ = !0;
            break;
          }
        }
        f.columnFilters.__global__ !== !0 && (f.columnFilters.__global__ = !1);
      }
    }
    const _ = (g) => {
      for (let f = 0; f < a.length; f++)
        if (g.columnFilters[a[f]] === !1)
          return !1;
      return !0;
    };
    return Pd(n.rows, _, e);
  }, P(e.options, "debugTable", "getFilteredRowModel", () => e._autoResetPageIndex()));
}
function Md(e) {
  return (n) => N(() => [n.getState().pagination, n.getPrePaginationRowModel(), n.options.paginateExpandedRows ? void 0 : n.getState().expanded], (r, o) => {
    if (!o.rows.length)
      return o;
    const {
      pageSize: i,
      pageIndex: t
    } = r;
    let {
      rows: a,
      flatRows: l,
      rowsById: u
    } = o;
    const c = i * t, p = c + i;
    a = a.slice(c, p);
    let _;
    n.options.paginateExpandedRows ? _ = {
      rows: a,
      flatRows: l,
      rowsById: u
    } : _ = Nd({
      rows: a,
      flatRows: l,
      rowsById: u
    }), _.flatRows = [];
    const g = (f) => {
      _.flatRows.push(f), f.subRows.length && f.subRows.forEach(g);
    };
    return _.rows.forEach(g), _;
  }, P(n.options, "debugTable", "getPaginationRowModel"));
}
function Fd() {
  return (e) => N(() => [e.getState().sorting, e.getPreSortedRowModel()], (n, r) => {
    if (!r.rows.length || !(n != null && n.length))
      return r;
    const o = e.getState().sorting, i = [], t = o.filter((u) => {
      var c;
      return (c = e.getColumn(u.id)) == null ? void 0 : c.getCanSort();
    }), a = {};
    t.forEach((u) => {
      const c = e.getColumn(u.id);
      c && (a[u.id] = {
        sortUndefined: c.columnDef.sortUndefined,
        invertSorting: c.columnDef.invertSorting,
        sortingFn: c.getSortingFn()
      });
    });
    const l = (u) => {
      const c = u.map((p) => ({
        ...p
      }));
      return c.sort((p, _) => {
        for (let f = 0; f < t.length; f += 1) {
          var g;
          const m = t[f], h = a[m.id], v = h.sortUndefined, w = (g = m == null ? void 0 : m.desc) != null ? g : !1;
          let y = 0;
          if (v) {
            const b = p.getValue(m.id), $ = _.getValue(m.id), x = b === void 0, R = $ === void 0;
            if (x || R) {
              if (v === "first") return x ? -1 : 1;
              if (v === "last") return x ? 1 : -1;
              y = x && R ? 0 : x ? v : -v;
            }
          }
          if (y === 0 && (y = h.sortingFn(p, _, m.id)), y !== 0)
            return w && (y *= -1), h.invertSorting && (y *= -1), y;
        }
        return p.index - _.index;
      }), c.forEach((p) => {
        var _;
        i.push(p), (_ = p.subRows) != null && _.length && (p.subRows = l(p.subRows));
      }), c;
    };
    return {
      rows: l(r.rows),
      flatRows: i,
      rowsById: r.rowsById
    };
  }, P(e.options, "debugTable", "getSortedRowModel", () => e._autoResetPageIndex()));
}
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function Tu(e, n) {
  return e ? Dd(e) ? /* @__PURE__ */ s.createElement(e, n) : e : null;
}
function Dd(e) {
  return Td(e) || typeof e == "function" || Ld(e);
}
function Td(e) {
  return typeof e == "function" && (() => {
    const n = Object.getPrototypeOf(e);
    return n.prototype && n.prototype.isReactComponent;
  })();
}
function Ld(e) {
  return typeof e == "object" && typeof e.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(e.$$typeof.description);
}
function jd(e) {
  const n = {
    state: {},
    // Dummy state
    onStateChange: () => {
    },
    // noop
    renderFallbackValue: null,
    ...e
  }, [r] = s.useState(() => ({
    current: Rd(n)
  })), [o, i] = s.useState(() => r.current.initialState);
  return r.current.setOptions((t) => ({
    ...t,
    ...e,
    state: {
      ...o,
      ...e.state
    },
    // Similarly, we'll maintain both our internal state and any user-provided
    // state.
    onStateChange: (a) => {
      i(a), e.onStateChange == null || e.onStateChange(a);
    }
  })), r.current;
}
function Id(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var vi = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var wi;
function Vd() {
  return wi || (wi = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o(l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(null, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(vi)), vi.exports;
}
var zd = Vd();
const qd = /* @__PURE__ */ Id(zd), Pr = {
  "purpur-heading": "_purpur-heading_k9fhq_1",
  "purpur-heading--hyphens": "_purpur-heading--hyphens_k9fhq_8",
  "purpur-heading--negative": "_purpur-heading--negative_k9fhq_11",
  "purpur-heading--subsection-100": "_purpur-heading--subsection-100_k9fhq_14",
  "purpur-heading--title-100": "_purpur-heading--title-100_k9fhq_20",
  "purpur-heading--title-200": "_purpur-heading--title-200_k9fhq_26",
  "purpur-heading--title-300": "_purpur-heading--title-300_k9fhq_32",
  "purpur-heading--title-400": "_purpur-heading--title-400_k9fhq_38",
  "purpur-heading--title-500": "_purpur-heading--title-500_k9fhq_44",
  "purpur-heading--title-600": "_purpur-heading--title-600_k9fhq_50",
  "purpur-heading--title-700": "_purpur-heading--title-700_k9fhq_56",
  "purpur-heading--display-25": "_purpur-heading--display-25_k9fhq_62",
  "purpur-heading--display-50": "_purpur-heading--display-50_k9fhq_68",
  "purpur-heading--display-100": "_purpur-heading--display-100_k9fhq_74",
  "purpur-heading--display-200": "_purpur-heading--display-200_k9fhq_80"
}, Hd = {
  TITLE100: "title-100"
}, kr = "purpur-heading", rn = ({
  children: e,
  className: n = "",
  enableHyphenation: r = !1,
  negative: o = !1,
  tag: i,
  variant: t = Hd.TITLE100,
  ...a
}) => {
  const l = i, u = qd([
    n,
    Pr[kr],
    Pr[`${kr}--${t}`],
    {
      [Pr[`${kr}--hyphens`]]: r,
      [Pr[`${kr}--negative`]]: o
    }
  ]);
  return /* @__PURE__ */ d(l, { className: u, ...a, children: e });
};
rn.displayName = "Heading";
function Bd(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var yi = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var bi;
function Wd() {
  return bi || (bi = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o(l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(null, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(yi)), yi.exports;
}
var Gd = Wd();
const Zd = /* @__PURE__ */ Bd(Gd), qt = {
  "purpur-paragraph": "_purpur-paragraph_1rh57_1",
  "purpur-paragraph--disabled": "_purpur-paragraph--disabled_1rh57_7",
  "purpur-paragraph--hyphens": "_purpur-paragraph--hyphens_1rh57_10",
  "purpur-paragraph--negative": "_purpur-paragraph--negative_1rh57_13",
  "purpur-paragraph--paragraph-100": "_purpur-paragraph--paragraph-100_1rh57_16",
  "purpur-paragraph--paragraph-100-medium": "_purpur-paragraph--paragraph-100-medium_1rh57_22",
  "purpur-paragraph--paragraph-100-bold": "_purpur-paragraph--paragraph-100-bold_1rh57_29",
  "purpur-paragraph--paragraph-200": "_purpur-paragraph--paragraph-200_1rh57_36",
  "purpur-paragraph--preamble-100": "_purpur-paragraph--preamble-100_1rh57_42",
  "purpur-paragraph--preamble-200": "_purpur-paragraph--preamble-200_1rh57_48",
  "purpur-paragraph--additional-100": "_purpur-paragraph--additional-100_1rh57_54",
  "purpur-paragraph--additional-100-medium": "_purpur-paragraph--additional-100-medium_1rh57_60",
  "purpur-paragraph--overline-100": "_purpur-paragraph--overline-100_1rh57_67",
  "purpur-paragraph--overline-200": "_purpur-paragraph--overline-200_1rh57_75"
}, Ud = {
  PARAGRAPH100: "paragraph-100"
}, Ht = "purpur-paragraph", se = ({
  ["data-testid"]: e,
  children: n,
  className: r,
  disabled: o,
  enableHyphenation: i = !1,
  negative: t = !1,
  variant: a = Ud.PARAGRAPH100,
  ...l
}) => {
  const u = Zd([
    r,
    qt[Ht],
    qt[`${Ht}--${a}`],
    {
      [qt[`${Ht}--hyphens`]]: i,
      [qt[`${Ht}--disabled`]]: o,
      [qt[`${Ht}--negative`]]: t
    }
  ]);
  return /* @__PURE__ */ d("p", { ...l, className: u, "data-testid": e, children: n });
};
se.displayName = "Paragraph";
function Xd(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Nn = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var $i;
function Yd() {
  return $i || ($i = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o.call(this, l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return this && this[t] || t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(this, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, this && this[l] || l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(Nn)), Nn.exports;
}
var Kd = Yd();
const z = /* @__PURE__ */ Xd(Kd), G = {
  "purpur-table": "_purpur-table_1ofj6_1",
  "purpur-table__container": "_purpur-table__container_1ofj6_12",
  "purpur-table-column-header-cell__first-header-visible": "_purpur-table-column-header-cell__first-header-visible_1ofj6_16",
  "purpur-table-column-header-cell__last-header-visible": "_purpur-table-column-header-cell__last-header-visible_1ofj6_19",
  "purpur-table-row-cell__last-row-first-cell-visible": "_purpur-table-row-cell__last-row-first-cell-visible_1ofj6_22",
  "purpur-table-row-cell__last-row-last-cell-visible": "_purpur-table-row-cell__last-row-last-cell-visible_1ofj6_25",
  "purpur-table__table": "_purpur-table__table_1ofj6_29",
  "purpur-table__table--full-width": "_purpur-table__table--full-width_1ofj6_35",
  "purpur-table-header": "_purpur-table-header_1ofj6_39",
  "purpur-table-column-header-cell": "_purpur-table-column-header-cell_1ofj6_16",
  "purpur-table-column-header-cell__sticky-header": "_purpur-table-column-header-cell__sticky-header_1ofj6_48",
  "purpur-table-column-header-cell__sticky-column": "_purpur-table-column-header-cell__sticky-column_1ofj6_54",
  "purpur-table-header--has-filters": "_purpur-table-header--has-filters_1ofj6_57",
  "purpur-table-row": "_purpur-table-row_1ofj6_22",
  "purpur-table-column-header-cell__checkbox": "_purpur-table-column-header-cell__checkbox_1ofj6_69",
  "purpur-table-column-header-cell__border-radius-first-cell": "_purpur-table-column-header-cell__border-radius-first-cell_1ofj6_72",
  "purpur-table-column-header-cell__border-radius-last-cell": "_purpur-table-column-header-cell__border-radius-last-cell_1ofj6_75",
  "purpur-table-column-header-cell__content": "_purpur-table-column-header-cell__content_1ofj6_78",
  "purpur-table-column-header-cell__title": "_purpur-table-column-header-cell__title_1ofj6_84",
  "purpur-table-column-header-cell__title--default": "_purpur-table-column-header-cell__title--default_1ofj6_90",
  "purpur-table-column-header-cell__sortable-title": "_purpur-table-column-header-cell__sortable-title_1ofj6_93",
  "purpur-table-column-header-cell__filter-wrapper": "_purpur-table-column-header-cell__filter-wrapper_1ofj6_96",
  "purpur-table-row-cell": "_purpur-table-row-cell_1ofj6_22",
  "purpur-table-row-cell__border-radius-first-cell": "_purpur-table-row-cell__border-radius-first-cell_1ofj6_111",
  "purpur-table-row-cell__border-radius-last-cell": "_purpur-table-row-cell__border-radius-last-cell_1ofj6_114",
  "purpur-table-row-cell__row-selection": "_purpur-table-row-cell__row-selection_1ofj6_120",
  "purpur-table-row-cell__row-toggle": "_purpur-table-row-cell__row-toggle_1ofj6_120",
  "purpur-table-row--selected": "_purpur-table-row--selected_1ofj6_129",
  "purpur-table-row-cell__sticky-column": "_purpur-table-row-cell__sticky-column_1ofj6_140",
  "purpur-table-column-header-cell__sticky-column__with-sticky-border": "_purpur-table-column-header-cell__sticky-column__with-sticky-border_1ofj6_151",
  "purpur-table-row-cell__sticky-column__with-sticky-border": "_purpur-table-row-cell__sticky-column__with-sticky-border_1ofj6_152",
  "purpur-table-row-cell__date": "_purpur-table-row-cell__date_1ofj6_165",
  "purpur-table-row-cell__icon-text": "_purpur-table-row-cell__icon-text_1ofj6_171",
  "purpur-table-row-cell__error-message": "_purpur-table-row-cell__error-message_1ofj6_178",
  "purpur-table-row-cell__warning-message": "_purpur-table-row-cell__warning-message_1ofj6_178",
  "purpur-table-row-cell__right-align": "_purpur-table-row-cell__right-align_1ofj6_210",
  "purpur-table-row-cell__truncate-wrapper": "_purpur-table-row-cell__truncate-wrapper_1ofj6_213",
  "purpur-table-row-cell__truncate": "_purpur-table-row-cell__truncate_1ofj6_213",
  "purpur-table-row-cell__skeleton": "_purpur-table-row-cell__skeleton_1ofj6_233",
  "purpur-table-row-cell__tooltip-content": "_purpur-table-row-cell__tooltip-content_1ofj6_237",
  "purpur-table--primary": "_purpur-table--primary_1ofj6_241",
  "purpur-table-body": "_purpur-table-body_1ofj6_244",
  "purpur-table--secondary": "_purpur-table--secondary_1ofj6_251",
  "purpur-table__empty-section": "_purpur-table__empty-section_1ofj6_261",
  "purpur-table__empty-section__icon": "_purpur-table__empty-section__icon_1ofj6_270",
  "purpur-table__empty-section__texts": "_purpur-table__empty-section__texts_1ofj6_276",
  "purpur-table__empty-section--primary": "_purpur-table__empty-section--primary_1ofj6_283",
  "purpur-table__empty-section--secondary": "_purpur-table__empty-section--secondary_1ofj6_286"
}, Jd = {
  LG: "lg"
};
function Qd(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var xi = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Si;
function ef() {
  return Si || (Si = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o(l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(null, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(xi)), xi.exports;
}
var tf = ef();
const Ci = /* @__PURE__ */ Qd(tf), rf = "_rotate_1xozj_1", nf = "_dash_1xozj_1", Bt = {
  "purpur-spinner": "_purpur-spinner_1xozj_1",
  rotate: rf,
  "purpur-spinner--xxs": "_purpur-spinner--xxs_1xozj_4",
  "purpur-spinner--xs": "_purpur-spinner--xs_1xozj_8",
  "purpur-spinner--sm": "_purpur-spinner--sm_1xozj_12",
  "purpur-spinner--md": "_purpur-spinner--md_1xozj_16",
  "purpur-spinner--lg": "_purpur-spinner--lg_1xozj_20",
  "purpur-spinner__circle": "_purpur-spinner__circle_1xozj_24",
  dash: nf,
  "purpur-spinner__circle--disabled": "_purpur-spinner__circle--disabled_1xozj_33",
  "purpur-spinner__circle--negative": "_purpur-spinner__circle--negative_1xozj_36"
}, Wt = "purpur-spinner", of = {
  SM: "sm"
}, af = ({
  ["data-testid"]: e,
  disabled: n = !1,
  negative: r = !1,
  size: o = of.SM,
  ...i
}) => /* @__PURE__ */ d(
  "div",
  {
    className: Ci([Bt[Wt], Bt[`${Wt}--${o}`]]),
    "data-testid": e,
    ...i,
    children: /* @__PURE__ */ d("svg", { viewBox: "0 0 50 50", children: /* @__PURE__ */ d(
      "circle",
      {
        className: Ci(Bt[`${Wt}__circle`], {
          [Bt[`${Wt}__circle--disabled`]]: n,
          [Bt[`${Wt}__circle--negative`]]: r
        }),
        cx: "25",
        cy: "25",
        r: "20"
      }
    ) })
  }
);
function lf(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ri = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Ei;
function uf() {
  return Ei || (Ei = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o.call(this, l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return this && this[t] || t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(this, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, this && this[l] || l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(Ri)), Ri.exports;
}
var sf = uf();
const cf = /* @__PURE__ */ lf(sf), pf = {
  "purpur-button": "_purpur-button_w455q_1",
  "purpur-button--xs": "_purpur-button--xs_w455q_33",
  "purpur-button--icon-only": "_purpur-button--icon-only_w455q_36",
  "purpur-button--sm": "_purpur-button--sm_w455q_39",
  "purpur-button--md": "_purpur-button--md_w455q_45",
  "purpur-button--lg": "_purpur-button--lg_w455q_51",
  "purpur-button--full-width": "_purpur-button--full-width_w455q_57",
  "purpur-button--primary": "_purpur-button--primary_w455q_60",
  "purpur-button--disabled": "_purpur-button--disabled_w455q_64",
  "purpur-button--primary-negative": "_purpur-button--primary-negative_w455q_70",
  "purpur-button--secondary": "_purpur-button--secondary_w455q_82",
  "purpur-button--secondary-negative": "_purpur-button--secondary-negative_w455q_93",
  "purpur-button--expressive": "_purpur-button--expressive_w455q_104",
  "purpur-button--expressive-negative": "_purpur-button--expressive-negative_w455q_114",
  "purpur-button--negative": "_purpur-button--negative_w455q_126",
  "purpur-button--destructive": "_purpur-button--destructive_w455q_133",
  "purpur-button--destructive-negative": "_purpur-button--destructive-negative_w455q_143",
  "purpur-button--tertiary-purple": "_purpur-button--tertiary-purple_w455q_153",
  "purpur-button--tertiary-purple-negative": "_purpur-button--tertiary-purple-negative_w455q_166",
  "purpur-button--text-negative": "_purpur-button--text-negative_w455q_181",
  "purpur-button--text": "_purpur-button--text_w455q_181"
}, df = cf.bind(pf), Ke = "purpur-button", ff = ({
  children: e,
  className: n,
  ["data-testid"]: r,
  disabled: o = !1,
  fullWidth: i = !1,
  iconOnly: t,
  loading: a = !1,
  negative: l = !1,
  onClick: u,
  size: c = "md",
  variant: p,
  type: _ = "button",
  ...g
}, f) => {
  if (t && p === "destructive")
    return null;
  const m = df(
    [
      Ke,
      `${Ke}--${l ? `${p}-negative` : p}`,
      `${Ke}--${c}`
    ],
    {
      [`${Ke}--icon-only`]: t,
      [`${Ke}--negative`]: l,
      [`${Ke}--full-width`]: i,
      [`${Ke}--disabled`]: o || a
    },
    n
  ), h = (w) => {
    o || a ? w.preventDefault() : u && u(w);
  }, v = !!g["aria-disabled"] || o || a;
  return /* @__PURE__ */ C(
    "button",
    {
      className: m,
      "data-testid": r,
      type: _,
      ref: f,
      "aria-disabled": v,
      onClick: h,
      ...g,
      children: [
        a && /* @__PURE__ */ d(af, { size: c === Jd.LG ? "xs" : "xxs", negative: l, disabled: v }),
        " ",
        e
      ]
    }
  );
}, re = W(ff);
re.displayName = "Button";
function gf(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ni = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Pi;
function _f() {
  return Pi || (Pi = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o.call(this, l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return this && this[t] || t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(this, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, this && this[l] || l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(Ni)), Ni.exports;
}
var hf = _f();
const mf = /* @__PURE__ */ gf(hf), vf = {
  "purpur-icon": "_purpur-icon_8u1lq_1",
  "purpur-icon--xxs": "_purpur-icon--xxs_8u1lq_4",
  "purpur-icon--xs": "_purpur-icon--xs_8u1lq_8",
  "purpur-icon--sm": "_purpur-icon--sm_8u1lq_12",
  "purpur-icon--md": "_purpur-icon--md_8u1lq_16",
  "purpur-icon--lg": "_purpur-icon--lg_8u1lq_20",
  "purpur-icon--xl": "_purpur-icon--xl_8u1lq_24"
}, wf = mf.bind(vf), ki = "purpur-icon", yf = "md", bf = (e) => e.filter((n) => Object.keys(n).length >= 1).map((n) => `${n.name}="${n.value}"`).join(" "), $f = ({ content: e = "", title: n } = {}) => {
  const r = [
    { name: "xmlns", value: "http://www.w3.org/2000/svg" },
    { name: "fill", value: "currentColor" },
    { name: "viewBox", value: "0 0 24 24" },
    n ? { name: "role", value: "img" } : { name: "aria-hidden", value: "true" }
  ], o = n ? `<title>${n}</title>` : "";
  return `<svg ${bf(r)}>${o}${e}</svg>`;
}, xf = (e) => e.replace(/<(\/?)svg([^>]*)>/g, "").trim(), Lu = ({
  ["data-testid"]: e,
  svg: n,
  allyTitle: r,
  className: o,
  size: i = yf,
  ...t
}) => {
  const a = $f({
    content: xf(n.svg),
    title: r
  }), l = wf(o, ki, `${ki}--${i}`);
  return /* @__PURE__ */ d(
    "span",
    {
      className: l,
      "data-testid": e,
      dangerouslySetInnerHTML: { __html: a },
      ...t
    }
  );
};
Lu.displayName = "Icon";
const Sf = {
  name: "checkmark-bold",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M21.243 4.176a2 2 0 0 1 .324 2.81l-10.45 13.176a2.092 2.092 0 0 1-3.118.18l-5.413-5.413A2 2 0 1 1 5.414 12.1l3.9 3.9 9.118-11.5a2 2 0 0 1 2.81-.324Z" clip-rule="evenodd"/></svg>',
  keywords: ["checkmark-bold"],
  category: "utility"
};
function Oi(e, n) {
  if (typeof e == "function")
    return e(n);
  e != null && (e.current = n);
}
function Cf(...e) {
  return (n) => {
    let r = !1;
    const o = e.map((i) => {
      const t = Oi(i, n);
      return !r && typeof t == "function" && (r = !0), t;
    });
    if (r)
      return () => {
        for (let i = 0; i < o.length; i++) {
          const t = o[i];
          typeof t == "function" ? t() : Oi(e[i], null);
        }
      };
  };
}
var ju = s.forwardRef((e, n) => {
  const { children: r, ...o } = e, i = s.Children.toArray(r), t = i.find(Ef);
  if (t) {
    const a = t.props.children, l = i.map((u) => u === t ? s.Children.count(a) > 1 ? s.Children.only(null) : s.isValidElement(a) ? a.props.children : null : u);
    return /* @__PURE__ */ d(fo, { ...o, ref: n, children: s.isValidElement(a) ? s.cloneElement(a, void 0, l) : null });
  }
  return /* @__PURE__ */ d(fo, { ...o, ref: n, children: r });
});
ju.displayName = "Slot";
var fo = s.forwardRef((e, n) => {
  const { children: r, ...o } = e;
  if (s.isValidElement(r)) {
    const i = Pf(r), t = Nf(o, r.props);
    return r.type !== s.Fragment && (t.ref = n ? Cf(n, i) : i), s.cloneElement(r, t);
  }
  return s.Children.count(r) > 1 ? s.Children.only(null) : null;
});
fo.displayName = "SlotClone";
var Rf = ({ children: e }) => /* @__PURE__ */ d(q, { children: e });
function Ef(e) {
  return s.isValidElement(e) && e.type === Rf;
}
function Nf(e, n) {
  const r = { ...n };
  for (const o in n) {
    const i = e[o], t = n[o];
    /^on[A-Z]/.test(o) ? i && t ? r[o] = (...a) => {
      t(...a), i(...a);
    } : i && (r[o] = i) : o === "style" ? r[o] = { ...i, ...t } : o === "className" && (r[o] = [i, t].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function Pf(e) {
  var n, r;
  let o = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, i = o && "isReactWarning" in o && o.isReactWarning;
  return i ? e.ref : (o = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, i = o && "isReactWarning" in o && o.isReactWarning, i ? e.props.ref : e.props.ref || e.ref);
}
var kf = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Of = kf.reduce((e, n) => {
  const r = s.forwardRef((o, i) => {
    const { asChild: t, ...a } = o, l = t ? ju : n;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ d(l, { ...a, ref: i });
  });
  return r.displayName = `Primitive.${n}`, { ...e, [n]: r };
}, {}), Af = "Label", Iu = s.forwardRef((e, n) => /* @__PURE__ */ d(
  Of.label,
  {
    ...e,
    ref: n,
    onMouseDown: (r) => {
      var o;
      r.target.closest("button, input, select, textarea") || ((o = e.onMouseDown) == null || o.call(e, r), !r.defaultPrevented && r.detail > 1 && r.preventDefault());
    }
  }
));
Iu.displayName = Af;
var Mf = Iu;
function Ff(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ai = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Mi;
function Df() {
  return Mi || (Mi = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o(l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(null, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(Ai)), Ai.exports;
}
var Tf = Df();
const Lf = /* @__PURE__ */ Ff(Tf), Pn = {
  "purpur-label": "_purpur-label_1jndl_1",
  "purpur-label--negative": "_purpur-label--negative_1jndl_8",
  "purpur-label--disabled": "_purpur-label--disabled_1jndl_11"
}, kn = "purpur-label", jf = ({
  children: e,
  className: n,
  disabled: r,
  negative: o = !1,
  ...i
}) => {
  const t = Lf([
    n,
    Pn[kn],
    {
      [Pn[`${kn}--disabled`]]: r,
      [Pn[`${kn}--negative`]]: o
    }
  ]);
  return /* @__PURE__ */ d(Mf, { className: t, ...i, children: e });
};
function If(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Fi = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Di;
function Vf() {
  return Di || (Di = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o(l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(null, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(Fi)), Fi.exports;
}
var zf = Vf();
const qf = /* @__PURE__ */ If(zf), Gt = {
  "purpur-paragraph": "_purpur-paragraph_1rh57_1",
  "purpur-paragraph--disabled": "_purpur-paragraph--disabled_1rh57_7",
  "purpur-paragraph--hyphens": "_purpur-paragraph--hyphens_1rh57_10",
  "purpur-paragraph--negative": "_purpur-paragraph--negative_1rh57_13",
  "purpur-paragraph--paragraph-100": "_purpur-paragraph--paragraph-100_1rh57_16",
  "purpur-paragraph--paragraph-100-medium": "_purpur-paragraph--paragraph-100-medium_1rh57_22",
  "purpur-paragraph--paragraph-100-bold": "_purpur-paragraph--paragraph-100-bold_1rh57_29",
  "purpur-paragraph--paragraph-200": "_purpur-paragraph--paragraph-200_1rh57_36",
  "purpur-paragraph--preamble-100": "_purpur-paragraph--preamble-100_1rh57_42",
  "purpur-paragraph--preamble-200": "_purpur-paragraph--preamble-200_1rh57_48",
  "purpur-paragraph--additional-100": "_purpur-paragraph--additional-100_1rh57_54",
  "purpur-paragraph--additional-100-medium": "_purpur-paragraph--additional-100-medium_1rh57_60",
  "purpur-paragraph--overline-100": "_purpur-paragraph--overline-100_1rh57_67",
  "purpur-paragraph--overline-200": "_purpur-paragraph--overline-200_1rh57_75"
}, Hf = {
  PARAGRAPH100: "paragraph-100"
}, Zt = "purpur-paragraph", Vu = ({
  ["data-testid"]: e,
  children: n,
  className: r,
  disabled: o,
  enableHyphenation: i = !1,
  negative: t = !1,
  variant: a = Hf.PARAGRAPH100,
  ...l
}) => {
  const u = qf([
    r,
    Gt[Zt],
    Gt[`${Zt}--${a}`],
    {
      [Gt[`${Zt}--hyphens`]]: i,
      [Gt[`${Zt}--disabled`]]: o,
      [Gt[`${Zt}--negative`]]: t
    }
  ]);
  return /* @__PURE__ */ d("p", { ...l, className: u, "data-testid": e, children: n });
};
Vu.displayName = "Paragraph";
function Bf(e, n, { checkForDefaultPrevented: r = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), r === !1 || !o.defaultPrevented)
      return n == null ? void 0 : n(o);
  };
}
function Ti(e, n) {
  if (typeof e == "function")
    return e(n);
  e != null && (e.current = n);
}
function zu(...e) {
  return (n) => {
    let r = !1;
    const o = e.map((i) => {
      const t = Ti(i, n);
      return !r && typeof t == "function" && (r = !0), t;
    });
    if (r)
      return () => {
        for (let i = 0; i < o.length; i++) {
          const t = o[i];
          typeof t == "function" ? t() : Ti(e[i], null);
        }
      };
  };
}
function Wf(...e) {
  return s.useCallback(zu(...e), e);
}
function Gf(e, n = []) {
  let r = [];
  function o(t, a) {
    const l = s.createContext(a), u = r.length;
    r = [...r, a];
    const c = (_) => {
      var g;
      const { scope: f, children: m, ...h } = _, v = ((g = f == null ? void 0 : f[e]) == null ? void 0 : g[u]) || l, w = s.useMemo(() => h, Object.values(h));
      return /* @__PURE__ */ d(v.Provider, { value: w, children: m });
    };
    c.displayName = t + "Provider";
    function p(_, g) {
      var f;
      const m = ((f = g == null ? void 0 : g[e]) == null ? void 0 : f[u]) || l, h = s.useContext(m);
      if (h) return h;
      if (a !== void 0) return a;
      throw new Error(`\`${_}\` must be used within \`${t}\``);
    }
    return [c, p];
  }
  const i = () => {
    const t = r.map((a) => s.createContext(a));
    return function(a) {
      const l = (a == null ? void 0 : a[e]) || t;
      return s.useMemo(
        () => ({ [`__scope${e}`]: { ...a, [e]: l } }),
        [a, l]
      );
    };
  };
  return i.scopeName = e, [o, Zf(i, ...n)];
}
function Zf(...e) {
  const n = e[0];
  if (e.length === 1) return n;
  const r = () => {
    const o = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(i) {
      const t = o.reduce((a, { useScope: l, scopeName: u }) => {
        const c = l(i)[`__scope${u}`];
        return { ...a, ...c };
      }, {});
      return s.useMemo(() => ({ [`__scope${n.scopeName}`]: t }), [t]);
    };
  };
  return r.scopeName = n.scopeName, r;
}
function qu(e) {
  const n = s.useRef(e);
  return s.useEffect(() => {
    n.current = e;
  }), s.useMemo(() => (...r) => {
    var o;
    return (o = n.current) == null ? void 0 : o.call(n, ...r);
  }, []);
}
function Uf({
  prop: e,
  defaultProp: n,
  onChange: r = () => {
  }
}) {
  const [o, i] = Xf({ defaultProp: n, onChange: r }), t = e !== void 0, a = t ? e : o, l = qu(r), u = s.useCallback(
    (c) => {
      if (t) {
        const p = typeof c == "function" ? c(e) : c;
        p !== e && l(p);
      } else
        i(c);
    },
    [t, e, i, l]
  );
  return [a, u];
}
function Xf({
  defaultProp: e,
  onChange: n
}) {
  const r = s.useState(e), [o] = r, i = s.useRef(o), t = qu(n);
  return s.useEffect(() => {
    i.current !== o && (t(o), i.current = o);
  }, [o, i, t]), r;
}
function Yf(e) {
  const n = s.useRef({ value: e, previous: e });
  return s.useMemo(() => (n.current.value !== e && (n.current.previous = n.current.value, n.current.value = e), n.current.previous), [e]);
}
var Kf = globalThis != null && globalThis.document ? s.useLayoutEffect : () => {
};
function Jf(e) {
  const [n, r] = s.useState(void 0);
  return Kf(() => {
    if (e) {
      r({ width: e.offsetWidth, height: e.offsetHeight });
      const o = new ResizeObserver((i) => {
        if (!Array.isArray(i) || !i.length)
          return;
        const t = i[0];
        let a, l;
        if ("borderBoxSize" in t) {
          const u = t.borderBoxSize, c = Array.isArray(u) ? u[0] : u;
          a = c.inlineSize, l = c.blockSize;
        } else
          a = e.offsetWidth, l = e.offsetHeight;
        r({ width: a, height: l });
      });
      return o.observe(e, { box: "border-box" }), () => o.unobserve(e);
    } else
      r(void 0);
  }, [e]), n;
}
var Hu = s.forwardRef((e, n) => {
  const { children: r, ...o } = e, i = s.Children.toArray(r), t = i.find(eg);
  if (t) {
    const a = t.props.children, l = i.map((u) => u === t ? s.Children.count(a) > 1 ? s.Children.only(null) : s.isValidElement(a) ? a.props.children : null : u);
    return /* @__PURE__ */ d(go, { ...o, ref: n, children: s.isValidElement(a) ? s.cloneElement(a, void 0, l) : null });
  }
  return /* @__PURE__ */ d(go, { ...o, ref: n, children: r });
});
Hu.displayName = "Slot";
var go = s.forwardRef((e, n) => {
  const { children: r, ...o } = e;
  if (s.isValidElement(r)) {
    const i = rg(r), t = tg(o, r.props);
    return r.type !== s.Fragment && (t.ref = n ? zu(n, i) : i), s.cloneElement(r, t);
  }
  return s.Children.count(r) > 1 ? s.Children.only(null) : null;
});
go.displayName = "SlotClone";
var Qf = ({ children: e }) => /* @__PURE__ */ d(q, { children: e });
function eg(e) {
  return s.isValidElement(e) && e.type === Qf;
}
function tg(e, n) {
  const r = { ...n };
  for (const o in n) {
    const i = e[o], t = n[o];
    /^on[A-Z]/.test(o) ? i && t ? r[o] = (...a) => {
      t(...a), i(...a);
    } : i && (r[o] = i) : o === "style" ? r[o] = { ...i, ...t } : o === "className" && (r[o] = [i, t].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function rg(e) {
  var n, r;
  let o = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, i = o && "isReactWarning" in o && o.isReactWarning;
  return i ? e.ref : (o = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, i = o && "isReactWarning" in o && o.isReactWarning, i ? e.props.ref : e.props.ref || e.ref);
}
var ng = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Bu = ng.reduce((e, n) => {
  const r = s.forwardRef((o, i) => {
    const { asChild: t, ...a } = o, l = t ? Hu : n;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ d(l, { ...a, ref: i });
  });
  return r.displayName = `Primitive.${n}`, { ...e, [n]: r };
}, {}), Ho = "Switch", [og, Ux] = Gf(Ho), [ig, ag] = og(Ho), Wu = s.forwardRef(
  (e, n) => {
    const {
      __scopeSwitch: r,
      name: o,
      checked: i,
      defaultChecked: t,
      required: a,
      disabled: l,
      value: u = "on",
      onCheckedChange: c,
      form: p,
      ..._
    } = e, [g, f] = s.useState(null), m = Wf(n, (b) => f(b)), h = s.useRef(!1), v = g ? p || !!g.closest("form") : !0, [w = !1, y] = Uf({
      prop: i,
      defaultProp: t,
      onChange: c
    });
    return /* @__PURE__ */ C(ig, { scope: r, checked: w, disabled: l, children: [
      /* @__PURE__ */ d(
        Bu.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": w,
          "aria-required": a,
          "data-state": Uu(w),
          "data-disabled": l ? "" : void 0,
          disabled: l,
          value: u,
          ..._,
          ref: m,
          onClick: Bf(e.onClick, (b) => {
            y(($) => !$), v && (h.current = b.isPropagationStopped(), h.current || b.stopPropagation());
          })
        }
      ),
      v && /* @__PURE__ */ d(
        lg,
        {
          control: g,
          bubbles: !h.current,
          name: o,
          value: u,
          checked: w,
          required: a,
          disabled: l,
          form: p,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
Wu.displayName = Ho;
var Gu = "SwitchThumb", Zu = s.forwardRef(
  (e, n) => {
    const { __scopeSwitch: r, ...o } = e, i = ag(Gu, r);
    return /* @__PURE__ */ d(
      Bu.span,
      {
        "data-state": Uu(i.checked),
        "data-disabled": i.disabled ? "" : void 0,
        ...o,
        ref: n
      }
    );
  }
);
Zu.displayName = Gu;
var lg = (e) => {
  const { control: n, checked: r, bubbles: o = !0, ...i } = e, t = s.useRef(null), a = Yf(r), l = Jf(n);
  return s.useEffect(() => {
    const u = t.current, c = window.HTMLInputElement.prototype, p = Object.getOwnPropertyDescriptor(c, "checked").set;
    if (a !== r && p) {
      const _ = new Event("click", { bubbles: o });
      p.call(u, r), u.dispatchEvent(_);
    }
  }, [a, r, o]), /* @__PURE__ */ d(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: r,
      ...i,
      tabIndex: -1,
      ref: t,
      style: {
        ...e.style,
        ...l,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function Uu(e) {
  return e ? "checked" : "unchecked";
}
var ug = Wu, sg = Zu;
function cg(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Li = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var ji;
function pg() {
  return ji || (ji = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o(l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(null, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(Li)), Li.exports;
}
var dg = pg();
const On = /* @__PURE__ */ cg(dg), Ii = (e) => e && "touches" in e, fg = ({
  children: e,
  disabled: n,
  onStart: r,
  onDrag: o,
  onStop: i,
  bounds: t,
  position: a,
  style: l
}) => {
  const [u, c] = j(void 0), [p, _] = j(void 0), [g, f] = j(!1), m = (w) => {
    if (!n) {
      w.preventDefault();
      const y = Ii(w.nativeEvent) ? w.nativeEvent.touches[0].clientX : w.nativeEvent.clientX;
      _(y), r == null || r();
    }
  }, h = ao(
    (w) => {
      if (typeof p != "number")
        return;
      const y = (Ii(w) ? w.touches[0].clientX : w.clientX) - p;
      if (!y)
        return;
      const b = a + y;
      !g && Math.abs(b) && f(!0);
      const $ = b > t.right ? t.right : b < t.left ? t.left : b;
      c($), o == null || o({ x: $ });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [o, c, g, p]
  ), v = ao(() => {
    _(void 0), c(void 0), f(!1), i == null || i();
  }, [i, _]);
  return le(() => (window.addEventListener("mousemove", h), window.addEventListener("touchmove", h), () => {
    window.removeEventListener("mousemove", h), window.removeEventListener("touchmove", h);
  }), [h]), le(() => (window.addEventListener("mouseup", v), window.addEventListener("touchend", v), () => {
    window.removeEventListener("mouseup", v), window.removeEventListener("touchend", v);
  }), [v]), jp(e) ? Lp(e, {
    onMouseDown: m,
    onTouchStart: m,
    style: { ...l, transform: `translateX(${g ? u : a}px)` }
  }) : null;
}, Vi = {
  width: void 0,
  height: void 0
};
function zi(e) {
  const { ref: n, box: r = "content-box", round: o } = e, [{ width: i, height: t }, a] = j(Vi), l = gg(), u = ue({ ...Vi }), c = ue(void 0);
  return c.current = e.onResize, le(() => {
    if (!n.current || typeof window > "u" || !("ResizeObserver" in window))
      return;
    const p = new ResizeObserver(([_]) => {
      const g = r === "border-box" ? "borderBoxSize" : r === "device-pixel-content-box" ? "devicePixelContentBoxSize" : "contentBoxSize", f = qi(_, g, "inlineSize"), m = qi(_, g, "blockSize");
      if (u.current.width !== f || u.current.height !== m) {
        const h = {
          width: f && o ? Math.round(f) : f,
          height: m && o ? Math.round(m) : m
        };
        u.current.width = f, u.current.height = m, c.current ? c.current(h) : l() && a(h);
      }
    });
    return p.observe(n.current, { box: r }), () => {
      p.disconnect();
    };
  }, [r, n, l, o]), { width: i, height: t };
}
function qi(e, n, r) {
  return e[n] ? Array.isArray(e[n]) ? e[n][0][r] : (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore Support Firefox's non-standard behavior
    e[n][r]
  ) : n === "contentBoxSize" ? e.contentRect[r === "inlineSize" ? "width" : "height"] : void 0;
}
function gg() {
  const e = ue(!1);
  return le(() => (e.current = !0, () => {
    e.current = !1;
  }), []), ao(() => e.current, []);
}
const _g = ({ checked: e, onChange: n }) => {
  const r = ue(null), o = ue(null), [i, t] = j(void 0), [a, l] = j(!1), [u, c] = j(0), { height: p = 0 } = zi({ ref: o, round: !0 }), { height: _ = 0 } = zi({ ref: r, round: !0 }), g = (_ || 0) - p, f = p + g, m = g / 2, h = f / 2, v = typeof i == "number" && (e ? i < h : i > h);
  return {
    trackRef: r,
    thumbRef: o,
    isDragging: a,
    bounds: { left: m, right: f },
    position: e ? f : m,
    onDrag: ({ x: w }) => {
      t(w), Math.abs((e ? f : m) - w) > 2 && l(!0);
    },
    onStop: () => {
      l(!1), a && c(Date.now()), v && (n == null || n(!e));
    },
    onChangeWithDrag: () => {
      Date.now() - u > 50 && (n == null || n(!e)), t(void 0);
    }
  };
}, Ce = {
  "purpur-toggle": "_purpur-toggle_1xng6_1",
  "purpur-toggle__track": "_purpur-toggle__track_1xng6_7",
  "purpur-toggle__checkmark-container": "_purpur-toggle__checkmark-container_1xng6_45",
  "purpur-toggle__thumb": "_purpur-toggle__thumb_1xng6_60",
  "purpur-toggle__thumb--dragging": "_purpur-toggle__thumb--dragging_1xng6_80",
  "purpur-toggle__checkmark": "_purpur-toggle__checkmark_1xng6_45",
  "purpur-toggle__label--right": "_purpur-toggle__label--right_1xng6_100",
  "purpur-toggle__label--left": "_purpur-toggle__label--left_1xng6_103",
  "purpur-toggle__container": "_purpur-toggle__container_1xng6_106"
}, Re = "purpur-toggle", hg = ({
  ["data-testid"]: e,
  className: n,
  label: r,
  onChange: o,
  labelPosition: i = "right",
  checked: t,
  disableDrag: a,
  defaultChecked: l,
  ...u
}, c) => {
  const [p, _] = j(
    typeof t == "boolean" ? t : !!l
  ), g = !!(typeof t == "boolean" ? t : p), { thumbRef: f, trackRef: m, isDragging: h, onChangeWithDrag: v, ...w } = _g({
    checked: g,
    onChange: (b) => {
      u.disabled || (o == null || o(b), _(b));
    }
  }), y = () => /* @__PURE__ */ d(
    jf,
    {
      htmlFor: u.id,
      "data-testid": e && `${e}-label`,
      disabled: u.disabled,
      className: On(
        Ce[`${Re}__label`],
        Ce[`${Re}__label--${i}`]
      ),
      children: /* @__PURE__ */ d(Vu, { disabled: u.disabled, children: r })
    }
  );
  return /* @__PURE__ */ C("div", { className: On([n, Ce[`${Re}__container`]]), children: [
    r && i === "left" && y(),
    /* @__PURE__ */ d(
      ug,
      {
        ...u,
        ref: c,
        id: u.id,
        "data-testid": e,
        className: Ce[Re],
        onCheckedChange: v,
        checked: g,
        children: /* @__PURE__ */ C("span", { ref: m, className: Ce[`${Re}__track`], children: [
          /* @__PURE__ */ d("span", { className: Ce[`${Re}__checkmark-container`], children: /* @__PURE__ */ d(
            Lu,
            {
              className: Ce[`${Re}__checkmark`],
              svg: Sf,
              size: "xxs"
            }
          ) }),
          /* @__PURE__ */ d(fg, { disabled: a, ...w, children: /* @__PURE__ */ d(
            sg,
            {
              ref: f,
              "data-testid": e && `${e}-thumb`,
              className: On([
                Ce[`${Re}__thumb`],
                {
                  [Ce[`${Re}__thumb--dragging`]]: h
                }
              ])
            }
          ) })
        ] })
      }
    ),
    r && i === "right" && y()
  ] });
}, nn = W(hg);
nn.displayName = "Toggle";
const Hr = {
  "purpur-table-action-bar": "_purpur-table-action-bar_1gs9x_1",
  "purpur-table-action-bar--is-visible": "_purpur-table-action-bar--is-visible_1gs9x_20",
  "purpur-table-action-bar__selected-wrapper": "_purpur-table-action-bar__selected-wrapper_1gs9x_24",
  "purpur-table-action-bar__button-group": "_purpur-table-action-bar__button-group_1gs9x_33",
  "purpur-table-action-bar__primary-secondary-buttons": "_purpur-table-action-bar__primary-secondary-buttons_1gs9x_42"
}, mg = "64em", vg = {
  MAX_LG: `(max-width: ${mg})`
}, wg = () => {
  const [e, n] = j(!1);
  return Cu(() => {
    const r = window.matchMedia(vg.MAX_LG);
    function o() {
      n(r.matches);
    }
    return window.addEventListener("resize", o), o(), () => window.removeEventListener("resize", o);
  }, []), { isLgOrSmaller: e };
}, Ut = "purpur-table-action-bar", Or = z.bind(Hr), ft = "purpur-table-action-bar", yg = ({
  rowCount: e,
  selectedRowsCount: n,
  copy: r,
  isVisible: o,
  onCancelSelection: i,
  onToggleSelected: t,
  onPrimaryButtonClick: a,
  onSecondaryButtonClick: l
}) => {
  const { isLgOrSmaller: u } = wg(), c = Ft();
  return /* @__PURE__ */ C(
    "div",
    {
      "data-testid": ft,
      className: Or(Ut, { [`${Ut}--is-visible`]: o }),
      children: [
        /* @__PURE__ */ C("div", { className: Or(Hr[`${Ut}__selected-wrapper`]), children: [
          /* @__PURE__ */ C(se, { "data-testid": `${ft}-selected-text`, children: [
            /* @__PURE__ */ d("span", { children: n }),
            " ",
            r.selectedRowsCount.of,
            " ",
            e,
            " ",
            r.selectedRowsCount.selected
          ] }),
          /* @__PURE__ */ d(
            nn,
            {
              "data-testid": `${ft}-toggle-selected`,
              id: `${c}-toggle-selected`,
              label: r.buttons.toggleSelected,
              onChange: t
            }
          )
        ] }),
        /* @__PURE__ */ C("div", { className: Or(Hr[`${Ut}__button-group`]), children: [
          /* @__PURE__ */ d(
            re,
            {
              "data-testid": `${ft}-cancel-button`,
              variant: "tertiary-purple",
              fullWidth: u,
              onClick: i,
              children: r.buttons.cancel
            }
          ),
          /* @__PURE__ */ C("div", { className: Or(Hr[`${Ut}__primary-secondary-buttons`]), children: [
            l && r.buttons.secondary && /* @__PURE__ */ d(
              re,
              {
                "data-testid": `${ft}-secondary-button`,
                variant: "secondary",
                fullWidth: u,
                onClick: l,
                children: r.buttons.secondary
              }
            ),
            a && r.buttons.primary && /* @__PURE__ */ d(
              re,
              {
                "data-testid": `${ft}-primary-button`,
                variant: "primary",
                fullWidth: u,
                onClick: a,
                children: r.buttons.primary
              }
            )
          ] })
        ] })
      ]
    }
  );
}, bg = z.bind(G), $g = "purpur-table-body", xg = ({ children: e, className: n, ...r }) => {
  const o = bg([n, $g]);
  return /* @__PURE__ */ d("tbody", { className: o, ...r, children: e });
};
function Sg(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Hi = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Bi;
function Cg() {
  return Bi || (Bi = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o.call(this, l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return this && this[t] || t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(this, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, this && this[l] || l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(Hi)), Hi.exports;
}
var Rg = Cg();
const Eg = /* @__PURE__ */ Sg(Rg), Ng = {
  "purpur-icon": "_purpur-icon_8u1lq_1",
  "purpur-icon--xxs": "_purpur-icon--xxs_8u1lq_4",
  "purpur-icon--xs": "_purpur-icon--xs_8u1lq_8",
  "purpur-icon--sm": "_purpur-icon--sm_8u1lq_12",
  "purpur-icon--md": "_purpur-icon--md_8u1lq_16",
  "purpur-icon--lg": "_purpur-icon--lg_8u1lq_20",
  "purpur-icon--xl": "_purpur-icon--xl_8u1lq_24"
}, Pg = Eg.bind(Ng), Wi = "purpur-icon", kg = "md", Og = (e) => e.filter((n) => Object.keys(n).length >= 1).map((n) => `${n.name}="${n.value}"`).join(" "), Ag = ({ content: e = "", title: n } = {}) => {
  const r = [
    { name: "xmlns", value: "http://www.w3.org/2000/svg" },
    { name: "fill", value: "currentColor" },
    { name: "viewBox", value: "0 0 24 24" },
    n ? { name: "role", value: "img" } : { name: "aria-hidden", value: "true" }
  ], o = n ? `<title>${n}</title>` : "";
  return `<svg ${Og(r)}>${o}${e}</svg>`;
}, Mg = (e) => e.replace(/<(\/?)svg([^>]*)>/g, "").trim(), Xu = ({
  ["data-testid"]: e,
  svg: n,
  allyTitle: r,
  className: o,
  size: i = kg,
  ...t
}) => {
  const a = Ag({
    content: Mg(n.svg),
    title: r
  }), l = Pg(o, Wi, `${Wi}--${i}`);
  return /* @__PURE__ */ d(
    "span",
    {
      className: l,
      "data-testid": e,
      dangerouslySetInnerHTML: { __html: a },
      ...t
    }
  );
};
Xu.displayName = "Icon";
const Fg = {
  name: "error-filled",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 24" fill="currentColor"><path fill-rule="evenodd" d="M14.268 3.5c-.77-1.333-2.694-1.333-3.464 0l-8.66 15c-.77 1.333.192 3 1.732 3h17.32c1.54 0 2.502-1.667 1.733-3l-8.66-15Zm-.694 5.067-.247 6.876h-1.566l-.247-6.876a1.03 1.03 0 1 1 2.06 0Zm.212 8.917c0 .649-.585 1.234-1.25 1.234-.648 0-1.25-.585-1.25-1.234 0-.633.602-1.234 1.25-1.234.665 0 1.25.601 1.25 1.234Z" clip-rule="evenodd"/></svg>',
  keywords: ["error-filled"],
  category: "status"
};
function Dg(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Gi = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Zi;
function Tg() {
  return Zi || (Zi = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o(l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(null, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(Gi)), Gi.exports;
}
var Lg = Tg();
const jg = /* @__PURE__ */ Dg(Lg), Ui = {
  "purpur-field-error-text": "_purpur-field-error-text_1lj7e_1",
  "purpur-field-error-text__icon": "_purpur-field-error-text__icon_1lj7e_11"
}, Xi = "purpur-field-error-text", Ig = ({
  children: e,
  className: n,
  ["aria-relevant"]: r = "additions text",
  ...o
}) => /* @__PURE__ */ C(
  "div",
  {
    className: jg([n, Ui[Xi]]),
    "aria-live": "assertive",
    "aria-relevant": r,
    ...o,
    children: [
      /* @__PURE__ */ d(Xu, { svg: Fg, size: "xs", className: Ui[`${Xi}__icon`] }),
      e
    ]
  }
);
function Vg(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Yi = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Ki;
function zg() {
  return Ki || (Ki = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o.call(this, l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return this && this[t] || t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(this, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, this && this[l] || l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(Yi)), Yi.exports;
}
var qg = zg();
const Hg = /* @__PURE__ */ Vg(qg), Bg = {
  "purpur-icon": "_purpur-icon_8u1lq_1",
  "purpur-icon--xxs": "_purpur-icon--xxs_8u1lq_4",
  "purpur-icon--xs": "_purpur-icon--xs_8u1lq_8",
  "purpur-icon--sm": "_purpur-icon--sm_8u1lq_12",
  "purpur-icon--md": "_purpur-icon--md_8u1lq_16",
  "purpur-icon--lg": "_purpur-icon--lg_8u1lq_20",
  "purpur-icon--xl": "_purpur-icon--xl_8u1lq_24"
}, Wg = Hg.bind(Bg), Ji = "purpur-icon", Gg = "md", Zg = (e) => e.filter((n) => Object.keys(n).length >= 1).map((n) => `${n.name}="${n.value}"`).join(" "), Ug = ({ content: e = "", title: n } = {}) => {
  const r = [
    { name: "xmlns", value: "http://www.w3.org/2000/svg" },
    { name: "fill", value: "currentColor" },
    { name: "viewBox", value: "0 0 24 24" },
    n ? { name: "role", value: "img" } : { name: "aria-hidden", value: "true" }
  ], o = n ? `<title>${n}</title>` : "";
  return `<svg ${Zg(r)}>${o}${e}</svg>`;
}, Xg = (e) => e.replace(/<(\/?)svg([^>]*)>/g, "").trim(), _o = ({
  ["data-testid"]: e,
  svg: n,
  allyTitle: r,
  className: o,
  size: i = Gg,
  ...t
}) => {
  const a = Ug({
    content: Xg(n.svg),
    title: r
  }), l = Wg(o, Ji, `${Ji}--${i}`);
  return /* @__PURE__ */ d(
    "span",
    {
      className: l,
      "data-testid": e,
      dangerouslySetInnerHTML: { __html: a },
      ...t
    }
  );
};
_o.displayName = "Icon";
const Yg = {
  name: "checkmark-bold",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M21.243 4.176a2 2 0 0 1 .324 2.81l-10.45 13.176a2.092 2.092 0 0 1-3.118.18l-5.413-5.413A2 2 0 1 1 5.414 12.1l3.9 3.9 9.118-11.5a2 2 0 0 1 2.81-.324Z" clip-rule="evenodd"/></svg>',
  keywords: ["checkmark-bold"],
  category: "utility"
}, Kg = {
  name: "minus-bold",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M3 12c0-1.105.711-2 1.588-2h14.824c.877 0 1.588.895 1.588 2s-.711 2-1.588 2H4.588C3.711 14 3 13.105 3 12Z" clip-rule="evenodd"/></svg>',
  keywords: ["minus-bold"],
  category: "utility"
};
function Qi(e, n) {
  if (typeof e == "function")
    return e(n);
  e != null && (e.current = n);
}
function Jg(...e) {
  return (n) => {
    let r = !1;
    const o = e.map((i) => {
      const t = Qi(i, n);
      return !r && typeof t == "function" && (r = !0), t;
    });
    if (r)
      return () => {
        for (let i = 0; i < o.length; i++) {
          const t = o[i];
          typeof t == "function" ? t() : Qi(e[i], null);
        }
      };
  };
}
var Yu = s.forwardRef((e, n) => {
  const { children: r, ...o } = e, i = s.Children.toArray(r), t = i.find(e_);
  if (t) {
    const a = t.props.children, l = i.map((u) => u === t ? s.Children.count(a) > 1 ? s.Children.only(null) : s.isValidElement(a) ? a.props.children : null : u);
    return /* @__PURE__ */ d(ho, { ...o, ref: n, children: s.isValidElement(a) ? s.cloneElement(a, void 0, l) : null });
  }
  return /* @__PURE__ */ d(ho, { ...o, ref: n, children: r });
});
Yu.displayName = "Slot";
var ho = s.forwardRef((e, n) => {
  const { children: r, ...o } = e;
  if (s.isValidElement(r)) {
    const i = r_(r), t = t_(o, r.props);
    return r.type !== s.Fragment && (t.ref = n ? Jg(n, i) : i), s.cloneElement(r, t);
  }
  return s.Children.count(r) > 1 ? s.Children.only(null) : null;
});
ho.displayName = "SlotClone";
var Qg = ({ children: e }) => /* @__PURE__ */ d(q, { children: e });
function e_(e) {
  return s.isValidElement(e) && e.type === Qg;
}
function t_(e, n) {
  const r = { ...n };
  for (const o in n) {
    const i = e[o], t = n[o];
    /^on[A-Z]/.test(o) ? i && t ? r[o] = (...a) => {
      t(...a), i(...a);
    } : i && (r[o] = i) : o === "style" ? r[o] = { ...i, ...t } : o === "className" && (r[o] = [i, t].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function r_(e) {
  var n, r;
  let o = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, i = o && "isReactWarning" in o && o.isReactWarning;
  return i ? e.ref : (o = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, i = o && "isReactWarning" in o && o.isReactWarning, i ? e.props.ref : e.props.ref || e.ref);
}
var n_ = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], o_ = n_.reduce((e, n) => {
  const r = s.forwardRef((o, i) => {
    const { asChild: t, ...a } = o, l = t ? Yu : n;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ d(l, { ...a, ref: i });
  });
  return r.displayName = `Primitive.${n}`, { ...e, [n]: r };
}, {}), i_ = "Label", Ku = s.forwardRef((e, n) => /* @__PURE__ */ d(
  o_.label,
  {
    ...e,
    ref: n,
    onMouseDown: (r) => {
      var o;
      r.target.closest("button, input, select, textarea") || ((o = e.onMouseDown) == null || o.call(e, r), !r.defaultPrevented && r.detail > 1 && r.preventDefault());
    }
  }
));
Ku.displayName = i_;
var a_ = Ku;
function l_(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ea = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var ta;
function u_() {
  return ta || (ta = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o(l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(null, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(ea)), ea.exports;
}
var s_ = u_();
const c_ = /* @__PURE__ */ l_(s_), An = {
  "purpur-label": "_purpur-label_1jndl_1",
  "purpur-label--negative": "_purpur-label--negative_1jndl_8",
  "purpur-label--disabled": "_purpur-label--disabled_1jndl_11"
}, Mn = "purpur-label", p_ = ({
  children: e,
  className: n,
  disabled: r,
  negative: o = !1,
  ...i
}) => {
  const t = c_([
    n,
    An[Mn],
    {
      [An[`${Mn}--disabled`]]: r,
      [An[`${Mn}--negative`]]: o
    }
  ]);
  return /* @__PURE__ */ d(a_, { className: t, ...i, children: e });
};
function d_(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ra = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var na;
function f_() {
  return na || (na = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o(l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(null, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(ra)), ra.exports;
}
var g_ = f_();
const __ = /* @__PURE__ */ d_(g_), Xt = {
  "purpur-paragraph": "_purpur-paragraph_1rh57_1",
  "purpur-paragraph--disabled": "_purpur-paragraph--disabled_1rh57_7",
  "purpur-paragraph--hyphens": "_purpur-paragraph--hyphens_1rh57_10",
  "purpur-paragraph--negative": "_purpur-paragraph--negative_1rh57_13",
  "purpur-paragraph--paragraph-100": "_purpur-paragraph--paragraph-100_1rh57_16",
  "purpur-paragraph--paragraph-100-medium": "_purpur-paragraph--paragraph-100-medium_1rh57_22",
  "purpur-paragraph--paragraph-100-bold": "_purpur-paragraph--paragraph-100-bold_1rh57_29",
  "purpur-paragraph--paragraph-200": "_purpur-paragraph--paragraph-200_1rh57_36",
  "purpur-paragraph--preamble-100": "_purpur-paragraph--preamble-100_1rh57_42",
  "purpur-paragraph--preamble-200": "_purpur-paragraph--preamble-200_1rh57_48",
  "purpur-paragraph--additional-100": "_purpur-paragraph--additional-100_1rh57_54",
  "purpur-paragraph--additional-100-medium": "_purpur-paragraph--additional-100-medium_1rh57_60",
  "purpur-paragraph--overline-100": "_purpur-paragraph--overline-100_1rh57_67",
  "purpur-paragraph--overline-200": "_purpur-paragraph--overline-200_1rh57_75"
}, h_ = {
  PARAGRAPH100: "paragraph-100"
}, Yt = "purpur-paragraph", Ju = ({
  ["data-testid"]: e,
  children: n,
  className: r,
  disabled: o,
  enableHyphenation: i = !1,
  negative: t = !1,
  variant: a = h_.PARAGRAPH100,
  ...l
}) => {
  const u = __([
    r,
    Xt[Yt],
    Xt[`${Yt}--${a}`],
    {
      [Xt[`${Yt}--hyphens`]]: i,
      [Xt[`${Yt}--disabled`]]: o,
      [Xt[`${Yt}--negative`]]: t
    }
  ]);
  return /* @__PURE__ */ d("p", { ...l, className: u, "data-testid": e, children: n });
};
Ju.displayName = "Paragraph";
function oa(e, n) {
  if (typeof e == "function")
    return e(n);
  e != null && (e.current = n);
}
function Qu(...e) {
  return (n) => {
    let r = !1;
    const o = e.map((i) => {
      const t = oa(i, n);
      return !r && typeof t == "function" && (r = !0), t;
    });
    if (r)
      return () => {
        for (let i = 0; i < o.length; i++) {
          const t = o[i];
          typeof t == "function" ? t() : oa(e[i], null);
        }
      };
  };
}
function es(...e) {
  return s.useCallback(Qu(...e), e);
}
function m_(e, n = []) {
  let r = [];
  function o(t, a) {
    const l = s.createContext(a), u = r.length;
    r = [...r, a];
    const c = (_) => {
      var g;
      const { scope: f, children: m, ...h } = _, v = ((g = f == null ? void 0 : f[e]) == null ? void 0 : g[u]) || l, w = s.useMemo(() => h, Object.values(h));
      return /* @__PURE__ */ d(v.Provider, { value: w, children: m });
    };
    c.displayName = t + "Provider";
    function p(_, g) {
      var f;
      const m = ((f = g == null ? void 0 : g[e]) == null ? void 0 : f[u]) || l, h = s.useContext(m);
      if (h) return h;
      if (a !== void 0) return a;
      throw new Error(`\`${_}\` must be used within \`${t}\``);
    }
    return [c, p];
  }
  const i = () => {
    const t = r.map((a) => s.createContext(a));
    return function(a) {
      const l = (a == null ? void 0 : a[e]) || t;
      return s.useMemo(
        () => ({ [`__scope${e}`]: { ...a, [e]: l } }),
        [a, l]
      );
    };
  };
  return i.scopeName = e, [o, v_(i, ...n)];
}
function v_(...e) {
  const n = e[0];
  if (e.length === 1) return n;
  const r = () => {
    const o = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(i) {
      const t = o.reduce((a, { useScope: l, scopeName: u }) => {
        const c = l(i)[`__scope${u}`];
        return { ...a, ...c };
      }, {});
      return s.useMemo(() => ({ [`__scope${n.scopeName}`]: t }), [t]);
    };
  };
  return r.scopeName = n.scopeName, r;
}
function ia(e, n, { checkForDefaultPrevented: r = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), r === !1 || !o.defaultPrevented)
      return n == null ? void 0 : n(o);
  };
}
function ts(e) {
  const n = s.useRef(e);
  return s.useEffect(() => {
    n.current = e;
  }), s.useMemo(() => (...r) => {
    var o;
    return (o = n.current) == null ? void 0 : o.call(n, ...r);
  }, []);
}
function w_({
  prop: e,
  defaultProp: n,
  onChange: r = () => {
  }
}) {
  const [o, i] = y_({ defaultProp: n, onChange: r }), t = e !== void 0, a = t ? e : o, l = ts(r), u = s.useCallback(
    (c) => {
      if (t) {
        const p = typeof c == "function" ? c(e) : c;
        p !== e && l(p);
      } else
        i(c);
    },
    [t, e, i, l]
  );
  return [a, u];
}
function y_({
  defaultProp: e,
  onChange: n
}) {
  const r = s.useState(e), [o] = r, i = s.useRef(o), t = ts(n);
  return s.useEffect(() => {
    i.current !== o && (t(o), i.current = o);
  }, [o, i, t]), r;
}
function b_(e) {
  const n = s.useRef({ value: e, previous: e });
  return s.useMemo(() => (n.current.value !== e && (n.current.previous = n.current.value, n.current.value = e), n.current.previous), [e]);
}
var mo = globalThis != null && globalThis.document ? s.useLayoutEffect : () => {
};
function $_(e) {
  const [n, r] = s.useState(void 0);
  return mo(() => {
    if (e) {
      r({ width: e.offsetWidth, height: e.offsetHeight });
      const o = new ResizeObserver((i) => {
        if (!Array.isArray(i) || !i.length)
          return;
        const t = i[0];
        let a, l;
        if ("borderBoxSize" in t) {
          const u = t.borderBoxSize, c = Array.isArray(u) ? u[0] : u;
          a = c.inlineSize, l = c.blockSize;
        } else
          a = e.offsetWidth, l = e.offsetHeight;
        r({ width: a, height: l });
      });
      return o.observe(e, { box: "border-box" }), () => o.unobserve(e);
    } else
      r(void 0);
  }, [e]), n;
}
function x_(e, n) {
  return s.useReducer((r, o) => n[r][o] ?? r, e);
}
var rs = (e) => {
  const { present: n, children: r } = e, o = S_(n), i = typeof r == "function" ? r({ present: o.isPresent }) : s.Children.only(r), t = es(o.ref, C_(i));
  return typeof r == "function" || o.isPresent ? s.cloneElement(i, { ref: t }) : null;
};
rs.displayName = "Presence";
function S_(e) {
  const [n, r] = s.useState(), o = s.useRef({}), i = s.useRef(e), t = s.useRef("none"), a = e ? "mounted" : "unmounted", [l, u] = x_(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return s.useEffect(() => {
    const c = Ar(o.current);
    t.current = l === "mounted" ? c : "none";
  }, [l]), mo(() => {
    const c = o.current, p = i.current;
    if (p !== e) {
      const _ = t.current, g = Ar(c);
      e ? u("MOUNT") : g === "none" || (c == null ? void 0 : c.display) === "none" ? u("UNMOUNT") : u(p && _ !== g ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
    }
  }, [e, u]), mo(() => {
    if (n) {
      let c;
      const p = n.ownerDocument.defaultView ?? window, _ = (f) => {
        const m = Ar(o.current).includes(f.animationName);
        if (f.target === n && m && (u("ANIMATION_END"), !i.current)) {
          const h = n.style.animationFillMode;
          n.style.animationFillMode = "forwards", c = p.setTimeout(() => {
            n.style.animationFillMode === "forwards" && (n.style.animationFillMode = h);
          });
        }
      }, g = (f) => {
        f.target === n && (t.current = Ar(o.current));
      };
      return n.addEventListener("animationstart", g), n.addEventListener("animationcancel", _), n.addEventListener("animationend", _), () => {
        p.clearTimeout(c), n.removeEventListener("animationstart", g), n.removeEventListener("animationcancel", _), n.removeEventListener("animationend", _);
      };
    } else
      u("ANIMATION_END");
  }, [n, u]), {
    isPresent: ["mounted", "unmountSuspended"].includes(l),
    ref: s.useCallback((c) => {
      c && (o.current = getComputedStyle(c)), r(c);
    }, [])
  };
}
function Ar(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function C_(e) {
  var n, r;
  let o = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, i = o && "isReactWarning" in o && o.isReactWarning;
  return i ? e.ref : (o = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, i = o && "isReactWarning" in o && o.isReactWarning, i ? e.props.ref : e.props.ref || e.ref);
}
var ns = s.forwardRef((e, n) => {
  const { children: r, ...o } = e, i = s.Children.toArray(r), t = i.find(E_);
  if (t) {
    const a = t.props.children, l = i.map((u) => u === t ? s.Children.count(a) > 1 ? s.Children.only(null) : s.isValidElement(a) ? a.props.children : null : u);
    return /* @__PURE__ */ d(vo, { ...o, ref: n, children: s.isValidElement(a) ? s.cloneElement(a, void 0, l) : null });
  }
  return /* @__PURE__ */ d(vo, { ...o, ref: n, children: r });
});
ns.displayName = "Slot";
var vo = s.forwardRef((e, n) => {
  const { children: r, ...o } = e;
  if (s.isValidElement(r)) {
    const i = P_(r), t = N_(o, r.props);
    return r.type !== s.Fragment && (t.ref = n ? Qu(n, i) : i), s.cloneElement(r, t);
  }
  return s.Children.count(r) > 1 ? s.Children.only(null) : null;
});
vo.displayName = "SlotClone";
var R_ = ({ children: e }) => /* @__PURE__ */ d(q, { children: e });
function E_(e) {
  return s.isValidElement(e) && e.type === R_;
}
function N_(e, n) {
  const r = { ...n };
  for (const o in n) {
    const i = e[o], t = n[o];
    /^on[A-Z]/.test(o) ? i && t ? r[o] = (...a) => {
      t(...a), i(...a);
    } : i && (r[o] = i) : o === "style" ? r[o] = { ...i, ...t } : o === "className" && (r[o] = [i, t].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function P_(e) {
  var n, r;
  let o = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, i = o && "isReactWarning" in o && o.isReactWarning;
  return i ? e.ref : (o = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, i = o && "isReactWarning" in o && o.isReactWarning, i ? e.props.ref : e.props.ref || e.ref);
}
var k_ = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], os = k_.reduce((e, n) => {
  const r = s.forwardRef((o, i) => {
    const { asChild: t, ...a } = o, l = t ? ns : n;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ d(l, { ...a, ref: i });
  });
  return r.displayName = `Primitive.${n}`, { ...e, [n]: r };
}, {}), Bo = "Checkbox", [O_, Xx] = m_(Bo), [A_, M_] = O_(Bo), is = s.forwardRef(
  (e, n) => {
    const {
      __scopeCheckbox: r,
      name: o,
      checked: i,
      defaultChecked: t,
      required: a,
      disabled: l,
      value: u = "on",
      onCheckedChange: c,
      form: p,
      ..._
    } = e, [g, f] = s.useState(null), m = es(n, ($) => f($)), h = s.useRef(!1), v = g ? p || !!g.closest("form") : !0, [w = !1, y] = w_({
      prop: i,
      defaultProp: t,
      onChange: c
    }), b = s.useRef(w);
    return s.useEffect(() => {
      const $ = g == null ? void 0 : g.form;
      if ($) {
        const x = () => y(b.current);
        return $.addEventListener("reset", x), () => $.removeEventListener("reset", x);
      }
    }, [g, y]), /* @__PURE__ */ C(A_, { scope: r, state: w, disabled: l, children: [
      /* @__PURE__ */ d(
        os.button,
        {
          type: "button",
          role: "checkbox",
          "aria-checked": ze(w) ? "mixed" : w,
          "aria-required": a,
          "data-state": us(w),
          "data-disabled": l ? "" : void 0,
          disabled: l,
          value: u,
          ..._,
          ref: m,
          onKeyDown: ia(e.onKeyDown, ($) => {
            $.key === "Enter" && $.preventDefault();
          }),
          onClick: ia(e.onClick, ($) => {
            y((x) => ze(x) ? !0 : !x), v && (h.current = $.isPropagationStopped(), h.current || $.stopPropagation());
          })
        }
      ),
      v && /* @__PURE__ */ d(
        F_,
        {
          control: g,
          bubbles: !h.current,
          name: o,
          value: u,
          checked: w,
          required: a,
          disabled: l,
          form: p,
          style: { transform: "translateX(-100%)" },
          defaultChecked: ze(t) ? !1 : t
        }
      )
    ] });
  }
);
is.displayName = Bo;
var as = "CheckboxIndicator", ls = s.forwardRef(
  (e, n) => {
    const { __scopeCheckbox: r, forceMount: o, ...i } = e, t = M_(as, r);
    return /* @__PURE__ */ d(rs, { present: o || ze(t.state) || t.state === !0, children: /* @__PURE__ */ d(
      os.span,
      {
        "data-state": us(t.state),
        "data-disabled": t.disabled ? "" : void 0,
        ...i,
        ref: n,
        style: { pointerEvents: "none", ...e.style }
      }
    ) });
  }
);
ls.displayName = as;
var F_ = (e) => {
  const { control: n, checked: r, bubbles: o = !0, defaultChecked: i, ...t } = e, a = s.useRef(null), l = b_(r), u = $_(n);
  s.useEffect(() => {
    const p = a.current, _ = window.HTMLInputElement.prototype, g = Object.getOwnPropertyDescriptor(_, "checked").set;
    if (l !== r && g) {
      const f = new Event("click", { bubbles: o });
      p.indeterminate = ze(r), g.call(p, ze(r) ? !1 : r), p.dispatchEvent(f);
    }
  }, [l, r, o]);
  const c = s.useRef(ze(r) ? !1 : r);
  return /* @__PURE__ */ d(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: i ?? c.current,
      ...t,
      tabIndex: -1,
      ref: a,
      style: {
        ...e.style,
        ...u,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function ze(e) {
  return e === "indeterminate";
}
function us(e) {
  return ze(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
var D_ = is, T_ = ls;
function L_(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var aa = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var la;
function j_() {
  return la || (la = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o.call(this, l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return this && this[t] || t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(this, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, this && this[l] || l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(aa)), aa.exports;
}
var I_ = j_();
const V_ = /* @__PURE__ */ L_(I_), z_ = {
  "purpur-checkbox": "_purpur-checkbox_m4999_1",
  "purpur-checkbox__box": "_purpur-checkbox__box_m4999_7",
  "purpur-checkbox--error": "_purpur-checkbox--error_m4999_16",
  "purpur-checkbox--error-checkbox": "_purpur-checkbox--error-checkbox_m4999_16",
  "purpur-checkbox__indicator": "_purpur-checkbox__indicator_m4999_59",
  "purpur-checkbox__label": "_purpur-checkbox__label_m4999_70",
  "purpur-checkbox__wrapper": "_purpur-checkbox__wrapper_m4999_73",
  "purpur-checkbox__container": "_purpur-checkbox__container_m4999_79"
}, gt = V_.bind(z_), Te = "purpur-checkbox", q_ = ({
  ["data-testid"]: e,
  checked: n,
  className: r,
  error: o = !1,
  errorText: i,
  label: t,
  onChange: a,
  ...l
}, u) => {
  const c = i && !n, p = o && !n;
  return /* @__PURE__ */ C("div", { className: gt([r, `${Te}__wrapper`]), children: [
    /* @__PURE__ */ C("div", { className: gt([r, `${Te}__container`]), children: [
      /* @__PURE__ */ d(
        D_,
        {
          ...l,
          checked: n,
          className: gt([
            Te,
            {
              [`${Te}--error`]: c,
              [`${Te}--error-checkbox`]: p
            }
          ]),
          "data-testid": e,
          onCheckedChange: a,
          ref: u,
          children: /* @__PURE__ */ d("span", { className: gt(`${Te}__box`), children: /* @__PURE__ */ d(T_, { className: gt(`${Te}__indicator`), children: n === "indeterminate" ? /* @__PURE__ */ d(
            _o,
            {
              "data-testid": e && `${e}-checked-icon`,
              size: "xs",
              svg: Kg
            }
          ) : /* @__PURE__ */ d(
            _o,
            {
              "data-testid": e && `${e}-indeterminate-icon`,
              size: "xs",
              svg: Yg
            }
          ) }) })
        }
      ),
      t && /* @__PURE__ */ d(
        p_,
        {
          htmlFor: l.id,
          "data-testid": e && `${e}-label`,
          disabled: l.disabled,
          className: gt(`${Te}__label`),
          children: /* @__PURE__ */ C(Ju, { variant: "paragraph-100", disabled: l.disabled, children: [
            l.required && /* @__PURE__ */ d("span", { "aria-hidden": !0, children: "* " }),
            t
          ] })
        }
      )
    ] }),
    c && /* @__PURE__ */ d(Ig, { "data-testid": e && `${e}-error-text`, children: i })
  ] });
}, Wo = W(q_);
Wo.displayName = "Checkbox";
function H_(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ua = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var sa;
function B_() {
  return sa || (sa = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o.call(this, l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return this && this[t] || t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(this, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, this && this[l] || l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(ua)), ua.exports;
}
var W_ = B_();
const G_ = /* @__PURE__ */ H_(W_), Z_ = {
  "purpur-icon": "_purpur-icon_8u1lq_1",
  "purpur-icon--xxs": "_purpur-icon--xxs_8u1lq_4",
  "purpur-icon--xs": "_purpur-icon--xs_8u1lq_8",
  "purpur-icon--sm": "_purpur-icon--sm_8u1lq_12",
  "purpur-icon--md": "_purpur-icon--md_8u1lq_16",
  "purpur-icon--lg": "_purpur-icon--lg_8u1lq_20",
  "purpur-icon--xl": "_purpur-icon--xl_8u1lq_24"
}, U_ = G_.bind(Z_), ca = "purpur-icon", X_ = "md", Y_ = (e) => e.filter((n) => Object.keys(n).length >= 1).map((n) => `${n.name}="${n.value}"`).join(" "), K_ = ({ content: e = "", title: n } = {}) => {
  const r = [
    { name: "xmlns", value: "http://www.w3.org/2000/svg" },
    { name: "fill", value: "currentColor" },
    { name: "viewBox", value: "0 0 24 24" },
    n ? { name: "role", value: "img" } : { name: "aria-hidden", value: "true" }
  ], o = n ? `<title>${n}</title>` : "";
  return `<svg ${Y_(r)}>${o}${e}</svg>`;
}, J_ = (e) => e.replace(/<(\/?)svg([^>]*)>/g, "").trim(), $e = ({
  ["data-testid"]: e,
  svg: n,
  allyTitle: r,
  className: o,
  size: i = X_,
  ...t
}) => {
  const a = K_({
    content: J_(n.svg),
    title: r
  }), l = U_(o, ca, `${ca}--${i}`);
  return /* @__PURE__ */ d(
    "span",
    {
      className: l,
      "data-testid": e,
      dangerouslySetInnerHTML: { __html: a },
      ...t
    }
  );
};
$e.displayName = "Icon";
const Q_ = {
  name: "arrow-down",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M12 20.9a.9.9 0 0 1-.636-.264l-5.5-5.5a.9.9 0 1 1 1.272-1.272l3.964 3.963V4a.9.9 0 1 1 1.8 0v13.827l3.964-3.963a.9.9 0 0 1 1.272 1.272l-5.5 5.5A.9.9 0 0 1 12 20.9Z" clip-rule="evenodd"/></svg>',
  keywords: ["arrow-down"],
  category: "utility"
}, ss = (e) => /* @__PURE__ */ d($e, { ...e, svg: Q_ });
ss.displayName = "IconArrowDown";
const eh = {
  name: "arrow-up",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M11.364 3.364a.9.9 0 0 1 1.272 0l5.5 5.5a.9.9 0 1 1-1.272 1.272L12.9 6.173V20a.9.9 0 0 1-1.8 0V6.173l-3.964 3.963a.9.9 0 0 1-1.272-1.272l5.5-5.5Z" clip-rule="evenodd"/></svg>',
  keywords: ["arrow-up"],
  category: "utility"
}, cs = (e) => /* @__PURE__ */ d($e, { ...e, svg: eh });
cs.displayName = "IconArrowUp";
const th = {
  name: "sorter",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M17 3.1a.9.9 0 0 1 .636.264l4.5 4.5a.9.9 0 1 1-1.272 1.272L17.9 6.173V20a.9.9 0 0 1-1.8 0V6.173l-2.964 2.963a.9.9 0 0 1-1.272-1.272l4.5-4.5A.9.9 0 0 1 17 3.1Zm-10 0a.9.9 0 0 1 .9.9v13.827l2.964-2.963a.9.9 0 1 1 1.272 1.272l-4.5 4.5a.9.9 0 0 1-1.272 0l-4.5-4.5a.9.9 0 0 1 1.272-1.272L6.1 17.827V4a.9.9 0 0 1 .9-.9Z" clip-rule="evenodd"/></svg>',
  keywords: ["sorter"],
  category: "utility"
}, ps = (e) => /* @__PURE__ */ d($e, { ...e, svg: th });
ps.displayName = "IconSorter";
function rh(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var pa = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var da;
function nh() {
  return da || (da = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o.call(this, l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return this && this[t] || t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(this, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, this && this[l] || l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(pa)), pa.exports;
}
var oh = nh();
const ih = /* @__PURE__ */ rh(oh), ah = {
  "purpur-icon": "_purpur-icon_8u1lq_1",
  "purpur-icon--xxs": "_purpur-icon--xxs_8u1lq_4",
  "purpur-icon--xs": "_purpur-icon--xs_8u1lq_8",
  "purpur-icon--sm": "_purpur-icon--sm_8u1lq_12",
  "purpur-icon--md": "_purpur-icon--md_8u1lq_16",
  "purpur-icon--lg": "_purpur-icon--lg_8u1lq_20",
  "purpur-icon--xl": "_purpur-icon--xl_8u1lq_24"
}, lh = ih.bind(ah), fa = "purpur-icon", uh = "md", sh = (e) => e.filter((n) => Object.keys(n).length >= 1).map((n) => `${n.name}="${n.value}"`).join(" "), ch = ({ content: e = "", title: n } = {}) => {
  const r = [
    { name: "xmlns", value: "http://www.w3.org/2000/svg" },
    { name: "fill", value: "currentColor" },
    { name: "viewBox", value: "0 0 24 24" },
    n ? { name: "role", value: "img" } : { name: "aria-hidden", value: "true" }
  ], o = n ? `<title>${n}</title>` : "";
  return `<svg ${sh(r)}>${o}${e}</svg>`;
}, ph = (e) => e.replace(/<(\/?)svg([^>]*)>/g, "").trim(), ds = ({
  ["data-testid"]: e,
  svg: n,
  allyTitle: r,
  className: o,
  size: i = uh,
  ...t
}) => {
  const a = ch({
    content: ph(n.svg),
    title: r
  }), l = lh(o, fa, `${fa}--${i}`);
  return /* @__PURE__ */ d(
    "span",
    {
      className: l,
      "data-testid": e,
      dangerouslySetInnerHTML: { __html: a },
      ...t
    }
  );
};
ds.displayName = "Icon";
const dh = {
  name: "error-filled",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 24" fill="currentColor"><path fill-rule="evenodd" d="M14.268 3.5c-.77-1.333-2.694-1.333-3.464 0l-8.66 15c-.77 1.333.192 3 1.732 3h17.32c1.54 0 2.502-1.667 1.733-3l-8.66-15Zm-.694 5.067-.247 6.876h-1.566l-.247-6.876a1.03 1.03 0 1 1 2.06 0Zm.212 8.917c0 .649-.585 1.234-1.25 1.234-.648 0-1.25-.585-1.25-1.234 0-.633.602-1.234 1.25-1.234.665 0 1.25.601 1.25 1.234Z" clip-rule="evenodd"/></svg>',
  keywords: ["error-filled"],
  category: "status"
};
function fh(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ga = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var _a;
function gh() {
  return _a || (_a = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o(l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(null, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(ga)), ga.exports;
}
var _h = gh();
const hh = /* @__PURE__ */ fh(_h), ha = {
  "purpur-field-error-text": "_purpur-field-error-text_1lj7e_1",
  "purpur-field-error-text__icon": "_purpur-field-error-text__icon_1lj7e_11"
}, ma = "purpur-field-error-text", mh = ({
  children: e,
  className: n,
  ["aria-relevant"]: r = "additions text",
  ...o
}) => /* @__PURE__ */ C(
  "div",
  {
    className: hh([n, ha[ma]]),
    "aria-live": "assertive",
    "aria-relevant": r,
    ...o,
    children: [
      /* @__PURE__ */ d(ds, { svg: dh, size: "xs", className: ha[`${ma}__icon`] }),
      e
    ]
  }
);
function vh(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var va = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var wa;
function wh() {
  return wa || (wa = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o(l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(null, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(va)), va.exports;
}
var yh = wh();
const bh = /* @__PURE__ */ vh(yh), ya = {
  "purpur-field-helper-text": "_purpur-field-helper-text_atw6b_1",
  "purpur-field-helper-text--disabled": "_purpur-field-helper-text--disabled_atw6b_9"
}, ba = "purpur-field-helper-text", $h = ({
  children: e,
  className: n,
  disabled: r,
  id: o,
  ...i
}) => {
  const t = bh([
    n,
    ya[ba],
    {
      [ya[`${ba}--disabled`]]: r
    }
  ]);
  return /* @__PURE__ */ d("span", { id: o, className: t, ...i, children: e });
};
function xh(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var $a = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var xa;
function Sh() {
  return xa || (xa = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o.call(this, l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return this && this[t] || t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(this, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, this && this[l] || l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }($a)), $a.exports;
}
var Ch = Sh();
const Rh = /* @__PURE__ */ xh(Ch), Eh = {
  "purpur-icon": "_purpur-icon_8u1lq_1",
  "purpur-icon--xxs": "_purpur-icon--xxs_8u1lq_4",
  "purpur-icon--xs": "_purpur-icon--xs_8u1lq_8",
  "purpur-icon--sm": "_purpur-icon--sm_8u1lq_12",
  "purpur-icon--md": "_purpur-icon--md_8u1lq_16",
  "purpur-icon--lg": "_purpur-icon--lg_8u1lq_20",
  "purpur-icon--xl": "_purpur-icon--xl_8u1lq_24"
}, Nh = Rh.bind(Eh), Sa = "purpur-icon", Ph = "md", kh = (e) => e.filter((n) => Object.keys(n).length >= 1).map((n) => `${n.name}="${n.value}"`).join(" "), Oh = ({ content: e = "", title: n } = {}) => {
  const r = [
    { name: "xmlns", value: "http://www.w3.org/2000/svg" },
    { name: "fill", value: "currentColor" },
    { name: "viewBox", value: "0 0 24 24" },
    n ? { name: "role", value: "img" } : { name: "aria-hidden", value: "true" }
  ], o = n ? `<title>${n}</title>` : "";
  return `<svg ${kh(r)}>${o}${e}</svg>`;
}, Ah = (e) => e.replace(/<(\/?)svg([^>]*)>/g, "").trim(), Go = ({
  ["data-testid"]: e,
  svg: n,
  allyTitle: r,
  className: o,
  size: i = Ph,
  ...t
}) => {
  const a = Oh({
    content: Ah(n.svg),
    title: r
  }), l = Nh(o, Sa, `${Sa}--${i}`);
  return /* @__PURE__ */ d(
    "span",
    {
      className: l,
      "data-testid": e,
      dangerouslySetInnerHTML: { __html: a },
      ...t
    }
  );
};
Go.displayName = "Icon";
const Mh = {
  name: "check-circle-filled",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm4.712-12.491a.875.875 0 1 0-1.424-1.018l-4.4 6.16-2.27-2.27a.875.875 0 0 0-1.237 1.238l3 3a.875.875 0 0 0 1.331-.11l5-7Z" clip-rule="evenodd"/></svg>',
  keywords: ["check-circle-filled"],
  category: "status"
}, fs = (e) => /* @__PURE__ */ d(Go, { ...e, svg: Mh });
fs.displayName = "IconCheckCircleFilled";
const Fh = {
  name: "chevron-down",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M20.136 7.864a.9.9 0 0 0-1.272 0L12 14.727 5.136 7.864a.9.9 0 0 0-1.272 1.272l7.5 7.5a.9.9 0 0 0 1.272 0l7.5-7.5a.9.9 0 0 0 0-1.272Z" clip-rule="evenodd"/></svg>',
  keywords: ["chevron-down"],
  category: "utility"
}, gs = (e) => /* @__PURE__ */ d(Go, { ...e, svg: Fh });
gs.displayName = "IconChevronDown";
function Ca(e, n) {
  if (typeof e == "function")
    return e(n);
  e != null && (e.current = n);
}
function Dh(...e) {
  return (n) => {
    let r = !1;
    const o = e.map((i) => {
      const t = Ca(i, n);
      return !r && typeof t == "function" && (r = !0), t;
    });
    if (r)
      return () => {
        for (let i = 0; i < o.length; i++) {
          const t = o[i];
          typeof t == "function" ? t() : Ca(e[i], null);
        }
      };
  };
}
var _s = s.forwardRef((e, n) => {
  const { children: r, ...o } = e, i = s.Children.toArray(r), t = i.find(Lh);
  if (t) {
    const a = t.props.children, l = i.map((u) => u === t ? s.Children.count(a) > 1 ? s.Children.only(null) : s.isValidElement(a) ? a.props.children : null : u);
    return /* @__PURE__ */ d(wo, { ...o, ref: n, children: s.isValidElement(a) ? s.cloneElement(a, void 0, l) : null });
  }
  return /* @__PURE__ */ d(wo, { ...o, ref: n, children: r });
});
_s.displayName = "Slot";
var wo = s.forwardRef((e, n) => {
  const { children: r, ...o } = e;
  if (s.isValidElement(r)) {
    const i = Ih(r), t = jh(o, r.props);
    return r.type !== s.Fragment && (t.ref = n ? Dh(n, i) : i), s.cloneElement(r, t);
  }
  return s.Children.count(r) > 1 ? s.Children.only(null) : null;
});
wo.displayName = "SlotClone";
var Th = ({ children: e }) => /* @__PURE__ */ d(q, { children: e });
function Lh(e) {
  return s.isValidElement(e) && e.type === Th;
}
function jh(e, n) {
  const r = { ...n };
  for (const o in n) {
    const i = e[o], t = n[o];
    /^on[A-Z]/.test(o) ? i && t ? r[o] = (...a) => {
      t(...a), i(...a);
    } : i && (r[o] = i) : o === "style" ? r[o] = { ...i, ...t } : o === "className" && (r[o] = [i, t].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function Ih(e) {
  var n, r;
  let o = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, i = o && "isReactWarning" in o && o.isReactWarning;
  return i ? e.ref : (o = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, i = o && "isReactWarning" in o && o.isReactWarning, i ? e.props.ref : e.props.ref || e.ref);
}
var Vh = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], zh = Vh.reduce((e, n) => {
  const r = s.forwardRef((o, i) => {
    const { asChild: t, ...a } = o, l = t ? _s : n;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ d(l, { ...a, ref: i });
  });
  return r.displayName = `Primitive.${n}`, { ...e, [n]: r };
}, {}), qh = "Label", hs = s.forwardRef((e, n) => /* @__PURE__ */ d(
  zh.label,
  {
    ...e,
    ref: n,
    onMouseDown: (r) => {
      var o;
      r.target.closest("button, input, select, textarea") || ((o = e.onMouseDown) == null || o.call(e, r), !r.defaultPrevented && r.detail > 1 && r.preventDefault());
    }
  }
));
hs.displayName = qh;
var Hh = hs;
function Bh(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ra = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Ea;
function Wh() {
  return Ea || (Ea = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o(l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(null, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(Ra)), Ra.exports;
}
var Gh = Wh();
const Zh = /* @__PURE__ */ Bh(Gh), Fn = {
  "purpur-label": "_purpur-label_1jndl_1",
  "purpur-label--negative": "_purpur-label--negative_1jndl_8",
  "purpur-label--disabled": "_purpur-label--disabled_1jndl_11"
}, Dn = "purpur-label", Uh = ({
  children: e,
  className: n,
  disabled: r,
  negative: o = !1,
  ...i
}) => {
  const t = Zh([
    n,
    Fn[Dn],
    {
      [Fn[`${Dn}--disabled`]]: r,
      [Fn[`${Dn}--negative`]]: o
    }
  ]);
  return /* @__PURE__ */ d(Hh, { className: t, ...i, children: e });
};
function Xh(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Na = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Pa;
function Yh() {
  return Pa || (Pa = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o(l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(null, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(Na)), Na.exports;
}
var Kh = Yh();
const ka = /* @__PURE__ */ Xh(Kh), Jh = "_rotate_1xozj_1", Qh = "_dash_1xozj_1", Kt = {
  "purpur-spinner": "_purpur-spinner_1xozj_1",
  rotate: Jh,
  "purpur-spinner--xxs": "_purpur-spinner--xxs_1xozj_4",
  "purpur-spinner--xs": "_purpur-spinner--xs_1xozj_8",
  "purpur-spinner--sm": "_purpur-spinner--sm_1xozj_12",
  "purpur-spinner--md": "_purpur-spinner--md_1xozj_16",
  "purpur-spinner--lg": "_purpur-spinner--lg_1xozj_20",
  "purpur-spinner__circle": "_purpur-spinner__circle_1xozj_24",
  dash: Qh,
  "purpur-spinner__circle--disabled": "_purpur-spinner__circle--disabled_1xozj_33",
  "purpur-spinner__circle--negative": "_purpur-spinner__circle--negative_1xozj_36"
}, Jt = "purpur-spinner", em = {
  SM: "sm"
}, tm = ({
  ["data-testid"]: e,
  disabled: n = !1,
  negative: r = !1,
  size: o = em.SM,
  ...i
}) => /* @__PURE__ */ d(
  "div",
  {
    className: ka([Kt[Jt], Kt[`${Jt}--${o}`]]),
    "data-testid": e,
    ...i,
    children: /* @__PURE__ */ d("svg", { viewBox: "0 0 50 50", children: /* @__PURE__ */ d(
      "circle",
      {
        className: ka(Kt[`${Jt}__circle`], {
          [Kt[`${Jt}__circle--disabled`]]: n,
          [Kt[`${Jt}__circle--negative`]]: r
        }),
        cx: "25",
        cy: "25",
        r: "20"
      }
    ) })
  }
);
function rm(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Oa = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Aa;
function nm() {
  return Aa || (Aa = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o.call(this, l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return this && this[t] || t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(this, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, this && this[l] || l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(Oa)), Oa.exports;
}
var om = nm();
const im = /* @__PURE__ */ rm(om), am = {
  "purpur-select": "_purpur-select_imnd8_1",
  "purpur-select__label": "_purpur-select__label_imnd8_7",
  "purpur-select__field-row": "_purpur-select__field-row_imnd8_12",
  "purpur-select__frame": "_purpur-select__frame_imnd8_16",
  "purpur-select__select-container": "_purpur-select__select-container_imnd8_23",
  "purpur-select__select-container--disabled": "_purpur-select__select-container--disabled_imnd8_31",
  "purpur-select__select-container--readonly": "_purpur-select__select-container--readonly_imnd8_34",
  "purpur-select__select": "_purpur-select__select_imnd8_23",
  "purpur-select__select--error": "_purpur-select__select--error_imnd8_83",
  "purpur-select__select--is-valid": "_purpur-select__select--is-valid_imnd8_86",
  "purpur-select__end-adornments": "_purpur-select__end-adornments_imnd8_92",
  "purpur-select__select-icon": "_purpur-select__select-icon_imnd8_102",
  "purpur-select__select-icon--readonly": "_purpur-select__select-icon--readonly_imnd8_105",
  "purpur-select__select-icon--disabled": "_purpur-select__select-icon--disabled_imnd8_105",
  "purpur-select__valid-icon": "_purpur-select__valid-icon_imnd8_108"
}, de = im.bind(am), V = "purpur-select", lm = ({
  label: e,
  options: n,
  className: r,
  errorText: o,
  helperText: i,
  placeholder: t,
  readOnly: a = !1,
  ["data-testid"]: l,
  valid: u,
  loading: c,
  ...p
}, _) => {
  const g = (y) => l ? `${l}-${y}` : void 0, f = u && !o, m = Ft(), h = p.id ?? m, v = i ? `${h}-helper-text` : void 0, w = de([
    `${V}__select-container`,
    {
      [`${V}__select-container--disabled`]: p.disabled,
      [`${V}__select-container--readonly`]: a && !p.disabled
    }
  ]);
  return de([
    `${V}__select-icon`,
    {
      [`${V}__select-icon--disabled`]: p.disabled,
      [`${V}__select-icon--readonly`]: a && !p.disabled,
      [`${V}__select-icon--is-valid`]: f
    }
  ]), f && de(`${V}__valid-icon`), /* @__PURE__ */ C("div", { className: de(V, r), children: [
    e && /* @__PURE__ */ C(
      Uh,
      {
        htmlFor: h,
        className: de(`${V}__label`),
        "data-testid": g("label"),
        disabled: p.disabled,
        children: [
          p.required && /* @__PURE__ */ d("span", { "aria-hidden": !0, children: "*" }),
          e
        ]
      }
    ),
    /* @__PURE__ */ d("div", { className: de(`${V}__field-row`), children: /* @__PURE__ */ C("div", { className: w, children: [
      /* @__PURE__ */ C(
        "select",
        {
          ...p,
          onChange: a || p == null ? void 0 : p.onChange,
          id: h,
          ref: _,
          "data-testid": g("select"),
          "aria-describedby": p["aria-describedby"] || v,
          "aria-invalid": p["aria-invalid"] || !!o,
          "aria-disabled": p["aria-disabled"] || p.disabled,
          "aria-readonly": p["aria-readonly"] || a && !p.disabled,
          className: de([
            `${V}__select`,
            {
              [`${V}__select--error`]: !!o,
              [`${V}__select--is-valid`]: f
            }
          ]),
          children: [
            t && /* @__PURE__ */ d("option", { value: t.value ?? t.label, disabled: !0, children: t.label }),
            n.map(
              (y, b) => um(y) ? sm(y, h, b, a) : ms(y, h, b, a)
            )
          ]
        }
      ),
      /* @__PURE__ */ C("div", { className: de(`${V}__end-adornments`), children: [
        c ? /* @__PURE__ */ d(
          tm,
          {
            disabled: p.disabled,
            size: "xxs",
            "data-testid": g("spinner")
          },
          "spinner"
        ) : /* @__PURE__ */ d(
          gs,
          {
            className: de([
              `${V}__select-icon`,
              {
                [`${V}__select-icon--disabled`]: p.disabled,
                [`${V}__select-icon--readonly`]: a && !p.disabled,
                [`${V}__select-icon--is-valid`]: f
              }
            ]),
            "data-testid": g("dropdown-icon"),
            size: "sm"
          },
          "chevron-down-icon"
        ),
        f && /* @__PURE__ */ d(
          fs,
          {
            "data-testid": g("valid-icon"),
            className: de(`${V}__valid-icon`)
          },
          "valid-icon"
        )
      ] }),
      /* @__PURE__ */ d("div", { className: de(`${V}__frame`) })
    ] }) }),
    v && /* @__PURE__ */ d(
      $h,
      {
        disabled: p.disabled,
        "data-testid": g("helper-text"),
        id: v,
        children: i
      }
    ),
    o && /* @__PURE__ */ d(mh, { "data-testid": g("error-text"), children: o })
  ] });
}, um = (e) => e.hasOwnProperty("options"), sm = (e, n, r, o) => {
  const i = `${n}--group--${r}`;
  return /* @__PURE__ */ d("optgroup", { label: e.label, children: e.options.map((t, a) => ms(t, i, a, o)) }, i);
}, ms = (e, n, r, o) => /* @__PURE__ */ d(
  "option",
  {
    value: e.value ?? e.label,
    disabled: o,
    children: e.label
  },
  `${n}--option--${r}`
), vs = W(lm);
vs.displayName = "Select";
const cm = {
  LG: "lg"
};
function pm(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ma = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Fa;
function dm() {
  return Fa || (Fa = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o(l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(null, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(Ma)), Ma.exports;
}
var fm = dm();
const Da = /* @__PURE__ */ pm(fm), gm = "_rotate_1xozj_1", _m = "_dash_1xozj_1", Qt = {
  "purpur-spinner": "_purpur-spinner_1xozj_1",
  rotate: gm,
  "purpur-spinner--xxs": "_purpur-spinner--xxs_1xozj_4",
  "purpur-spinner--xs": "_purpur-spinner--xs_1xozj_8",
  "purpur-spinner--sm": "_purpur-spinner--sm_1xozj_12",
  "purpur-spinner--md": "_purpur-spinner--md_1xozj_16",
  "purpur-spinner--lg": "_purpur-spinner--lg_1xozj_20",
  "purpur-spinner__circle": "_purpur-spinner__circle_1xozj_24",
  dash: _m,
  "purpur-spinner__circle--disabled": "_purpur-spinner__circle--disabled_1xozj_33",
  "purpur-spinner__circle--negative": "_purpur-spinner__circle--negative_1xozj_36"
}, er = "purpur-spinner", hm = {
  SM: "sm"
}, mm = ({
  ["data-testid"]: e,
  disabled: n = !1,
  negative: r = !1,
  size: o = hm.SM,
  ...i
}) => /* @__PURE__ */ d(
  "div",
  {
    className: Da([Qt[er], Qt[`${er}--${o}`]]),
    "data-testid": e,
    ...i,
    children: /* @__PURE__ */ d("svg", { viewBox: "0 0 50 50", children: /* @__PURE__ */ d(
      "circle",
      {
        className: Da(Qt[`${er}__circle`], {
          [Qt[`${er}__circle--disabled`]]: n,
          [Qt[`${er}__circle--negative`]]: r
        }),
        cx: "25",
        cy: "25",
        r: "20"
      }
    ) })
  }
);
function vm(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ta = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var La;
function wm() {
  return La || (La = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o.call(this, l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return this && this[t] || t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(this, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, this && this[l] || l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(Ta)), Ta.exports;
}
var ym = wm();
const bm = /* @__PURE__ */ vm(ym), $m = {
  "purpur-button": "_purpur-button_w455q_1",
  "purpur-button--xs": "_purpur-button--xs_w455q_33",
  "purpur-button--icon-only": "_purpur-button--icon-only_w455q_36",
  "purpur-button--sm": "_purpur-button--sm_w455q_39",
  "purpur-button--md": "_purpur-button--md_w455q_45",
  "purpur-button--lg": "_purpur-button--lg_w455q_51",
  "purpur-button--full-width": "_purpur-button--full-width_w455q_57",
  "purpur-button--primary": "_purpur-button--primary_w455q_60",
  "purpur-button--disabled": "_purpur-button--disabled_w455q_64",
  "purpur-button--primary-negative": "_purpur-button--primary-negative_w455q_70",
  "purpur-button--secondary": "_purpur-button--secondary_w455q_82",
  "purpur-button--secondary-negative": "_purpur-button--secondary-negative_w455q_93",
  "purpur-button--expressive": "_purpur-button--expressive_w455q_104",
  "purpur-button--expressive-negative": "_purpur-button--expressive-negative_w455q_114",
  "purpur-button--negative": "_purpur-button--negative_w455q_126",
  "purpur-button--destructive": "_purpur-button--destructive_w455q_133",
  "purpur-button--destructive-negative": "_purpur-button--destructive-negative_w455q_143",
  "purpur-button--tertiary-purple": "_purpur-button--tertiary-purple_w455q_153",
  "purpur-button--tertiary-purple-negative": "_purpur-button--tertiary-purple-negative_w455q_166",
  "purpur-button--text-negative": "_purpur-button--text-negative_w455q_181",
  "purpur-button--text": "_purpur-button--text_w455q_181"
}, xm = bm.bind($m), Je = "purpur-button", Sm = ({
  children: e,
  className: n,
  ["data-testid"]: r,
  disabled: o = !1,
  fullWidth: i = !1,
  iconOnly: t,
  loading: a = !1,
  negative: l = !1,
  onClick: u,
  size: c = "md",
  variant: p,
  type: _ = "button",
  ...g
}, f) => {
  if (t && p === "destructive")
    return null;
  const m = xm(
    [
      Je,
      `${Je}--${l ? `${p}-negative` : p}`,
      `${Je}--${c}`
    ],
    {
      [`${Je}--icon-only`]: t,
      [`${Je}--negative`]: l,
      [`${Je}--full-width`]: i,
      [`${Je}--disabled`]: o || a
    },
    n
  ), h = (w) => {
    o || a ? w.preventDefault() : u && u(w);
  }, v = !!g["aria-disabled"] || o || a;
  return /* @__PURE__ */ C(
    "button",
    {
      className: m,
      "data-testid": r,
      type: _,
      ref: f,
      "aria-disabled": v,
      onClick: h,
      ...g,
      children: [
        a && /* @__PURE__ */ d(mm, { size: c === cm.LG ? "xs" : "xxs", negative: l, disabled: v }),
        " ",
        e
      ]
    }
  );
}, ws = W(Sm);
ws.displayName = "Button";
function Cm(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ja = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Ia;
function Rm() {
  return Ia || (Ia = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o.call(this, l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return this && this[t] || t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(this, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, this && this[l] || l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(ja)), ja.exports;
}
var Em = Rm();
const Nm = /* @__PURE__ */ Cm(Em), Pm = {
  "purpur-icon": "_purpur-icon_8u1lq_1",
  "purpur-icon--xxs": "_purpur-icon--xxs_8u1lq_4",
  "purpur-icon--xs": "_purpur-icon--xs_8u1lq_8",
  "purpur-icon--sm": "_purpur-icon--sm_8u1lq_12",
  "purpur-icon--md": "_purpur-icon--md_8u1lq_16",
  "purpur-icon--lg": "_purpur-icon--lg_8u1lq_20",
  "purpur-icon--xl": "_purpur-icon--xl_8u1lq_24"
}, km = Nm.bind(Pm), Va = "purpur-icon", Om = "md", Am = (e) => e.filter((n) => Object.keys(n).length >= 1).map((n) => `${n.name}="${n.value}"`).join(" "), Mm = ({ content: e = "", title: n } = {}) => {
  const r = [
    { name: "xmlns", value: "http://www.w3.org/2000/svg" },
    { name: "fill", value: "currentColor" },
    { name: "viewBox", value: "0 0 24 24" },
    n ? { name: "role", value: "img" } : { name: "aria-hidden", value: "true" }
  ], o = n ? `<title>${n}</title>` : "";
  return `<svg ${Am(r)}>${o}${e}</svg>`;
}, Fm = (e) => e.replace(/<(\/?)svg([^>]*)>/g, "").trim(), ys = ({
  ["data-testid"]: e,
  svg: n,
  allyTitle: r,
  className: o,
  size: i = Om,
  ...t
}) => {
  const a = Mm({
    content: Fm(n.svg),
    title: r
  }), l = km(o, Va, `${Va}--${i}`);
  return /* @__PURE__ */ d(
    "span",
    {
      className: l,
      "data-testid": e,
      dangerouslySetInnerHTML: { __html: a },
      ...t
    }
  );
};
ys.displayName = "Icon";
const Dm = {
  name: "error-filled",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 24" fill="currentColor"><path fill-rule="evenodd" d="M14.268 3.5c-.77-1.333-2.694-1.333-3.464 0l-8.66 15c-.77 1.333.192 3 1.732 3h17.32c1.54 0 2.502-1.667 1.733-3l-8.66-15Zm-.694 5.067-.247 6.876h-1.566l-.247-6.876a1.03 1.03 0 1 1 2.06 0Zm.212 8.917c0 .649-.585 1.234-1.25 1.234-.648 0-1.25-.585-1.25-1.234 0-.633.602-1.234 1.25-1.234.665 0 1.25.601 1.25 1.234Z" clip-rule="evenodd"/></svg>',
  keywords: ["error-filled"],
  category: "status"
};
function Tm(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var za = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var qa;
function Lm() {
  return qa || (qa = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o(l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(null, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(za)), za.exports;
}
var jm = Lm();
const Im = /* @__PURE__ */ Tm(jm), Ha = {
  "purpur-field-error-text": "_purpur-field-error-text_1lj7e_1",
  "purpur-field-error-text__icon": "_purpur-field-error-text__icon_1lj7e_11"
}, Ba = "purpur-field-error-text", Vm = ({
  children: e,
  className: n,
  ["aria-relevant"]: r = "additions text",
  ...o
}) => /* @__PURE__ */ C(
  "div",
  {
    className: Im([n, Ha[Ba]]),
    "aria-live": "assertive",
    "aria-relevant": r,
    ...o,
    children: [
      /* @__PURE__ */ d(ys, { svg: Dm, size: "xs", className: Ha[`${Ba}__icon`] }),
      e
    ]
  }
);
function zm(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Wa = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Ga;
function qm() {
  return Ga || (Ga = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o(l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(null, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(Wa)), Wa.exports;
}
var Hm = qm();
const Bm = /* @__PURE__ */ zm(Hm), Za = {
  "purpur-field-helper-text": "_purpur-field-helper-text_atw6b_1",
  "purpur-field-helper-text--disabled": "_purpur-field-helper-text--disabled_atw6b_9"
}, Ua = "purpur-field-helper-text", Wm = ({
  children: e,
  className: n,
  disabled: r,
  id: o,
  ...i
}) => {
  const t = Bm([
    n,
    Za[Ua],
    {
      [Za[`${Ua}--disabled`]]: r
    }
  ]);
  return /* @__PURE__ */ d("span", { id: o, className: t, ...i, children: e });
};
function Gm(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Xa = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Ya;
function Zm() {
  return Ya || (Ya = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o.call(this, l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return this && this[t] || t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(this, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, this && this[l] || l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(Xa)), Xa.exports;
}
var Um = Zm();
const Xm = /* @__PURE__ */ Gm(Um), Ym = {
  "purpur-icon": "_purpur-icon_8u1lq_1",
  "purpur-icon--xxs": "_purpur-icon--xxs_8u1lq_4",
  "purpur-icon--xs": "_purpur-icon--xs_8u1lq_8",
  "purpur-icon--sm": "_purpur-icon--sm_8u1lq_12",
  "purpur-icon--md": "_purpur-icon--md_8u1lq_16",
  "purpur-icon--lg": "_purpur-icon--lg_8u1lq_20",
  "purpur-icon--xl": "_purpur-icon--xl_8u1lq_24"
}, Km = Xm.bind(Ym), Ka = "purpur-icon", Jm = "md", Qm = (e) => e.filter((n) => Object.keys(n).length >= 1).map((n) => `${n.name}="${n.value}"`).join(" "), ev = ({ content: e = "", title: n } = {}) => {
  const r = [
    { name: "xmlns", value: "http://www.w3.org/2000/svg" },
    { name: "fill", value: "currentColor" },
    { name: "viewBox", value: "0 0 24 24" },
    n ? { name: "role", value: "img" } : { name: "aria-hidden", value: "true" }
  ], o = n ? `<title>${n}</title>` : "";
  return `<svg ${Qm(r)}>${o}${e}</svg>`;
}, tv = (e) => e.replace(/<(\/?)svg([^>]*)>/g, "").trim(), Zo = ({
  ["data-testid"]: e,
  svg: n,
  allyTitle: r,
  className: o,
  size: i = Jm,
  ...t
}) => {
  const a = ev({
    content: tv(n.svg),
    title: r
  }), l = Km(o, Ka, `${Ka}--${i}`);
  return /* @__PURE__ */ d(
    "span",
    {
      className: l,
      "data-testid": e,
      dangerouslySetInnerHTML: { __html: a },
      ...t
    }
  );
};
Zo.displayName = "Icon";
const rv = {
  name: "check-circle-filled",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm4.712-12.491a.875.875 0 1 0-1.424-1.018l-4.4 6.16-2.27-2.27a.875.875 0 0 0-1.237 1.238l3 3a.875.875 0 0 0 1.331-.11l5-7Z" clip-rule="evenodd"/></svg>',
  keywords: ["check-circle-filled"],
  category: "status"
}, bs = (e) => /* @__PURE__ */ d(Zo, { ...e, svg: rv });
bs.displayName = "IconCheckCircleFilled";
const nv = {
  name: "close",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M4.864 4.864a.9.9 0 0 1 1.273 0L12 10.727l5.864-5.863a.9.9 0 0 1 1.272 1.272L13.273 12l5.863 5.864a.9.9 0 1 1-1.272 1.272L12 13.273l-5.863 5.863a.9.9 0 0 1-1.273-1.272L10.727 12 4.864 6.136a.9.9 0 0 1 0-1.272Z" clip-rule="evenodd"/></svg>',
  keywords: ["close"],
  category: "utility"
}, $s = (e) => /* @__PURE__ */ d(Zo, { ...e, svg: nv });
$s.displayName = "IconClose";
function Ja(e, n) {
  if (typeof e == "function")
    return e(n);
  e != null && (e.current = n);
}
function ov(...e) {
  return (n) => {
    let r = !1;
    const o = e.map((i) => {
      const t = Ja(i, n);
      return !r && typeof t == "function" && (r = !0), t;
    });
    if (r)
      return () => {
        for (let i = 0; i < o.length; i++) {
          const t = o[i];
          typeof t == "function" ? t() : Ja(e[i], null);
        }
      };
  };
}
var xs = s.forwardRef((e, n) => {
  const { children: r, ...o } = e, i = s.Children.toArray(r), t = i.find(av);
  if (t) {
    const a = t.props.children, l = i.map((u) => u === t ? s.Children.count(a) > 1 ? s.Children.only(null) : s.isValidElement(a) ? a.props.children : null : u);
    return /* @__PURE__ */ d(yo, { ...o, ref: n, children: s.isValidElement(a) ? s.cloneElement(a, void 0, l) : null });
  }
  return /* @__PURE__ */ d(yo, { ...o, ref: n, children: r });
});
xs.displayName = "Slot";
var yo = s.forwardRef((e, n) => {
  const { children: r, ...o } = e;
  if (s.isValidElement(r)) {
    const i = uv(r), t = lv(o, r.props);
    return r.type !== s.Fragment && (t.ref = n ? ov(n, i) : i), s.cloneElement(r, t);
  }
  return s.Children.count(r) > 1 ? s.Children.only(null) : null;
});
yo.displayName = "SlotClone";
var iv = ({ children: e }) => /* @__PURE__ */ d(q, { children: e });
function av(e) {
  return s.isValidElement(e) && e.type === iv;
}
function lv(e, n) {
  const r = { ...n };
  for (const o in n) {
    const i = e[o], t = n[o];
    /^on[A-Z]/.test(o) ? i && t ? r[o] = (...a) => {
      t(...a), i(...a);
    } : i && (r[o] = i) : o === "style" ? r[o] = { ...i, ...t } : o === "className" && (r[o] = [i, t].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function uv(e) {
  var n, r;
  let o = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, i = o && "isReactWarning" in o && o.isReactWarning;
  return i ? e.ref : (o = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, i = o && "isReactWarning" in o && o.isReactWarning, i ? e.props.ref : e.props.ref || e.ref);
}
var sv = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], cv = sv.reduce((e, n) => {
  const r = s.forwardRef((o, i) => {
    const { asChild: t, ...a } = o, l = t ? xs : n;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ d(l, { ...a, ref: i });
  });
  return r.displayName = `Primitive.${n}`, { ...e, [n]: r };
}, {}), pv = "Label", Ss = s.forwardRef((e, n) => /* @__PURE__ */ d(
  cv.label,
  {
    ...e,
    ref: n,
    onMouseDown: (r) => {
      var o;
      r.target.closest("button, input, select, textarea") || ((o = e.onMouseDown) == null || o.call(e, r), !r.defaultPrevented && r.detail > 1 && r.preventDefault());
    }
  }
));
Ss.displayName = pv;
var dv = Ss;
function fv(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Qa = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var el;
function gv() {
  return el || (el = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o(l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(null, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(Qa)), Qa.exports;
}
var _v = gv();
const hv = /* @__PURE__ */ fv(_v), Tn = {
  "purpur-label": "_purpur-label_1jndl_1",
  "purpur-label--negative": "_purpur-label--negative_1jndl_8",
  "purpur-label--disabled": "_purpur-label--disabled_1jndl_11"
}, Ln = "purpur-label", mv = ({
  children: e,
  className: n,
  disabled: r,
  negative: o = !1,
  ...i
}) => {
  const t = hv([
    n,
    Tn[Ln],
    {
      [Tn[`${Ln}--disabled`]]: r,
      [Tn[`${Ln}--negative`]]: o
    }
  ]);
  return /* @__PURE__ */ d(dv, { className: t, ...i, children: e });
};
function vv(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var tl = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var rl;
function wv() {
  return rl || (rl = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o(l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(null, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(tl)), tl.exports;
}
var yv = wv();
const nl = /* @__PURE__ */ vv(yv), bv = "_rotate_1xozj_1", $v = "_dash_1xozj_1", tr = {
  "purpur-spinner": "_purpur-spinner_1xozj_1",
  rotate: bv,
  "purpur-spinner--xxs": "_purpur-spinner--xxs_1xozj_4",
  "purpur-spinner--xs": "_purpur-spinner--xs_1xozj_8",
  "purpur-spinner--sm": "_purpur-spinner--sm_1xozj_12",
  "purpur-spinner--md": "_purpur-spinner--md_1xozj_16",
  "purpur-spinner--lg": "_purpur-spinner--lg_1xozj_20",
  "purpur-spinner__circle": "_purpur-spinner__circle_1xozj_24",
  dash: $v,
  "purpur-spinner__circle--disabled": "_purpur-spinner__circle--disabled_1xozj_33",
  "purpur-spinner__circle--negative": "_purpur-spinner__circle--negative_1xozj_36"
}, rr = "purpur-spinner", xv = {
  SM: "sm"
}, Sv = ({
  ["data-testid"]: e,
  disabled: n = !1,
  negative: r = !1,
  size: o = xv.SM,
  ...i
}) => /* @__PURE__ */ d(
  "div",
  {
    className: nl([tr[rr], tr[`${rr}--${o}`]]),
    "data-testid": e,
    ...i,
    children: /* @__PURE__ */ d("svg", { viewBox: "0 0 50 50", children: /* @__PURE__ */ d(
      "circle",
      {
        className: nl(tr[`${rr}__circle`], {
          [tr[`${rr}__circle--disabled`]]: n,
          [tr[`${rr}__circle--negative`]]: r
        }),
        cx: "25",
        cy: "25",
        r: "20"
      }
    ) })
  }
);
function Cv(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ol = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var il;
function Rv() {
  return il || (il = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o.call(this, l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return this && this[t] || t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(this, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, this && this[l] || l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(ol)), ol.exports;
}
var Ev = Rv();
const Nv = /* @__PURE__ */ Cv(Ev), Pv = {
  "purpur-text-field": "_purpur-text-field_3gl1k_1",
  "purpur-text-field__label": "_purpur-text-field__label_3gl1k_7",
  "purpur-text-field__label-text": "_purpur-text-field__label-text_3gl1k_12",
  "purpur-text-field__field-row": "_purpur-text-field__field-row_3gl1k_15",
  "purpur-text-field__frame": "_purpur-text-field__frame_3gl1k_19",
  "purpur-text-field__input-container": "_purpur-text-field__input-container_3gl1k_26",
  "purpur-text-field__input-container--disabled": "_purpur-text-field__input-container--disabled_3gl1k_37",
  "purpur-text-field__input-container--readonly": "_purpur-text-field__input-container--readonly_3gl1k_40",
  "purpur-text-field__input-container--has-clear-button": "_purpur-text-field__input-container--has-clear-button_3gl1k_43",
  "purpur-text-field__input-container--end-adornment": "_purpur-text-field__input-container--end-adornment_3gl1k_46",
  "purpur-text-field__input": "_purpur-text-field__input_3gl1k_26",
  "purpur-text-field__input-container--start-adornment": "_purpur-text-field__input-container--start-adornment_3gl1k_52",
  "purpur-text-field__input--valid": "_purpur-text-field__input--valid_3gl1k_94",
  "purpur-text-field__input--error": "_purpur-text-field__input--error_3gl1k_94",
  "purpur-text-field__adornment-container": "_purpur-text-field__adornment-container_3gl1k_106",
  "purpur-text-field__valid-icon": "_purpur-text-field__valid-icon_3gl1k_111"
}, kv = (e) => ue(e), Ee = Nv.bind(Pv), X = "purpur-text-field", Ov = ({
  ["data-testid"]: e,
  className: n,
  clearButtonAriaLabel: r,
  beforeField: o,
  afterField: i,
  endAdornment: t,
  errorText: a,
  helperText: l,
  label: u,
  loading: c = !1,
  onClear: p,
  startAdornment: _,
  valid: g = !1,
  ...f
}, m) => {
  var h;
  const v = Ft(), w = f.id ?? v, y = (A) => e ? `${e}-${A}` : void 0, b = g && !a, $ = l ? `${w}-helper-text` : void 0, x = [_].filter((A) => !!A), R = (typeof f.value == "number" ? f.value !== void 0 : (h = f.value) == null ? void 0 : h.length) && !f.disabled && !f.readOnly && !c && p && r, S = kv(null), O = (A) => {
    S.current = A, typeof m == "function" ? m(A) : m && (m.current = A);
  }, E = () => {
    var A;
    p == null || p(), (A = S.current) == null || A.focus();
  }, k = [
    c && /* @__PURE__ */ d(
      Sv,
      {
        disabled: f.disabled,
        size: "xs",
        "data-testid": y("spinner")
      },
      "spinner"
    ),
    R && /* @__PURE__ */ d(
      ws,
      {
        variant: "tertiary-purple",
        onClick: E,
        iconOnly: !0,
        "aria-label": r ?? "",
        "data-testid": y("clear-button"),
        tabIndex: -1,
        children: /* @__PURE__ */ d($s, { size: "xs" })
      },
      "clear-button"
    ),
    b && /* @__PURE__ */ d(
      bs,
      {
        "data-testid": y("valid-icon"),
        className: Ee(`${X}__valid-icon`)
      },
      "valid-icon"
    )
  ].filter((A) => !!A), D = Ee([
    `${X}__input-container`,
    {
      [`${X}__input-container--start-adornment`]: x.length,
      [`${X}__input-container--end-adornment`]: k.length || t,
      [`${X}__input-container--disabled`]: f.disabled,
      [`${X}__input-container--has-clear-button`]: R,
      [`${X}__input-container--readonly`]: f.readOnly && !f.disabled
    }
  ]);
  return /* @__PURE__ */ C("div", { className: Ee(n, X), children: [
    u && /* @__PURE__ */ C(
      mv,
      {
        htmlFor: w,
        className: Ee(`${X}__label`),
        "data-testid": y("label"),
        disabled: f.disabled,
        children: [
          f.required && /* @__PURE__ */ d("span", { "aria-hidden": !0, children: "*" }),
          u
        ]
      }
    ),
    /* @__PURE__ */ C("div", { className: Ee(`${X}__field-row`), children: [
      !!o && o,
      /* @__PURE__ */ C("div", { className: D, children: [
        !!x.length && /* @__PURE__ */ d(
          "div",
          {
            "data-testid": y("start-adornments"),
            className: Ee(`${X}__adornment-container`),
            children: x
          }
        ),
        /* @__PURE__ */ d(
          "input",
          {
            ...f,
            id: w,
            ref: O,
            "data-testid": y("input"),
            "aria-describedby": f["aria-describedby"] || $,
            "aria-invalid": f["aria-invalid"] || !!a,
            className: Ee([
              `${X}__input`,
              {
                [`${X}__input--valid`]: b,
                [`${X}__input--error`]: !!a
              }
            ])
          }
        ),
        /* @__PURE__ */ d("div", { className: Ee(`${X}__frame`) }),
        (!!k.length || t) && /* @__PURE__ */ C(
          "div",
          {
            "data-testid": y("end-adornments"),
            className: Ee(`${X}__adornment-container`),
            children: [
              k,
              t
            ]
          }
        )
      ] }),
      !!i && i
    ] }),
    $ && /* @__PURE__ */ d(Wm, { "data-testid": y("helper-text"), id: $, children: l }),
    a && /* @__PURE__ */ d(Vm, { "data-testid": y("error-text"), children: a })
  ] });
}, Cs = W(Ov);
Cs.displayName = "TextField";
function al(e, n) {
  if (typeof e == "function")
    return e(n);
  e != null && (e.current = n);
}
function Av(...e) {
  return (n) => {
    let r = !1;
    const o = e.map((i) => {
      const t = al(i, n);
      return !r && typeof t == "function" && (r = !0), t;
    });
    if (r)
      return () => {
        for (let i = 0; i < o.length; i++) {
          const t = o[i];
          typeof t == "function" ? t() : al(e[i], null);
        }
      };
  };
}
var Rs = s.forwardRef((e, n) => {
  const { children: r, ...o } = e, i = s.Children.toArray(r), t = i.find(Fv);
  if (t) {
    const a = t.props.children, l = i.map((u) => u === t ? s.Children.count(a) > 1 ? s.Children.only(null) : s.isValidElement(a) ? a.props.children : null : u);
    return /* @__PURE__ */ d(bo, { ...o, ref: n, children: s.isValidElement(a) ? s.cloneElement(a, void 0, l) : null });
  }
  return /* @__PURE__ */ d(bo, { ...o, ref: n, children: r });
});
Rs.displayName = "Slot";
var bo = s.forwardRef((e, n) => {
  const { children: r, ...o } = e;
  if (s.isValidElement(r)) {
    const i = Tv(r), t = Dv(o, r.props);
    return r.type !== s.Fragment && (t.ref = n ? Av(n, i) : i), s.cloneElement(r, t);
  }
  return s.Children.count(r) > 1 ? s.Children.only(null) : null;
});
bo.displayName = "SlotClone";
var Mv = ({ children: e }) => /* @__PURE__ */ d(q, { children: e });
function Fv(e) {
  return s.isValidElement(e) && e.type === Mv;
}
function Dv(e, n) {
  const r = { ...n };
  for (const o in n) {
    const i = e[o], t = n[o];
    /^on[A-Z]/.test(o) ? i && t ? r[o] = (...a) => {
      t(...a), i(...a);
    } : i && (r[o] = i) : o === "style" ? r[o] = { ...i, ...t } : o === "className" && (r[o] = [i, t].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function Tv(e) {
  var n, r;
  let o = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, i = o && "isReactWarning" in o && o.isReactWarning;
  return i ? e.ref : (o = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, i = o && "isReactWarning" in o && o.isReactWarning, i ? e.props.ref : e.props.ref || e.ref);
}
var Lv = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], jv = Lv.reduce((e, n) => {
  const r = s.forwardRef((o, i) => {
    const { asChild: t, ...a } = o, l = t ? Rs : n;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ d(l, { ...a, ref: i });
  });
  return r.displayName = `Primitive.${n}`, { ...e, [n]: r };
}, {}), Iv = "VisuallyHidden", Es = s.forwardRef(
  (e, n) => /* @__PURE__ */ d(
    jv.span,
    {
      ...e,
      ref: n,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
Es.displayName = Iv;
var Vv = Es;
const zv = ({
  asChild: e,
  children: n,
  className: r = "",
  ["data-testid"]: o
}) => /* @__PURE__ */ d(Vv, { asChild: e, "data-testid": o, className: r, children: n }), qv = (e) => {
  const r = 16 / (Number(
    getComputedStyle(document.documentElement).getPropertyValue("--purpur-rescale") || "1"
  ) || 1);
  return e / r;
}, on = (e) => `${qv(e)}rem`, Rt = z.bind(G), K = "purpur-table-column-header-cell", Hv = ({
  className: e,
  enableSorting: n,
  header: r,
  sortingAriaLabels: o,
  stickyColumn: i,
  stickyHeaders: t,
  tanstackTable: a,
  isScrolled: l,
  showBorder: u
}) => {
  var x, R;
  const c = n && r.column.getCanSort(), p = r.column.getCanFilter(), _ = ((x = r.column.columnDef.meta) == null ? void 0 : x.cellType) === "rowSelection", g = ((R = r.column.columnDef.meta) == null ? void 0 : R.cellType) === "rowToggle", [f, m] = j(!1), h = ue(null);
  le(() => {
    const S = h.current;
    if (!S)
      return;
    const O = new IntersectionObserver(
      ([E]) => {
        m(E.isIntersecting);
      },
      { threshold: 1 }
    );
    return O.observe(S), () => {
      S && O.unobserve(S);
    };
  }, []);
  const v = (S) => {
    switch (S) {
      case "desc":
        return "descending";
      case "asc":
        return "ascending";
      case !1:
      default:
        return "none";
    }
  }, w = on(r.getSize()), y = r.column.getIsFirstColumn(), b = r.column.getIsLastColumn(), $ = typeof r.column.columnDef.header == "string" ? `${r.column.columnDef.header}` : void 0;
  return /* @__PURE__ */ d(
    "th",
    {
      ref: h,
      className: Rt([
        e,
        K,
        {
          [`${K}__checkbox`]: _,
          [`${K}__sticky-column`]: i,
          [`${K}__sticky-header`]: t,
          [`${K}__sticky-column__with-sticky-border`]: l && u,
          [`${K}__first-header-visible`]: y && f,
          [`${K}__last-header-visible`]: b && f,
          [`${K}__border-radius-first-cell`]: y,
          [`${K}__border-radius-last-cell`]: b
        }
      ]),
      style: {
        // If column resizing is enabled Don't use column.getSize() on every header and every data cell. Instead, calculate all column widths once upfront, memoized! https://tanstack.com/table/latest/docs/guide/column-sizing#column-sizing-guide
        maxWidth: w,
        minWidth: w
      },
      scope: "col",
      "aria-sort": v(r.column.getIsSorted()),
      "aria-label": $,
      children: /* @__PURE__ */ C("div", { className: Rt(`${K}__content`), children: [
        /* @__PURE__ */ d("div", { className: Rt(`${K}__title`), children: /* @__PURE__ */ d(
          Bv,
          {
            header: r,
            tanstackTable: a,
            canSort: c,
            isCheckBox: _,
            isRadiobutton: g,
            sortingAriaLabels: o
          }
        ) }),
        p && !_ && /* @__PURE__ */ d("div", { className: Rt(`${K}__filter-wrapper`), children: /* @__PURE__ */ d(Uv, { header: r }) })
      ] })
    }
  );
}, Bv = ({
  header: e,
  tanstackTable: n,
  canSort: r,
  isCheckBox: o,
  isRadiobutton: i,
  sortingAriaLabels: t
}) => {
  var a, l, u, c;
  if (o)
    return /* @__PURE__ */ d(
      Wv,
      {
        id: e.id,
        tanstackTable: n,
        "aria-label": ((l = (a = e.column.columnDef.meta) == null ? void 0 : a.rowSelectionAriaLabels) == null ? void 0 : l.header) ?? ""
      }
    );
  if (i) {
    const p = ((c = (u = e.column.columnDef.meta) == null ? void 0 : u.rowSelectionAriaLabels) == null ? void 0 : c.header) ?? "";
    return /* @__PURE__ */ d(zv, { children: p });
  }
  return r && t ? /* @__PURE__ */ C(
    re,
    {
      variant: "text",
      iconOnly: !1,
      size: "sm",
      type: "button",
      "aria-label": Zv(e.column.getIsSorted(), t),
      onClick: e.column.getToggleSortingHandler(),
      className: Rt(`${K}__sortable-title`),
      children: [
        /* @__PURE__ */ d(ll, { header: e }),
        Gv(e.column.getIsSorted())
      ]
    }
  ) : /* @__PURE__ */ d(ll, { className: Rt(`${K}__title--default`), header: e });
}, Wv = ({
  id: e,
  ["aria-label"]: n,
  tanstackTable: r
}) => {
  const o = r.getIsSomeRowsSelected() ? "indeterminate" : r.getIsAllPageRowsSelected();
  return /* @__PURE__ */ d(
    Wo,
    {
      id: e,
      onChange: () => r.toggleAllPageRowsSelected(),
      checked: o,
      "aria-label": n
    }
  );
}, ll = ({
  header: e,
  className: n
}) => /* @__PURE__ */ d(
  se,
  {
    "data-testid": "purpur-table-column-header-cell-title",
    variant: "paragraph-100-bold",
    className: n,
    children: Tu(e.column.columnDef.header, e.getContext())
  }
), Gv = (e) => {
  switch (e) {
    case "desc":
      return /* @__PURE__ */ d(ss, { size: "xs" });
    case "asc":
      return /* @__PURE__ */ d(cs, { size: "xs" });
    case !1:
    default:
      return /* @__PURE__ */ d(ps, { size: "xs" });
  }
}, Zv = (e, n) => {
  switch (e) {
    case "desc":
      return n.desc;
    case "asc":
      return n.asc;
    case !1:
    default:
      return n.default;
  }
}, Uv = ({ header: e }) => {
  var t;
  const { filterVariant: n, filterKey: r, filterPlaceholder: o, filterAriaLabel: i } = e.column.columnDef.meta ?? {};
  if (n === "string") {
    const a = e.column.getFilterValue();
    return /* @__PURE__ */ d(
      Cs,
      {
        onChange: (l) => e.column.setFilterValue(l.target.value),
        type: "text",
        value: a ?? "",
        placeholder: o,
        "aria-label": i
      }
    );
  }
  if (n === "select") {
    const a = e.column.getFilterValue(), l = (t = e.column.columnDef.meta) == null ? void 0 : t.selectProps;
    return /* @__PURE__ */ d(
      vs,
      {
        ...l,
        onChange: (u) => {
          const c = r ? { filterKey: r, value: u.target.value } : u.target.value;
          e.column.setFilterValue(c);
        },
        value: (a == null ? void 0 : a.value) ?? ""
      }
    );
  }
  return null;
};
function Y(e, n, { checkForDefaultPrevented: r = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), r === !1 || !o.defaultPrevented)
      return n == null ? void 0 : n(o);
  };
}
function ul(e, n) {
  if (typeof e == "function")
    return e(n);
  e != null && (e.current = n);
}
function Ns(...e) {
  return (n) => {
    let r = !1;
    const o = e.map((i) => {
      const t = ul(i, n);
      return !r && typeof t == "function" && (r = !0), t;
    });
    if (r)
      return () => {
        for (let i = 0; i < o.length; i++) {
          const t = o[i];
          typeof t == "function" ? t() : ul(e[i], null);
        }
      };
  };
}
function ie(...e) {
  return s.useCallback(Ns(...e), e);
}
function Xv(e, n) {
  const r = s.createContext(n), o = (t) => {
    const { children: a, ...l } = t, u = s.useMemo(() => l, Object.values(l));
    return /* @__PURE__ */ d(r.Provider, { value: u, children: a });
  };
  o.displayName = e + "Provider";
  function i(t) {
    const a = s.useContext(r);
    if (a) return a;
    if (n !== void 0) return n;
    throw new Error(`\`${t}\` must be used within \`${e}\``);
  }
  return [o, i];
}
function Ps(e, n = []) {
  let r = [];
  function o(t, a) {
    const l = s.createContext(a), u = r.length;
    r = [...r, a];
    const c = (_) => {
      var g;
      const { scope: f, children: m, ...h } = _, v = ((g = f == null ? void 0 : f[e]) == null ? void 0 : g[u]) || l, w = s.useMemo(() => h, Object.values(h));
      return /* @__PURE__ */ d(v.Provider, { value: w, children: m });
    };
    c.displayName = t + "Provider";
    function p(_, g) {
      var f;
      const m = ((f = g == null ? void 0 : g[e]) == null ? void 0 : f[u]) || l, h = s.useContext(m);
      if (h) return h;
      if (a !== void 0) return a;
      throw new Error(`\`${_}\` must be used within \`${t}\``);
    }
    return [c, p];
  }
  const i = () => {
    const t = r.map((a) => s.createContext(a));
    return function(a) {
      const l = (a == null ? void 0 : a[e]) || t;
      return s.useMemo(
        () => ({ [`__scope${e}`]: { ...a, [e]: l } }),
        [a, l]
      );
    };
  };
  return i.scopeName = e, [o, Yv(i, ...n)];
}
function Yv(...e) {
  const n = e[0];
  if (e.length === 1) return n;
  const r = () => {
    const o = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(i) {
      const t = o.reduce((a, { useScope: l, scopeName: u }) => {
        const c = l(i)[`__scope${u}`];
        return { ...a, ...c };
      }, {});
      return s.useMemo(() => ({ [`__scope${n.scopeName}`]: t }), [t]);
    };
  };
  return r.scopeName = n.scopeName, r;
}
var gr = globalThis != null && globalThis.document ? s.useLayoutEffect : () => {
}, Kv = s.useId || (() => {
}), Jv = 0;
function jn(e) {
  const [n, r] = s.useState(Kv());
  return gr(() => {
    r((o) => o ?? String(Jv++));
  }, [e]), e || (n ? `radix-${n}` : "");
}
function J(e) {
  const n = s.useRef(e);
  return s.useEffect(() => {
    n.current = e;
  }), s.useMemo(() => (...r) => {
    var o;
    return (o = n.current) == null ? void 0 : o.call(n, ...r);
  }, []);
}
function Qv({
  prop: e,
  defaultProp: n,
  onChange: r = () => {
  }
}) {
  const [o, i] = e1({ defaultProp: n, onChange: r }), t = e !== void 0, a = t ? e : o, l = J(r), u = s.useCallback(
    (c) => {
      if (t) {
        const p = typeof c == "function" ? c(e) : c;
        p !== e && l(p);
      } else
        i(c);
    },
    [t, e, i, l]
  );
  return [a, u];
}
function e1({
  defaultProp: e,
  onChange: n
}) {
  const r = s.useState(e), [o] = r, i = s.useRef(o), t = J(n);
  return s.useEffect(() => {
    i.current !== o && (t(o), i.current = o);
  }, [o, i, t]), r;
}
var Uo = s.forwardRef((e, n) => {
  const { children: r, ...o } = e, i = s.Children.toArray(r), t = i.find(r1);
  if (t) {
    const a = t.props.children, l = i.map((u) => u === t ? s.Children.count(a) > 1 ? s.Children.only(null) : s.isValidElement(a) ? a.props.children : null : u);
    return /* @__PURE__ */ d($o, { ...o, ref: n, children: s.isValidElement(a) ? s.cloneElement(a, void 0, l) : null });
  }
  return /* @__PURE__ */ d($o, { ...o, ref: n, children: r });
});
Uo.displayName = "Slot";
var $o = s.forwardRef((e, n) => {
  const { children: r, ...o } = e;
  if (s.isValidElement(r)) {
    const i = o1(r), t = n1(o, r.props);
    return r.type !== s.Fragment && (t.ref = n ? Ns(n, i) : i), s.cloneElement(r, t);
  }
  return s.Children.count(r) > 1 ? s.Children.only(null) : null;
});
$o.displayName = "SlotClone";
var t1 = ({ children: e }) => /* @__PURE__ */ d(q, { children: e });
function r1(e) {
  return s.isValidElement(e) && e.type === t1;
}
function n1(e, n) {
  const r = { ...n };
  for (const o in n) {
    const i = e[o], t = n[o];
    /^on[A-Z]/.test(o) ? i && t ? r[o] = (...a) => {
      t(...a), i(...a);
    } : i && (r[o] = i) : o === "style" ? r[o] = { ...i, ...t } : o === "className" && (r[o] = [i, t].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function o1(e) {
  var n, r;
  let o = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, i = o && "isReactWarning" in o && o.isReactWarning;
  return i ? e.ref : (o = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, i = o && "isReactWarning" in o && o.isReactWarning, i ? e.props.ref : e.props.ref || e.ref);
}
var i1 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Q = i1.reduce((e, n) => {
  const r = s.forwardRef((o, i) => {
    const { asChild: t, ...a } = o, l = t ? Uo : n;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ d(l, { ...a, ref: i });
  });
  return r.displayName = `Primitive.${n}`, { ...e, [n]: r };
}, {});
function a1(e, n) {
  e && jo.flushSync(() => e.dispatchEvent(n));
}
function l1(e, n = globalThis == null ? void 0 : globalThis.document) {
  const r = J(e);
  s.useEffect(() => {
    const o = (i) => {
      i.key === "Escape" && r(i);
    };
    return n.addEventListener("keydown", o, { capture: !0 }), () => n.removeEventListener("keydown", o, { capture: !0 });
  }, [r, n]);
}
var u1 = "DismissableLayer", xo = "dismissableLayer.update", s1 = "dismissableLayer.pointerDownOutside", c1 = "dismissableLayer.focusOutside", sl, ks = s.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Os = s.forwardRef(
  (e, n) => {
    const {
      disableOutsidePointerEvents: r = !1,
      onEscapeKeyDown: o,
      onPointerDownOutside: i,
      onFocusOutside: t,
      onInteractOutside: a,
      onDismiss: l,
      ...u
    } = e, c = s.useContext(ks), [p, _] = s.useState(null), g = (p == null ? void 0 : p.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, f] = s.useState({}), m = ie(n, (S) => _(S)), h = Array.from(c.layers), [v] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), w = h.indexOf(v), y = p ? h.indexOf(p) : -1, b = c.layersWithOutsidePointerEventsDisabled.size > 0, $ = y >= w, x = f1((S) => {
      const O = S.target, E = [...c.branches].some((k) => k.contains(O));
      !$ || E || (i == null || i(S), a == null || a(S), S.defaultPrevented || l == null || l());
    }, g), R = g1((S) => {
      const O = S.target;
      [...c.branches].some((E) => E.contains(O)) || (t == null || t(S), a == null || a(S), S.defaultPrevented || l == null || l());
    }, g);
    return l1((S) => {
      y === c.layers.size - 1 && (o == null || o(S), !S.defaultPrevented && l && (S.preventDefault(), l()));
    }, g), s.useEffect(() => {
      if (p)
        return r && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (sl = g.body.style.pointerEvents, g.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(p)), c.layers.add(p), cl(), () => {
          r && c.layersWithOutsidePointerEventsDisabled.size === 1 && (g.body.style.pointerEvents = sl);
        };
    }, [p, g, r, c]), s.useEffect(() => () => {
      p && (c.layers.delete(p), c.layersWithOutsidePointerEventsDisabled.delete(p), cl());
    }, [p, c]), s.useEffect(() => {
      const S = () => f({});
      return document.addEventListener(xo, S), () => document.removeEventListener(xo, S);
    }, []), /* @__PURE__ */ d(
      Q.div,
      {
        ...u,
        ref: m,
        style: {
          pointerEvents: b ? $ ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: Y(e.onFocusCapture, R.onFocusCapture),
        onBlurCapture: Y(e.onBlurCapture, R.onBlurCapture),
        onPointerDownCapture: Y(
          e.onPointerDownCapture,
          x.onPointerDownCapture
        )
      }
    );
  }
);
Os.displayName = u1;
var p1 = "DismissableLayerBranch", d1 = s.forwardRef((e, n) => {
  const r = s.useContext(ks), o = s.useRef(null), i = ie(n, o);
  return s.useEffect(() => {
    const t = o.current;
    if (t)
      return r.branches.add(t), () => {
        r.branches.delete(t);
      };
  }, [r.branches]), /* @__PURE__ */ d(Q.div, { ...e, ref: i });
});
d1.displayName = p1;
function f1(e, n = globalThis == null ? void 0 : globalThis.document) {
  const r = J(e), o = s.useRef(!1), i = s.useRef(() => {
  });
  return s.useEffect(() => {
    const t = (l) => {
      if (l.target && !o.current) {
        let u = function() {
          As(
            s1,
            r,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: l };
        l.pointerType === "touch" ? (n.removeEventListener("click", i.current), i.current = u, n.addEventListener("click", i.current, { once: !0 })) : u();
      } else
        n.removeEventListener("click", i.current);
      o.current = !1;
    }, a = window.setTimeout(() => {
      n.addEventListener("pointerdown", t);
    }, 0);
    return () => {
      window.clearTimeout(a), n.removeEventListener("pointerdown", t), n.removeEventListener("click", i.current);
    };
  }, [n, r]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => o.current = !0
  };
}
function g1(e, n = globalThis == null ? void 0 : globalThis.document) {
  const r = J(e), o = s.useRef(!1);
  return s.useEffect(() => {
    const i = (t) => {
      t.target && !o.current && As(c1, r, { originalEvent: t }, {
        discrete: !1
      });
    };
    return n.addEventListener("focusin", i), () => n.removeEventListener("focusin", i);
  }, [n, r]), {
    onFocusCapture: () => o.current = !0,
    onBlurCapture: () => o.current = !1
  };
}
function cl() {
  const e = new CustomEvent(xo);
  document.dispatchEvent(e);
}
function As(e, n, r, { discrete: o }) {
  const i = r.originalEvent.target, t = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: r });
  n && i.addEventListener(e, n, { once: !0 }), o ? a1(i, t) : i.dispatchEvent(t);
}
var In = "focusScope.autoFocusOnMount", Vn = "focusScope.autoFocusOnUnmount", pl = { bubbles: !1, cancelable: !0 }, _1 = "FocusScope", Ms = s.forwardRef((e, n) => {
  const {
    loop: r = !1,
    trapped: o = !1,
    onMountAutoFocus: i,
    onUnmountAutoFocus: t,
    ...a
  } = e, [l, u] = s.useState(null), c = J(i), p = J(t), _ = s.useRef(null), g = ie(n, (h) => u(h)), f = s.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  s.useEffect(() => {
    if (o) {
      let h = function(b) {
        if (f.paused || !l) return;
        const $ = b.target;
        l.contains($) ? _.current = $ : Ie(_.current, { select: !0 });
      }, v = function(b) {
        if (f.paused || !l) return;
        const $ = b.relatedTarget;
        $ !== null && (l.contains($) || Ie(_.current, { select: !0 }));
      }, w = function(b) {
        if (document.activeElement === document.body)
          for (const $ of b)
            $.removedNodes.length > 0 && Ie(l);
      };
      document.addEventListener("focusin", h), document.addEventListener("focusout", v);
      const y = new MutationObserver(w);
      return l && y.observe(l, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", h), document.removeEventListener("focusout", v), y.disconnect();
      };
    }
  }, [o, l, f.paused]), s.useEffect(() => {
    if (l) {
      fl.add(f);
      const h = document.activeElement;
      if (!l.contains(h)) {
        const v = new CustomEvent(In, pl);
        l.addEventListener(In, c), l.dispatchEvent(v), v.defaultPrevented || (h1(b1(Fs(l)), { select: !0 }), document.activeElement === h && Ie(l));
      }
      return () => {
        l.removeEventListener(In, c), setTimeout(() => {
          const v = new CustomEvent(Vn, pl);
          l.addEventListener(Vn, p), l.dispatchEvent(v), v.defaultPrevented || Ie(h ?? document.body, { select: !0 }), l.removeEventListener(Vn, p), fl.remove(f);
        }, 0);
      };
    }
  }, [l, c, p, f]);
  const m = s.useCallback(
    (h) => {
      if (!r && !o || f.paused) return;
      const v = h.key === "Tab" && !h.altKey && !h.ctrlKey && !h.metaKey, w = document.activeElement;
      if (v && w) {
        const y = h.currentTarget, [b, $] = m1(y);
        b && $ ? !h.shiftKey && w === $ ? (h.preventDefault(), r && Ie(b, { select: !0 })) : h.shiftKey && w === b && (h.preventDefault(), r && Ie($, { select: !0 })) : w === y && h.preventDefault();
      }
    },
    [r, o, f.paused]
  );
  return /* @__PURE__ */ d(Q.div, { tabIndex: -1, ...a, ref: g, onKeyDown: m });
});
Ms.displayName = _1;
function h1(e, { select: n = !1 } = {}) {
  const r = document.activeElement;
  for (const o of e)
    if (Ie(o, { select: n }), document.activeElement !== r) return;
}
function m1(e) {
  const n = Fs(e), r = dl(n, e), o = dl(n.reverse(), e);
  return [r, o];
}
function Fs(e) {
  const n = [], r = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const i = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || i ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; r.nextNode(); ) n.push(r.currentNode);
  return n;
}
function dl(e, n) {
  for (const r of e)
    if (!v1(r, { upTo: n })) return r;
}
function v1(e, { upTo: n }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (n !== void 0 && e === n) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function w1(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Ie(e, { select: n = !1 } = {}) {
  if (e && e.focus) {
    const r = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== r && w1(e) && n && e.select();
  }
}
var fl = y1();
function y1() {
  let e = [];
  return {
    add(n) {
      const r = e[0];
      n !== r && (r == null || r.pause()), e = gl(e, n), e.unshift(n);
    },
    remove(n) {
      var r;
      e = gl(e, n), (r = e[0]) == null || r.resume();
    }
  };
}
function gl(e, n) {
  const r = [...e], o = r.indexOf(n);
  return o !== -1 && r.splice(o, 1), r;
}
function b1(e) {
  return e.filter((n) => n.tagName !== "A");
}
var $1 = "Portal", Ds = s.forwardRef((e, n) => {
  var r;
  const { container: o, ...i } = e, [t, a] = s.useState(!1);
  gr(() => a(!0), []);
  const l = o || t && ((r = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : r.body);
  return l ? Ru.createPortal(/* @__PURE__ */ d(Q.div, { ...i, ref: n }), l) : null;
});
Ds.displayName = $1;
function x1(e, n) {
  return s.useReducer((r, o) => n[r][o] ?? r, e);
}
var Ge = (e) => {
  const { present: n, children: r } = e, o = S1(n), i = typeof r == "function" ? r({ present: o.isPresent }) : s.Children.only(r), t = ie(o.ref, C1(i));
  return typeof r == "function" || o.isPresent ? s.cloneElement(i, { ref: t }) : null;
};
Ge.displayName = "Presence";
function S1(e) {
  const [n, r] = s.useState(), o = s.useRef({}), i = s.useRef(e), t = s.useRef("none"), a = e ? "mounted" : "unmounted", [l, u] = x1(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return s.useEffect(() => {
    const c = Mr(o.current);
    t.current = l === "mounted" ? c : "none";
  }, [l]), gr(() => {
    const c = o.current, p = i.current;
    if (p !== e) {
      const _ = t.current, g = Mr(c);
      e ? u("MOUNT") : g === "none" || (c == null ? void 0 : c.display) === "none" ? u("UNMOUNT") : u(p && _ !== g ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
    }
  }, [e, u]), gr(() => {
    if (n) {
      let c;
      const p = n.ownerDocument.defaultView ?? window, _ = (f) => {
        const m = Mr(o.current).includes(f.animationName);
        if (f.target === n && m && (u("ANIMATION_END"), !i.current)) {
          const h = n.style.animationFillMode;
          n.style.animationFillMode = "forwards", c = p.setTimeout(() => {
            n.style.animationFillMode === "forwards" && (n.style.animationFillMode = h);
          });
        }
      }, g = (f) => {
        f.target === n && (t.current = Mr(o.current));
      };
      return n.addEventListener("animationstart", g), n.addEventListener("animationcancel", _), n.addEventListener("animationend", _), () => {
        p.clearTimeout(c), n.removeEventListener("animationstart", g), n.removeEventListener("animationcancel", _), n.removeEventListener("animationend", _);
      };
    } else
      u("ANIMATION_END");
  }, [n, u]), {
    isPresent: ["mounted", "unmountSuspended"].includes(l),
    ref: s.useCallback((c) => {
      c && (o.current = getComputedStyle(c)), r(c);
    }, [])
  };
}
function Mr(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function C1(e) {
  var n, r;
  let o = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, i = o && "isReactWarning" in o && o.isReactWarning;
  return i ? e.ref : (o = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, i = o && "isReactWarning" in o && o.isReactWarning, i ? e.props.ref : e.props.ref || e.ref);
}
var zn = 0;
function R1() {
  s.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? _l()), document.body.insertAdjacentElement("beforeend", e[1] ?? _l()), zn++, () => {
      zn === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((n) => n.remove()), zn--;
    };
  }, []);
}
function _l() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var we = function() {
  return we = Object.assign || function(e) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
    }
    return e;
  }, we.apply(this, arguments);
};
function Ts(e, n) {
  var r = {};
  for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && n.indexOf(o) < 0 && (r[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, o = Object.getOwnPropertySymbols(e); i < o.length; i++)
      n.indexOf(o[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[i]) && (r[o[i]] = e[o[i]]);
  return r;
}
function E1(e, n, r) {
  for (var o = 0, i = n.length, t; o < i; o++)
    (t || !(o in n)) && (t || (t = Array.prototype.slice.call(n, 0, o)), t[o] = n[o]);
  return e.concat(t || Array.prototype.slice.call(n));
}
var Br = "right-scroll-bar-position", Wr = "width-before-scroll-bar", N1 = "with-scroll-bars-hidden", P1 = "--removed-body-scroll-bar-size";
function qn(e, n) {
  return typeof e == "function" ? e(n) : e && (e.current = n), e;
}
function k1(e, n) {
  var r = j(function() {
    return {
      // value
      value: e,
      // last callback
      callback: n,
      // "memoized" public interface
      facade: {
        get current() {
          return r.value;
        },
        set current(o) {
          var i = r.value;
          i !== o && (r.value = o, r.callback(o, i));
        }
      }
    };
  })[0];
  return r.callback = n, r.facade;
}
var O1 = typeof window < "u" ? s.useLayoutEffect : s.useEffect, hl = /* @__PURE__ */ new WeakMap();
function A1(e, n) {
  var r = k1(null, function(o) {
    return e.forEach(function(i) {
      return qn(i, o);
    });
  });
  return O1(function() {
    var o = hl.get(r);
    if (o) {
      var i = new Set(o), t = new Set(e), a = r.current;
      i.forEach(function(l) {
        t.has(l) || qn(l, null);
      }), t.forEach(function(l) {
        i.has(l) || qn(l, a);
      });
    }
    hl.set(r, e);
  }, [e]), r;
}
function M1(e) {
  return e;
}
function F1(e, n) {
  n === void 0 && (n = M1);
  var r = [], o = !1, i = {
    read: function() {
      if (o)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return r.length ? r[r.length - 1] : e;
    },
    useMedium: function(t) {
      var a = n(t, o);
      return r.push(a), function() {
        r = r.filter(function(l) {
          return l !== a;
        });
      };
    },
    assignSyncMedium: function(t) {
      for (o = !0; r.length; ) {
        var a = r;
        r = [], a.forEach(t);
      }
      r = {
        push: function(l) {
          return t(l);
        },
        filter: function() {
          return r;
        }
      };
    },
    assignMedium: function(t) {
      o = !0;
      var a = [];
      if (r.length) {
        var l = r;
        r = [], l.forEach(t), a = r;
      }
      var u = function() {
        var p = a;
        a = [], p.forEach(t);
      }, c = function() {
        return Promise.resolve().then(u);
      };
      c(), r = {
        push: function(p) {
          a.push(p), c();
        },
        filter: function(p) {
          return a = a.filter(p), r;
        }
      };
    }
  };
  return i;
}
function D1(e) {
  e === void 0 && (e = {});
  var n = F1(null);
  return n.options = we({ async: !0, ssr: !1 }, e), n;
}
var Ls = function(e) {
  var n = e.sideCar, r = Ts(e, ["sideCar"]);
  if (!n)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var o = n.read();
  if (!o)
    throw new Error("Sidecar medium not found");
  return s.createElement(o, we({}, r));
};
Ls.isSideCarExport = !0;
function T1(e, n) {
  return e.useMedium(n), Ls;
}
var js = D1(), Hn = function() {
}, an = s.forwardRef(function(e, n) {
  var r = s.useRef(null), o = s.useState({
    onScrollCapture: Hn,
    onWheelCapture: Hn,
    onTouchMoveCapture: Hn
  }), i = o[0], t = o[1], a = e.forwardProps, l = e.children, u = e.className, c = e.removeScrollBar, p = e.enabled, _ = e.shards, g = e.sideCar, f = e.noIsolation, m = e.inert, h = e.allowPinchZoom, v = e.as, w = v === void 0 ? "div" : v, y = e.gapMode, b = Ts(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), $ = g, x = A1([r, n]), R = we(we({}, b), i);
  return s.createElement(
    s.Fragment,
    null,
    p && s.createElement($, { sideCar: js, removeScrollBar: c, shards: _, noIsolation: f, inert: m, setCallbacks: t, allowPinchZoom: !!h, lockRef: r, gapMode: y }),
    a ? s.cloneElement(s.Children.only(l), we(we({}, R), { ref: x })) : s.createElement(w, we({}, R, { className: u, ref: x }), l)
  );
});
an.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
an.classNames = {
  fullWidth: Wr,
  zeroRight: Br
};
var L1 = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function j1() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var n = L1();
  return n && e.setAttribute("nonce", n), e;
}
function I1(e, n) {
  e.styleSheet ? e.styleSheet.cssText = n : e.appendChild(document.createTextNode(n));
}
function V1(e) {
  var n = document.head || document.getElementsByTagName("head")[0];
  n.appendChild(e);
}
var z1 = function() {
  var e = 0, n = null;
  return {
    add: function(r) {
      e == 0 && (n = j1()) && (I1(n, r), V1(n)), e++;
    },
    remove: function() {
      e--, !e && n && (n.parentNode && n.parentNode.removeChild(n), n = null);
    }
  };
}, q1 = function() {
  var e = z1();
  return function(n, r) {
    s.useEffect(function() {
      return e.add(n), function() {
        e.remove();
      };
    }, [n && r]);
  };
}, Is = function() {
  var e = q1(), n = function(r) {
    var o = r.styles, i = r.dynamic;
    return e(o, i), null;
  };
  return n;
}, H1 = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Bn = function(e) {
  return parseInt(e || "", 10) || 0;
}, B1 = function(e) {
  var n = window.getComputedStyle(document.body), r = n[e === "padding" ? "paddingLeft" : "marginLeft"], o = n[e === "padding" ? "paddingTop" : "marginTop"], i = n[e === "padding" ? "paddingRight" : "marginRight"];
  return [Bn(r), Bn(o), Bn(i)];
}, W1 = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return H1;
  var n = B1(e), r = document.documentElement.clientWidth, o = window.innerWidth;
  return {
    left: n[0],
    top: n[1],
    right: n[2],
    gap: Math.max(0, o - r + n[2] - n[0])
  };
}, G1 = Is(), Et = "data-scroll-locked", Z1 = function(e, n, r, o) {
  var i = e.left, t = e.top, a = e.right, l = e.gap;
  return r === void 0 && (r = "margin"), `
  .`.concat(N1, ` {
   overflow: hidden `).concat(o, `;
   padding-right: `).concat(l, "px ").concat(o, `;
  }
  body[`).concat(Et, `] {
    overflow: hidden `).concat(o, `;
    overscroll-behavior: contain;
    `).concat([
    n && "position: relative ".concat(o, ";"),
    r === "margin" && `
    padding-left: `.concat(i, `px;
    padding-top: `).concat(t, `px;
    padding-right: `).concat(a, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(l, "px ").concat(o, `;
    `),
    r === "padding" && "padding-right: ".concat(l, "px ").concat(o, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Br, ` {
    right: `).concat(l, "px ").concat(o, `;
  }
  
  .`).concat(Wr, ` {
    margin-right: `).concat(l, "px ").concat(o, `;
  }
  
  .`).concat(Br, " .").concat(Br, ` {
    right: 0 `).concat(o, `;
  }
  
  .`).concat(Wr, " .").concat(Wr, ` {
    margin-right: 0 `).concat(o, `;
  }
  
  body[`).concat(Et, `] {
    `).concat(P1, ": ").concat(l, `px;
  }
`);
}, ml = function() {
  var e = parseInt(document.body.getAttribute(Et) || "0", 10);
  return isFinite(e) ? e : 0;
}, U1 = function() {
  s.useEffect(function() {
    return document.body.setAttribute(Et, (ml() + 1).toString()), function() {
      var e = ml() - 1;
      e <= 0 ? document.body.removeAttribute(Et) : document.body.setAttribute(Et, e.toString());
    };
  }, []);
}, X1 = function(e) {
  var n = e.noRelative, r = e.noImportant, o = e.gapMode, i = o === void 0 ? "margin" : o;
  U1();
  var t = s.useMemo(function() {
    return W1(i);
  }, [i]);
  return s.createElement(G1, { styles: Z1(t, !n, i, r ? "" : "!important") });
}, So = !1;
if (typeof window < "u")
  try {
    var Fr = Object.defineProperty({}, "passive", {
      get: function() {
        return So = !0, !0;
      }
    });
    window.addEventListener("test", Fr, Fr), window.removeEventListener("test", Fr, Fr);
  } catch {
    So = !1;
  }
var _t = So ? { passive: !1 } : !1, Y1 = function(e) {
  return e.tagName === "TEXTAREA";
}, Vs = function(e, n) {
  if (!(e instanceof Element))
    return !1;
  var r = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    r[n] !== "hidden" && // contains scroll inside self
    !(r.overflowY === r.overflowX && !Y1(e) && r[n] === "visible")
  );
}, K1 = function(e) {
  return Vs(e, "overflowY");
}, J1 = function(e) {
  return Vs(e, "overflowX");
}, vl = function(e, n) {
  var r = n.ownerDocument, o = n;
  do {
    typeof ShadowRoot < "u" && o instanceof ShadowRoot && (o = o.host);
    var i = zs(e, o);
    if (i) {
      var t = qs(e, o), a = t[1], l = t[2];
      if (a > l)
        return !0;
    }
    o = o.parentNode;
  } while (o && o !== r.body);
  return !1;
}, Q1 = function(e) {
  var n = e.scrollTop, r = e.scrollHeight, o = e.clientHeight;
  return [
    n,
    r,
    o
  ];
}, e0 = function(e) {
  var n = e.scrollLeft, r = e.scrollWidth, o = e.clientWidth;
  return [
    n,
    r,
    o
  ];
}, zs = function(e, n) {
  return e === "v" ? K1(n) : J1(n);
}, qs = function(e, n) {
  return e === "v" ? Q1(n) : e0(n);
}, t0 = function(e, n) {
  return e === "h" && n === "rtl" ? -1 : 1;
}, r0 = function(e, n, r, o, i) {
  var t = t0(e, window.getComputedStyle(n).direction), a = t * o, l = r.target, u = n.contains(l), c = !1, p = a > 0, _ = 0, g = 0;
  do {
    var f = qs(e, l), m = f[0], h = f[1], v = f[2], w = h - v - t * m;
    (m || w) && zs(e, l) && (_ += w, g += m), l instanceof ShadowRoot ? l = l.host : l = l.parentNode;
  } while (
    // portaled content
    !u && l !== document.body || // self content
    u && (n.contains(l) || n === l)
  );
  return (p && Math.abs(_) < 1 || !p && Math.abs(g) < 1) && (c = !0), c;
}, Dr = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, wl = function(e) {
  return [e.deltaX, e.deltaY];
}, yl = function(e) {
  return e && "current" in e ? e.current : e;
}, n0 = function(e, n) {
  return e[0] === n[0] && e[1] === n[1];
}, o0 = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, i0 = 0, ht = [];
function a0(e) {
  var n = s.useRef([]), r = s.useRef([0, 0]), o = s.useRef(), i = s.useState(i0++)[0], t = s.useState(Is)[0], a = s.useRef(e);
  s.useEffect(function() {
    a.current = e;
  }, [e]), s.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(i));
      var h = E1([e.lockRef.current], (e.shards || []).map(yl)).filter(Boolean);
      return h.forEach(function(v) {
        return v.classList.add("allow-interactivity-".concat(i));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(i)), h.forEach(function(v) {
          return v.classList.remove("allow-interactivity-".concat(i));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var l = s.useCallback(function(h, v) {
    if ("touches" in h && h.touches.length === 2 || h.type === "wheel" && h.ctrlKey)
      return !a.current.allowPinchZoom;
    var w = Dr(h), y = r.current, b = "deltaX" in h ? h.deltaX : y[0] - w[0], $ = "deltaY" in h ? h.deltaY : y[1] - w[1], x, R = h.target, S = Math.abs(b) > Math.abs($) ? "h" : "v";
    if ("touches" in h && S === "h" && R.type === "range")
      return !1;
    var O = vl(S, R);
    if (!O)
      return !0;
    if (O ? x = S : (x = S === "v" ? "h" : "v", O = vl(S, R)), !O)
      return !1;
    if (!o.current && "changedTouches" in h && (b || $) && (o.current = x), !x)
      return !0;
    var E = o.current || x;
    return r0(E, v, h, E === "h" ? b : $);
  }, []), u = s.useCallback(function(h) {
    var v = h;
    if (!(!ht.length || ht[ht.length - 1] !== t)) {
      var w = "deltaY" in v ? wl(v) : Dr(v), y = n.current.filter(function(x) {
        return x.name === v.type && (x.target === v.target || v.target === x.shadowParent) && n0(x.delta, w);
      })[0];
      if (y && y.should) {
        v.cancelable && v.preventDefault();
        return;
      }
      if (!y) {
        var b = (a.current.shards || []).map(yl).filter(Boolean).filter(function(x) {
          return x.contains(v.target);
        }), $ = b.length > 0 ? l(v, b[0]) : !a.current.noIsolation;
        $ && v.cancelable && v.preventDefault();
      }
    }
  }, []), c = s.useCallback(function(h, v, w, y) {
    var b = { name: h, delta: v, target: w, should: y, shadowParent: l0(w) };
    n.current.push(b), setTimeout(function() {
      n.current = n.current.filter(function($) {
        return $ !== b;
      });
    }, 1);
  }, []), p = s.useCallback(function(h) {
    r.current = Dr(h), o.current = void 0;
  }, []), _ = s.useCallback(function(h) {
    c(h.type, wl(h), h.target, l(h, e.lockRef.current));
  }, []), g = s.useCallback(function(h) {
    c(h.type, Dr(h), h.target, l(h, e.lockRef.current));
  }, []);
  s.useEffect(function() {
    return ht.push(t), e.setCallbacks({
      onScrollCapture: _,
      onWheelCapture: _,
      onTouchMoveCapture: g
    }), document.addEventListener("wheel", u, _t), document.addEventListener("touchmove", u, _t), document.addEventListener("touchstart", p, _t), function() {
      ht = ht.filter(function(h) {
        return h !== t;
      }), document.removeEventListener("wheel", u, _t), document.removeEventListener("touchmove", u, _t), document.removeEventListener("touchstart", p, _t);
    };
  }, []);
  var f = e.removeScrollBar, m = e.inert;
  return s.createElement(
    s.Fragment,
    null,
    m ? s.createElement(t, { styles: o0(i) }) : null,
    f ? s.createElement(X1, { gapMode: e.gapMode }) : null
  );
}
function l0(e) {
  for (var n = null; e !== null; )
    e instanceof ShadowRoot && (n = e.host, e = e.host), e = e.parentNode;
  return n;
}
const u0 = T1(js, a0);
var Hs = s.forwardRef(function(e, n) {
  return s.createElement(an, we({}, e, { ref: n, sideCar: u0 }));
});
Hs.classNames = an.classNames;
var s0 = function(e) {
  if (typeof document > "u")
    return null;
  var n = Array.isArray(e) ? e[0] : e;
  return n.ownerDocument.body;
}, mt = /* @__PURE__ */ new WeakMap(), Tr = /* @__PURE__ */ new WeakMap(), Lr = {}, Wn = 0, Bs = function(e) {
  return e && (e.host || Bs(e.parentNode));
}, c0 = function(e, n) {
  return n.map(function(r) {
    if (e.contains(r))
      return r;
    var o = Bs(r);
    return o && e.contains(o) ? o : (console.error("aria-hidden", r, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(r) {
    return !!r;
  });
}, p0 = function(e, n, r, o) {
  var i = c0(n, Array.isArray(e) ? e : [e]);
  Lr[r] || (Lr[r] = /* @__PURE__ */ new WeakMap());
  var t = Lr[r], a = [], l = /* @__PURE__ */ new Set(), u = new Set(i), c = function(_) {
    !_ || l.has(_) || (l.add(_), c(_.parentNode));
  };
  i.forEach(c);
  var p = function(_) {
    !_ || u.has(_) || Array.prototype.forEach.call(_.children, function(g) {
      if (l.has(g))
        p(g);
      else
        try {
          var f = g.getAttribute(o), m = f !== null && f !== "false", h = (mt.get(g) || 0) + 1, v = (t.get(g) || 0) + 1;
          mt.set(g, h), t.set(g, v), a.push(g), h === 1 && m && Tr.set(g, !0), v === 1 && g.setAttribute(r, "true"), m || g.setAttribute(o, "true");
        } catch (w) {
          console.error("aria-hidden: cannot operate on ", g, w);
        }
    });
  };
  return p(n), l.clear(), Wn++, function() {
    a.forEach(function(_) {
      var g = mt.get(_) - 1, f = t.get(_) - 1;
      mt.set(_, g), t.set(_, f), g || (Tr.has(_) || _.removeAttribute(o), Tr.delete(_)), f || _.removeAttribute(r);
    }), Wn--, Wn || (mt = /* @__PURE__ */ new WeakMap(), mt = /* @__PURE__ */ new WeakMap(), Tr = /* @__PURE__ */ new WeakMap(), Lr = {});
  };
}, d0 = function(e, n, r) {
  r === void 0 && (r = "data-aria-hidden");
  var o = Array.from(Array.isArray(e) ? e : [e]), i = s0(e);
  return i ? (o.push.apply(o, Array.from(i.querySelectorAll("[aria-live]"))), p0(o, i, r, "aria-hidden")) : function() {
    return null;
  };
}, Xo = "Dialog", [Ws, Yx] = Ps(Xo), [f0, he] = Ws(Xo), Gs = (e) => {
  const {
    __scopeDialog: n,
    children: r,
    open: o,
    defaultOpen: i,
    onOpenChange: t,
    modal: a = !0
  } = e, l = s.useRef(null), u = s.useRef(null), [c = !1, p] = Qv({
    prop: o,
    defaultProp: i,
    onChange: t
  });
  return /* @__PURE__ */ d(
    f0,
    {
      scope: n,
      triggerRef: l,
      contentRef: u,
      contentId: jn(),
      titleId: jn(),
      descriptionId: jn(),
      open: c,
      onOpenChange: p,
      onOpenToggle: s.useCallback(() => p((_) => !_), [p]),
      modal: a,
      children: r
    }
  );
};
Gs.displayName = Xo;
var Zs = "DialogTrigger", Us = s.forwardRef(
  (e, n) => {
    const { __scopeDialog: r, ...o } = e, i = he(Zs, r), t = ie(n, i.triggerRef);
    return /* @__PURE__ */ d(
      Q.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": i.open,
        "aria-controls": i.contentId,
        "data-state": Jo(i.open),
        ...o,
        ref: t,
        onClick: Y(e.onClick, i.onOpenToggle)
      }
    );
  }
);
Us.displayName = Zs;
var Yo = "DialogPortal", [g0, Xs] = Ws(Yo, {
  forceMount: void 0
}), Ys = (e) => {
  const { __scopeDialog: n, forceMount: r, children: o, container: i } = e, t = he(Yo, n);
  return /* @__PURE__ */ d(g0, { scope: n, forceMount: r, children: s.Children.map(o, (a) => /* @__PURE__ */ d(Ge, { present: r || t.open, children: /* @__PURE__ */ d(Ds, { asChild: !0, container: i, children: a }) })) });
};
Ys.displayName = Yo;
var Zr = "DialogOverlay", Ks = s.forwardRef(
  (e, n) => {
    const r = Xs(Zr, e.__scopeDialog), { forceMount: o = r.forceMount, ...i } = e, t = he(Zr, e.__scopeDialog);
    return t.modal ? /* @__PURE__ */ d(Ge, { present: o || t.open, children: /* @__PURE__ */ d(_0, { ...i, ref: n }) }) : null;
  }
);
Ks.displayName = Zr;
var _0 = s.forwardRef(
  (e, n) => {
    const { __scopeDialog: r, ...o } = e, i = he(Zr, r);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ d(Hs, { as: Uo, allowPinchZoom: !0, shards: [i.contentRef], children: /* @__PURE__ */ d(
        Q.div,
        {
          "data-state": Jo(i.open),
          ...o,
          ref: n,
          style: { pointerEvents: "auto", ...o.style }
        }
      ) })
    );
  }
), rt = "DialogContent", Js = s.forwardRef(
  (e, n) => {
    const r = Xs(rt, e.__scopeDialog), { forceMount: o = r.forceMount, ...i } = e, t = he(rt, e.__scopeDialog);
    return /* @__PURE__ */ d(Ge, { present: o || t.open, children: t.modal ? /* @__PURE__ */ d(h0, { ...i, ref: n }) : /* @__PURE__ */ d(m0, { ...i, ref: n }) });
  }
);
Js.displayName = rt;
var h0 = s.forwardRef(
  (e, n) => {
    const r = he(rt, e.__scopeDialog), o = s.useRef(null), i = ie(n, r.contentRef, o);
    return s.useEffect(() => {
      const t = o.current;
      if (t) return d0(t);
    }, []), /* @__PURE__ */ d(
      Qs,
      {
        ...e,
        ref: i,
        trapFocus: r.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: Y(e.onCloseAutoFocus, (t) => {
          var a;
          t.preventDefault(), (a = r.triggerRef.current) == null || a.focus();
        }),
        onPointerDownOutside: Y(e.onPointerDownOutside, (t) => {
          const a = t.detail.originalEvent, l = a.button === 0 && a.ctrlKey === !0;
          (a.button === 2 || l) && t.preventDefault();
        }),
        onFocusOutside: Y(
          e.onFocusOutside,
          (t) => t.preventDefault()
        )
      }
    );
  }
), m0 = s.forwardRef(
  (e, n) => {
    const r = he(rt, e.__scopeDialog), o = s.useRef(!1), i = s.useRef(!1);
    return /* @__PURE__ */ d(
      Qs,
      {
        ...e,
        ref: n,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (t) => {
          var a, l;
          (a = e.onCloseAutoFocus) == null || a.call(e, t), t.defaultPrevented || (o.current || (l = r.triggerRef.current) == null || l.focus(), t.preventDefault()), o.current = !1, i.current = !1;
        },
        onInteractOutside: (t) => {
          var a, l;
          (a = e.onInteractOutside) == null || a.call(e, t), t.defaultPrevented || (o.current = !0, t.detail.originalEvent.type === "pointerdown" && (i.current = !0));
          const u = t.target;
          (l = r.triggerRef.current) != null && l.contains(u) && t.preventDefault(), t.detail.originalEvent.type === "focusin" && i.current && t.preventDefault();
        }
      }
    );
  }
), Qs = s.forwardRef(
  (e, n) => {
    const { __scopeDialog: r, trapFocus: o, onOpenAutoFocus: i, onCloseAutoFocus: t, ...a } = e, l = he(rt, r), u = s.useRef(null), c = ie(n, u);
    return R1(), /* @__PURE__ */ C(q, { children: [
      /* @__PURE__ */ d(
        Ms,
        {
          asChild: !0,
          loop: !0,
          trapped: o,
          onMountAutoFocus: i,
          onUnmountAutoFocus: t,
          children: /* @__PURE__ */ d(
            Os,
            {
              role: "dialog",
              id: l.contentId,
              "aria-describedby": l.descriptionId,
              "aria-labelledby": l.titleId,
              "data-state": Jo(l.open),
              ...a,
              ref: c,
              onDismiss: () => l.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ C(q, { children: [
        /* @__PURE__ */ d(v0, { titleId: l.titleId }),
        /* @__PURE__ */ d(y0, { contentRef: u, descriptionId: l.descriptionId })
      ] })
    ] });
  }
), Ko = "DialogTitle", ec = s.forwardRef(
  (e, n) => {
    const { __scopeDialog: r, ...o } = e, i = he(Ko, r);
    return /* @__PURE__ */ d(Q.h2, { id: i.titleId, ...o, ref: n });
  }
);
ec.displayName = Ko;
var tc = "DialogDescription", rc = s.forwardRef(
  (e, n) => {
    const { __scopeDialog: r, ...o } = e, i = he(tc, r);
    return /* @__PURE__ */ d(Q.p, { id: i.descriptionId, ...o, ref: n });
  }
);
rc.displayName = tc;
var nc = "DialogClose", oc = s.forwardRef(
  (e, n) => {
    const { __scopeDialog: r, ...o } = e, i = he(nc, r);
    return /* @__PURE__ */ d(
      Q.button,
      {
        type: "button",
        ...o,
        ref: n,
        onClick: Y(e.onClick, () => i.onOpenChange(!1))
      }
    );
  }
);
oc.displayName = nc;
function Jo(e) {
  return e ? "open" : "closed";
}
var ic = "DialogTitleWarning", [Kx, ac] = Xv(ic, {
  contentName: rt,
  titleName: Ko,
  docsSlug: "dialog"
}), v0 = ({ titleId: e }) => {
  const n = ac(ic), r = `\`${n.contentName}\` requires a \`${n.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${n.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${n.docsSlug}`;
  return s.useEffect(() => {
    e && (document.getElementById(e) || console.error(r));
  }, [r, e]), null;
}, w0 = "DialogDescriptionWarning", y0 = ({ contentRef: e, descriptionId: n }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${ac(w0).contentName}}.`;
  return s.useEffect(() => {
    var o;
    const i = (o = e.current) == null ? void 0 : o.getAttribute("aria-describedby");
    n && i && (document.getElementById(n) || console.warn(r));
  }, [r, e, n]), null;
}, b0 = Gs, $0 = Us, x0 = Ys, S0 = Ks, C0 = Js, jr = ec, R0 = rc, E0 = oc;
function N0(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var bl = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var $l;
function P0() {
  return $l || ($l = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o.call(this, l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return this && this[t] || t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(this, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, this && this[l] || l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(bl)), bl.exports;
}
var k0 = P0();
const at = /* @__PURE__ */ N0(k0), lc = Ip(null), O0 = {}, A0 = "_drawerSmallScreenAnimation_1xk2s_1", M0 = "_drawerLargeScreenAnimation_1xk2s_1", F0 = "_slideDown_1xk2s_1", D0 = "_overlayAnimation_1xk2s_1", T0 = {
  "purpur-drawer-content": "_purpur-drawer-content_1xk2s_1",
  drawerSmallScreenAnimation: A0,
  "purpur-drawer-content--fit-to-content": "_purpur-drawer-content--fit-to-content_1xk2s_12",
  drawerLargeScreenAnimation: M0,
  "purpur-drawer-content__content-container": "_purpur-drawer-content__content-container_1xk2s_35",
  "purpur-drawer-content__drawer-frame": "_purpur-drawer-content__drawer-frame_1xk2s_40",
  slideDown: F0,
  "purpur-drawer-content__description": "_purpur-drawer-content__description_1xk2s_50",
  "purpur-drawer-overlay": "_purpur-drawer-overlay_1xk2s_61",
  overlayAnimation: D0
}, L0 = {
  "purpur-drawer-container--header": "_purpur-drawer-container--header_1u45h_1",
  "purpur-drawer-container--body": "_purpur-drawer-container--body_1u45h_10",
  "purpur-drawer-container--sticky": "_purpur-drawer-container--sticky_1u45h_18",
  "purpur-drawer-container--footer": "_purpur-drawer-container--footer_1u45h_26"
}, j0 = at.bind(L0), Gn = "purpur-drawer-container", Ct = W(
  ({
    ["data-testid"]: e = "purpur-drawer-container",
    children: n,
    className: r,
    variant: o = "body",
    stickyFooter: i,
    ...t
  }, a) => {
    const l = j0([
      r,
      Gn,
      {
        [`${Gn}--${o}`]: o
      },
      {
        [`${Gn}--sticky`]: i
      }
    ]);
    return /* @__PURE__ */ d("div", { className: l, "data-testid": e, ref: a, ...t, children: n });
  }
);
Ct.displayName = "DrawerContainer";
const I0 = {
  "purpur-drawer-frame": "_purpur-drawer-frame_1gdvv_1",
  "purpur-drawer-frame--sticky-footer": "_purpur-drawer-frame--sticky-footer_1gdvv_17",
  "purpur-drawer-frame__header": "_purpur-drawer-frame__header_1gdvv_20",
  "purpur-drawer-frame__body": "_purpur-drawer-frame__body_1gdvv_23",
  "purpur-drawer-frame--fit-to-content": "_purpur-drawer-frame--fit-to-content_1gdvv_27",
  "purpur-drawer-frame__footer": "_purpur-drawer-frame__footer_1gdvv_36",
  "purpur-drawer-frame__content-container": "_purpur-drawer-frame__content-container_1gdvv_39",
  "purpur-drawer-frame__content-container--no-footer": "_purpur-drawer-frame__content-container--no-footer_1gdvv_44"
}, V0 = {
  "purpur-drawer-handle": "_purpur-drawer-handle_3n0ew_1"
}, z0 = (e, n, r, o, i, t) => ({
  onPointerDown: (a) => {
    e.current = { y: a.clientY };
  },
  onPointerMove: (a) => {
    if (!e.current)
      return;
    const l = a.clientY - e.current.y, u = !!n.current, c = Math.max(0, l), p = a.pointerType === "touch" ? 10 : 2, _ = { y: c }, g = { originalEvent: a, delta: _ };
    u ? (n.current = _, o(g)) : xl(_, 0) ? (n.current = _, r(), a.target.setPointerCapture(a.pointerId)) : Math.abs(l) > p && (e.current = null);
  },
  onPointerUp: (a) => {
    const l = n.current, u = a.target;
    if (u.hasPointerCapture(a.pointerId) && u.releasePointerCapture(a.pointerId), n.current = null, e.current = null, l) {
      const c = a.currentTarget, p = { originalEvent: a, delta: l };
      xl(l, 0) && l.y > 200 ? t(p) : i(), c.addEventListener("click", (_) => _.preventDefault(), {
        once: !0
      });
    }
  }
}), xl = (e, n = 0) => Math.abs(e.y) > n, q0 = at.bind(V0), H0 = "purpur-drawer-handle", uc = W(
  ({
    ["data-testid"]: e = "purpur-drawer-handle",
    className: n,
    onSwipeStart: r,
    onSwipeMove: o,
    onSwipeCancel: i,
    onSwipeEnd: t,
    ...a
  }, l) => {
    const u = q0([n, H0]), c = io.useRef(null), p = io.useRef(null), { onPointerDown: _, onPointerMove: g, onPointerUp: f } = z0(
      p,
      c,
      r,
      o,
      i,
      t
    );
    return /* @__PURE__ */ d(
      "div",
      {
        className: u,
        "data-testid": e,
        onPointerDown: _,
        onPointerMove: g,
        onPointerUp: f,
        ref: l,
        ...a
      }
    );
  }
);
uc.displayName = "DrawerHandle";
const B0 = {
  LG: "lg"
};
function W0(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Sl = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Cl;
function G0() {
  return Cl || (Cl = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o(l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(null, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(Sl)), Sl.exports;
}
var Z0 = G0();
const Rl = /* @__PURE__ */ W0(Z0), U0 = "_rotate_1xozj_1", X0 = "_dash_1xozj_1", nr = {
  "purpur-spinner": "_purpur-spinner_1xozj_1",
  rotate: U0,
  "purpur-spinner--xxs": "_purpur-spinner--xxs_1xozj_4",
  "purpur-spinner--xs": "_purpur-spinner--xs_1xozj_8",
  "purpur-spinner--sm": "_purpur-spinner--sm_1xozj_12",
  "purpur-spinner--md": "_purpur-spinner--md_1xozj_16",
  "purpur-spinner--lg": "_purpur-spinner--lg_1xozj_20",
  "purpur-spinner__circle": "_purpur-spinner__circle_1xozj_24",
  dash: X0,
  "purpur-spinner__circle--disabled": "_purpur-spinner__circle--disabled_1xozj_33",
  "purpur-spinner__circle--negative": "_purpur-spinner__circle--negative_1xozj_36"
}, or = "purpur-spinner", Y0 = {
  SM: "sm"
}, K0 = ({
  ["data-testid"]: e,
  disabled: n = !1,
  negative: r = !1,
  size: o = Y0.SM,
  ...i
}) => /* @__PURE__ */ d(
  "div",
  {
    className: Rl([nr[or], nr[`${or}--${o}`]]),
    "data-testid": e,
    ...i,
    children: /* @__PURE__ */ d("svg", { viewBox: "0 0 50 50", children: /* @__PURE__ */ d(
      "circle",
      {
        className: Rl(nr[`${or}__circle`], {
          [nr[`${or}__circle--disabled`]]: n,
          [nr[`${or}__circle--negative`]]: r
        }),
        cx: "25",
        cy: "25",
        r: "20"
      }
    ) })
  }
);
function J0(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var El = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Nl;
function Q0() {
  return Nl || (Nl = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o.call(this, l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return this && this[t] || t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(this, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, this && this[l] || l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(El)), El.exports;
}
var ew = Q0();
const tw = /* @__PURE__ */ J0(ew), rw = {
  "purpur-button": "_purpur-button_w455q_1",
  "purpur-button--xs": "_purpur-button--xs_w455q_33",
  "purpur-button--icon-only": "_purpur-button--icon-only_w455q_36",
  "purpur-button--sm": "_purpur-button--sm_w455q_39",
  "purpur-button--md": "_purpur-button--md_w455q_45",
  "purpur-button--lg": "_purpur-button--lg_w455q_51",
  "purpur-button--full-width": "_purpur-button--full-width_w455q_57",
  "purpur-button--primary": "_purpur-button--primary_w455q_60",
  "purpur-button--disabled": "_purpur-button--disabled_w455q_64",
  "purpur-button--primary-negative": "_purpur-button--primary-negative_w455q_70",
  "purpur-button--secondary": "_purpur-button--secondary_w455q_82",
  "purpur-button--secondary-negative": "_purpur-button--secondary-negative_w455q_93",
  "purpur-button--expressive": "_purpur-button--expressive_w455q_104",
  "purpur-button--expressive-negative": "_purpur-button--expressive-negative_w455q_114",
  "purpur-button--negative": "_purpur-button--negative_w455q_126",
  "purpur-button--destructive": "_purpur-button--destructive_w455q_133",
  "purpur-button--destructive-negative": "_purpur-button--destructive-negative_w455q_143",
  "purpur-button--tertiary-purple": "_purpur-button--tertiary-purple_w455q_153",
  "purpur-button--tertiary-purple-negative": "_purpur-button--tertiary-purple-negative_w455q_166",
  "purpur-button--text-negative": "_purpur-button--text-negative_w455q_181",
  "purpur-button--text": "_purpur-button--text_w455q_181"
}, Zn = {
  TERTIARY_PURPLE: "tertiary-purple",
  TEXT: "text"
}, nw = tw.bind(rw), Qe = "purpur-button", ow = ({
  children: e,
  className: n,
  ["data-testid"]: r,
  disabled: o = !1,
  fullWidth: i = !1,
  iconOnly: t,
  loading: a = !1,
  negative: l = !1,
  onClick: u,
  size: c = "md",
  variant: p,
  type: _ = "button",
  ...g
}, f) => {
  if (t && p === "destructive")
    return null;
  const m = nw(
    [
      Qe,
      `${Qe}--${l ? `${p}-negative` : p}`,
      `${Qe}--${c}`
    ],
    {
      [`${Qe}--icon-only`]: t,
      [`${Qe}--negative`]: l,
      [`${Qe}--full-width`]: i,
      [`${Qe}--disabled`]: o || a
    },
    n
  ), h = (w) => {
    o || a ? w.preventDefault() : u && u(w);
  }, v = !!g["aria-disabled"] || o || a;
  return /* @__PURE__ */ C(
    "button",
    {
      className: m,
      "data-testid": r,
      type: _,
      ref: f,
      "aria-disabled": v,
      onClick: h,
      ...g,
      children: [
        a && /* @__PURE__ */ d(K0, { size: c === B0.LG ? "xs" : "xxs", negative: l, disabled: v }),
        " ",
        e
      ]
    }
  );
}, Co = W(ow);
Co.displayName = "Button";
function iw(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Pl = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var kl;
function aw() {
  return kl || (kl = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o(l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(null, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(Pl)), Pl.exports;
}
var lw = aw();
const uw = /* @__PURE__ */ iw(lw), Ir = {
  "purpur-heading": "_purpur-heading_k9fhq_1",
  "purpur-heading--hyphens": "_purpur-heading--hyphens_k9fhq_8",
  "purpur-heading--negative": "_purpur-heading--negative_k9fhq_11",
  "purpur-heading--subsection-100": "_purpur-heading--subsection-100_k9fhq_14",
  "purpur-heading--title-100": "_purpur-heading--title-100_k9fhq_20",
  "purpur-heading--title-200": "_purpur-heading--title-200_k9fhq_26",
  "purpur-heading--title-300": "_purpur-heading--title-300_k9fhq_32",
  "purpur-heading--title-400": "_purpur-heading--title-400_k9fhq_38",
  "purpur-heading--title-500": "_purpur-heading--title-500_k9fhq_44",
  "purpur-heading--title-600": "_purpur-heading--title-600_k9fhq_50",
  "purpur-heading--title-700": "_purpur-heading--title-700_k9fhq_56",
  "purpur-heading--display-25": "_purpur-heading--display-25_k9fhq_62",
  "purpur-heading--display-50": "_purpur-heading--display-50_k9fhq_68",
  "purpur-heading--display-100": "_purpur-heading--display-100_k9fhq_74",
  "purpur-heading--display-200": "_purpur-heading--display-200_k9fhq_80"
}, Ro = {
  TITLE100: "title-100",
  TITLE200: "title-200"
}, Vr = "purpur-heading", Eo = ({
  children: e,
  className: n = "",
  enableHyphenation: r = !1,
  negative: o = !1,
  tag: i,
  variant: t = Ro.TITLE100,
  ...a
}) => {
  const l = i, u = uw([
    n,
    Ir[Vr],
    Ir[`${Vr}--${t}`],
    {
      [Ir[`${Vr}--hyphens`]]: r,
      [Ir[`${Vr}--negative`]]: o
    }
  ]);
  return /* @__PURE__ */ d(l, { className: u, ...a, children: e });
};
Eo.displayName = "Heading";
function sw(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ol = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Al;
function cw() {
  return Al || (Al = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o.call(this, l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return this && this[t] || t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(this, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, this && this[l] || l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(Ol)), Ol.exports;
}
var pw = cw();
const dw = /* @__PURE__ */ sw(pw), fw = {
  "purpur-icon": "_purpur-icon_8u1lq_1",
  "purpur-icon--xxs": "_purpur-icon--xxs_8u1lq_4",
  "purpur-icon--xs": "_purpur-icon--xs_8u1lq_8",
  "purpur-icon--sm": "_purpur-icon--sm_8u1lq_12",
  "purpur-icon--md": "_purpur-icon--md_8u1lq_16",
  "purpur-icon--lg": "_purpur-icon--lg_8u1lq_20",
  "purpur-icon--xl": "_purpur-icon--xl_8u1lq_24"
}, gw = dw.bind(fw), Ml = "purpur-icon", _w = "md", hw = (e) => e.filter((n) => Object.keys(n).length >= 1).map((n) => `${n.name}="${n.value}"`).join(" "), mw = ({ content: e = "", title: n } = {}) => {
  const r = [
    { name: "xmlns", value: "http://www.w3.org/2000/svg" },
    { name: "fill", value: "currentColor" },
    { name: "viewBox", value: "0 0 24 24" },
    n ? { name: "role", value: "img" } : { name: "aria-hidden", value: "true" }
  ], o = n ? `<title>${n}</title>` : "";
  return `<svg ${hw(r)}>${o}${e}</svg>`;
}, vw = (e) => e.replace(/<(\/?)svg([^>]*)>/g, "").trim(), Qo = ({
  ["data-testid"]: e,
  svg: n,
  allyTitle: r,
  className: o,
  size: i = _w,
  ...t
}) => {
  const a = mw({
    content: vw(n.svg),
    title: r
  }), l = gw(o, Ml, `${Ml}--${i}`);
  return /* @__PURE__ */ d(
    "span",
    {
      className: l,
      "data-testid": e,
      dangerouslySetInnerHTML: { __html: a },
      ...t
    }
  );
};
Qo.displayName = "Icon";
const ww = {
  name: "arrow-left",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M3.1 12a.9.9 0 0 1 .264-.636l5.5-5.5a.9.9 0 0 1 1.272 1.272L6.173 11.1H20a.9.9 0 0 1 0 1.8H6.173l3.963 3.964a.9.9 0 1 1-1.272 1.272l-5.5-5.5A.9.9 0 0 1 3.1 12Z" clip-rule="evenodd"/></svg>',
  keywords: ["arrow-left"],
  category: "utility"
}, sc = (e) => /* @__PURE__ */ d(Qo, { ...e, svg: ww });
sc.displayName = "IconArrowLeft";
const yw = {
  name: "close",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M4.864 4.864a.9.9 0 0 1 1.273 0L12 10.727l5.864-5.863a.9.9 0 0 1 1.272 1.272L13.273 12l5.863 5.864a.9.9 0 1 1-1.272 1.272L12 13.273l-5.863 5.863a.9.9 0 0 1-1.273-1.272L10.727 12 4.864 6.136a.9.9 0 0 1 0-1.272Z" clip-rule="evenodd"/></svg>',
  keywords: ["close"],
  category: "utility"
}, cc = (e) => /* @__PURE__ */ d(Qo, { ...e, svg: yw });
cc.displayName = "IconClose";
function Fl(e, n) {
  if (typeof e == "function")
    return e(n);
  e != null && (e.current = n);
}
function bw(...e) {
  return (n) => {
    let r = !1;
    const o = e.map((i) => {
      const t = Fl(i, n);
      return !r && typeof t == "function" && (r = !0), t;
    });
    if (r)
      return () => {
        for (let i = 0; i < o.length; i++) {
          const t = o[i];
          typeof t == "function" ? t() : Fl(e[i], null);
        }
      };
  };
}
var pc = s.forwardRef((e, n) => {
  const { children: r, ...o } = e, i = s.Children.toArray(r), t = i.find(xw);
  if (t) {
    const a = t.props.children, l = i.map((u) => u === t ? s.Children.count(a) > 1 ? s.Children.only(null) : s.isValidElement(a) ? a.props.children : null : u);
    return /* @__PURE__ */ d(No, { ...o, ref: n, children: s.isValidElement(a) ? s.cloneElement(a, void 0, l) : null });
  }
  return /* @__PURE__ */ d(No, { ...o, ref: n, children: r });
});
pc.displayName = "Slot";
var No = s.forwardRef((e, n) => {
  const { children: r, ...o } = e;
  if (s.isValidElement(r)) {
    const i = Cw(r), t = Sw(o, r.props);
    return r.type !== s.Fragment && (t.ref = n ? bw(n, i) : i), s.cloneElement(r, t);
  }
  return s.Children.count(r) > 1 ? s.Children.only(null) : null;
});
No.displayName = "SlotClone";
var $w = ({ children: e }) => /* @__PURE__ */ d(q, { children: e });
function xw(e) {
  return s.isValidElement(e) && e.type === $w;
}
function Sw(e, n) {
  const r = { ...n };
  for (const o in n) {
    const i = e[o], t = n[o];
    /^on[A-Z]/.test(o) ? i && t ? r[o] = (...a) => {
      t(...a), i(...a);
    } : i && (r[o] = i) : o === "style" ? r[o] = { ...i, ...t } : o === "className" && (r[o] = [i, t].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function Cw(e) {
  var n, r;
  let o = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, i = o && "isReactWarning" in o && o.isReactWarning;
  return i ? e.ref : (o = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, i = o && "isReactWarning" in o && o.isReactWarning, i ? e.props.ref : e.props.ref || e.ref);
}
var Rw = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Ew = Rw.reduce((e, n) => {
  const r = s.forwardRef((o, i) => {
    const { asChild: t, ...a } = o, l = t ? pc : n;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ d(l, { ...a, ref: i });
  });
  return r.displayName = `Primitive.${n}`, { ...e, [n]: r };
}, {}), Nw = "VisuallyHidden", dc = s.forwardRef(
  (e, n) => /* @__PURE__ */ d(
    Ew.span,
    {
      ...e,
      ref: n,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
dc.displayName = Nw;
var Pw = dc;
const Dl = ({
  asChild: e,
  children: n,
  className: r = "",
  ["data-testid"]: o
}) => /* @__PURE__ */ d(Pw, { asChild: e, "data-testid": o, className: r, children: n }), kw = {
  "purpur-drawer-header__row": "_purpur-drawer-header__row_1yg5w_1",
  "purpur-drawer-header__row--with-back-button": "_purpur-drawer-header__row--with-back-button_1yg5w_6",
  "purpur-drawer-header__left": "_purpur-drawer-header__left_1yg5w_9",
  "purpur-drawer-header__right": "_purpur-drawer-header__right_1yg5w_12",
  "purpur-drawer-header__close-button": "_purpur-drawer-header__close-button_1yg5w_15",
  "purpur-drawer-header__back-button--only-icon": "_purpur-drawer-header__back-button--only-icon_1yg5w_18"
}, vt = at.bind(kw), Le = "purpur-drawer-header", fc = W(
  ({
    ["data-testid"]: e = "purpur-drawer-header",
    backButton: n,
    backButtonText: r,
    backButtonOnlyIcon: o,
    className: i,
    closeButtonAriaLabel: t,
    headerContent: a,
    onBackButtonClick: l,
    title: u,
    ...c
  }, p) => {
    const _ = vt([i, Le]);
    return /* @__PURE__ */ C("div", { className: _, "data-testid": e, ref: p, ...c, children: [
      /* @__PURE__ */ C(
        "div",
        {
          className: vt([
            `${Le}__row`,
            {
              [`${Le}__row--with-back-button`]: n && r && l
            }
          ]),
          "data-testid": `${e}-row`,
          children: [
            /* @__PURE__ */ d("div", { className: vt(`${Le}__left`), children: n && r && l ? /* @__PURE__ */ C(
              Co,
              {
                "aria-label": o ? r : "",
                className: vt([
                  `${Le}__back-button`,
                  {
                    [`${Le}__back-button--only-icon`]: o
                  }
                ]),
                "data-testid": `${e}-back-button`,
                iconOnly: o,
                onClick: l,
                size: "sm",
                variant: o ? Zn.TERTIARY_PURPLE : Zn.TEXT,
                children: [
                  /* @__PURE__ */ d(sc, { size: "sm" }),
                  !o && r
                ]
              }
            ) : a ? /* @__PURE__ */ C(q, { children: [
              a,
              /* @__PURE__ */ d(Dl, { asChild: !0, children: /* @__PURE__ */ d(jr, { asChild: !0, children: u }) })
            ] }) : /* @__PURE__ */ d(jr, { asChild: !0, children: /* @__PURE__ */ d(
              Eo,
              {
                "data-testid": `${e}-title`,
                tag: "h2",
                variant: Ro.TITLE200,
                children: u
              }
            ) }) }),
            /* @__PURE__ */ d("div", { className: vt(`${Le}__right`), children: /* @__PURE__ */ d(E0, { asChild: !0, children: /* @__PURE__ */ d(
              Co,
              {
                "aria-label": t,
                className: vt(`${Le}__close-button`),
                iconOnly: !0,
                size: "sm",
                variant: Zn.TERTIARY_PURPLE,
                children: /* @__PURE__ */ d(cc, { size: "sm" })
              }
            ) }) })
          ]
        }
      ),
      n && r && l && (a ? /* @__PURE__ */ C(q, { children: [
        a,
        /* @__PURE__ */ d(Dl, { asChild: !0, children: /* @__PURE__ */ d(jr, { asChild: !0, children: u }) })
      ] }) : /* @__PURE__ */ d(jr, { asChild: !0, children: /* @__PURE__ */ d(
        Eo,
        {
          "data-testid": `${e}-title-with-back-button`,
          tag: "h2",
          variant: Ro.TITLE200,
          children: u
        }
      ) }))
    ] });
  }
);
fc.displayName = "DrawerHeader";
var Ow = s.createContext(void 0);
function Aw(e) {
  const n = s.useContext(Ow);
  return e || n || "ltr";
}
function Mw(e, [n, r]) {
  return Math.min(r, Math.max(n, e));
}
function Fw(e, n) {
  return s.useReducer((r, o) => n[r][o] ?? r, e);
}
var ei = "ScrollArea", [gc, Jx] = Ps(ei), [Dw, ce] = gc(ei), _c = s.forwardRef(
  (e, n) => {
    const {
      __scopeScrollArea: r,
      type: o = "hover",
      dir: i,
      scrollHideDelay: t = 600,
      ...a
    } = e, [l, u] = s.useState(null), [c, p] = s.useState(null), [_, g] = s.useState(null), [f, m] = s.useState(null), [h, v] = s.useState(null), [w, y] = s.useState(0), [b, $] = s.useState(0), [x, R] = s.useState(!1), [S, O] = s.useState(!1), E = ie(n, (D) => u(D)), k = Aw(i);
    return /* @__PURE__ */ d(
      Dw,
      {
        scope: r,
        type: o,
        dir: k,
        scrollHideDelay: t,
        scrollArea: l,
        viewport: c,
        onViewportChange: p,
        content: _,
        onContentChange: g,
        scrollbarX: f,
        onScrollbarXChange: m,
        scrollbarXEnabled: x,
        onScrollbarXEnabledChange: R,
        scrollbarY: h,
        onScrollbarYChange: v,
        scrollbarYEnabled: S,
        onScrollbarYEnabledChange: O,
        onCornerWidthChange: y,
        onCornerHeightChange: $,
        children: /* @__PURE__ */ d(
          Q.div,
          {
            dir: k,
            ...a,
            ref: E,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              "--radix-scroll-area-corner-width": w + "px",
              "--radix-scroll-area-corner-height": b + "px",
              ...e.style
            }
          }
        )
      }
    );
  }
);
_c.displayName = ei;
var hc = "ScrollAreaViewport", mc = s.forwardRef(
  (e, n) => {
    const { __scopeScrollArea: r, children: o, nonce: i, ...t } = e, a = ce(hc, r), l = s.useRef(null), u = ie(n, l, a.onViewportChange);
    return /* @__PURE__ */ C(q, { children: [
      /* @__PURE__ */ d(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: i
        }
      ),
      /* @__PURE__ */ d(
        Q.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...t,
          ref: u,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: a.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: a.scrollbarYEnabled ? "scroll" : "hidden",
            ...e.style
          },
          children: /* @__PURE__ */ d("div", { ref: a.onContentChange, style: { minWidth: "100%", display: "table" }, children: o })
        }
      )
    ] });
  }
);
mc.displayName = hc;
var xe = "ScrollAreaScrollbar", vc = s.forwardRef(
  (e, n) => {
    const { forceMount: r, ...o } = e, i = ce(xe, e.__scopeScrollArea), { onScrollbarXEnabledChange: t, onScrollbarYEnabledChange: a } = i, l = e.orientation === "horizontal";
    return s.useEffect(() => (l ? t(!0) : a(!0), () => {
      l ? t(!1) : a(!1);
    }), [l, t, a]), i.type === "hover" ? /* @__PURE__ */ d(Tw, { ...o, ref: n, forceMount: r }) : i.type === "scroll" ? /* @__PURE__ */ d(Lw, { ...o, ref: n, forceMount: r }) : i.type === "auto" ? /* @__PURE__ */ d(wc, { ...o, ref: n, forceMount: r }) : i.type === "always" ? /* @__PURE__ */ d(ti, { ...o, ref: n }) : null;
  }
);
vc.displayName = xe;
var Tw = s.forwardRef((e, n) => {
  const { forceMount: r, ...o } = e, i = ce(xe, e.__scopeScrollArea), [t, a] = s.useState(!1);
  return s.useEffect(() => {
    const l = i.scrollArea;
    let u = 0;
    if (l) {
      const c = () => {
        window.clearTimeout(u), a(!0);
      }, p = () => {
        u = window.setTimeout(() => a(!1), i.scrollHideDelay);
      };
      return l.addEventListener("pointerenter", c), l.addEventListener("pointerleave", p), () => {
        window.clearTimeout(u), l.removeEventListener("pointerenter", c), l.removeEventListener("pointerleave", p);
      };
    }
  }, [i.scrollArea, i.scrollHideDelay]), /* @__PURE__ */ d(Ge, { present: r || t, children: /* @__PURE__ */ d(
    wc,
    {
      "data-state": t ? "visible" : "hidden",
      ...o,
      ref: n
    }
  ) });
}), Lw = s.forwardRef((e, n) => {
  const { forceMount: r, ...o } = e, i = ce(xe, e.__scopeScrollArea), t = e.orientation === "horizontal", a = un(() => u("SCROLL_END"), 100), [l, u] = Fw("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return s.useEffect(() => {
    if (l === "idle") {
      const c = window.setTimeout(() => u("HIDE"), i.scrollHideDelay);
      return () => window.clearTimeout(c);
    }
  }, [l, i.scrollHideDelay, u]), s.useEffect(() => {
    const c = i.viewport, p = t ? "scrollLeft" : "scrollTop";
    if (c) {
      let _ = c[p];
      const g = () => {
        const f = c[p];
        _ !== f && (u("SCROLL"), a()), _ = f;
      };
      return c.addEventListener("scroll", g), () => c.removeEventListener("scroll", g);
    }
  }, [i.viewport, t, u, a]), /* @__PURE__ */ d(Ge, { present: r || l !== "hidden", children: /* @__PURE__ */ d(
    ti,
    {
      "data-state": l === "hidden" ? "hidden" : "visible",
      ...o,
      ref: n,
      onPointerEnter: Y(e.onPointerEnter, () => u("POINTER_ENTER")),
      onPointerLeave: Y(e.onPointerLeave, () => u("POINTER_LEAVE"))
    }
  ) });
}), wc = s.forwardRef((e, n) => {
  const r = ce(xe, e.__scopeScrollArea), { forceMount: o, ...i } = e, [t, a] = s.useState(!1), l = e.orientation === "horizontal", u = un(() => {
    if (r.viewport) {
      const c = r.viewport.offsetWidth < r.viewport.scrollWidth, p = r.viewport.offsetHeight < r.viewport.scrollHeight;
      a(l ? c : p);
    }
  }, 10);
  return kt(r.viewport, u), kt(r.content, u), /* @__PURE__ */ d(Ge, { present: o || t, children: /* @__PURE__ */ d(
    ti,
    {
      "data-state": t ? "visible" : "hidden",
      ...i,
      ref: n
    }
  ) });
}), ti = s.forwardRef((e, n) => {
  const { orientation: r = "vertical", ...o } = e, i = ce(xe, e.__scopeScrollArea), t = s.useRef(null), a = s.useRef(0), [l, u] = s.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), c = xc(l.viewport, l.content), p = {
    ...o,
    sizes: l,
    onSizesChange: u,
    hasThumb: c > 0 && c < 1,
    onThumbChange: (g) => t.current = g,
    onThumbPointerUp: () => a.current = 0,
    onThumbPointerDown: (g) => a.current = g
  };
  function _(g, f) {
    return Bw(g, a.current, l, f);
  }
  return r === "horizontal" ? /* @__PURE__ */ d(
    jw,
    {
      ...p,
      ref: n,
      onThumbPositionChange: () => {
        if (i.viewport && t.current) {
          const g = i.viewport.scrollLeft, f = Tl(g, l, i.dir);
          t.current.style.transform = `translate3d(${f}px, 0, 0)`;
        }
      },
      onWheelScroll: (g) => {
        i.viewport && (i.viewport.scrollLeft = g);
      },
      onDragScroll: (g) => {
        i.viewport && (i.viewport.scrollLeft = _(g, i.dir));
      }
    }
  ) : r === "vertical" ? /* @__PURE__ */ d(
    Iw,
    {
      ...p,
      ref: n,
      onThumbPositionChange: () => {
        if (i.viewport && t.current) {
          const g = i.viewport.scrollTop, f = Tl(g, l);
          t.current.style.transform = `translate3d(0, ${f}px, 0)`;
        }
      },
      onWheelScroll: (g) => {
        i.viewport && (i.viewport.scrollTop = g);
      },
      onDragScroll: (g) => {
        i.viewport && (i.viewport.scrollTop = _(g));
      }
    }
  ) : null;
}), jw = s.forwardRef((e, n) => {
  const { sizes: r, onSizesChange: o, ...i } = e, t = ce(xe, e.__scopeScrollArea), [a, l] = s.useState(), u = s.useRef(null), c = ie(n, u, t.onScrollbarXChange);
  return s.useEffect(() => {
    u.current && l(getComputedStyle(u.current));
  }, [u]), /* @__PURE__ */ d(
    bc,
    {
      "data-orientation": "horizontal",
      ...i,
      ref: c,
      sizes: r,
      style: {
        bottom: 0,
        left: t.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: t.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": ln(r) + "px",
        ...e.style
      },
      onThumbPointerDown: (p) => e.onThumbPointerDown(p.x),
      onDragScroll: (p) => e.onDragScroll(p.x),
      onWheelScroll: (p, _) => {
        if (t.viewport) {
          const g = t.viewport.scrollLeft + p.deltaX;
          e.onWheelScroll(g), Cc(g, _) && p.preventDefault();
        }
      },
      onResize: () => {
        u.current && t.viewport && a && o({
          content: t.viewport.scrollWidth,
          viewport: t.viewport.offsetWidth,
          scrollbar: {
            size: u.current.clientWidth,
            paddingStart: Xr(a.paddingLeft),
            paddingEnd: Xr(a.paddingRight)
          }
        });
      }
    }
  );
}), Iw = s.forwardRef((e, n) => {
  const { sizes: r, onSizesChange: o, ...i } = e, t = ce(xe, e.__scopeScrollArea), [a, l] = s.useState(), u = s.useRef(null), c = ie(n, u, t.onScrollbarYChange);
  return s.useEffect(() => {
    u.current && l(getComputedStyle(u.current));
  }, [u]), /* @__PURE__ */ d(
    bc,
    {
      "data-orientation": "vertical",
      ...i,
      ref: c,
      sizes: r,
      style: {
        top: 0,
        right: t.dir === "ltr" ? 0 : void 0,
        left: t.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": ln(r) + "px",
        ...e.style
      },
      onThumbPointerDown: (p) => e.onThumbPointerDown(p.y),
      onDragScroll: (p) => e.onDragScroll(p.y),
      onWheelScroll: (p, _) => {
        if (t.viewport) {
          const g = t.viewport.scrollTop + p.deltaY;
          e.onWheelScroll(g), Cc(g, _) && p.preventDefault();
        }
      },
      onResize: () => {
        u.current && t.viewport && a && o({
          content: t.viewport.scrollHeight,
          viewport: t.viewport.offsetHeight,
          scrollbar: {
            size: u.current.clientHeight,
            paddingStart: Xr(a.paddingTop),
            paddingEnd: Xr(a.paddingBottom)
          }
        });
      }
    }
  );
}), [Vw, yc] = gc(xe), bc = s.forwardRef((e, n) => {
  const {
    __scopeScrollArea: r,
    sizes: o,
    hasThumb: i,
    onThumbChange: t,
    onThumbPointerUp: a,
    onThumbPointerDown: l,
    onThumbPositionChange: u,
    onDragScroll: c,
    onWheelScroll: p,
    onResize: _,
    ...g
  } = e, f = ce(xe, r), [m, h] = s.useState(null), v = ie(n, (E) => h(E)), w = s.useRef(null), y = s.useRef(""), b = f.viewport, $ = o.content - o.viewport, x = J(p), R = J(u), S = un(_, 10);
  function O(E) {
    if (w.current) {
      const k = E.clientX - w.current.left, D = E.clientY - w.current.top;
      c({ x: k, y: D });
    }
  }
  return s.useEffect(() => {
    const E = (k) => {
      const D = k.target;
      m != null && m.contains(D) && x(k, $);
    };
    return document.addEventListener("wheel", E, { passive: !1 }), () => document.removeEventListener("wheel", E, { passive: !1 });
  }, [b, m, $, x]), s.useEffect(R, [o, R]), kt(m, S), kt(f.content, S), /* @__PURE__ */ d(
    Vw,
    {
      scope: r,
      scrollbar: m,
      hasThumb: i,
      onThumbChange: J(t),
      onThumbPointerUp: J(a),
      onThumbPositionChange: R,
      onThumbPointerDown: J(l),
      children: /* @__PURE__ */ d(
        Q.div,
        {
          ...g,
          ref: v,
          style: { position: "absolute", ...g.style },
          onPointerDown: Y(e.onPointerDown, (E) => {
            E.button === 0 && (E.target.setPointerCapture(E.pointerId), w.current = m.getBoundingClientRect(), y.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", f.viewport && (f.viewport.style.scrollBehavior = "auto"), O(E));
          }),
          onPointerMove: Y(e.onPointerMove, O),
          onPointerUp: Y(e.onPointerUp, (E) => {
            const k = E.target;
            k.hasPointerCapture(E.pointerId) && k.releasePointerCapture(E.pointerId), document.body.style.webkitUserSelect = y.current, f.viewport && (f.viewport.style.scrollBehavior = ""), w.current = null;
          })
        }
      )
    }
  );
}), Ur = "ScrollAreaThumb", $c = s.forwardRef(
  (e, n) => {
    const { forceMount: r, ...o } = e, i = yc(Ur, e.__scopeScrollArea);
    return /* @__PURE__ */ d(Ge, { present: r || i.hasThumb, children: /* @__PURE__ */ d(zw, { ref: n, ...o }) });
  }
), zw = s.forwardRef(
  (e, n) => {
    const { __scopeScrollArea: r, style: o, ...i } = e, t = ce(Ur, r), a = yc(Ur, r), { onThumbPositionChange: l } = a, u = ie(
      n,
      (_) => a.onThumbChange(_)
    ), c = s.useRef(void 0), p = un(() => {
      c.current && (c.current(), c.current = void 0);
    }, 100);
    return s.useEffect(() => {
      const _ = t.viewport;
      if (_) {
        const g = () => {
          if (p(), !c.current) {
            const f = Ww(_, l);
            c.current = f, l();
          }
        };
        return l(), _.addEventListener("scroll", g), () => _.removeEventListener("scroll", g);
      }
    }, [t.viewport, p, l]), /* @__PURE__ */ d(
      Q.div,
      {
        "data-state": a.hasThumb ? "visible" : "hidden",
        ...i,
        ref: u,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...o
        },
        onPointerDownCapture: Y(e.onPointerDownCapture, (_) => {
          const g = _.target.getBoundingClientRect(), f = _.clientX - g.left, m = _.clientY - g.top;
          a.onThumbPointerDown({ x: f, y: m });
        }),
        onPointerUp: Y(e.onPointerUp, a.onThumbPointerUp)
      }
    );
  }
);
$c.displayName = Ur;
var ri = "ScrollAreaCorner", qw = s.forwardRef(
  (e, n) => {
    const r = ce(ri, e.__scopeScrollArea), o = !!(r.scrollbarX && r.scrollbarY);
    return r.type !== "scroll" && o ? /* @__PURE__ */ d(Hw, { ...e, ref: n }) : null;
  }
);
qw.displayName = ri;
var Hw = s.forwardRef((e, n) => {
  const { __scopeScrollArea: r, ...o } = e, i = ce(ri, r), [t, a] = s.useState(0), [l, u] = s.useState(0), c = !!(t && l);
  return kt(i.scrollbarX, () => {
    var p;
    const _ = ((p = i.scrollbarX) == null ? void 0 : p.offsetHeight) || 0;
    i.onCornerHeightChange(_), u(_);
  }), kt(i.scrollbarY, () => {
    var p;
    const _ = ((p = i.scrollbarY) == null ? void 0 : p.offsetWidth) || 0;
    i.onCornerWidthChange(_), a(_);
  }), c ? /* @__PURE__ */ d(
    Q.div,
    {
      ...o,
      ref: n,
      style: {
        width: t,
        height: l,
        position: "absolute",
        right: i.dir === "ltr" ? 0 : void 0,
        left: i.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...e.style
      }
    }
  ) : null;
});
function Xr(e) {
  return e ? parseInt(e, 10) : 0;
}
function xc(e, n) {
  const r = e / n;
  return isNaN(r) ? 0 : r;
}
function ln(e) {
  const n = xc(e.viewport, e.content), r = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, o = (e.scrollbar.size - r) * n;
  return Math.max(o, 18);
}
function Bw(e, n, r, o = "ltr") {
  const i = ln(r), t = i / 2, a = n || t, l = i - a, u = r.scrollbar.paddingStart + a, c = r.scrollbar.size - r.scrollbar.paddingEnd - l, p = r.content - r.viewport, _ = o === "ltr" ? [0, p] : [p * -1, 0];
  return Sc([u, c], _)(e);
}
function Tl(e, n, r = "ltr") {
  const o = ln(n), i = n.scrollbar.paddingStart + n.scrollbar.paddingEnd, t = n.scrollbar.size - i, a = n.content - n.viewport, l = t - o, u = r === "ltr" ? [0, a] : [a * -1, 0], c = Mw(e, u);
  return Sc([0, a], [0, l])(c);
}
function Sc(e, n) {
  return (r) => {
    if (e[0] === e[1] || n[0] === n[1]) return n[0];
    const o = (n[1] - n[0]) / (e[1] - e[0]);
    return n[0] + o * (r - e[0]);
  };
}
function Cc(e, n) {
  return e > 0 && e < n;
}
var Ww = (e, n = () => {
}) => {
  let r = { left: e.scrollLeft, top: e.scrollTop }, o = 0;
  return function i() {
    const t = { left: e.scrollLeft, top: e.scrollTop }, a = r.left !== t.left, l = r.top !== t.top;
    (a || l) && n(), r = t, o = window.requestAnimationFrame(i);
  }(), () => window.cancelAnimationFrame(o);
};
function un(e, n) {
  const r = J(e), o = s.useRef(0);
  return s.useEffect(() => () => window.clearTimeout(o.current), []), s.useCallback(() => {
    window.clearTimeout(o.current), o.current = window.setTimeout(r, n);
  }, [r, n]);
}
function kt(e, n) {
  const r = J(n);
  gr(() => {
    let o = 0;
    if (e) {
      const i = new ResizeObserver(() => {
        cancelAnimationFrame(o), o = window.requestAnimationFrame(r);
      });
      return i.observe(e), () => {
        window.cancelAnimationFrame(o), i.unobserve(e);
      };
    }
  }, [e, r]);
}
var Gw = _c, Zw = mc, Uw = vc, Xw = $c;
const Yw = {
  "purpur-drawer-scroll-area__root": "_purpur-drawer-scroll-area__root_1r0fa_1",
  "purpur-drawer-scroll-area__root--fit-to-content": "_purpur-drawer-scroll-area__root--fit-to-content_1r0fa_4",
  "purpur-drawer-scroll-area__viewport": "_purpur-drawer-scroll-area__viewport_1r0fa_10",
  "purpur-drawer-scroll-area__scrollbar": "_purpur-drawer-scroll-area__scrollbar_1r0fa_13",
  "purpur-drawer-scroll-area__thumb": "_purpur-drawer-scroll-area__thumb_1r0fa_24"
}, ir = at.bind(Yw), wt = "purpur-drawer-scroll-area", Po = W(
  ({
    ["data-testid"]: e = "purpur-drawer-scroll-area",
    children: n,
    className: r,
    fitToContent: o = !1,
    ...i
  }, t) => {
    const a = ir([r, wt]);
    return /* @__PURE__ */ d("div", { className: a, "data-testid": e, ref: t, ...i, children: /* @__PURE__ */ C(
      Gw,
      {
        className: ir(`${wt}__root`, {
          [`${wt}__root--fit-to-content`]: o
        }),
        children: [
          /* @__PURE__ */ d(Zw, { className: ir(`${wt}__viewport`), children: n }),
          /* @__PURE__ */ d(
            Uw,
            {
              className: ir(`${wt}__scrollbar`),
              orientation: "vertical",
              children: /* @__PURE__ */ d(Xw, { className: ir(`${wt}__thumb`) })
            }
          )
        ]
      }
    ) });
  }
);
Po.displayName = "DrawerScrollArea";
const yt = at.bind(I0), Ne = "purpur-drawer-frame", Rc = W(
  ({
    ["data-testid"]: e = "purpur-drawer-frame",
    backButton: n,
    backButtonText: r,
    backButtonOnlyIcon: o,
    children: i,
    className: t,
    closeButtonAriaLabel: a,
    fitToContent: l = !1,
    footerContent: u,
    headerContent: c,
    onAnimationEnd: p,
    onBackButtonClick: _,
    onSwipeStart: g,
    onSwipeMove: f,
    onSwipeCancel: m,
    onSwipeEnd: h,
    title: v,
    stickyFooter: w,
    ...y
  }, b) => {
    const $ = yt([
      t,
      Ne,
      {
        [`${Ne}--fit-to-content`]: l,
        [`${Ne}--sticky-footer`]: w
      }
    ]);
    return /* @__PURE__ */ C(
      "div",
      {
        className: $,
        "data-testid": e,
        ref: b,
        onAnimationEnd: p,
        ...y,
        children: [
          /* @__PURE__ */ d(
            uc,
            {
              onSwipeStart: g,
              onSwipeMove: f,
              onSwipeCancel: m,
              onSwipeEnd: h
            }
          ),
          /* @__PURE__ */ d(
            Ct,
            {
              className: yt(`${Ne}__header`),
              variant: "header",
              stickyFooter: w,
              children: /* @__PURE__ */ d(
                fc,
                {
                  title: v,
                  headerContent: c,
                  backButtonOnlyIcon: o,
                  backButton: n,
                  backButtonText: r,
                  closeButtonAriaLabel: a,
                  onBackButtonClick: _
                }
              )
            }
          ),
          w ? /* @__PURE__ */ C(q, { children: [
            /* @__PURE__ */ d(
              Po,
              {
                className: yt(`${Ne}__body`),
                "data-testid": `${e}-sticky-footer-scroll-area`,
                fitToContent: l,
                children: /* @__PURE__ */ d(Ct, { stickyFooter: !0, children: i })
              }
            ),
            u && /* @__PURE__ */ d(
              Ct,
              {
                className: yt(`${Ne}__footer`),
                "data-testid": `${e}-sticky-footer`,
                variant: "footer",
                stickyFooter: w,
                children: u
              }
            )
          ] }) : /* @__PURE__ */ d(
            Po,
            {
              className: yt(`${Ne}__body`),
              "data-testid": `${e}-scroll-area`,
              fitToContent: l,
              children: /* @__PURE__ */ C(
                "div",
                {
                  className: yt([
                    `${Ne}__content-container`,
                    { [`${Ne}__content-container--no-footer`]: !u }
                  ]),
                  children: [
                    /* @__PURE__ */ d(Ct, { stickyFooter: w, children: i }),
                    u && /* @__PURE__ */ d(
                      Ct,
                      {
                        "data-testid": `${e}-footer`,
                        stickyFooter: w,
                        variant: "footer",
                        children: u
                      }
                    )
                  ]
                }
              )
            }
          )
        ]
      }
    );
  }
);
Rc.displayName = "DrawerFrame";
const Kw = (e, n) => ({
  onAnimationEnd: (r) => {
    r.currentTarget.getAttribute("data-swipe") === "end" && n(!1);
  },
  onSwipeStart: () => {
    e.current && e.current.setAttribute("data-swipe", "start");
  },
  onSwipeMove: (r) => {
    if (!e.current)
      return;
    const { y: o } = r.delta;
    e.current.setAttribute("data-swipe", "move"), e.current.style.setProperty("--purpur-drawer-swipe-move-y", `${o}px`);
  },
  onSwipeCancel: () => {
    e.current && (e.current.setAttribute("data-swipe", "cancel"), e.current.style.removeProperty("--purpur-drawer-swipe-move-y"), e.current.style.removeProperty("--purpur-drawer-swipe-end-y"));
  },
  onSwipeEnd: (r) => {
    if (!e.current)
      return;
    const { y: o } = r.delta;
    e.current.setAttribute("data-swipe", "end"), e.current.style.removeProperty("--purpur-drawer-swipe-move-y"), e.current.style.setProperty("--purpur-drawer-swipe-end-y", `${o}px`);
  }
}), ar = at.bind(T0), lr = "purpur-drawer-content", Ec = W(
  ({
    ["data-testid"]: e = "purpur-drawer-content",
    backButton: n = !1,
    backButtonText: r,
    backButtonOnlyIcon: o = !1,
    bodyText: i,
    children: t,
    className: a,
    closeButtonAriaLabel: l,
    disableCloseOnClickOutside: u = !1,
    fitToContent: c = !1,
    footerContent: p,
    headerContent: _,
    onBackButtonClick: g,
    stickyFooter: f = !1,
    title: m,
    zIndex: h,
    ...v
  }, w) => {
    const y = ar([
      a,
      lr,
      { [`${lr}--fit-to-content`]: c }
    ]), b = ue(null), $ = Vp(lc), { onAnimationEnd: x, onSwipeStart: R, onSwipeMove: S, onSwipeCancel: O, onSwipeEnd: E } = Kw(b, $), k = (D) => {
      u && D.preventDefault();
    };
    return /* @__PURE__ */ d(x0, { children: /* @__PURE__ */ d(
      S0,
      {
        className: ar("purpur-drawer-overlay"),
        style: h ? { zIndex: h } : void 0,
        "data-testid": `${e}-overlay`,
        children: /* @__PURE__ */ d(
          C0,
          {
            onPointerDownOutside: k,
            className: y,
            "data-testid": e,
            ref: w,
            ...!i && { "aria-describedby": void 0 },
            ...v,
            children: /* @__PURE__ */ d(
              Rc,
              {
                backButton: n,
                backButtonText: r,
                backButtonOnlyIcon: o,
                closeButtonAriaLabel: l,
                className: ar(`${lr}__drawer-frame`),
                fitToContent: c,
                footerContent: p,
                headerContent: _,
                ref: b,
                onAnimationEnd: x,
                onBackButtonClick: g,
                onSwipeStart: R,
                onSwipeMove: S,
                onSwipeCancel: O,
                onSwipeEnd: E,
                stickyFooter: f,
                title: m,
                children: i ? /* @__PURE__ */ C("div", { className: ar(`${lr}__content-container`), children: [
                  /* @__PURE__ */ d(
                    R0,
                    {
                      className: ar(`${lr}__description`),
                      "data-testid": `${e}-description`,
                      children: i
                    }
                  ),
                  /* @__PURE__ */ d("div", { children: t })
                ] }) : t
              }
            )
          }
        )
      }
    ) });
  }
);
Ec.displayName = "DrawerContent";
const Nc = W(
  ({
    ["data-testid"]: e = "purpur-drawer-trigger",
    children: n,
    className: r,
    ...o
  }, i) => /* @__PURE__ */ d(
    $0,
    {
      asChild: !0,
      className: r,
      "data-testid": e,
      ref: i,
      ...o,
      children: n
    }
  )
);
Nc.displayName = "DrawerTrigger";
const Jw = at.bind(O0), Qw = "purpur-drawer", nt = ({
  ["data-testid"]: e = "purpur-drawer",
  children: n,
  className: r,
  onOpenChange: o,
  open: i = !1,
  ...t
}) => {
  const [a, l] = io.useState(i), u = Jw([r, Qw]), c = (p) => {
    l(p), o == null || o(p);
  };
  return le(() => {
    l(i);
  }, [i]), /* @__PURE__ */ d(lc.Provider, { value: c, children: /* @__PURE__ */ d("div", { className: u, "data-testid": e, ...t, children: /* @__PURE__ */ d(b0, { open: a, onOpenChange: c, children: n }) }) });
};
nt.Trigger = Nc;
nt.Content = Ec;
nt.displayName = "Drawer";
const ey = {
  "purpur-table-export-drawer__content": "_purpur-table-export-drawer__content_1soij_1"
}, ty = "purpur-table-export-drawer", ry = z.bind(ey), Un = "purpur-table-export-drawer", ny = ({
  id: e,
  exportFormats: n,
  isOpen: r,
  copy: o,
  onExportData: i,
  setDrawerIsOpen: t
}) => /* @__PURE__ */ d("div", { id: e, children: /* @__PURE__ */ d(nt, { "data-testid": Un, open: r, onOpenChange: t, children: /* @__PURE__ */ d(
  nt.Content,
  {
    "data-testid": `${Un}-content`,
    zIndex: 6,
    title: o.title,
    bodyText: o.bodyText,
    closeButtonAriaLabel: o.closeButtonAriaLabel,
    children: /* @__PURE__ */ d("div", { className: ry(`${ty}__content`), children: n.map((a) => /* @__PURE__ */ d(
      re,
      {
        "data-testid": `${Un}-export-button`,
        variant: "secondary",
        onClick: () => i(a),
        fullWidth: !0,
        children: `${o.link} ${a}`
      },
      a
    )) })
  }
) }) }), oy = z.bind(G), Ll = "purpur-table-header", iy = ({
  children: e,
  className: n,
  columnFiltersEnabled: r,
  ...o
}) => {
  const i = oy([
    n,
    Ll,
    {
      [`${Ll}--has-filters`]: r
    }
  ]);
  return /* @__PURE__ */ d("thead", { className: i, ...o, children: e });
}, ay = z.bind(G), jl = "purpur-table-row", Yr = ({
  children: e,
  className: n,
  ["data-testid"]: r,
  isSelected: o
}) => /* @__PURE__ */ d(
  "tr",
  {
    "data-testid": r,
    className: ay([n, jl, { [`${jl}--selected`]: o }]),
    children: e
  }
);
function ly(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Il = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Vl;
function uy() {
  return Vl || (Vl = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o.call(this, l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return this && this[t] || t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(this, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, this && this[l] || l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(Il)), Il.exports;
}
var sy = uy();
const cy = /* @__PURE__ */ ly(sy), py = {
  "purpur-icon": "_purpur-icon_8u1lq_1",
  "purpur-icon--xxs": "_purpur-icon--xxs_8u1lq_4",
  "purpur-icon--xs": "_purpur-icon--xs_8u1lq_8",
  "purpur-icon--sm": "_purpur-icon--sm_8u1lq_12",
  "purpur-icon--md": "_purpur-icon--md_8u1lq_16",
  "purpur-icon--lg": "_purpur-icon--lg_8u1lq_20",
  "purpur-icon--xl": "_purpur-icon--xl_8u1lq_24"
}, dy = cy.bind(py), zl = "purpur-icon", fy = "md", gy = (e) => e.filter((n) => Object.keys(n).length >= 1).map((n) => `${n.name}="${n.value}"`).join(" "), _y = ({ content: e = "", title: n } = {}) => {
  const r = [
    { name: "xmlns", value: "http://www.w3.org/2000/svg" },
    { name: "fill", value: "currentColor" },
    { name: "viewBox", value: "0 0 24 24" },
    n ? { name: "role", value: "img" } : { name: "aria-hidden", value: "true" }
  ], o = n ? `<title>${n}</title>` : "";
  return `<svg ${gy(r)}>${o}${e}</svg>`;
}, hy = (e) => e.replace(/<(\/?)svg([^>]*)>/g, "").trim(), Pc = ({
  ["data-testid"]: e,
  svg: n,
  allyTitle: r,
  className: o,
  size: i = fy,
  ...t
}) => {
  const a = _y({
    content: hy(n.svg),
    title: r
  }), l = dy(o, zl, `${zl}--${i}`);
  return /* @__PURE__ */ d(
    "span",
    {
      className: l,
      "data-testid": e,
      dangerouslySetInnerHTML: { __html: a },
      ...t
    }
  );
};
Pc.displayName = "Icon";
const my = {
  name: "alert",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="m13.038 7.067-.247 6.876h-1.566l-.247-6.876a1.03 1.03 0 1 1 2.06 0Zm.212 8.917c0 .649-.586 1.234-1.25 1.234-.649 0-1.25-.585-1.25-1.234 0-.633.601-1.234 1.25-1.234.664 0 1.25.601 1.25 1.234Z"/><path fill-rule="evenodd" d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-1.75 0a8.25 8.25 0 1 1-16.5 0 8.25 8.25 0 0 1 16.5 0Z" clip-rule="evenodd"/></svg>',
  keywords: ["alert"],
  category: "status"
}, vy = {
  name: "check-circle",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M16.487 9.514a.872.872 0 1 0-1.42-1.014l-4.248 5.948-2.18-2.18a.872.872 0 0 0-1.233 1.234l2.908 2.908a.872.872 0 0 0 1.326-.11l4.847-6.786Z"/><path fill-rule="evenodd" d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-1.75 0a8.25 8.25 0 1 1-16.5 0 8.25 8.25 0 0 1 16.5 0Z" clip-rule="evenodd"/></svg>',
  keywords: ["check-circle"],
  category: "status"
}, wy = {
  name: "devices",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M10 3.4a.1.1 0 0 0-.1.1V4a.9.9 0 0 1-1.8 0v-.5c0-1.05.85-1.9 1.9-1.9h10c1.05 0 1.9.85 1.9 1.9v15a1.9 1.9 0 0 1-1.9 1.9h-6a.9.9 0 1 1 0-1.8h6a.1.1 0 0 0 .1-.1v-15a.1.1 0 0 0-.1-.1H10ZM2.1 8c0-1.05.85-1.9 1.9-1.9h6c1.05 0 1.9.85 1.9 1.9v12a1.9 1.9 0 0 1-1.9 1.9H4A1.9 1.9 0 0 1 2.1 20V8ZM4 7.9a.1.1 0 0 0-.1.1v12a.1.1 0 0 0 .1.1h6a.1.1 0 0 0 .1-.1V8a.1.1 0 0 0-.1-.1H4ZM14.6 17a.9.9 0 0 1 .9-.9h.5a.9.9 0 1 1 0 1.8h-.5a.9.9 0 0 1-.9-.9Zm-8.5 1.5a.9.9 0 0 1 .9-.9h.5a.9.9 0 1 1 0 1.8H7a.9.9 0 0 1-.9-.9Z" clip-rule="evenodd"/></svg>',
  keywords: ["devices"],
  category: "device"
}, yy = {
  name: "error",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M10.354 3.05c.732-1.267 2.56-1.267 3.291 0l8.66 15c.732 1.267-.182 2.85-1.645 2.85H3.34c-1.463 0-2.377-1.583-1.646-2.85l8.66-15Zm1.595.862a.092.092 0 0 0-.036.038l-8.66 15a.092.092 0 0 0-.015.05c0 .014.005.032.015.05a.11.11 0 0 0 .036.038.09.09 0 0 0 .05.012H20.66a.088.088 0 0 0 .05-.012.106.106 0 0 0 .037-.038.105.105 0 0 0 .015-.05.092.092 0 0 0-.015-.05l-8.66-15a.092.092 0 0 0-.036-.038A.106.106 0 0 0 12 3.9a.105.105 0 0 0-.05.012Z" clip-rule="evenodd"/><path d="m12.523 14.922.412-6.25a.936.936 0 1 0-1.868 0l.421 6.25h1.035ZM12 17.52c.44 0 .826-.387.826-.815 0-.418-.387-.816-.826-.816-.428 0-.825.398-.825.816 0 .428.397.815.825.815Z"/><path fill-rule="evenodd" d="M12.691 15.096h-1.37l-.431-6.53a1 1 0 0 1 .997-1.066h.227a1 1 0 0 1 .998 1.064l-.42 6.532Zm.244-6.425a.936.936 0 1 0-1.868.002l.421 6.249h1.035l.412-6.25ZM13 16.706c0 .526-.466.99-1 .99-.522 0-1-.463-1-.99 0-.264.125-.51.304-.689.18-.178.429-.301.696-.301.536 0 1 .475 1 .99Zm-.174 0c0 .428-.387.815-.826.815-.428 0-.825-.387-.825-.815 0-.418.397-.816.825-.816.44 0 .826.398.826.816Z" clip-rule="evenodd"/></svg>',
  keywords: ["error"],
  category: "status"
}, by = {
  name: "info",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M11 8.18c0 .537.469.979 1.007.979.524 0 .993-.442.993-.98s-.469-.979-.993-.979c-.538 0-1.007.441-1.007.98Zm.152 1.958v6.897h1.696v-6.897h-1.696Z"/><path fill-rule="evenodd" d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-1.75 0a8.25 8.25 0 1 1-16.5 0 8.25 8.25 0 0 1 16.5 0Z" clip-rule="evenodd"/></svg>',
  keywords: ["info"],
  category: "status"
}, $y = {
  name: "offering",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M7.118 4.6H7a1.9 1.9 0 0 0-1.9 1.9V8a1.9 1.9 0 0 0 1.5 1.858v.642a.9.9 0 1 0 1.8 0v-.6h3.2v.6a.9.9 0 0 0 1.8 0v-.6h3.7V11a.9.9 0 0 0 1.8 0V9.858A1.9 1.9 0 0 0 20.4 8V6.5a1.9 1.9 0 0 0-1.9-1.9h-.618c-.063-.708-.3-1.394-.756-1.943-.56-.674-1.384-1.057-2.376-1.057-.92 0-1.696.33-2.25.915-.554-.585-1.33-.915-2.25-.915-.992 0-1.816.383-2.376 1.057-.457.549-.693 1.235-.756 1.943Zm1.812 0h2.64c-.053-.34-.174-.607-.328-.792-.192-.232-.493-.408-.992-.408s-.8.176-.992.408c-.154.185-.275.452-.328.792Zm4.5 0h2.64c-.053-.34-.174-.607-.328-.792-.192-.232-.493-.408-.992-.408s-.8.176-.992.408c-.154.185-.275.452-.328.792Zm-.03 3.5h5.1a.1.1 0 0 0 .1-.1V6.5a.1.1 0 0 0-.1-.1h-5.1v1.7Zm-1.8-1.7H7a.1.1 0 0 0-.1.1V8a.1.1 0 0 0 .1.1h4.6V6.4Zm8.335 5.147c.743-.107 1.52.135 2.201.817.474.473.695 1.011.708 1.548.012.508-.163.927-.318 1.2-.185.326-.47.607-.634.77l-.049.047-4.414 4.414a1.9 1.9 0 0 1-1.343.557H7.914a.1.1 0 0 0-.07.03l-.5.5a1.9 1.9 0 0 1-2.687 0L2.57 19.342a1.9 1.9 0 0 1 0-2.686l4-4a1.9 1.9 0 0 1 1.343-.557H14.5v.9-.9h.041l.065.004a2.73 2.73 0 0 1 .79.185 2.665 2.665 0 0 1 1.46 1.417c.188-.162.375-.324.551-.479.46-.401.815-.722.957-.863.338-.34.882-.719 1.571-.817ZM15.088 15.1a1.06 1.06 0 0 0 .08-.145c.1-.207.113-.38.027-.553a.867.867 0 0 0-.668-.497.628.628 0 0 0-.042-.005h-6.57a.1.1 0 0 0-.071.03l-4 4a.1.1 0 0 0 0 .14l2.085 2.087a.1.1 0 0 0 .142 0l.5-.5a1.9 1.9 0 0 1 1.343-.557h8.172a.1.1 0 0 0 .07-.03l4.415-4.414c.225-.225.334-.335.39-.434a.539.539 0 0 0 .083-.266.283.283 0 0 0-.026-.11.712.712 0 0 0-.154-.21c-.319-.318-.542-.326-.674-.307-.186.026-.392.146-.554.307-.191.192-.595.553-1.043.946-.904.79-2.143 1.838-2.561 2.144l-.238.174H10.5a.9.9 0 0 1 0-1.8h4.588Z" clip-rule="evenodd"/></svg>',
  keywords: ["offering"],
  category: "other"
}, xy = {
  name: "question",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M13.672 12.056c-.635.547-1.242 1.07-1.164 2.062h-1.385c-.309-1.553.504-2.214 1.23-2.805.514-.419.986-.802.986-1.442 0-.593-.489-1.068-1.267-1.068-.764 0-1.345.422-1.872 1.187L9 9.067C9.712 7.92 10.807 7.3 12.086 7.3 13.906 7.3 15 8.42 15 9.78c0 1.133-.678 1.717-1.328 2.277Zm-.822 3.763c0 .54-.487 1.028-1.041 1.028-.554 0-1.042-.488-1.042-1.028 0-.528.488-1.029 1.042-1.029s1.042.501 1.042 1.029Z"/><path fill-rule="evenodd" d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-1.75 0a8.25 8.25 0 1 1-16.5 0 8.25 8.25 0 0 1 16.5 0Z" clip-rule="evenodd"/></svg>',
  keywords: ["question"],
  category: "status"
}, Sy = {
  name: "tag",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M3.1 4a.9.9 0 0 1 .9-.9h6.5a.9.9 0 0 1 .636.264l10 10a.9.9 0 0 1 0 1.272l-4.5 4.5a.9.9 0 1 1-1.272-1.272L19.227 14l-9.1-9.1H4.9v5.227l9.736 9.737a.9.9 0 1 1-1.272 1.272l-10-10A.9.9 0 0 1 3.1 10.5V4ZM8 7.4a.6.6 0 1 0 0 1.2.6.6 0 0 0 0-1.2ZM5.6 8a2.4 2.4 0 1 1 4.8 0 2.4 2.4 0 0 1-4.8 0Z" clip-rule="evenodd"/></svg>',
  keywords: ["tag"],
  category: "other"
};
function Cy(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ql = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Hl;
function Ry() {
  return Hl || (Hl = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o(l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(null, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(ql)), ql.exports;
}
var Ey = Ry();
const Bl = /* @__PURE__ */ Cy(Ey), Xn = {
  "purpur-badge": "_purpur-badge_1mlzj_1",
  "purpur-badge__icon": "_purpur-badge__icon_1mlzj_13",
  "purpur-badge--attention": "_purpur-badge--attention_1mlzj_17",
  "purpur-badge--special": "_purpur-badge--special_1mlzj_21",
  "purpur-badge--neutral": "_purpur-badge--neutral_1mlzj_25",
  "purpur-badge--general": "_purpur-badge--general_1mlzj_29",
  "purpur-badge--information": "_purpur-badge--information_1mlzj_33",
  "purpur-badge--success": "_purpur-badge--success_1mlzj_37",
  "purpur-badge--warning": "_purpur-badge--warning_1mlzj_41",
  "purpur-badge--error": "_purpur-badge--error_1mlzj_45",
  "purpur-badge--black-friday": "_purpur-badge--black-friday_1mlzj_49"
}, Yn = "purpur-badge", Pe = {
  ATTENTION: "attention",
  BLACK_FRIDAY: "black-friday",
  ERROR: "error",
  GENERAL: "general",
  INFORMATION: "information",
  NEUTRAL: "neutral",
  SPECIAL: "special",
  SUCCESS: "success",
  WARNING: "warning"
}, Ny = (e) => {
  switch (e) {
    case Pe.ATTENTION:
    case Pe.SPECIAL:
      return $y;
    case Pe.INFORMATION:
      return by;
    case Pe.GENERAL:
      return wy;
    case Pe.SUCCESS:
      return vy;
    case Pe.WARNING:
      return my;
    case Pe.ERROR:
      return yy;
    case Pe.NEUTRAL:
      return xy;
    case Pe.BLACK_FRIDAY:
      return Sy;
    default:
      return;
  }
}, Py = ({
  children: e,
  showIcon: n = !0,
  iconAllyTitle: r,
  variant: o,
  ["data-testid"]: i,
  className: t = "",
  ...a
}) => {
  const l = Ny(o), u = Bl([t, Xn[Yn], Xn[`${Yn}--${o}`]]);
  return /* @__PURE__ */ C("span", { className: u, "data-testid": i, ...a, children: [
    n && l && /* @__PURE__ */ d(
      Pc,
      {
        "data-testid": `${i}-icon`,
        allyTitle: r,
        size: "xs",
        svg: l,
        className: Bl(Xn[`${Yn}__icon`])
      }
    ),
    e
  ] });
}, ae = () => /* @__PURE__ */ d(se, { children: "-" }), ky = ({ cell: e }) => {
  const n = e.getValue();
  if (!n)
    return /* @__PURE__ */ d(ae, {});
  const { variant: r, children: o, ...i } = n;
  return /* @__PURE__ */ d(Py, { variant: r, ...i, children: o });
}, Oy = {
  LG: "lg"
};
function Ay(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Wl = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Gl;
function My() {
  return Gl || (Gl = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o(l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(null, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(Wl)), Wl.exports;
}
var Fy = My();
const Zl = /* @__PURE__ */ Ay(Fy), Dy = "_rotate_1xozj_1", Ty = "_dash_1xozj_1", ur = {
  "purpur-spinner": "_purpur-spinner_1xozj_1",
  rotate: Dy,
  "purpur-spinner--xxs": "_purpur-spinner--xxs_1xozj_4",
  "purpur-spinner--xs": "_purpur-spinner--xs_1xozj_8",
  "purpur-spinner--sm": "_purpur-spinner--sm_1xozj_12",
  "purpur-spinner--md": "_purpur-spinner--md_1xozj_16",
  "purpur-spinner--lg": "_purpur-spinner--lg_1xozj_20",
  "purpur-spinner__circle": "_purpur-spinner__circle_1xozj_24",
  dash: Ty,
  "purpur-spinner__circle--disabled": "_purpur-spinner__circle--disabled_1xozj_33",
  "purpur-spinner__circle--negative": "_purpur-spinner__circle--negative_1xozj_36"
}, sr = "purpur-spinner", Ly = {
  SM: "sm"
}, jy = ({
  ["data-testid"]: e,
  disabled: n = !1,
  negative: r = !1,
  size: o = Ly.SM,
  ...i
}) => /* @__PURE__ */ d(
  "div",
  {
    className: Zl([ur[sr], ur[`${sr}--${o}`]]),
    "data-testid": e,
    ...i,
    children: /* @__PURE__ */ d("svg", { viewBox: "0 0 50 50", children: /* @__PURE__ */ d(
      "circle",
      {
        className: Zl(ur[`${sr}__circle`], {
          [ur[`${sr}__circle--disabled`]]: n,
          [ur[`${sr}__circle--negative`]]: r
        }),
        cx: "25",
        cy: "25",
        r: "20"
      }
    ) })
  }
);
function Iy(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ul = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Xl;
function Vy() {
  return Xl || (Xl = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o.call(this, l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return this && this[t] || t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(this, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, this && this[l] || l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(Ul)), Ul.exports;
}
var zy = Vy();
const qy = /* @__PURE__ */ Iy(zy), Hy = {
  "purpur-button": "_purpur-button_w455q_1",
  "purpur-button--xs": "_purpur-button--xs_w455q_33",
  "purpur-button--icon-only": "_purpur-button--icon-only_w455q_36",
  "purpur-button--sm": "_purpur-button--sm_w455q_39",
  "purpur-button--md": "_purpur-button--md_w455q_45",
  "purpur-button--lg": "_purpur-button--lg_w455q_51",
  "purpur-button--full-width": "_purpur-button--full-width_w455q_57",
  "purpur-button--primary": "_purpur-button--primary_w455q_60",
  "purpur-button--disabled": "_purpur-button--disabled_w455q_64",
  "purpur-button--primary-negative": "_purpur-button--primary-negative_w455q_70",
  "purpur-button--secondary": "_purpur-button--secondary_w455q_82",
  "purpur-button--secondary-negative": "_purpur-button--secondary-negative_w455q_93",
  "purpur-button--expressive": "_purpur-button--expressive_w455q_104",
  "purpur-button--expressive-negative": "_purpur-button--expressive-negative_w455q_114",
  "purpur-button--negative": "_purpur-button--negative_w455q_126",
  "purpur-button--destructive": "_purpur-button--destructive_w455q_133",
  "purpur-button--destructive-negative": "_purpur-button--destructive-negative_w455q_143",
  "purpur-button--tertiary-purple": "_purpur-button--tertiary-purple_w455q_153",
  "purpur-button--tertiary-purple-negative": "_purpur-button--tertiary-purple-negative_w455q_166",
  "purpur-button--text-negative": "_purpur-button--text-negative_w455q_181",
  "purpur-button--text": "_purpur-button--text_w455q_181"
}, By = {
  TERTIARY_PURPLE: "tertiary-purple"
}, Wy = qy.bind(Hy), et = "purpur-button", Gy = ({
  children: e,
  className: n,
  ["data-testid"]: r,
  disabled: o = !1,
  fullWidth: i = !1,
  iconOnly: t,
  loading: a = !1,
  negative: l = !1,
  onClick: u,
  size: c = "md",
  variant: p,
  type: _ = "button",
  ...g
}, f) => {
  if (t && p === "destructive")
    return null;
  const m = Wy(
    [
      et,
      `${et}--${l ? `${p}-negative` : p}`,
      `${et}--${c}`
    ],
    {
      [`${et}--icon-only`]: t,
      [`${et}--negative`]: l,
      [`${et}--full-width`]: i,
      [`${et}--disabled`]: o || a
    },
    n
  ), h = (w) => {
    o || a ? w.preventDefault() : u && u(w);
  }, v = !!g["aria-disabled"] || o || a;
  return /* @__PURE__ */ C(
    "button",
    {
      className: m,
      "data-testid": r,
      type: _,
      ref: f,
      "aria-disabled": v,
      onClick: h,
      ...g,
      children: [
        a && /* @__PURE__ */ d(jy, { size: c === Oy.LG ? "xs" : "xxs", negative: l, disabled: v }),
        " ",
        e
      ]
    }
  );
}, kc = W(Gy);
kc.displayName = "Button";
function Zy(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Yl = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Kl;
function Uy() {
  return Kl || (Kl = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o.call(this, l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return this && this[t] || t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(this, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, this && this[l] || l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(Yl)), Yl.exports;
}
var Xy = Uy();
const Yy = /* @__PURE__ */ Zy(Xy), Ky = {
  "purpur-icon": "_purpur-icon_8u1lq_1",
  "purpur-icon--xxs": "_purpur-icon--xxs_8u1lq_4",
  "purpur-icon--xs": "_purpur-icon--xs_8u1lq_8",
  "purpur-icon--sm": "_purpur-icon--sm_8u1lq_12",
  "purpur-icon--md": "_purpur-icon--md_8u1lq_16",
  "purpur-icon--lg": "_purpur-icon--lg_8u1lq_20",
  "purpur-icon--xl": "_purpur-icon--xl_8u1lq_24"
}, Jy = Yy.bind(Ky), Jl = "purpur-icon", Qy = "md", eb = (e) => e.filter((n) => Object.keys(n).length >= 1).map((n) => `${n.name}="${n.value}"`).join(" "), tb = ({ content: e = "", title: n } = {}) => {
  const r = [
    { name: "xmlns", value: "http://www.w3.org/2000/svg" },
    { name: "fill", value: "currentColor" },
    { name: "viewBox", value: "0 0 24 24" },
    n ? { name: "role", value: "img" } : { name: "aria-hidden", value: "true" }
  ], o = n ? `<title>${n}</title>` : "";
  return `<svg ${eb(r)}>${o}${e}</svg>`;
}, rb = (e) => e.replace(/<(\/?)svg([^>]*)>/g, "").trim(), Oc = ({
  ["data-testid"]: e,
  svg: n,
  allyTitle: r,
  className: o,
  size: i = Qy,
  ...t
}) => {
  const a = tb({
    content: rb(n.svg),
    title: r
  }), l = Jy(o, Jl, `${Jl}--${i}`);
  return /* @__PURE__ */ d(
    "span",
    {
      className: l,
      "data-testid": e,
      dangerouslySetInnerHTML: { __html: a },
      ...t
    }
  );
};
Oc.displayName = "Icon";
const nb = {
  name: "info",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M11 8.18c0 .537.469.979 1.007.979.524 0 .993-.442.993-.98s-.469-.979-.993-.979c-.538 0-1.007.441-1.007.98Zm.152 1.958v6.897h1.696v-6.897h-1.696Z"/><path fill-rule="evenodd" d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-1.75 0a8.25 8.25 0 1 1-16.5 0 8.25 8.25 0 0 1 16.5 0Z" clip-rule="evenodd"/></svg>',
  keywords: ["info"],
  category: "status"
}, Ac = (e) => /* @__PURE__ */ d(Oc, { ...e, svg: nb });
Ac.displayName = "IconInfo";
function ob(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ql = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var eu;
function ib() {
  return eu || (eu = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o(l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(null, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(Ql)), Ql.exports;
}
var ab = ib();
const lb = /* @__PURE__ */ ob(ab), cr = {
  "purpur-paragraph": "_purpur-paragraph_1rh57_1",
  "purpur-paragraph--disabled": "_purpur-paragraph--disabled_1rh57_7",
  "purpur-paragraph--hyphens": "_purpur-paragraph--hyphens_1rh57_10",
  "purpur-paragraph--negative": "_purpur-paragraph--negative_1rh57_13",
  "purpur-paragraph--paragraph-100": "_purpur-paragraph--paragraph-100_1rh57_16",
  "purpur-paragraph--paragraph-100-medium": "_purpur-paragraph--paragraph-100-medium_1rh57_22",
  "purpur-paragraph--paragraph-100-bold": "_purpur-paragraph--paragraph-100-bold_1rh57_29",
  "purpur-paragraph--paragraph-200": "_purpur-paragraph--paragraph-200_1rh57_36",
  "purpur-paragraph--preamble-100": "_purpur-paragraph--preamble-100_1rh57_42",
  "purpur-paragraph--preamble-200": "_purpur-paragraph--preamble-200_1rh57_48",
  "purpur-paragraph--additional-100": "_purpur-paragraph--additional-100_1rh57_54",
  "purpur-paragraph--additional-100-medium": "_purpur-paragraph--additional-100-medium_1rh57_60",
  "purpur-paragraph--overline-100": "_purpur-paragraph--overline-100_1rh57_67",
  "purpur-paragraph--overline-200": "_purpur-paragraph--overline-200_1rh57_75"
}, Mc = {
  PARAGRAPH100: "paragraph-100"
}, pr = "purpur-paragraph", Fc = ({
  ["data-testid"]: e,
  children: n,
  className: r,
  disabled: o,
  enableHyphenation: i = !1,
  negative: t = !1,
  variant: a = Mc.PARAGRAPH100,
  ...l
}) => {
  const u = lb([
    r,
    cr[pr],
    cr[`${pr}--${a}`],
    {
      [cr[`${pr}--hyphens`]]: i,
      [cr[`${pr}--disabled`]]: o,
      [cr[`${pr}--negative`]]: t
    }
  ]);
  return /* @__PURE__ */ d("p", { ...l, className: u, "data-testid": e, children: n });
};
Fc.displayName = "Paragraph";
const ub = "400ms";
function Oe(e, n, { checkForDefaultPrevented: r = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), r === !1 || !o.defaultPrevented)
      return n == null ? void 0 : n(o);
  };
}
function tu(e, n) {
  if (typeof e == "function")
    return e(n);
  e != null && (e.current = n);
}
function Dc(...e) {
  return (n) => {
    let r = !1;
    const o = e.map((i) => {
      const t = tu(i, n);
      return !r && typeof t == "function" && (r = !0), t;
    });
    if (r)
      return () => {
        for (let i = 0; i < o.length; i++) {
          const t = o[i];
          typeof t == "function" ? t() : tu(e[i], null);
        }
      };
  };
}
function lt(...e) {
  return s.useCallback(Dc(...e), e);
}
function Tc(e, n = []) {
  let r = [];
  function o(t, a) {
    const l = s.createContext(a), u = r.length;
    r = [...r, a];
    const c = (_) => {
      var g;
      const { scope: f, children: m, ...h } = _, v = ((g = f == null ? void 0 : f[e]) == null ? void 0 : g[u]) || l, w = s.useMemo(() => h, Object.values(h));
      return /* @__PURE__ */ d(v.Provider, { value: w, children: m });
    };
    c.displayName = t + "Provider";
    function p(_, g) {
      var f;
      const m = ((f = g == null ? void 0 : g[e]) == null ? void 0 : f[u]) || l, h = s.useContext(m);
      if (h) return h;
      if (a !== void 0) return a;
      throw new Error(`\`${_}\` must be used within \`${t}\``);
    }
    return [c, p];
  }
  const i = () => {
    const t = r.map((a) => s.createContext(a));
    return function(a) {
      const l = (a == null ? void 0 : a[e]) || t;
      return s.useMemo(
        () => ({ [`__scope${e}`]: { ...a, [e]: l } }),
        [a, l]
      );
    };
  };
  return i.scopeName = e, [o, sb(i, ...n)];
}
function sb(...e) {
  const n = e[0];
  if (e.length === 1) return n;
  const r = () => {
    const o = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(i) {
      const t = o.reduce((a, { useScope: l, scopeName: u }) => {
        const c = l(i)[`__scope${u}`];
        return { ...a, ...c };
      }, {});
      return s.useMemo(() => ({ [`__scope${n.scopeName}`]: t }), [t]);
    };
  };
  return r.scopeName = n.scopeName, r;
}
var Lc = s.forwardRef((e, n) => {
  const { children: r, ...o } = e, i = s.Children.toArray(r), t = i.find(cb);
  if (t) {
    const a = t.props.children, l = i.map((u) => u === t ? s.Children.count(a) > 1 ? s.Children.only(null) : s.isValidElement(a) ? a.props.children : null : u);
    return /* @__PURE__ */ d(ko, { ...o, ref: n, children: s.isValidElement(a) ? s.cloneElement(a, void 0, l) : null });
  }
  return /* @__PURE__ */ d(ko, { ...o, ref: n, children: r });
});
Lc.displayName = "Slot";
var ko = s.forwardRef((e, n) => {
  const { children: r, ...o } = e;
  if (s.isValidElement(r)) {
    const i = db(r), t = pb(o, r.props);
    return r.type !== s.Fragment && (t.ref = n ? Dc(n, i) : i), s.cloneElement(r, t);
  }
  return s.Children.count(r) > 1 ? s.Children.only(null) : null;
});
ko.displayName = "SlotClone";
var jc = ({ children: e }) => /* @__PURE__ */ d(q, { children: e });
function cb(e) {
  return s.isValidElement(e) && e.type === jc;
}
function pb(e, n) {
  const r = { ...n };
  for (const o in n) {
    const i = e[o], t = n[o];
    /^on[A-Z]/.test(o) ? i && t ? r[o] = (...a) => {
      t(...a), i(...a);
    } : i && (r[o] = i) : o === "style" ? r[o] = { ...i, ...t } : o === "className" && (r[o] = [i, t].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function db(e) {
  var n, r;
  let o = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, i = o && "isReactWarning" in o && o.isReactWarning;
  return i ? e.ref : (o = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, i = o && "isReactWarning" in o && o.isReactWarning, i ? e.props.ref : e.props.ref || e.ref);
}
var fb = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Ze = fb.reduce((e, n) => {
  const r = s.forwardRef((o, i) => {
    const { asChild: t, ...a } = o, l = t ? Lc : n;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ d(l, { ...a, ref: i });
  });
  return r.displayName = `Primitive.${n}`, { ...e, [n]: r };
}, {});
function gb(e, n) {
  e && jo.flushSync(() => e.dispatchEvent(n));
}
function Dt(e) {
  const n = s.useRef(e);
  return s.useEffect(() => {
    n.current = e;
  }), s.useMemo(() => (...r) => {
    var o;
    return (o = n.current) == null ? void 0 : o.call(n, ...r);
  }, []);
}
function _b(e, n = globalThis == null ? void 0 : globalThis.document) {
  const r = Dt(e);
  s.useEffect(() => {
    const o = (i) => {
      i.key === "Escape" && r(i);
    };
    return n.addEventListener("keydown", o, { capture: !0 }), () => n.removeEventListener("keydown", o, { capture: !0 });
  }, [r, n]);
}
var hb = "DismissableLayer", Oo = "dismissableLayer.update", mb = "dismissableLayer.pointerDownOutside", vb = "dismissableLayer.focusOutside", ru, Ic = s.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Vc = s.forwardRef(
  (e, n) => {
    const {
      disableOutsidePointerEvents: r = !1,
      onEscapeKeyDown: o,
      onPointerDownOutside: i,
      onFocusOutside: t,
      onInteractOutside: a,
      onDismiss: l,
      ...u
    } = e, c = s.useContext(Ic), [p, _] = s.useState(null), g = (p == null ? void 0 : p.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, f] = s.useState({}), m = lt(n, (S) => _(S)), h = Array.from(c.layers), [v] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), w = h.indexOf(v), y = p ? h.indexOf(p) : -1, b = c.layersWithOutsidePointerEventsDisabled.size > 0, $ = y >= w, x = bb((S) => {
      const O = S.target, E = [...c.branches].some((k) => k.contains(O));
      !$ || E || (i == null || i(S), a == null || a(S), S.defaultPrevented || l == null || l());
    }, g), R = $b((S) => {
      const O = S.target;
      [...c.branches].some((E) => E.contains(O)) || (t == null || t(S), a == null || a(S), S.defaultPrevented || l == null || l());
    }, g);
    return _b((S) => {
      y === c.layers.size - 1 && (o == null || o(S), !S.defaultPrevented && l && (S.preventDefault(), l()));
    }, g), s.useEffect(() => {
      if (p)
        return r && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (ru = g.body.style.pointerEvents, g.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(p)), c.layers.add(p), nu(), () => {
          r && c.layersWithOutsidePointerEventsDisabled.size === 1 && (g.body.style.pointerEvents = ru);
        };
    }, [p, g, r, c]), s.useEffect(() => () => {
      p && (c.layers.delete(p), c.layersWithOutsidePointerEventsDisabled.delete(p), nu());
    }, [p, c]), s.useEffect(() => {
      const S = () => f({});
      return document.addEventListener(Oo, S), () => document.removeEventListener(Oo, S);
    }, []), /* @__PURE__ */ d(
      Ze.div,
      {
        ...u,
        ref: m,
        style: {
          pointerEvents: b ? $ ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: Oe(e.onFocusCapture, R.onFocusCapture),
        onBlurCapture: Oe(e.onBlurCapture, R.onBlurCapture),
        onPointerDownCapture: Oe(
          e.onPointerDownCapture,
          x.onPointerDownCapture
        )
      }
    );
  }
);
Vc.displayName = hb;
var wb = "DismissableLayerBranch", yb = s.forwardRef((e, n) => {
  const r = s.useContext(Ic), o = s.useRef(null), i = lt(n, o);
  return s.useEffect(() => {
    const t = o.current;
    if (t)
      return r.branches.add(t), () => {
        r.branches.delete(t);
      };
  }, [r.branches]), /* @__PURE__ */ d(Ze.div, { ...e, ref: i });
});
yb.displayName = wb;
function bb(e, n = globalThis == null ? void 0 : globalThis.document) {
  const r = Dt(e), o = s.useRef(!1), i = s.useRef(() => {
  });
  return s.useEffect(() => {
    const t = (l) => {
      if (l.target && !o.current) {
        let u = function() {
          zc(
            mb,
            r,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: l };
        l.pointerType === "touch" ? (n.removeEventListener("click", i.current), i.current = u, n.addEventListener("click", i.current, { once: !0 })) : u();
      } else
        n.removeEventListener("click", i.current);
      o.current = !1;
    }, a = window.setTimeout(() => {
      n.addEventListener("pointerdown", t);
    }, 0);
    return () => {
      window.clearTimeout(a), n.removeEventListener("pointerdown", t), n.removeEventListener("click", i.current);
    };
  }, [n, r]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => o.current = !0
  };
}
function $b(e, n = globalThis == null ? void 0 : globalThis.document) {
  const r = Dt(e), o = s.useRef(!1);
  return s.useEffect(() => {
    const i = (t) => {
      t.target && !o.current && zc(vb, r, { originalEvent: t }, {
        discrete: !1
      });
    };
    return n.addEventListener("focusin", i), () => n.removeEventListener("focusin", i);
  }, [n, r]), {
    onFocusCapture: () => o.current = !0,
    onBlurCapture: () => o.current = !1
  };
}
function nu() {
  const e = new CustomEvent(Oo);
  document.dispatchEvent(e);
}
function zc(e, n, r, { discrete: o }) {
  const i = r.originalEvent.target, t = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: r });
  n && i.addEventListener(e, n, { once: !0 }), o ? gb(i, t) : i.dispatchEvent(t);
}
var ot = globalThis != null && globalThis.document ? s.useLayoutEffect : () => {
}, xb = s.useId || (() => {
}), Sb = 0;
function Cb(e) {
  const [n, r] = s.useState(xb());
  return ot(() => {
    r((o) => o ?? String(Sb++));
  }, [e]), n ? `radix-${n}` : "";
}
const Rb = ["top", "right", "bottom", "left"], ye = Math.min, te = Math.max, Kr = Math.round, zr = Math.floor, He = (e) => ({
  x: e,
  y: e
}), Eb = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Nb = {
  start: "end",
  end: "start"
};
function Ao(e, n, r) {
  return te(e, ye(n, r));
}
function Ae(e, n) {
  return typeof e == "function" ? e(n) : e;
}
function Me(e) {
  return e.split("-")[0];
}
function Tt(e) {
  return e.split("-")[1];
}
function ni(e) {
  return e === "x" ? "y" : "x";
}
function oi(e) {
  return e === "y" ? "height" : "width";
}
function Be(e) {
  return ["top", "bottom"].includes(Me(e)) ? "y" : "x";
}
function ii(e) {
  return ni(Be(e));
}
function Pb(e, n, r) {
  r === void 0 && (r = !1);
  const o = Tt(e), i = ii(e), t = oi(i);
  let a = i === "x" ? o === (r ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return n.reference[t] > n.floating[t] && (a = Jr(a)), [a, Jr(a)];
}
function kb(e) {
  const n = Jr(e);
  return [Mo(e), n, Mo(n)];
}
function Mo(e) {
  return e.replace(/start|end/g, (n) => Nb[n]);
}
function Ob(e, n, r) {
  const o = ["left", "right"], i = ["right", "left"], t = ["top", "bottom"], a = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return r ? n ? i : o : n ? o : i;
    case "left":
    case "right":
      return n ? t : a;
    default:
      return [];
  }
}
function Ab(e, n, r, o) {
  const i = Tt(e);
  let t = Ob(Me(e), r === "start", o);
  return i && (t = t.map((a) => a + "-" + i), n && (t = t.concat(t.map(Mo)))), t;
}
function Jr(e) {
  return e.replace(/left|right|bottom|top/g, (n) => Eb[n]);
}
function Mb(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function qc(e) {
  return typeof e != "number" ? Mb(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Qr(e) {
  const {
    x: n,
    y: r,
    width: o,
    height: i
  } = e;
  return {
    width: o,
    height: i,
    top: r,
    left: n,
    right: n + o,
    bottom: r + i,
    x: n,
    y: r
  };
}
function ou(e, n, r) {
  let {
    reference: o,
    floating: i
  } = e;
  const t = Be(n), a = ii(n), l = oi(a), u = Me(n), c = t === "y", p = o.x + o.width / 2 - i.width / 2, _ = o.y + o.height / 2 - i.height / 2, g = o[l] / 2 - i[l] / 2;
  let f;
  switch (u) {
    case "top":
      f = {
        x: p,
        y: o.y - i.height
      };
      break;
    case "bottom":
      f = {
        x: p,
        y: o.y + o.height
      };
      break;
    case "right":
      f = {
        x: o.x + o.width,
        y: _
      };
      break;
    case "left":
      f = {
        x: o.x - i.width,
        y: _
      };
      break;
    default:
      f = {
        x: o.x,
        y: o.y
      };
  }
  switch (Tt(n)) {
    case "start":
      f[a] -= g * (r && c ? -1 : 1);
      break;
    case "end":
      f[a] += g * (r && c ? -1 : 1);
      break;
  }
  return f;
}
const Fb = async (e, n, r) => {
  const {
    placement: o = "bottom",
    strategy: i = "absolute",
    middleware: t = [],
    platform: a
  } = r, l = t.filter(Boolean), u = await (a.isRTL == null ? void 0 : a.isRTL(n));
  let c = await a.getElementRects({
    reference: e,
    floating: n,
    strategy: i
  }), {
    x: p,
    y: _
  } = ou(c, o, u), g = o, f = {}, m = 0;
  for (let h = 0; h < l.length; h++) {
    const {
      name: v,
      fn: w
    } = l[h], {
      x: y,
      y: b,
      data: $,
      reset: x
    } = await w({
      x: p,
      y: _,
      initialPlacement: o,
      placement: g,
      strategy: i,
      middlewareData: f,
      rects: c,
      platform: a,
      elements: {
        reference: e,
        floating: n
      }
    });
    p = y ?? p, _ = b ?? _, f = {
      ...f,
      [v]: {
        ...f[v],
        ...$
      }
    }, x && m <= 50 && (m++, typeof x == "object" && (x.placement && (g = x.placement), x.rects && (c = x.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: n,
      strategy: i
    }) : x.rects), {
      x: p,
      y: _
    } = ou(c, g, u)), h = -1);
  }
  return {
    x: p,
    y: _,
    placement: g,
    strategy: i,
    middlewareData: f
  };
};
async function _r(e, n) {
  var r;
  n === void 0 && (n = {});
  const {
    x: o,
    y: i,
    platform: t,
    rects: a,
    elements: l,
    strategy: u
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: p = "viewport",
    elementContext: _ = "floating",
    altBoundary: g = !1,
    padding: f = 0
  } = Ae(n, e), m = qc(f), h = l[g ? _ === "floating" ? "reference" : "floating" : _], v = Qr(await t.getClippingRect({
    element: (r = await (t.isElement == null ? void 0 : t.isElement(h))) == null || r ? h : h.contextElement || await (t.getDocumentElement == null ? void 0 : t.getDocumentElement(l.floating)),
    boundary: c,
    rootBoundary: p,
    strategy: u
  })), w = _ === "floating" ? {
    x: o,
    y: i,
    width: a.floating.width,
    height: a.floating.height
  } : a.reference, y = await (t.getOffsetParent == null ? void 0 : t.getOffsetParent(l.floating)), b = await (t.isElement == null ? void 0 : t.isElement(y)) ? await (t.getScale == null ? void 0 : t.getScale(y)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, $ = Qr(t.convertOffsetParentRelativeRectToViewportRelativeRect ? await t.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: l,
    rect: w,
    offsetParent: y,
    strategy: u
  }) : w);
  return {
    top: (v.top - $.top + m.top) / b.y,
    bottom: ($.bottom - v.bottom + m.bottom) / b.y,
    left: (v.left - $.left + m.left) / b.x,
    right: ($.right - v.right + m.right) / b.x
  };
}
const Db = (e) => ({
  name: "arrow",
  options: e,
  async fn(n) {
    const {
      x: r,
      y: o,
      placement: i,
      rects: t,
      platform: a,
      elements: l,
      middlewareData: u
    } = n, {
      element: c,
      padding: p = 0
    } = Ae(e, n) || {};
    if (c == null)
      return {};
    const _ = qc(p), g = {
      x: r,
      y: o
    }, f = ii(i), m = oi(f), h = await a.getDimensions(c), v = f === "y", w = v ? "top" : "left", y = v ? "bottom" : "right", b = v ? "clientHeight" : "clientWidth", $ = t.reference[m] + t.reference[f] - g[f] - t.floating[m], x = g[f] - t.reference[f], R = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(c));
    let S = R ? R[b] : 0;
    (!S || !await (a.isElement == null ? void 0 : a.isElement(R))) && (S = l.floating[b] || t.floating[m]);
    const O = $ / 2 - x / 2, E = S / 2 - h[m] / 2 - 1, k = ye(_[w], E), D = ye(_[y], E), A = k, ee = S - h[m] - D, T = S / 2 - h[m] / 2 + O, M = Ao(A, T, ee), Z = !u.arrow && Tt(i) != null && T !== M && t.reference[m] / 2 - (T < A ? k : D) - h[m] / 2 < 0, F = Z ? T < A ? T - A : T - ee : 0;
    return {
      [f]: g[f] + F,
      data: {
        [f]: M,
        centerOffset: T - M - F,
        ...Z && {
          alignmentOffset: F
        }
      },
      reset: Z
    };
  }
}), Tb = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(n) {
      var r, o;
      const {
        placement: i,
        middlewareData: t,
        rects: a,
        initialPlacement: l,
        platform: u,
        elements: c
      } = n, {
        mainAxis: p = !0,
        crossAxis: _ = !0,
        fallbackPlacements: g,
        fallbackStrategy: f = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: h = !0,
        ...v
      } = Ae(e, n);
      if ((r = t.arrow) != null && r.alignmentOffset)
        return {};
      const w = Me(i), y = Be(l), b = Me(l) === l, $ = await (u.isRTL == null ? void 0 : u.isRTL(c.floating)), x = g || (b || !h ? [Jr(l)] : kb(l)), R = m !== "none";
      !g && R && x.push(...Ab(l, h, m, $));
      const S = [l, ...x], O = await _r(n, v), E = [];
      let k = ((o = t.flip) == null ? void 0 : o.overflows) || [];
      if (p && E.push(O[w]), _) {
        const T = Pb(i, a, $);
        E.push(O[T[0]], O[T[1]]);
      }
      if (k = [...k, {
        placement: i,
        overflows: E
      }], !E.every((T) => T <= 0)) {
        var D, A;
        const T = (((D = t.flip) == null ? void 0 : D.index) || 0) + 1, M = S[T];
        if (M)
          return {
            data: {
              index: T,
              overflows: k
            },
            reset: {
              placement: M
            }
          };
        let Z = (A = k.filter((F) => F.overflows[0] <= 0).sort((F, H) => F.overflows[1] - H.overflows[1])[0]) == null ? void 0 : A.placement;
        if (!Z)
          switch (f) {
            case "bestFit": {
              var ee;
              const F = (ee = k.filter((H) => {
                if (R) {
                  const I = Be(H.placement);
                  return I === y || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  I === "y";
                }
                return !0;
              }).map((H) => [H.placement, H.overflows.filter((I) => I > 0).reduce((I, ut) => I + ut, 0)]).sort((H, I) => H[1] - I[1])[0]) == null ? void 0 : ee[0];
              F && (Z = F);
              break;
            }
            case "initialPlacement":
              Z = l;
              break;
          }
        if (i !== Z)
          return {
            reset: {
              placement: Z
            }
          };
      }
      return {};
    }
  };
};
function iu(e, n) {
  return {
    top: e.top - n.height,
    right: e.right - n.width,
    bottom: e.bottom - n.height,
    left: e.left - n.width
  };
}
function au(e) {
  return Rb.some((n) => e[n] >= 0);
}
const Lb = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(n) {
      const {
        rects: r
      } = n, {
        strategy: o = "referenceHidden",
        ...i
      } = Ae(e, n);
      switch (o) {
        case "referenceHidden": {
          const t = await _r(n, {
            ...i,
            elementContext: "reference"
          }), a = iu(t, r.reference);
          return {
            data: {
              referenceHiddenOffsets: a,
              referenceHidden: au(a)
            }
          };
        }
        case "escaped": {
          const t = await _r(n, {
            ...i,
            altBoundary: !0
          }), a = iu(t, r.floating);
          return {
            data: {
              escapedOffsets: a,
              escaped: au(a)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function jb(e, n) {
  const {
    placement: r,
    platform: o,
    elements: i
  } = e, t = await (o.isRTL == null ? void 0 : o.isRTL(i.floating)), a = Me(r), l = Tt(r), u = Be(r) === "y", c = ["left", "top"].includes(a) ? -1 : 1, p = t && u ? -1 : 1, _ = Ae(n, e);
  let {
    mainAxis: g,
    crossAxis: f,
    alignmentAxis: m
  } = typeof _ == "number" ? {
    mainAxis: _,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ..._
  };
  return l && typeof m == "number" && (f = l === "end" ? m * -1 : m), u ? {
    x: f * p,
    y: g * c
  } : {
    x: g * c,
    y: f * p
  };
}
const Ib = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(n) {
      var r, o;
      const {
        x: i,
        y: t,
        placement: a,
        middlewareData: l
      } = n, u = await jb(n, e);
      return a === ((r = l.offset) == null ? void 0 : r.placement) && (o = l.arrow) != null && o.alignmentOffset ? {} : {
        x: i + u.x,
        y: t + u.y,
        data: {
          ...u,
          placement: a
        }
      };
    }
  };
}, Vb = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(n) {
      const {
        x: r,
        y: o,
        placement: i
      } = n, {
        mainAxis: t = !0,
        crossAxis: a = !1,
        limiter: l = {
          fn: (v) => {
            let {
              x: w,
              y
            } = v;
            return {
              x: w,
              y
            };
          }
        },
        ...u
      } = Ae(e, n), c = {
        x: r,
        y: o
      }, p = await _r(n, u), _ = Be(Me(i)), g = ni(_);
      let f = c[g], m = c[_];
      if (t) {
        const v = g === "y" ? "top" : "left", w = g === "y" ? "bottom" : "right", y = f + p[v], b = f - p[w];
        f = Ao(y, f, b);
      }
      if (a) {
        const v = _ === "y" ? "top" : "left", w = _ === "y" ? "bottom" : "right", y = m + p[v], b = m - p[w];
        m = Ao(y, m, b);
      }
      const h = l.fn({
        ...n,
        [g]: f,
        [_]: m
      });
      return {
        ...h,
        data: {
          x: h.x - r,
          y: h.y - o
        }
      };
    }
  };
}, zb = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(n) {
      const {
        x: r,
        y: o,
        placement: i,
        rects: t,
        middlewareData: a
      } = n, {
        offset: l = 0,
        mainAxis: u = !0,
        crossAxis: c = !0
      } = Ae(e, n), p = {
        x: r,
        y: o
      }, _ = Be(i), g = ni(_);
      let f = p[g], m = p[_];
      const h = Ae(l, n), v = typeof h == "number" ? {
        mainAxis: h,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...h
      };
      if (u) {
        const b = g === "y" ? "height" : "width", $ = t.reference[g] - t.floating[b] + v.mainAxis, x = t.reference[g] + t.reference[b] - v.mainAxis;
        f < $ ? f = $ : f > x && (f = x);
      }
      if (c) {
        var w, y;
        const b = g === "y" ? "width" : "height", $ = ["top", "left"].includes(Me(i)), x = t.reference[_] - t.floating[b] + ($ && ((w = a.offset) == null ? void 0 : w[_]) || 0) + ($ ? 0 : v.crossAxis), R = t.reference[_] + t.reference[b] + ($ ? 0 : ((y = a.offset) == null ? void 0 : y[_]) || 0) - ($ ? v.crossAxis : 0);
        m < x ? m = x : m > R && (m = R);
      }
      return {
        [g]: f,
        [_]: m
      };
    }
  };
}, qb = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(n) {
      const {
        placement: r,
        rects: o,
        platform: i,
        elements: t
      } = n, {
        apply: a = () => {
        },
        ...l
      } = Ae(e, n), u = await _r(n, l), c = Me(r), p = Tt(r), _ = Be(r) === "y", {
        width: g,
        height: f
      } = o.floating;
      let m, h;
      c === "top" || c === "bottom" ? (m = c, h = p === (await (i.isRTL == null ? void 0 : i.isRTL(t.floating)) ? "start" : "end") ? "left" : "right") : (h = c, m = p === "end" ? "top" : "bottom");
      const v = f - u.top - u.bottom, w = g - u.left - u.right, y = ye(f - u[m], v), b = ye(g - u[h], w), $ = !n.middlewareData.shift;
      let x = y, R = b;
      if (_ ? R = p || $ ? ye(b, w) : w : x = p || $ ? ye(y, v) : v, $ && !p) {
        const O = te(u.left, 0), E = te(u.right, 0), k = te(u.top, 0), D = te(u.bottom, 0);
        _ ? R = g - 2 * (O !== 0 || E !== 0 ? O + E : te(u.left, u.right)) : x = f - 2 * (k !== 0 || D !== 0 ? k + D : te(u.top, u.bottom));
      }
      await a({
        ...n,
        availableWidth: R,
        availableHeight: x
      });
      const S = await i.getDimensions(t.floating);
      return g !== S.width || f !== S.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Lt(e) {
  return Hc(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function ne(e) {
  var n;
  return (e == null || (n = e.ownerDocument) == null ? void 0 : n.defaultView) || window;
}
function Fe(e) {
  var n;
  return (n = (Hc(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : n.documentElement;
}
function Hc(e) {
  return e instanceof Node || e instanceof ne(e).Node;
}
function ge(e) {
  return e instanceof Element || e instanceof ne(e).Element;
}
function be(e) {
  return e instanceof HTMLElement || e instanceof ne(e).HTMLElement;
}
function lu(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof ne(e).ShadowRoot;
}
function mr(e) {
  const {
    overflow: n,
    overflowX: r,
    overflowY: o,
    display: i
  } = _e(e);
  return /auto|scroll|overlay|hidden|clip/.test(n + o + r) && !["inline", "contents"].includes(i);
}
function Hb(e) {
  return ["table", "td", "th"].includes(Lt(e));
}
function sn(e) {
  return [":popover-open", ":modal"].some((n) => {
    try {
      return e.matches(n);
    } catch {
      return !1;
    }
  });
}
function ai(e) {
  const n = li(), r = ge(e) ? _e(e) : e;
  return r.transform !== "none" || r.perspective !== "none" || (r.containerType ? r.containerType !== "normal" : !1) || !n && (r.backdropFilter ? r.backdropFilter !== "none" : !1) || !n && (r.filter ? r.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((o) => (r.willChange || "").includes(o)) || ["paint", "layout", "strict", "content"].some((o) => (r.contain || "").includes(o));
}
function Bb(e) {
  let n = We(e);
  for (; be(n) && !Ot(n); ) {
    if (ai(n))
      return n;
    if (sn(n))
      return null;
    n = We(n);
  }
  return null;
}
function li() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Ot(e) {
  return ["html", "body", "#document"].includes(Lt(e));
}
function _e(e) {
  return ne(e).getComputedStyle(e);
}
function cn(e) {
  return ge(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function We(e) {
  if (Lt(e) === "html")
    return e;
  const n = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    lu(e) && e.host || // Fallback.
    Fe(e)
  );
  return lu(n) ? n.host : n;
}
function Bc(e) {
  const n = We(e);
  return Ot(n) ? e.ownerDocument ? e.ownerDocument.body : e.body : be(n) && mr(n) ? n : Bc(n);
}
function hr(e, n, r) {
  var o;
  n === void 0 && (n = []), r === void 0 && (r = !0);
  const i = Bc(e), t = i === ((o = e.ownerDocument) == null ? void 0 : o.body), a = ne(i);
  if (t) {
    const l = Fo(a);
    return n.concat(a, a.visualViewport || [], mr(i) ? i : [], l && r ? hr(l) : []);
  }
  return n.concat(i, hr(i, [], r));
}
function Fo(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Wc(e) {
  const n = _e(e);
  let r = parseFloat(n.width) || 0, o = parseFloat(n.height) || 0;
  const i = be(e), t = i ? e.offsetWidth : r, a = i ? e.offsetHeight : o, l = Kr(r) !== t || Kr(o) !== a;
  return l && (r = t, o = a), {
    width: r,
    height: o,
    $: l
  };
}
function ui(e) {
  return ge(e) ? e : e.contextElement;
}
function Nt(e) {
  const n = ui(e);
  if (!be(n))
    return He(1);
  const r = n.getBoundingClientRect(), {
    width: o,
    height: i,
    $: t
  } = Wc(n);
  let a = (t ? Kr(r.width) : r.width) / o, l = (t ? Kr(r.height) : r.height) / i;
  return (!a || !Number.isFinite(a)) && (a = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: a,
    y: l
  };
}
const Wb = /* @__PURE__ */ He(0);
function Gc(e) {
  const n = ne(e);
  return !li() || !n.visualViewport ? Wb : {
    x: n.visualViewport.offsetLeft,
    y: n.visualViewport.offsetTop
  };
}
function Gb(e, n, r) {
  return n === void 0 && (n = !1), !r || n && r !== ne(e) ? !1 : n;
}
function it(e, n, r, o) {
  n === void 0 && (n = !1), r === void 0 && (r = !1);
  const i = e.getBoundingClientRect(), t = ui(e);
  let a = He(1);
  n && (o ? ge(o) && (a = Nt(o)) : a = Nt(e));
  const l = Gb(t, r, o) ? Gc(t) : He(0);
  let u = (i.left + l.x) / a.x, c = (i.top + l.y) / a.y, p = i.width / a.x, _ = i.height / a.y;
  if (t) {
    const g = ne(t), f = o && ge(o) ? ne(o) : o;
    let m = g, h = Fo(m);
    for (; h && o && f !== m; ) {
      const v = Nt(h), w = h.getBoundingClientRect(), y = _e(h), b = w.left + (h.clientLeft + parseFloat(y.paddingLeft)) * v.x, $ = w.top + (h.clientTop + parseFloat(y.paddingTop)) * v.y;
      u *= v.x, c *= v.y, p *= v.x, _ *= v.y, u += b, c += $, m = ne(h), h = Fo(m);
    }
  }
  return Qr({
    width: p,
    height: _,
    x: u,
    y: c
  });
}
function Zb(e) {
  let {
    elements: n,
    rect: r,
    offsetParent: o,
    strategy: i
  } = e;
  const t = i === "fixed", a = Fe(o), l = n ? sn(n.floating) : !1;
  if (o === a || l && t)
    return r;
  let u = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = He(1);
  const p = He(0), _ = be(o);
  if ((_ || !_ && !t) && ((Lt(o) !== "body" || mr(a)) && (u = cn(o)), be(o))) {
    const g = it(o);
    c = Nt(o), p.x = g.x + o.clientLeft, p.y = g.y + o.clientTop;
  }
  return {
    width: r.width * c.x,
    height: r.height * c.y,
    x: r.x * c.x - u.scrollLeft * c.x + p.x,
    y: r.y * c.y - u.scrollTop * c.y + p.y
  };
}
function Ub(e) {
  return Array.from(e.getClientRects());
}
function Zc(e) {
  return it(Fe(e)).left + cn(e).scrollLeft;
}
function Xb(e) {
  const n = Fe(e), r = cn(e), o = e.ownerDocument.body, i = te(n.scrollWidth, n.clientWidth, o.scrollWidth, o.clientWidth), t = te(n.scrollHeight, n.clientHeight, o.scrollHeight, o.clientHeight);
  let a = -r.scrollLeft + Zc(e);
  const l = -r.scrollTop;
  return _e(o).direction === "rtl" && (a += te(n.clientWidth, o.clientWidth) - i), {
    width: i,
    height: t,
    x: a,
    y: l
  };
}
function Yb(e, n) {
  const r = ne(e), o = Fe(e), i = r.visualViewport;
  let t = o.clientWidth, a = o.clientHeight, l = 0, u = 0;
  if (i) {
    t = i.width, a = i.height;
    const c = li();
    (!c || c && n === "fixed") && (l = i.offsetLeft, u = i.offsetTop);
  }
  return {
    width: t,
    height: a,
    x: l,
    y: u
  };
}
function Kb(e, n) {
  const r = it(e, !0, n === "fixed"), o = r.top + e.clientTop, i = r.left + e.clientLeft, t = be(e) ? Nt(e) : He(1), a = e.clientWidth * t.x, l = e.clientHeight * t.y, u = i * t.x, c = o * t.y;
  return {
    width: a,
    height: l,
    x: u,
    y: c
  };
}
function uu(e, n, r) {
  let o;
  if (n === "viewport")
    o = Yb(e, r);
  else if (n === "document")
    o = Xb(Fe(e));
  else if (ge(n))
    o = Kb(n, r);
  else {
    const i = Gc(e);
    o = {
      ...n,
      x: n.x - i.x,
      y: n.y - i.y
    };
  }
  return Qr(o);
}
function Uc(e, n) {
  const r = We(e);
  return r === n || !ge(r) || Ot(r) ? !1 : _e(r).position === "fixed" || Uc(r, n);
}
function Jb(e, n) {
  const r = n.get(e);
  if (r)
    return r;
  let o = hr(e, [], !1).filter((l) => ge(l) && Lt(l) !== "body"), i = null;
  const t = _e(e).position === "fixed";
  let a = t ? We(e) : e;
  for (; ge(a) && !Ot(a); ) {
    const l = _e(a), u = ai(a);
    !u && l.position === "fixed" && (i = null), (t ? !u && !i : !u && l.position === "static" && i && ["absolute", "fixed"].includes(i.position) || mr(a) && !u && Uc(e, a)) ? o = o.filter((c) => c !== a) : i = l, a = We(a);
  }
  return n.set(e, o), o;
}
function Qb(e) {
  let {
    element: n,
    boundary: r,
    rootBoundary: o,
    strategy: i
  } = e;
  const t = [...r === "clippingAncestors" ? sn(n) ? [] : Jb(n, this._c) : [].concat(r), o], a = t[0], l = t.reduce((u, c) => {
    const p = uu(n, c, i);
    return u.top = te(p.top, u.top), u.right = ye(p.right, u.right), u.bottom = ye(p.bottom, u.bottom), u.left = te(p.left, u.left), u;
  }, uu(n, a, i));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function e$(e) {
  const {
    width: n,
    height: r
  } = Wc(e);
  return {
    width: n,
    height: r
  };
}
function t$(e, n, r) {
  const o = be(n), i = Fe(n), t = r === "fixed", a = it(e, !0, t, n);
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const u = He(0);
  if (o || !o && !t)
    if ((Lt(n) !== "body" || mr(i)) && (l = cn(n)), o) {
      const _ = it(n, !0, t, n);
      u.x = _.x + n.clientLeft, u.y = _.y + n.clientTop;
    } else i && (u.x = Zc(i));
  const c = a.left + l.scrollLeft - u.x, p = a.top + l.scrollTop - u.y;
  return {
    x: c,
    y: p,
    width: a.width,
    height: a.height
  };
}
function Kn(e) {
  return _e(e).position === "static";
}
function su(e, n) {
  return !be(e) || _e(e).position === "fixed" ? null : n ? n(e) : e.offsetParent;
}
function Xc(e, n) {
  const r = ne(e);
  if (sn(e))
    return r;
  if (!be(e)) {
    let i = We(e);
    for (; i && !Ot(i); ) {
      if (ge(i) && !Kn(i))
        return i;
      i = We(i);
    }
    return r;
  }
  let o = su(e, n);
  for (; o && Hb(o) && Kn(o); )
    o = su(o, n);
  return o && Ot(o) && Kn(o) && !ai(o) ? r : o || Bb(e) || r;
}
const r$ = async function(e) {
  const n = this.getOffsetParent || Xc, r = this.getDimensions, o = await r(e.floating);
  return {
    reference: t$(e.reference, await n(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function n$(e) {
  return _e(e).direction === "rtl";
}
const o$ = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Zb,
  getDocumentElement: Fe,
  getClippingRect: Qb,
  getOffsetParent: Xc,
  getElementRects: r$,
  getClientRects: Ub,
  getDimensions: e$,
  getScale: Nt,
  isElement: ge,
  isRTL: n$
};
function i$(e, n) {
  let r = null, o;
  const i = Fe(e);
  function t() {
    var l;
    clearTimeout(o), (l = r) == null || l.disconnect(), r = null;
  }
  function a(l, u) {
    l === void 0 && (l = !1), u === void 0 && (u = 1), t();
    const {
      left: c,
      top: p,
      width: _,
      height: g
    } = e.getBoundingClientRect();
    if (l || n(), !_ || !g)
      return;
    const f = zr(p), m = zr(i.clientWidth - (c + _)), h = zr(i.clientHeight - (p + g)), v = zr(c), w = {
      rootMargin: -f + "px " + -m + "px " + -h + "px " + -v + "px",
      threshold: te(0, ye(1, u)) || 1
    };
    let y = !0;
    function b($) {
      const x = $[0].intersectionRatio;
      if (x !== u) {
        if (!y)
          return a();
        x ? a(!1, x) : o = setTimeout(() => {
          a(!1, 1e-7);
        }, 1e3);
      }
      y = !1;
    }
    try {
      r = new IntersectionObserver(b, {
        ...w,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(b, w);
    }
    r.observe(e);
  }
  return a(!0), t;
}
function a$(e, n, r, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: t = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: l = typeof IntersectionObserver == "function",
    animationFrame: u = !1
  } = o, c = ui(e), p = i || t ? [...c ? hr(c) : [], ...hr(n)] : [];
  p.forEach((w) => {
    i && w.addEventListener("scroll", r, {
      passive: !0
    }), t && w.addEventListener("resize", r);
  });
  const _ = c && l ? i$(c, r) : null;
  let g = -1, f = null;
  a && (f = new ResizeObserver((w) => {
    let [y] = w;
    y && y.target === c && f && (f.unobserve(n), cancelAnimationFrame(g), g = requestAnimationFrame(() => {
      var b;
      (b = f) == null || b.observe(n);
    })), r();
  }), c && !u && f.observe(c), f.observe(n));
  let m, h = u ? it(e) : null;
  u && v();
  function v() {
    const w = it(e);
    h && (w.x !== h.x || w.y !== h.y || w.width !== h.width || w.height !== h.height) && r(), h = w, m = requestAnimationFrame(v);
  }
  return r(), () => {
    var w;
    p.forEach((y) => {
      i && y.removeEventListener("scroll", r), t && y.removeEventListener("resize", r);
    }), _ == null || _(), (w = f) == null || w.disconnect(), f = null, u && cancelAnimationFrame(m);
  };
}
const l$ = Ib, u$ = Vb, s$ = Tb, c$ = qb, p$ = Lb, cu = Db, d$ = zb, f$ = (e, n, r) => {
  const o = /* @__PURE__ */ new Map(), i = {
    platform: o$,
    ...r
  }, t = {
    ...i.platform,
    _c: o
  };
  return Fb(e, n, {
    ...i,
    platform: t
  });
};
var Gr = typeof document < "u" ? Cu : le;
function en(e, n) {
  if (e === n)
    return !0;
  if (typeof e != typeof n)
    return !1;
  if (typeof e == "function" && e.toString() === n.toString())
    return !0;
  let r, o, i;
  if (e && n && typeof e == "object") {
    if (Array.isArray(e)) {
      if (r = e.length, r !== n.length) return !1;
      for (o = r; o-- !== 0; )
        if (!en(e[o], n[o]))
          return !1;
      return !0;
    }
    if (i = Object.keys(e), r = i.length, r !== Object.keys(n).length)
      return !1;
    for (o = r; o-- !== 0; )
      if (!{}.hasOwnProperty.call(n, i[o]))
        return !1;
    for (o = r; o-- !== 0; ) {
      const t = i[o];
      if (!(t === "_owner" && e.$$typeof) && !en(e[t], n[t]))
        return !1;
    }
    return !0;
  }
  return e !== e && n !== n;
}
function Yc(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function pu(e, n) {
  const r = Yc(e);
  return Math.round(n * r) / r;
}
function du(e) {
  const n = s.useRef(e);
  return Gr(() => {
    n.current = e;
  }), n;
}
function g$(e) {
  e === void 0 && (e = {});
  const {
    placement: n = "bottom",
    strategy: r = "absolute",
    middleware: o = [],
    platform: i,
    elements: {
      reference: t,
      floating: a
    } = {},
    transform: l = !0,
    whileElementsMounted: u,
    open: c
  } = e, [p, _] = s.useState({
    x: 0,
    y: 0,
    strategy: r,
    placement: n,
    middlewareData: {},
    isPositioned: !1
  }), [g, f] = s.useState(o);
  en(g, o) || f(o);
  const [m, h] = s.useState(null), [v, w] = s.useState(null), y = s.useCallback((F) => {
    F !== R.current && (R.current = F, h(F));
  }, []), b = s.useCallback((F) => {
    F !== S.current && (S.current = F, w(F));
  }, []), $ = t || m, x = a || v, R = s.useRef(null), S = s.useRef(null), O = s.useRef(p), E = u != null, k = du(u), D = du(i), A = s.useCallback(() => {
    if (!R.current || !S.current)
      return;
    const F = {
      placement: n,
      strategy: r,
      middleware: g
    };
    D.current && (F.platform = D.current), f$(R.current, S.current, F).then((H) => {
      const I = {
        ...H,
        isPositioned: !0
      };
      ee.current && !en(O.current, I) && (O.current = I, jo.flushSync(() => {
        _(I);
      }));
    });
  }, [g, n, r, D]);
  Gr(() => {
    c === !1 && O.current.isPositioned && (O.current.isPositioned = !1, _((F) => ({
      ...F,
      isPositioned: !1
    })));
  }, [c]);
  const ee = s.useRef(!1);
  Gr(() => (ee.current = !0, () => {
    ee.current = !1;
  }), []), Gr(() => {
    if ($ && (R.current = $), x && (S.current = x), $ && x) {
      if (k.current)
        return k.current($, x, A);
      A();
    }
  }, [$, x, A, k, E]);
  const T = s.useMemo(() => ({
    reference: R,
    floating: S,
    setReference: y,
    setFloating: b
  }), [y, b]), M = s.useMemo(() => ({
    reference: $,
    floating: x
  }), [$, x]), Z = s.useMemo(() => {
    const F = {
      position: r,
      left: 0,
      top: 0
    };
    if (!M.floating)
      return F;
    const H = pu(M.floating, p.x), I = pu(M.floating, p.y);
    return l ? {
      ...F,
      transform: "translate(" + H + "px, " + I + "px)",
      ...Yc(M.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: r,
      left: H,
      top: I
    };
  }, [r, l, M.floating, p.x, p.y]);
  return s.useMemo(() => ({
    ...p,
    update: A,
    refs: T,
    elements: M,
    floatingStyles: Z
  }), [p, A, T, M, Z]);
}
const _$ = (e) => {
  function n(r) {
    return {}.hasOwnProperty.call(r, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(r) {
      const {
        element: o,
        padding: i
      } = typeof e == "function" ? e(r) : e;
      return o && n(o) ? o.current != null ? cu({
        element: o.current,
        padding: i
      }).fn(r) : {} : o ? cu({
        element: o,
        padding: i
      }).fn(r) : {};
    }
  };
}, h$ = (e, n) => ({
  ...l$(e),
  options: [e, n]
}), m$ = (e, n) => ({
  ...u$(e),
  options: [e, n]
}), v$ = (e, n) => ({
  ...d$(e),
  options: [e, n]
}), w$ = (e, n) => ({
  ...s$(e),
  options: [e, n]
}), y$ = (e, n) => ({
  ...c$(e),
  options: [e, n]
}), b$ = (e, n) => ({
  ...p$(e),
  options: [e, n]
}), $$ = (e, n) => ({
  ..._$(e),
  options: [e, n]
});
var x$ = "Arrow", Kc = s.forwardRef((e, n) => {
  const { children: r, width: o = 10, height: i = 5, ...t } = e;
  return /* @__PURE__ */ d(
    Ze.svg,
    {
      ...t,
      ref: n,
      width: o,
      height: i,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? r : /* @__PURE__ */ d("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
Kc.displayName = x$;
var S$ = Kc;
function C$(e) {
  const [n, r] = s.useState(void 0);
  return ot(() => {
    if (e) {
      r({ width: e.offsetWidth, height: e.offsetHeight });
      const o = new ResizeObserver((i) => {
        if (!Array.isArray(i) || !i.length)
          return;
        const t = i[0];
        let a, l;
        if ("borderBoxSize" in t) {
          const u = t.borderBoxSize, c = Array.isArray(u) ? u[0] : u;
          a = c.inlineSize, l = c.blockSize;
        } else
          a = e.offsetWidth, l = e.offsetHeight;
        r({ width: a, height: l });
      });
      return o.observe(e, { box: "border-box" }), () => o.unobserve(e);
    } else
      r(void 0);
  }, [e]), n;
}
var si = "Popper", [Jc, Qc] = Tc(si), [R$, ep] = Jc(si), tp = (e) => {
  const { __scopePopper: n, children: r } = e, [o, i] = s.useState(null);
  return /* @__PURE__ */ d(R$, { scope: n, anchor: o, onAnchorChange: i, children: r });
};
tp.displayName = si;
var rp = "PopperAnchor", np = s.forwardRef(
  (e, n) => {
    const { __scopePopper: r, virtualRef: o, ...i } = e, t = ep(rp, r), a = s.useRef(null), l = lt(n, a);
    return s.useEffect(() => {
      t.onAnchorChange((o == null ? void 0 : o.current) || a.current);
    }), o ? null : /* @__PURE__ */ d(Ze.div, { ...i, ref: l });
  }
);
np.displayName = rp;
var ci = "PopperContent", [E$, N$] = Jc(ci), op = s.forwardRef(
  (e, n) => {
    var r, o, i, t, a, l;
    const {
      __scopePopper: u,
      side: c = "bottom",
      sideOffset: p = 0,
      align: _ = "center",
      alignOffset: g = 0,
      arrowPadding: f = 0,
      avoidCollisions: m = !0,
      collisionBoundary: h = [],
      collisionPadding: v = 0,
      sticky: w = "partial",
      hideWhenDetached: y = !1,
      updatePositionStrategy: b = "optimized",
      onPlaced: $,
      ...x
    } = e, R = ep(ci, u), [S, O] = s.useState(null), E = lt(n, (me) => O(me)), [k, D] = s.useState(null), A = C$(k), ee = (A == null ? void 0 : A.width) ?? 0, T = (A == null ? void 0 : A.height) ?? 0, M = c + (_ !== "center" ? "-" + _ : ""), Z = typeof v == "number" ? v : { top: 0, right: 0, bottom: 0, left: 0, ...v }, F = Array.isArray(h) ? h : [h], H = F.length > 0, I = {
      padding: Z,
      boundary: F.filter(k$),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: H
    }, { refs: ut, floatingStyles: jt, placement: br, isPositioned: Ue, middlewareData: pe } = g$({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: M,
      whileElementsMounted: (...me) => a$(...me, {
        animationFrame: b === "always"
      }),
      elements: {
        reference: R.anchor
      },
      middleware: [
        h$({ mainAxis: p + T, alignmentAxis: g }),
        m && m$({
          mainAxis: !0,
          crossAxis: !1,
          limiter: w === "partial" ? v$() : void 0,
          ...I
        }),
        m && w$({ ...I }),
        y$({
          ...I,
          apply: ({ elements: me, rects: De, availableWidth: Vt, availableHeight: _n }) => {
            const { width: hn, height: mn } = De.reference, dt = me.floating.style;
            dt.setProperty("--radix-popper-available-width", `${Vt}px`), dt.setProperty("--radix-popper-available-height", `${_n}px`), dt.setProperty("--radix-popper-anchor-width", `${hn}px`), dt.setProperty("--radix-popper-anchor-height", `${mn}px`);
          }
        }),
        k && $$({ element: k, padding: f }),
        O$({ arrowWidth: ee, arrowHeight: T }),
        y && b$({ strategy: "referenceHidden", ...I })
      ]
    }), [It, st] = lp(br), ct = Dt($);
    ot(() => {
      Ue && (ct == null || ct());
    }, [Ue, ct]);
    const $r = (r = pe.arrow) == null ? void 0 : r.x, xr = (o = pe.arrow) == null ? void 0 : o.y, pt = ((i = pe.arrow) == null ? void 0 : i.centerOffset) !== 0, [Xe, gn] = s.useState();
    return ot(() => {
      S && gn(window.getComputedStyle(S).zIndex);
    }, [S]), /* @__PURE__ */ d(
      "div",
      {
        ref: ut.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...jt,
          transform: Ue ? jt.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: Xe,
          "--radix-popper-transform-origin": [
            (t = pe.transformOrigin) == null ? void 0 : t.x,
            (a = pe.transformOrigin) == null ? void 0 : a.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((l = pe.hide) == null ? void 0 : l.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ d(
          E$,
          {
            scope: u,
            placedSide: It,
            onArrowChange: D,
            arrowX: $r,
            arrowY: xr,
            shouldHideArrow: pt,
            children: /* @__PURE__ */ d(
              Ze.div,
              {
                "data-side": It,
                "data-align": st,
                ...x,
                ref: E,
                style: {
                  ...x.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: Ue ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
op.displayName = ci;
var ip = "PopperArrow", P$ = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, ap = s.forwardRef(function(e, n) {
  const { __scopePopper: r, ...o } = e, i = N$(ip, r), t = P$[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ d(
      "span",
      {
        ref: i.onArrowChange,
        style: {
          position: "absolute",
          left: i.arrowX,
          top: i.arrowY,
          [t]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[i.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[i.placedSide],
          visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ d(
          S$,
          {
            ...o,
            ref: n,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
ap.displayName = ip;
function k$(e) {
  return e !== null;
}
var O$ = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(n) {
    var r, o, i;
    const { placement: t, rects: a, middlewareData: l } = n, u = ((r = l.arrow) == null ? void 0 : r.centerOffset) !== 0, c = u ? 0 : e.arrowWidth, p = u ? 0 : e.arrowHeight, [_, g] = lp(t), f = { start: "0%", center: "50%", end: "100%" }[g], m = (((o = l.arrow) == null ? void 0 : o.x) ?? 0) + c / 2, h = (((i = l.arrow) == null ? void 0 : i.y) ?? 0) + p / 2;
    let v = "", w = "";
    return _ === "bottom" ? (v = u ? f : `${m}px`, w = `${-p}px`) : _ === "top" ? (v = u ? f : `${m}px`, w = `${a.floating.height + p}px`) : _ === "right" ? (v = `${-p}px`, w = u ? f : `${h}px`) : _ === "left" && (v = `${a.floating.width + p}px`, w = u ? f : `${h}px`), { data: { x: v, y: w } };
  }
});
function lp(e) {
  const [n, r = "center"] = e.split("-");
  return [n, r];
}
var A$ = tp, M$ = np, F$ = op, D$ = ap, T$ = "Portal", up = s.forwardRef((e, n) => {
  var r;
  const { container: o, ...i } = e, [t, a] = s.useState(!1);
  ot(() => a(!0), []);
  const l = o || t && ((r = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : r.body);
  return l ? Ru.createPortal(/* @__PURE__ */ d(Ze.div, { ...i, ref: n }), l) : null;
});
up.displayName = T$;
function L$(e, n) {
  return s.useReducer((r, o) => n[r][o] ?? r, e);
}
var pi = (e) => {
  const { present: n, children: r } = e, o = j$(n), i = typeof r == "function" ? r({ present: o.isPresent }) : s.Children.only(r), t = lt(o.ref, I$(i));
  return typeof r == "function" || o.isPresent ? s.cloneElement(i, { ref: t }) : null;
};
pi.displayName = "Presence";
function j$(e) {
  const [n, r] = s.useState(), o = s.useRef({}), i = s.useRef(e), t = s.useRef("none"), a = e ? "mounted" : "unmounted", [l, u] = L$(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return s.useEffect(() => {
    const c = qr(o.current);
    t.current = l === "mounted" ? c : "none";
  }, [l]), ot(() => {
    const c = o.current, p = i.current;
    if (p !== e) {
      const _ = t.current, g = qr(c);
      e ? u("MOUNT") : g === "none" || (c == null ? void 0 : c.display) === "none" ? u("UNMOUNT") : u(p && _ !== g ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
    }
  }, [e, u]), ot(() => {
    if (n) {
      let c;
      const p = n.ownerDocument.defaultView ?? window, _ = (f) => {
        const m = qr(o.current).includes(f.animationName);
        if (f.target === n && m && (u("ANIMATION_END"), !i.current)) {
          const h = n.style.animationFillMode;
          n.style.animationFillMode = "forwards", c = p.setTimeout(() => {
            n.style.animationFillMode === "forwards" && (n.style.animationFillMode = h);
          });
        }
      }, g = (f) => {
        f.target === n && (t.current = qr(o.current));
      };
      return n.addEventListener("animationstart", g), n.addEventListener("animationcancel", _), n.addEventListener("animationend", _), () => {
        p.clearTimeout(c), n.removeEventListener("animationstart", g), n.removeEventListener("animationcancel", _), n.removeEventListener("animationend", _);
      };
    } else
      u("ANIMATION_END");
  }, [n, u]), {
    isPresent: ["mounted", "unmountSuspended"].includes(l),
    ref: s.useCallback((c) => {
      c && (o.current = getComputedStyle(c)), r(c);
    }, [])
  };
}
function qr(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function I$(e) {
  var n, r;
  let o = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, i = o && "isReactWarning" in o && o.isReactWarning;
  return i ? e.ref : (o = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, i = o && "isReactWarning" in o && o.isReactWarning, i ? e.props.ref : e.props.ref || e.ref);
}
function V$({
  prop: e,
  defaultProp: n,
  onChange: r = () => {
  }
}) {
  const [o, i] = z$({ defaultProp: n, onChange: r }), t = e !== void 0, a = t ? e : o, l = Dt(r), u = s.useCallback(
    (c) => {
      if (t) {
        const p = typeof c == "function" ? c(e) : c;
        p !== e && l(p);
      } else
        i(c);
    },
    [t, e, i, l]
  );
  return [a, u];
}
function z$({
  defaultProp: e,
  onChange: n
}) {
  const r = s.useState(e), [o] = r, i = s.useRef(o), t = Dt(n);
  return s.useEffect(() => {
    i.current !== o && (t(o), i.current = o);
  }, [o, i, t]), r;
}
var q$ = "VisuallyHidden", sp = s.forwardRef(
  (e, n) => /* @__PURE__ */ d(
    Ze.span,
    {
      ...e,
      ref: n,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
sp.displayName = q$;
var H$ = sp, [pn, Qx] = Tc("Tooltip", [
  Qc
]), dn = Qc(), cp = "TooltipProvider", B$ = 700, Do = "tooltip.open", [W$, di] = pn(cp), pp = (e) => {
  const {
    __scopeTooltip: n,
    delayDuration: r = B$,
    skipDelayDuration: o = 300,
    disableHoverableContent: i = !1,
    children: t
  } = e, [a, l] = s.useState(!0), u = s.useRef(!1), c = s.useRef(0);
  return s.useEffect(() => {
    const p = c.current;
    return () => window.clearTimeout(p);
  }, []), /* @__PURE__ */ d(
    W$,
    {
      scope: n,
      isOpenDelayed: a,
      delayDuration: r,
      onOpen: s.useCallback(() => {
        window.clearTimeout(c.current), l(!1);
      }, []),
      onClose: s.useCallback(() => {
        window.clearTimeout(c.current), c.current = window.setTimeout(
          () => l(!0),
          o
        );
      }, [o]),
      isPointerInTransitRef: u,
      onPointerInTransitChange: s.useCallback((p) => {
        u.current = p;
      }, []),
      disableHoverableContent: i,
      children: t
    }
  );
};
pp.displayName = cp;
var fn = "Tooltip", [G$, vr] = pn(fn), dp = (e) => {
  const {
    __scopeTooltip: n,
    children: r,
    open: o,
    defaultOpen: i = !1,
    onOpenChange: t,
    disableHoverableContent: a,
    delayDuration: l
  } = e, u = di(fn, e.__scopeTooltip), c = dn(n), [p, _] = s.useState(null), g = Cb(), f = s.useRef(0), m = a ?? u.disableHoverableContent, h = l ?? u.delayDuration, v = s.useRef(!1), [w = !1, y] = V$({
    prop: o,
    defaultProp: i,
    onChange: (S) => {
      S ? (u.onOpen(), document.dispatchEvent(new CustomEvent(Do))) : u.onClose(), t == null || t(S);
    }
  }), b = s.useMemo(() => w ? v.current ? "delayed-open" : "instant-open" : "closed", [w]), $ = s.useCallback(() => {
    window.clearTimeout(f.current), f.current = 0, v.current = !1, y(!0);
  }, [y]), x = s.useCallback(() => {
    window.clearTimeout(f.current), f.current = 0, y(!1);
  }, [y]), R = s.useCallback(() => {
    window.clearTimeout(f.current), f.current = window.setTimeout(() => {
      v.current = !0, y(!0), f.current = 0;
    }, h);
  }, [h, y]);
  return s.useEffect(() => () => {
    f.current && (window.clearTimeout(f.current), f.current = 0);
  }, []), /* @__PURE__ */ d(A$, { ...c, children: /* @__PURE__ */ d(
    G$,
    {
      scope: n,
      contentId: g,
      open: w,
      stateAttribute: b,
      trigger: p,
      onTriggerChange: _,
      onTriggerEnter: s.useCallback(() => {
        u.isOpenDelayed ? R() : $();
      }, [u.isOpenDelayed, R, $]),
      onTriggerLeave: s.useCallback(() => {
        m ? x() : (window.clearTimeout(f.current), f.current = 0);
      }, [x, m]),
      onOpen: $,
      onClose: x,
      disableHoverableContent: m,
      children: r
    }
  ) });
};
dp.displayName = fn;
var To = "TooltipTrigger", fp = s.forwardRef(
  (e, n) => {
    const { __scopeTooltip: r, ...o } = e, i = vr(To, r), t = di(To, r), a = dn(r), l = s.useRef(null), u = lt(n, l, i.onTriggerChange), c = s.useRef(!1), p = s.useRef(!1), _ = s.useCallback(() => c.current = !1, []);
    return s.useEffect(() => () => document.removeEventListener("pointerup", _), [_]), /* @__PURE__ */ d(M$, { asChild: !0, ...a, children: /* @__PURE__ */ d(
      Ze.button,
      {
        "aria-describedby": i.open ? i.contentId : void 0,
        "data-state": i.stateAttribute,
        ...o,
        ref: u,
        onPointerMove: Oe(e.onPointerMove, (g) => {
          g.pointerType !== "touch" && !p.current && !t.isPointerInTransitRef.current && (i.onTriggerEnter(), p.current = !0);
        }),
        onPointerLeave: Oe(e.onPointerLeave, () => {
          i.onTriggerLeave(), p.current = !1;
        }),
        onPointerDown: Oe(e.onPointerDown, () => {
          c.current = !0, document.addEventListener("pointerup", _, { once: !0 });
        }),
        onFocus: Oe(e.onFocus, () => {
          c.current || i.onOpen();
        }),
        onBlur: Oe(e.onBlur, i.onClose),
        onClick: Oe(e.onClick, i.onClose)
      }
    ) });
  }
);
fp.displayName = To;
var fi = "TooltipPortal", [Z$, U$] = pn(fi, {
  forceMount: void 0
}), gp = (e) => {
  const { __scopeTooltip: n, forceMount: r, children: o, container: i } = e, t = vr(fi, n);
  return /* @__PURE__ */ d(Z$, { scope: n, forceMount: r, children: /* @__PURE__ */ d(pi, { present: r || t.open, children: /* @__PURE__ */ d(up, { asChild: !0, container: i, children: o }) }) });
};
gp.displayName = fi;
var At = "TooltipContent", _p = s.forwardRef(
  (e, n) => {
    const r = U$(At, e.__scopeTooltip), { forceMount: o = r.forceMount, side: i = "top", ...t } = e, a = vr(At, e.__scopeTooltip);
    return /* @__PURE__ */ d(pi, { present: o || a.open, children: a.disableHoverableContent ? /* @__PURE__ */ d(hp, { side: i, ...t, ref: n }) : /* @__PURE__ */ d(X$, { side: i, ...t, ref: n }) });
  }
), X$ = s.forwardRef((e, n) => {
  const r = vr(At, e.__scopeTooltip), o = di(At, e.__scopeTooltip), i = s.useRef(null), t = lt(n, i), [a, l] = s.useState(null), { trigger: u, onClose: c } = r, p = i.current, { onPointerInTransitChange: _ } = o, g = s.useCallback(() => {
    l(null), _(!1);
  }, [_]), f = s.useCallback(
    (m, h) => {
      const v = m.currentTarget, w = { x: m.clientX, y: m.clientY }, y = J$(w, v.getBoundingClientRect()), b = Q$(w, y), $ = e2(h.getBoundingClientRect()), x = r2([...b, ...$]);
      l(x), _(!0);
    },
    [_]
  );
  return s.useEffect(() => () => g(), [g]), s.useEffect(() => {
    if (u && p) {
      const m = (v) => f(v, p), h = (v) => f(v, u);
      return u.addEventListener("pointerleave", m), p.addEventListener("pointerleave", h), () => {
        u.removeEventListener("pointerleave", m), p.removeEventListener("pointerleave", h);
      };
    }
  }, [u, p, f, g]), s.useEffect(() => {
    if (a) {
      const m = (h) => {
        const v = h.target, w = { x: h.clientX, y: h.clientY }, y = (u == null ? void 0 : u.contains(v)) || (p == null ? void 0 : p.contains(v)), b = !t2(w, a);
        y ? g() : b && (g(), c());
      };
      return document.addEventListener("pointermove", m), () => document.removeEventListener("pointermove", m);
    }
  }, [u, p, a, c, g]), /* @__PURE__ */ d(hp, { ...e, ref: t });
}), [Y$, K$] = pn(fn, { isInside: !1 }), hp = s.forwardRef(
  (e, n) => {
    const {
      __scopeTooltip: r,
      children: o,
      "aria-label": i,
      onEscapeKeyDown: t,
      onPointerDownOutside: a,
      ...l
    } = e, u = vr(At, r), c = dn(r), { onClose: p } = u;
    return s.useEffect(() => (document.addEventListener(Do, p), () => document.removeEventListener(Do, p)), [p]), s.useEffect(() => {
      if (u.trigger) {
        const _ = (g) => {
          const f = g.target;
          f != null && f.contains(u.trigger) && p();
        };
        return window.addEventListener("scroll", _, { capture: !0 }), () => window.removeEventListener("scroll", _, { capture: !0 });
      }
    }, [u.trigger, p]), /* @__PURE__ */ d(
      Vc,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: t,
        onPointerDownOutside: a,
        onFocusOutside: (_) => _.preventDefault(),
        onDismiss: p,
        children: /* @__PURE__ */ C(
          F$,
          {
            "data-state": u.stateAttribute,
            ...c,
            ...l,
            ref: n,
            style: {
              ...l.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ d(jc, { children: o }),
              /* @__PURE__ */ d(Y$, { scope: r, isInside: !0, children: /* @__PURE__ */ d(H$, { id: u.contentId, role: "tooltip", children: i || o }) })
            ]
          }
        )
      }
    );
  }
);
_p.displayName = At;
var mp = "TooltipArrow", vp = s.forwardRef(
  (e, n) => {
    const { __scopeTooltip: r, ...o } = e, i = dn(r);
    return K$(
      mp,
      r
    ).isInside ? null : /* @__PURE__ */ d(D$, { ...i, ...o, ref: n });
  }
);
vp.displayName = mp;
function J$(e, n) {
  const r = Math.abs(n.top - e.y), o = Math.abs(n.bottom - e.y), i = Math.abs(n.right - e.x), t = Math.abs(n.left - e.x);
  switch (Math.min(r, o, i, t)) {
    case t:
      return "left";
    case i:
      return "right";
    case r:
      return "top";
    case o:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function Q$(e, n, r = 5) {
  const o = [];
  switch (n) {
    case "top":
      o.push(
        { x: e.x - r, y: e.y + r },
        { x: e.x + r, y: e.y + r }
      );
      break;
    case "bottom":
      o.push(
        { x: e.x - r, y: e.y - r },
        { x: e.x + r, y: e.y - r }
      );
      break;
    case "left":
      o.push(
        { x: e.x + r, y: e.y - r },
        { x: e.x + r, y: e.y + r }
      );
      break;
    case "right":
      o.push(
        { x: e.x - r, y: e.y - r },
        { x: e.x - r, y: e.y + r }
      );
      break;
  }
  return o;
}
function e2(e) {
  const { top: n, right: r, bottom: o, left: i } = e;
  return [
    { x: i, y: n },
    { x: r, y: n },
    { x: r, y: o },
    { x: i, y: o }
  ];
}
function t2(e, n) {
  const { x: r, y: o } = e;
  let i = !1;
  for (let t = 0, a = n.length - 1; t < n.length; a = t++) {
    const l = n[t].x, u = n[t].y, c = n[a].x, p = n[a].y;
    u > o != p > o && r < (c - l) * (o - u) / (p - u) + l && (i = !i);
  }
  return i;
}
function r2(e) {
  const n = e.slice();
  return n.sort((r, o) => r.x < o.x ? -1 : r.x > o.x ? 1 : r.y < o.y ? -1 : r.y > o.y ? 1 : 0), n2(n);
}
function n2(e) {
  if (e.length <= 1) return e.slice();
  const n = [];
  for (let o = 0; o < e.length; o++) {
    const i = e[o];
    for (; n.length >= 2; ) {
      const t = n[n.length - 1], a = n[n.length - 2];
      if ((t.x - a.x) * (i.y - a.y) >= (t.y - a.y) * (i.x - a.x)) n.pop();
      else break;
    }
    n.push(i);
  }
  n.pop();
  const r = [];
  for (let o = e.length - 1; o >= 0; o--) {
    const i = e[o];
    for (; r.length >= 2; ) {
      const t = r[r.length - 1], a = r[r.length - 2];
      if ((t.x - a.x) * (i.y - a.y) >= (t.y - a.y) * (i.x - a.x)) r.pop();
      else break;
    }
    r.push(i);
  }
  return r.pop(), n.length === 1 && r.length === 1 && n[0].x === r[0].x && n[0].y === r[0].y ? n : n.concat(r);
}
var o2 = pp, i2 = dp, a2 = fp, l2 = gp, u2 = _p, s2 = vp;
function c2(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var fu = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var gu;
function p2() {
  return gu || (gu = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o.call(this, l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return this && this[t] || t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(this, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, this && this[l] || l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(fu)), fu.exports;
}
var d2 = p2();
const f2 = /* @__PURE__ */ c2(d2), g2 = "_slideDownAndFade_fkagk_1", _2 = "_slideLeftAndFade_fkagk_1", h2 = "_slideUpAndFade_fkagk_1", m2 = "_slideRightAndFade_fkagk_1", v2 = {
  "purpur-tooltip": "_purpur-tooltip_fkagk_1",
  "purpur-tooltip__content": "_purpur-tooltip__content_fkagk_4",
  "purpur-tooltip__content--primary": "_purpur-tooltip__content--primary_fkagk_14",
  "purpur-tooltip__content--primary-negative": "_purpur-tooltip__content--primary-negative_fkagk_17",
  slideDownAndFade: g2,
  slideLeftAndFade: _2,
  slideUpAndFade: h2,
  slideRightAndFade: m2,
  "purpur-tooltip__arrow--primary": "_purpur-tooltip__arrow--primary_fkagk_32",
  "purpur-tooltip__arrow--primary-negative": "_purpur-tooltip__arrow--primary-negative_fkagk_35"
}, Jn = f2.bind(v2), w2 = {
  TOP: "top"
}, y2 = {
  CENTER: "center"
}, bt = "purpur-tooltip", gi = W(
  ({
    ["data-testid"]: e,
    buttonSize: n = "md",
    children: r,
    className: o,
    contentClassName: i,
    negative: t = !1,
    position: a = w2.TOP,
    align: l = y2.CENTER,
    triggerAriaLabel: u,
    triggerElement: c,
    ...p
  }, _) => {
    const [g, f] = j(!1), m = Jn([
      o,
      bt,
      `${bt}--primary${t ? "-negative" : ""}`
    ]), h = /* @__PURE__ */ d(
      kc,
      {
        ref: _,
        "aria-label": u,
        variant: By.TERTIARY_PURPLE,
        negative: t,
        iconOnly: !0,
        "data-testid": `${e}-trigger-button`,
        size: n,
        children: /* @__PURE__ */ d(Ac, { size: "md" })
      }
    );
    return /* @__PURE__ */ d("div", { "data-testid": e, className: m, children: /* @__PURE__ */ d(o2, { delayDuration: parseInt(ub), children: /* @__PURE__ */ C(i2, { open: g, onOpenChange: f, ...p, children: [
      /* @__PURE__ */ d(
        a2,
        {
          asChild: !0,
          onClick: (v) => {
            v.preventDefault(), f(!0);
          },
          children: zp.count(c) === 0 ? h : c
        }
      ),
      /* @__PURE__ */ d(l2, { children: /* @__PURE__ */ C(
        u2,
        {
          side: a,
          align: l,
          className: Jn([
            i,
            `${bt}__content`,
            `${bt}__content--primary${t ? "-negative" : ""}`
          ]),
          sideOffset: -5,
          "data-testid": `${e}-content`,
          children: [
            typeof r == "string" ? /* @__PURE__ */ d(
              Fc,
              {
                variant: Mc.PARAGRAPH100,
                negative: !t,
                "data-testid": `${e}-paragraph`,
                children: r
              }
            ) : r,
            /* @__PURE__ */ d(
              s2,
              {
                className: Jn([
                  `${bt}__arrow`,
                  `${bt}__arrow--primary${t ? "-negative" : ""}`
                ])
              }
            )
          ]
        }
      ) })
    ] }) }) });
  }
);
gi.displayName = "Tooltip";
const wp = () => {
  const [e, n] = j(!1), r = ue(null);
  return { showPopover: e, containerRef: r, onMouseEnter: () => {
    if (r.current) {
      const t = r.current.querySelector("a, p");
      if (t) {
        const a = r.current.clientWidth, l = t.tagName.toLowerCase() === "a" ? t.offsetWidth : t.scrollWidth;
        n(l > a);
      }
    }
  }, onMouseLeave: () => {
    n(!1);
  } };
}, Qn = z.bind(G), b2 = ({ cell: e }) => {
  const n = e.getValue(), { showPopover: r, containerRef: o, onMouseEnter: i, onMouseLeave: t } = wp();
  if (!n)
    return /* @__PURE__ */ d(ae, {});
  const a = on(e.column.getSize()), l = /* @__PURE__ */ d(
    "div",
    {
      ref: o,
      className: Qn("purpur-table-row-cell__truncate-wrapper"),
      style: {
        minWidth: a
      },
      onMouseEnter: i,
      onMouseLeave: t,
      children: /* @__PURE__ */ d(se, { className: Qn("purpur-table-row-cell__truncate"), children: n })
    }
  );
  return /* @__PURE__ */ d(
    gi,
    {
      position: "top",
      align: "center",
      triggerElement: l,
      open: r,
      contentClassName: Qn("purpur-table-row-cell__tooltip-content"),
      children: n
    }
  );
}, $2 = ({ cell: e }) => {
  var t;
  const n = e.row.original[e.column.id];
  if (n == null)
    return /* @__PURE__ */ d(ae, {});
  const r = (t = e.column.columnDef.meta) == null ? void 0 : t.onClick, { children: o, ...i } = n;
  return /* @__PURE__ */ d(re, { type: "button", onClick: () => r == null ? void 0 : r(e), size: "sm", ...i, children: o });
}, x2 = z.bind(G), S2 = ({ cell: e }) => {
  const n = e.row.original[e.column.id];
  return !n || !Array.isArray(n) || n.length === 0 ? /* @__PURE__ */ d(ae, {}) : /* @__PURE__ */ d("div", { className: x2("purpur-table-row-cell__button-group"), children: n.map((r, o) => {
    const { icon: i, ariaLabel: t, variant: a, ...l } = r;
    return /* @__PURE__ */ d(
      re,
      {
        iconOnly: !0,
        "aria-label": t,
        variant: a,
        type: "button",
        onClick: () => {
          var u, c;
          (c = (u = e.column.columnDef.meta) == null ? void 0 : u.onClick) == null || c.call(u, {
            ...e,
            buttonId: `${e.id}_${r.id}`
          });
        },
        ...l,
        children: i
      },
      r.id || `button-${o}`
    );
  }) });
};
function C2(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var _u = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var hu;
function R2() {
  return hu || (hu = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o.call(this, l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return this && this[t] || t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(this, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, this && this[l] || l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(_u)), _u.exports;
}
var E2 = R2();
const N2 = /* @__PURE__ */ C2(E2), P2 = {
  "purpur-icon": "_purpur-icon_8u1lq_1",
  "purpur-icon--xxs": "_purpur-icon--xxs_8u1lq_4",
  "purpur-icon--xs": "_purpur-icon--xs_8u1lq_8",
  "purpur-icon--sm": "_purpur-icon--sm_8u1lq_12",
  "purpur-icon--md": "_purpur-icon--md_8u1lq_16",
  "purpur-icon--lg": "_purpur-icon--lg_8u1lq_20",
  "purpur-icon--xl": "_purpur-icon--xl_8u1lq_24"
}, k2 = N2.bind(P2), mu = "purpur-icon", O2 = "md", A2 = (e) => e.filter((n) => Object.keys(n).length >= 1).map((n) => `${n.name}="${n.value}"`).join(" "), M2 = ({ content: e = "", title: n } = {}) => {
  const r = [
    { name: "xmlns", value: "http://www.w3.org/2000/svg" },
    { name: "fill", value: "currentColor" },
    { name: "viewBox", value: "0 0 24 24" },
    n ? { name: "role", value: "img" } : { name: "aria-hidden", value: "true" }
  ], o = n ? `<title>${n}</title>` : "";
  return `<svg ${A2(r)}>${o}${e}</svg>`;
}, F2 = (e) => e.replace(/<(\/?)svg([^>]*)>/g, "").trim(), Lo = ({
  ["data-testid"]: e,
  svg: n,
  allyTitle: r,
  className: o,
  size: i = O2,
  ...t
}) => {
  const a = M2({
    content: F2(n.svg),
    title: r
  }), l = k2(o, mu, `${mu}--${i}`);
  return /* @__PURE__ */ d(
    "span",
    {
      className: l,
      "data-testid": e,
      dangerouslySetInnerHTML: { __html: a },
      ...t
    }
  );
};
Lo.displayName = "Icon";
const D2 = {
  name: "arrow-left",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M3.1 12a.9.9 0 0 1 .264-.636l5.5-5.5a.9.9 0 0 1 1.272 1.272L6.173 11.1H20a.9.9 0 0 1 0 1.8H6.173l3.963 3.964a.9.9 0 1 1-1.272 1.272l-5.5-5.5A.9.9 0 0 1 3.1 12Z" clip-rule="evenodd"/></svg>',
  keywords: ["arrow-left"],
  category: "utility"
}, T2 = {
  name: "arrow-right",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M20.9 12a.9.9 0 0 1-.264.636l-5.5 5.5a.9.9 0 0 1-1.272-1.272l3.963-3.964H4a.9.9 0 0 1 0-1.8h13.827l-3.963-3.964a.9.9 0 1 1 1.272-1.272l5.5 5.5A.9.9 0 0 1 20.9 12Z" clip-rule="evenodd"/></svg>',
  keywords: ["arrow-right"],
  category: "utility"
}, L2 = {
  name: "external",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M15 3.4a.9.9 0 1 1 0-1.8h6.5a.9.9 0 0 1 .9.9V9a.9.9 0 1 1-1.8 0V4.673l-7.964 7.963a.9.9 0 1 1-1.272-1.272L19.327 3.4H15ZM1.6 5c0-1.05.85-1.9 1.9-1.9h6a.9.9 0 0 1 0 1.8h-6a.1.1 0 0 0-.1.1v15.5a.1.1 0 0 0 .1.1h16a.1.1 0 0 0 .1-.1V14a.9.9 0 1 1 1.8 0v6.5a1.9 1.9 0 0 1-1.9 1.9h-16a1.9 1.9 0 0 1-1.9-1.9V5Z" clip-rule="evenodd"/></svg>',
  keywords: ["external"],
  category: "media"
}, j2 = {
  name: "phone",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M5.341 2.228c.75-.622 1.73-.43 2.305.145l2.783 2.783a1.9 1.9 0 0 1 0 2.687L8.843 9.43a.1.1 0 0 0 0 .142l5.586 5.585a.1.1 0 0 0 .142 0l1.585-1.585a1.9 1.9 0 0 1 2.687 0l3.5 3.5c.343.342.698 1.023.31 1.742-.346.645-1.173 1.615-3.154 2.936-1.75 1.167-3.667 1.269-5.297.903-1.61-.361-3.015-1.192-3.839-2.016a.9.9 0 0 1 1.273-1.272c.573.572 1.669 1.242 2.96 1.532 1.27.285 2.656.188 3.905-.645 1.483-.989 2.137-1.68 2.418-2.06l-3.348-3.347a.1.1 0 0 0-.142 0l-1.586 1.585a1.9 1.9 0 0 1-2.687 0l-5.585-5.585a1.9 1.9 0 0 1 0-2.688l1.585-1.585a.1.1 0 0 0 0-.142L6.41 3.682c-.447.383-1.183 1.102-2.206 2.38-.878 1.097-1.14 2.08-1.127 2.951.013.898.323 1.758.732 2.59.24.488.733 1.079 1.551 1.88.561.549 1.227 1.152 2.002 1.854.344.312.71.644 1.098 1a.9.9 0 0 1-1.215 1.327c-.367-.336-.722-.658-1.061-.965a77.443 77.443 0 0 1-2.082-1.93c-.831-.813-1.523-1.586-1.909-2.372-.456-.93-.896-2.07-.916-3.356-.02-1.314.399-2.7 1.521-4.103 1.148-1.435 1.995-2.254 2.544-2.71Z" clip-rule="evenodd"/></svg>',
  keywords: ["phone"],
  category: "device"
};
function I2(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var vu = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var wu;
function V2() {
  return wu || (wu = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o.call(this, l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return this && this[t] || t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(this, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, this && this[l] || l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(vu)), vu.exports;
}
var z2 = V2();
const q2 = /* @__PURE__ */ I2(z2), H2 = {
  "purpur-cta-link": "_purpur-cta-link_1e75l_1",
  "purpur-cta-link--xs": "_purpur-cta-link--xs_1e75l_33",
  "purpur-cta-link--icon-only": "_purpur-cta-link--icon-only_1e75l_36",
  "purpur-cta-link--sm": "_purpur-cta-link--sm_1e75l_39",
  "purpur-cta-link--md": "_purpur-cta-link--md_1e75l_45",
  "purpur-cta-link--lg": "_purpur-cta-link--lg_1e75l_51",
  "purpur-cta-link--full-width": "_purpur-cta-link--full-width_1e75l_57",
  "purpur-cta-link--primary": "_purpur-cta-link--primary_1e75l_60",
  "purpur-cta-link--disabled": "_purpur-cta-link--disabled_1e75l_64",
  "purpur-cta-link--primary-negative": "_purpur-cta-link--primary-negative_1e75l_70",
  "purpur-cta-link--secondary": "_purpur-cta-link--secondary_1e75l_82",
  "purpur-cta-link--secondary-negative": "_purpur-cta-link--secondary-negative_1e75l_93",
  "purpur-cta-link--expressive": "_purpur-cta-link--expressive_1e75l_104",
  "purpur-cta-link--expressive-negative": "_purpur-cta-link--expressive-negative_1e75l_114"
}, B2 = q2.bind(H2), $t = "purpur-cta-link", W2 = {
  forward: T2,
  external: L2,
  back: D2,
  phone: j2
}, yp = W(
  ({
    children: e,
    className: n,
    ["data-testid"]: r,
    fullWidth: o = !1,
    iconOnly: i = !1,
    showIcon: t = !0,
    negative: a = !1,
    size: l = "md",
    variant: u,
    icon: c = "forward",
    ...p
  }, _) => {
    const g = B2(
      [
        n,
        $t,
        `${$t}--${a ? `${u}-negative` : u}`,
        `${$t}--${l}`
      ],
      {
        [`${$t}--icon-only`]: i,
        [`${$t}--negative`]: a,
        [`${$t}--full-width`]: o
      }
    ), f = W2[c], m = /* @__PURE__ */ C(q, { children: [
      t && (c === "back" || c === "phone") && /* @__PURE__ */ d(Lo, { svg: f, size: l === "lg" ? "sm" : "xs" }),
      (!i || i && !t) && e,
      t && (c === "forward" || c === "external") && /* @__PURE__ */ d(Lo, { svg: f, size: l === "lg" ? "sm" : "xs" })
    ] }), h = {
      ...p,
      className: g,
      "data-testid": r
    };
    return "href" in p && p.href ? /* @__PURE__ */ d("a", { ...h, ref: _, children: m }) : /* @__PURE__ */ d("span", { ...h, ref: _, children: m });
  }
);
yp.displayName = "CtaLink";
const G2 = ({ cell: e }) => {
  const n = e.getValue();
  if (!n)
    return /* @__PURE__ */ d(ae, {});
  const { variant: r, children: o, ...i } = n;
  return /* @__PURE__ */ d(yp, { variant: r, ...i, children: o });
}, Z2 = z.bind(G), U2 = ({ cell: e }) => {
  var t;
  const n = e.getValue();
  if (!n)
    return /* @__PURE__ */ d(ae, {});
  (t = e.column.columnDef.meta) != null && t.showTime;
  const r = new Date(n), o = r.toLocaleDateString("sv-SE"), i = r.toLocaleTimeString("sv-SE", { hour: "2-digit", minute: "2-digit" });
  return /* @__PURE__ */ C(se, { className: Z2("purpur-table-row-cell__date"), children: [
    o,
    /* @__PURE__ */ d("span", { children: ` ${i}` })
  ] });
}, X2 = {
  name: "error",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M10.354 3.05c.732-1.267 2.56-1.267 3.291 0l8.66 15c.732 1.267-.182 2.85-1.645 2.85H3.34c-1.463 0-2.377-1.583-1.646-2.85l8.66-15Zm1.595.862a.092.092 0 0 0-.036.038l-8.66 15a.092.092 0 0 0-.015.05c0 .014.005.032.015.05a.11.11 0 0 0 .036.038.09.09 0 0 0 .05.012H20.66a.088.088 0 0 0 .05-.012.106.106 0 0 0 .037-.038.105.105 0 0 0 .015-.05.092.092 0 0 0-.015-.05l-8.66-15a.092.092 0 0 0-.036-.038A.106.106 0 0 0 12 3.9a.105.105 0 0 0-.05.012Z" clip-rule="evenodd"/><path d="m12.523 14.922.412-6.25a.936.936 0 1 0-1.868 0l.421 6.25h1.035ZM12 17.52c.44 0 .826-.387.826-.815 0-.418-.387-.816-.826-.816-.428 0-.825.398-.825.816 0 .428.397.815.825.815Z"/><path fill-rule="evenodd" d="M12.691 15.096h-1.37l-.431-6.53a1 1 0 0 1 .997-1.066h.227a1 1 0 0 1 .998 1.064l-.42 6.532Zm.244-6.425a.936.936 0 1 0-1.868.002l.421 6.249h1.035l.412-6.25ZM13 16.706c0 .526-.466.99-1 .99-.522 0-1-.463-1-.99 0-.264.125-.51.304-.689.18-.178.429-.301.696-.301.536 0 1 .475 1 .99Zm-.174 0c0 .428-.387.815-.826.815-.428 0-.825-.387-.825-.815 0-.418.397-.816.825-.816.44 0 .826.398.826.816Z" clip-rule="evenodd"/></svg>',
  keywords: ["error"],
  category: "status"
}, bp = (e) => /* @__PURE__ */ d($e, { ...e, svg: X2 });
bp.displayName = "IconError";
const Y2 = z.bind(G), K2 = ({
  cell: e
}) => {
  const n = e.getValue();
  return n ? /* @__PURE__ */ C("div", { className: Y2("purpur-table-row-cell__error-message"), children: [
    /* @__PURE__ */ d(bp, { "data-testid": "error-icon" }),
    /* @__PURE__ */ d(se, { children: n })
  ] }) : /* @__PURE__ */ d(ae, {});
}, J2 = z.bind(G), Q2 = ({ cell: e }) => {
  const n = e.getValue();
  if (!n)
    return /* @__PURE__ */ d(ae, {});
  const { icon: r, text: o } = n;
  return /* @__PURE__ */ C("div", { className: J2("purpur-table-row-cell__icon-text"), children: [
    r,
    o && o
  ] });
}, ex = ({ cell: e }) => {
  const n = e.getValue();
  return n ? /* @__PURE__ */ d(se, { variant: "paragraph-100-bold", children: n }) : /* @__PURE__ */ d(ae, {});
};
function tx(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var yu = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var bu;
function rx() {
  return bu || (bu = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o.call(this, l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return this && this[t] || t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(this, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, this && this[l] || l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(yu)), yu.exports;
}
var nx = rx();
const ox = /* @__PURE__ */ tx(nx), ix = {
  "purpur-link": "_purpur-link_1066f_1",
  "purpur-link--text": "_purpur-link--text_1066f_18",
  "purpur-link--standalone": "_purpur-link--standalone_1066f_18",
  "purpur-link--navigation": "_purpur-link--navigation_1066f_18",
  "purpur-link--disable-visited": "_purpur-link--disable-visited_1066f_29",
  "purpur-link--text-negative": "_purpur-link--text-negative_1066f_32",
  "purpur-link--standalone-negative": "_purpur-link--standalone-negative_1066f_32",
  "purpur-link--navigation-negative": "_purpur-link--navigation-negative_1066f_32",
  "purpur-link--ensure-target-area": "_purpur-link--ensure-target-area_1066f_71",
  "purpur-link--silent": "_purpur-link--silent_1066f_77"
}, ax = ox.bind(ix), xt = "purpur-link", $p = ({
  ["data-testid"]: e,
  children: n,
  className: r,
  disableVisited: o = !0,
  ensureTargetArea: i,
  href: t,
  negative: a = !1,
  onClick: l,
  rel: u,
  silent: c,
  target: p,
  variant: _,
  ...g
}) => (
  /* eslint-disable-next-line jsx-a11y/click-events-have-key-events */
  /* @__PURE__ */ d(
    "span",
    {
      className: ax([
        r,
        xt,
        `${xt}--${a ? `${_}-negative` : _}`,
        {
          [`${xt}--silent`]: c,
          [`${xt}--negative`]: a,
          [`${xt}--disable-visited`]: o ?? c,
          [`${xt}--ensure-target-area`]: i
        }
      ]),
      "data-testid": e,
      onClick: t ? void 0 : l,
      ...g,
      children: t ? /* @__PURE__ */ d(
        "a",
        {
          href: t,
          target: p,
          rel: u,
          onClick: l,
          "data-testid": e ? `${e} a` : void 0,
          ...g,
          children: n
        }
      ) : n
    }
  )
);
$p.displayName = "Link";
const eo = z.bind(G), lx = ({ cell: e }) => {
  const n = e.getValue(), { showPopover: r, containerRef: o, onMouseEnter: i, onMouseLeave: t } = wp();
  if (!n)
    return /* @__PURE__ */ d(ae, {});
  const { children: a, href: l, variant: u, ...c } = n, p = on(e.column.getSize()), _ = /* @__PURE__ */ d(
    "div",
    {
      ref: o,
      className: eo("purpur-table-row-cell__truncate-wrapper"),
      style: {
        minWidth: p
      },
      onMouseEnter: i,
      onMouseLeave: t,
      children: /* @__PURE__ */ d(
        $p,
        {
          className: eo("purpur-table-row-cell__truncate"),
          variant: u ?? "text",
          href: l,
          onClick: (g) => {
            g.stopPropagation();
          },
          ...c,
          children: a
        }
      )
    }
  );
  return /* @__PURE__ */ d(
    gi,
    {
      position: "top",
      align: "center",
      triggerElement: _,
      open: r,
      contentClassName: eo("purpur-table-row-cell__tooltip-content"),
      children: a
    }
  );
}, ux = z.bind(G), sx = ({ cell: e }) => {
  var o;
  const n = e.getValue(), r = ((o = e.column.columnDef.meta) == null ? void 0 : o.numberCellAlignment) === "right";
  return n ? /* @__PURE__ */ d(se, { className: ux({ "purpur-table-row-cell__right-align": r }), children: n }) : /* @__PURE__ */ d(ae, {});
}, cx = z.bind(G), px = ({ cell: e }) => {
  var n, r;
  return /* @__PURE__ */ d(
    Wo,
    {
      id: e.id,
      className: cx("purpur-table-row-cell__row-selection"),
      onChange: e.row.getToggleSelectedHandler(),
      checked: e.row.getIsSelected(),
      disabled: !e.row.getCanSelect(),
      "aria-label": (r = (n = e.column.columnDef.meta) == null ? void 0 : n.rowSelectionAriaLabels) == null ? void 0 : r.row
    }
  );
}, dx = z.bind(G), fx = ({ cell: e }) => {
  var n, r;
  return /* @__PURE__ */ d(
    "input",
    {
      id: e.id,
      className: dx("purpur-table-row-cell__row-toggle"),
      type: "radio",
      onChange: e.row.getToggleSelectedHandler(),
      checked: e.row.getIsSelected(),
      "aria-checked": e.row.getIsSelected(),
      disabled: !e.row.getCanSelect(),
      "aria-label": (r = (n = e.column.columnDef.meta) == null ? void 0 : n.rowSelectionAriaLabels) == null ? void 0 : r.row
    }
  );
}, gx = ({ cell: e }) => {
  const n = e.getValue();
  return n ? /* @__PURE__ */ d(nn, { ...n }) : /* @__PURE__ */ d(ae, {});
}, _x = {
  name: "alert",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="m13.038 7.067-.247 6.876h-1.566l-.247-6.876a1.03 1.03 0 1 1 2.06 0Zm.212 8.917c0 .649-.586 1.234-1.25 1.234-.649 0-1.25-.585-1.25-1.234 0-.633.601-1.234 1.25-1.234.664 0 1.25.601 1.25 1.234Z"/><path fill-rule="evenodd" d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-1.75 0a8.25 8.25 0 1 1-16.5 0 8.25 8.25 0 0 1 16.5 0Z" clip-rule="evenodd"/></svg>',
  keywords: ["alert"],
  category: "status"
}, xp = (e) => /* @__PURE__ */ d($e, { ...e, svg: _x });
xp.displayName = "IconAlert";
const hx = z.bind(G), mx = ({
  cell: e
}) => {
  const n = e.getValue();
  return n ? /* @__PURE__ */ C("div", { className: hx("purpur-table-row-cell__warning-message"), children: [
    /* @__PURE__ */ d(xp, { "data-testid": "alert-icon" }),
    /* @__PURE__ */ d(se, { children: n })
  ] }) : /* @__PURE__ */ d(ae, {});
}, vx = z.bind(G), tt = "purpur-table-row-cell", Sp = ({
  className: e,
  ["data-testid"]: n,
  cell: r,
  stickyColumn: o,
  children: i,
  colSpan: t = 1,
  isScrolled: a,
  showBorder: l,
  isLastRow: u,
  isFirstCell: c,
  isLastCell: p
}) => {
  var v;
  const [_, g] = j(!1), f = ue(null);
  le(() => {
    const w = f.current;
    if (!w)
      return;
    const y = new IntersectionObserver(
      ([b]) => {
        g(b.isIntersecting);
      },
      { threshold: 1 }
    );
    return y.observe(w), () => {
      w && y.unobserve(w);
    };
  }, []);
  const m = vx([
    e,
    tt,
    {
      [`${tt}__sticky-column`]: o,
      [`${tt}__sticky-column__with-sticky-border`]: a && l,
      [`${tt}__border-radius-first-cell`]: c && u,
      [`${tt}__border-radius-last-cell`]: p && u,
      [`${tt}__last-row-first-cell-visible`]: ((r == null ? void 0 : r.column.getIsFirstColumn()) || c) && _ && u,
      [`${tt}__last-row-last-cell-visible`]: ((r == null ? void 0 : r.column.getIsLastColumn()) || p) && _ && u
    }
  ]), h = r ? wx(r) : i;
  return /* @__PURE__ */ d(
    "td",
    {
      ref: f,
      "data-testid": n,
      className: m,
      colSpan: t,
      children: h
    },
    (v = r == null ? void 0 : r.column.columnDef) == null ? void 0 : v.id
  );
}, wx = (e) => {
  const { cellType: n } = e.column.columnDef.meta ?? {};
  return (() => {
    switch (n) {
      case "badge":
        return /* @__PURE__ */ d(ky, { cell: e });
      case "bodyText":
        return /* @__PURE__ */ d(b2, { cell: e });
      case "button":
        return /* @__PURE__ */ d($2, { cell: e });
      case "buttonGroup":
        return /* @__PURE__ */ d(S2, { cell: e });
      case "ctaLink":
        return /* @__PURE__ */ d(G2, { cell: e });
      case "date":
        return /* @__PURE__ */ d(U2, { cell: e });
      case "errorAlertMessage":
        return /* @__PURE__ */ d(K2, { cell: e });
      case "iconText":
        return /* @__PURE__ */ d(Q2, { cell: e });
      case "leadText":
        return /* @__PURE__ */ d(ex, { cell: e });
      case "link":
        return /* @__PURE__ */ d(lx, { cell: e });
      case "number":
        return /* @__PURE__ */ d(sx, { cell: e });
      case "rowSelection":
        return /* @__PURE__ */ d(px, { cell: e });
      case "rowToggle":
        return /* @__PURE__ */ d(fx, { cell: e });
      case "toggle":
        return /* @__PURE__ */ d(gx, { cell: e });
      case "warningAlertMessage":
        return /* @__PURE__ */ d(mx, { cell: e });
      default:
        return Tu(e.column.columnDef.cell, e.getContext());
    }
  })();
};
function yx(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var $u = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var xu;
function bx() {
  return xu || (xu = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var t = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (t = i(t, o(l)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return r.apply(null, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var a = "";
        for (var l in t)
          n.call(t, l) && t[l] && (a = i(a, l));
        return a;
      }
      function i(t, a) {
        return a ? t ? t + " " + a : t + a : t;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }($u)), $u.exports;
}
var $x = bx();
const xx = /* @__PURE__ */ yx($x), Sx = "_loading_93tal_1", to = {
  "purpur-skeleton": "_purpur-skeleton_93tal_1",
  loading: Sx,
  "purpur-skeleton--default": "_purpur-skeleton--default_93tal_24",
  "purpur-skeleton--negative": "_purpur-skeleton--negative_93tal_30",
  "purpur-skeleton--xs": "_purpur-skeleton--xs_93tal_36",
  "purpur-skeleton--sm": "_purpur-skeleton--sm_93tal_39",
  "purpur-skeleton--md": "_purpur-skeleton--md_93tal_42",
  "purpur-skeleton--lg": "_purpur-skeleton--lg_93tal_45",
  "purpur-skeleton--full": "_purpur-skeleton--full_93tal_48"
}, ro = "purpur-skeleton", Cp = ({
  className: e,
  ["data-testid"]: n,
  radius: r = "xs",
  style: o,
  negative: i = !1,
  ...t
}) => {
  const a = xx([
    e,
    to[ro],
    to[`${ro}--${i ? "negative" : "default"}`],
    to[`${ro}--${r}`]
  ]);
  return /* @__PURE__ */ d("div", { className: a, style: o, "data-testid": n, ...t });
};
Cp.displayName = "Skeleton";
const Su = z.bind(G), je = "purpur-table-row-cell", Cx = ({
  isLastRow: e,
  isFirstCell: n,
  isLastCell: r,
  stickyColumn: o,
  isScrolled: i,
  showBorder: t,
  cellWidth: a
}) => {
  const l = Su([
    je,
    {
      [`${je}__sticky-column`]: o,
      [`${je}__sticky-column__with-sticky-border`]: i && t,
      [`${je}__border-radius-first-cell`]: n && e,
      [`${je}__border-radius-last-cell`]: r && e,
      [`${je}__last-row-first-cell-visible`]: n && e,
      [`${je}__last-row-last-cell-visible`]: r && e
    }
  ]), u = typeof a == "string" ? a : on(a);
  return /* @__PURE__ */ d(
    "td",
    {
      className: l,
      style: {
        minWidth: u,
        maxWidth: u
      },
      children: /* @__PURE__ */ d(
        Cp,
        {
          "data-testid": "purpur-table-cell-skeleton",
          className: Su(`${je}__skeleton`)
        }
      )
    }
  );
}, Rx = {
  name: "sync",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M12.015 4.786a7.218 7.218 0 0 0-7.219 7.219.9.9 0 1 1-1.8 0 9.018 9.018 0 0 1 15.189-6.577v-1.48a.9.9 0 1 1 1.8 0V8.92h-4.973a.9.9 0 0 1 0-1.8h2.318a7.199 7.199 0 0 0-5.315-2.334Zm8.118 6.319a.9.9 0 0 1 .9.9A9.018 9.018 0 0 1 5.83 18.568v1.469a.9.9 0 1 1-1.8 0v-4.973h4.973a.9.9 0 1 1 0 1.8H6.677a7.218 7.218 0 0 0 12.556-4.86.9.9 0 0 1 .9-.9Z" clip-rule="evenodd"/></svg>',
  keywords: ["sync"],
  category: "action"
}, Rp = (e) => /* @__PURE__ */ d($e, { ...e, svg: Rx });
Rp.displayName = "IconSync";
const Ex = {
  "purpur-table-settings-drawer": "_purpur-table-settings-drawer_spgbp_1",
  "purpur-table-settings-drawer__general-settings": "_purpur-table-settings-drawer__general-settings_spgbp_8",
  "purpur-table-settings-drawer__visible-columns": "_purpur-table-settings-drawer__visible-columns_spgbp_8",
  "purpur-table-settings-drawer__button-group": "_purpur-table-settings-drawer__button-group_spgbp_15",
  "purpur-table-settings-drawer__toggle": "_purpur-table-settings-drawer__toggle_spgbp_18"
}, wr = "purpur-table-settings-drawer", yr = z.bind(Ex), Mt = "purpur-table-settings-drawer", Nx = ({
  id: e,
  columnFiltersEnabled: n,
  copy: r,
  isDrawerOpen: o,
  showColumnFilters: i,
  stickyFirstColumn: t,
  stickyHeaders: a,
  getAllColumns: l,
  onResetSettings: u,
  setDrawerIsOpen: c,
  setShowColumnFiltersEnabled: p,
  setStickyFirstColumn: _,
  setStickyHeaders: g,
  enableRowSelection: f,
  rowSelectionEnabled: m,
  setRowSelectionEnabled: h
}) => /* @__PURE__ */ d("div", { id: e, children: /* @__PURE__ */ d(nt, { "data-testid": Mt, open: o, onOpenChange: c, children: /* @__PURE__ */ d(
  nt.Content,
  {
    "data-testid": `${Mt}-content`,
    zIndex: 6,
    closeButtonAriaLabel: r.buttons.closeDrawer,
    title: r.title,
    footerContent: /* @__PURE__ */ d(Px, { text: r.buttons.resetSettings, onClick: u }),
    stickyFooter: !0,
    "aria-describedby": void 0,
    children: /* @__PURE__ */ C("div", { className: yr(wr), children: [
      /* @__PURE__ */ d(
        kx,
        {
          setShowColumnFiltersEnabled: p,
          setStickyFirstColumn: _,
          setStickyHeaders: g,
          columnFiltersEnabled: n,
          showColumnFilters: i,
          stickyFirstColumn: t,
          stickyHeaders: a,
          copy: r.generalSettings,
          enableRowSelection: f,
          rowSelectionEnabled: m,
          setRowSelectionEnabled: h
        }
      ),
      /* @__PURE__ */ d(Ox, { getAllColumns: l, header: r.visibleColumns.header })
    ] })
  }
) }) }), Px = ({ text: e, onClick: n }) => /* @__PURE__ */ d("div", { className: yr(`${wr}__button-group`), children: /* @__PURE__ */ C(re, { "data-testid": `${Mt}-reset-button`, variant: "tertiary-purple", onClick: n, children: [
  /* @__PURE__ */ d(Rp, { size: "sm" }),
  e
] }) }), kx = ({
  setShowColumnFiltersEnabled: e,
  setStickyFirstColumn: n,
  setStickyHeaders: r,
  columnFiltersEnabled: o,
  showColumnFilters: i,
  stickyFirstColumn: t,
  stickyHeaders: a,
  copy: l,
  enableRowSelection: u,
  rowSelectionEnabled: c,
  setRowSelectionEnabled: p
}) => {
  const _ = Ft();
  return /* @__PURE__ */ C(
    "div",
    {
      "data-testid": `${Mt}-general-settings`,
      className: yr(`${wr}__general-settings`),
      "aria-labelledby": `${_}-general-settings`,
      children: [
        /* @__PURE__ */ d(rn, { id: `${_}-general-settings`, variant: "title-100", tag: "h3", children: l.header }),
        o && /* @__PURE__ */ d(
          dr,
          {
            id: `${_}-show-filters`,
            checked: i,
            label: l.toggles.showFilters,
            onChange: e
          }
        ),
        /* @__PURE__ */ d(
          dr,
          {
            id: `${_}-lock-first-column`,
            checked: t,
            label: l.toggles.lockFirstcolumn,
            onChange: n
          }
        ),
        /* @__PURE__ */ d(
          dr,
          {
            id: `${_}-sticky-header`,
            checked: a,
            label: l.toggles.stickyHeader,
            onChange: r
          }
        ),
        u && l.toggles.rowSelection && p && /* @__PURE__ */ d(
          dr,
          {
            id: `${_}-row-selection`,
            checked: c || !1,
            label: l.toggles.rowSelection,
            onChange: p
          }
        )
      ]
    }
  );
}, Ox = ({
  header: e,
  getAllColumns: n
}) => {
  const o = n().filter(
    (l) => l.id !== "row-selection" && l.id !== "row-toggle"
  ), i = o.filter((l) => l.getIsVisible()), t = (l) => !l.getCanHide() || i.length === 1 && i.includes(l), a = Ft();
  return /* @__PURE__ */ C(
    "section",
    {
      "data-testid": `${Mt}-visible-columns`,
      className: yr(`${wr}__visible-columns`),
      "aria-labelledby": `${a}-visible-columns`,
      children: [
        /* @__PURE__ */ d(rn, { id: `${a}-visible-columns`, variant: "title-100", tag: "h3", children: e }),
        o.map((l) => /* @__PURE__ */ d(
          dr,
          {
            id: l.id,
            checked: l.getIsVisible(),
            disabled: t(l),
            label: l.columnDef.header,
            onChange: () => l.toggleVisibility()
          },
          l.id
        ))
      ]
    }
  );
}, dr = ({
  id: e,
  checked: n,
  label: r,
  disabled: o,
  onChange: i
}) => /* @__PURE__ */ d(
  nn,
  {
    id: e,
    checked: n,
    label: r,
    disabled: o,
    labelPosition: "left",
    className: yr(`${wr}__toggle`),
    onChange: i,
    "data-testid": `${Mt}-toggle`
  }
), Ax = {
  name: "download",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M22.4 21.5a.9.9 0 0 1-.9.9h-19a.9.9 0 0 1-.9-.9V11a.9.9 0 0 1 1.8 0v9.6h17.2V11a.9.9 0 0 1 1.8 0v10.5Zm-9.764-4.864a.9.9 0 0 1-1.272 0l-5-5a.9.9 0 0 1 1.272-1.272l3.464 3.463V2.5a.9.9 0 0 1 1.8 0v11.327l3.464-3.463a.9.9 0 0 1 1.272 1.272l-5 5Z" clip-rule="evenodd"/></svg>',
  keywords: ["download"],
  category: "action"
}, Ep = (e) => /* @__PURE__ */ d($e, { ...e, svg: Ax });
Ep.displayName = "IconDownload";
const Mx = {
  name: "maximize",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M13.635 3.828c0-.483.392-.875.875-.875h5.782a.75.75 0 0 1 .75.75v5.782a.875.875 0 0 1-1.75 0V5.941l-4.673 4.673a.875.875 0 1 1-1.238-1.237l4.674-4.674H14.51a.875.875 0 0 1-.875-.875ZM10.36 20.169a.875.875 0 0 1-.875.875H3.703a.75.75 0 0 1-.75-.75v-5.782a.875.875 0 1 1 1.75 0v3.544l4.674-4.673a.875.875 0 1 1 1.237 1.237l-4.673 4.674h3.544c.484 0 .875.392.875.875Z" clip-rule="evenodd"/></svg>',
  keywords: ["maximize"],
  category: "action"
}, Np = (e) => /* @__PURE__ */ d($e, { ...e, svg: Mx });
Np.displayName = "IconMaximize";
const Fx = {
  name: "settings",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M8.846 3.245c0-1.05.85-1.9 1.9-1.9h2.509a1.9 1.9 0 0 1 1.9 1.9v1.011c.712.29 1.374.676 1.972 1.14l.877-.506a1.9 1.9 0 0 1 2.595.696l1.255 2.172a1.9 1.9 0 0 1-.696 2.596l-.877.506a8.43 8.43 0 0 1 0 2.278l.877.506a1.9 1.9 0 0 1 .695 2.596L20.6 18.412a1.9 1.9 0 0 1-2.596.696l-.877-.507c-.597.465-1.26.85-1.971 1.14v1.012a1.9 1.9 0 0 1-1.9 1.9h-2.51a1.9 1.9 0 0 1-1.9-1.9v-1.01A8.352 8.352 0 0 1 6.874 18.6l-.877.507a1.9 1.9 0 0 1-2.595-.696L2.146 16.24a1.9 1.9 0 0 1 .696-2.596l.876-.506a8.425 8.425 0 0 1 0-2.278l-.877-.506a1.9 1.9 0 0 1-.695-2.596L3.4 5.586a1.9 1.9 0 0 1 2.596-.696l.877.507a8.351 8.351 0 0 1 1.973-1.141V3.245Zm1.9-.1a.1.1 0 0 0-.1.1v2.3l-.629.2a6.551 6.551 0 0 0-2.44 1.41L7.09 7.6 5.096 6.45a.1.1 0 0 0-.137.037L3.705 8.658a.1.1 0 0 0 .036.137l1.992 1.15-.14.643a6.586 6.586 0 0 0 0 2.822l.14.643-1.991 1.15a.1.1 0 0 0-.037.136l1.254 2.173a.1.1 0 0 0 .137.037l1.994-1.151.487.444a6.552 6.552 0 0 0 2.44 1.411l.629.2v2.3a.1.1 0 0 0 .1.1h2.509a.1.1 0 0 0 .1-.1v-2.301l.628-.2a6.551 6.551 0 0 0 2.44-1.41l.486-.445 1.995 1.152a.1.1 0 0 0 .136-.037l1.255-2.172a.1.1 0 0 0-.037-.137l-1.992-1.15.14-.643a6.585 6.585 0 0 0 0-2.822l-.14-.643 1.992-1.15a.1.1 0 0 0 .037-.137l-1.254-2.172a.1.1 0 0 0-.137-.037l-1.995 1.152-.486-.445a6.551 6.551 0 0 0-2.44-1.411l-.628-.2v-2.3a.1.1 0 0 0-.1-.1h-2.51ZM12 9.9a2.1 2.1 0 1 0 0 4.2 2.1 2.1 0 0 0 0-4.2ZM8.1 12a3.9 3.9 0 1 1 7.8 0 3.9 3.9 0 0 1-7.8 0Z" clip-rule="evenodd"/></svg>',
  keywords: ["settings"],
  category: "action"
}, Pp = (e) => /* @__PURE__ */ d($e, { ...e, svg: Fx });
Pp.displayName = "IconSettings";
const Dx = {
  "purpur-table-toolbar": "_purpur-table-toolbar_8vziu_1",
  "purpur-table-toolbar__content": "_purpur-table-toolbar__content_8vziu_12"
}, no = "purpur-table-toolbar", oo = z.bind(Dx), St = "purpur-table-toolbar", Tx = ({
  ["aria-controls"]: e,
  settingsDrawerAriaControls: n,
  exportDrawerAriaControls: r,
  onExportData: o,
  onResetColumnFilters: i,
  onSetDrawerIsOpen: t,
  onToggleExpand: a,
  disableClearFilters: l,
  hasExportsDrawer: u,
  isExportDrawerOpen: c,
  isSettingsDrawerOpen: p,
  showFilters: _,
  toolbarCopy: g,
  totalRowCount: f,
  visibleRowCount: m
}) => {
  var h, v, w, y, b, $, x, R;
  return /* @__PURE__ */ C("div", { "data-testid": St, className: oo(no), children: [
    /* @__PURE__ */ C("div", { className: oo(`${no}__content`), children: [
      (g == null ? void 0 : g.rowCount) && /* @__PURE__ */ d(se, { "data-testid": `${St}-table-rows-count`, children: `${g.rowCount.showing} ${m} ${g.rowCount.of} ${f} ${g.rowCount.rows}` }),
      ((h = g == null ? void 0 : g.buttons) == null ? void 0 : h.clearFilters) && _ && /* @__PURE__ */ d(
        re,
        {
          "data-testid": `${St}-clear-filters-button`,
          variant: "text",
          onClick: i,
          type: "button",
          "aria-label": (v = g == null ? void 0 : g.ariaLabels) == null ? void 0 : v.clearFilters,
          "aria-controls": e,
          disabled: l,
          children: g.buttons.clearFilters
        }
      )
    ] }),
    /* @__PURE__ */ C("div", { className: oo(`${no}__content`), children: [
      ((w = g == null ? void 0 : g.buttons) == null ? void 0 : w.export) && /* @__PURE__ */ C(
        re,
        {
          "data-testid": `${St}-export-button`,
          variant: "text",
          type: "button",
          onClick: o,
          "aria-label": (y = g == null ? void 0 : g.ariaLabels) == null ? void 0 : y.export,
          ...u && {
            "aria-expanded": c,
            "aria-controls": r,
            "aria-haspopup": "dialog"
          },
          children: [
            /* @__PURE__ */ d(Ep, { size: "xs" }),
            g.buttons.export
          ]
        }
      ),
      ((b = g == null ? void 0 : g.buttons) == null ? void 0 : b.settings) && /* @__PURE__ */ C(
        re,
        {
          "data-testid": `${St}-settings-button`,
          variant: "text",
          onClick: () => t(!0),
          type: "button",
          "aria-label": ($ = g == null ? void 0 : g.ariaLabels) == null ? void 0 : $.settings,
          "aria-expanded": p,
          "aria-controls": n,
          "aria-haspopup": "dialog",
          children: [
            /* @__PURE__ */ d(Pp, { size: "xs" }),
            g.buttons.settings
          ]
        }
      ),
      a && ((x = g == null ? void 0 : g.buttons) == null ? void 0 : x.expand) && /* @__PURE__ */ C(
        re,
        {
          "data-testid": `${St}-expand-button`,
          variant: "text",
          onClick: () => a(),
          type: "button",
          "aria-label": (R = g == null ? void 0 : g.ariaLabels) == null ? void 0 : R.expand,
          "aria-controls": e,
          children: [
            /* @__PURE__ */ d(Np, { size: "xs" }),
            g.buttons.expand
          ]
        }
      )
    ] })
  ] });
}, Lx = (e, n, r) => {
  const { filterKey: o, value: i } = r, t = e.getValue(n);
  return i === "" || t[o] === i;
}, jx = (e, n, r) => {
  const o = n.getValue(r);
  return e.getValue(r).variant.localeCompare(o.variant);
}, Ix = (e, n, r) => {
  const o = n.getValue(r), i = e.getValue(r), t = o.children;
  return i.children.localeCompare(t);
}, Pt = z.bind(G), ve = "purpur-table", Vx = ({
  actionbarCopy: e,
  actionBarTotalRowCount: n,
  className: r,
  columns: o,
  data: i,
  emptyTableCopy: t,
  emptyTableHeadingTag: a,
  emptyTableIcon: l,
  enableActionBar: u,
  enableToolbar: c,
  exportDrawerCopy: p,
  exportFormats: _,
  fullWidth: g = !0,
  loading: f,
  paginationComponent: m,
  rowSelectionAriaLabels: h,
  settingsDrawerCopy: v,
  showOnlySelectedRows: w,
  skeletonRows: y,
  sortingAriaLabels: b,
  state: $,
  toolbarCopy: x,
  toolbarTotalRowCount: R,
  variant: S = "primary",
  getRowId: O,
  onExportData: E,
  onRowsCountChange: k,
  onToggleExpand: D,
  onPrimaryButtonClick: A,
  onSecondaryButtonClick: ee,
  setShowOnlySelectedRows: T,
  ...M
}) => {
  const [Z, F] = j(0), [H, I] = j(!1), [ut, jt] = j(!1), [br, Ue] = j(!1), [pe, It] = j(
    !!M.enableFilters
  ), [st, ct] = j(!0), [$r, xr] = j(!0), pt = ue(w), [Xe, gn] = j(!1), me = ue(null), De = Ft(), [Vt, _n] = j(!0), hn = Pt([
    r,
    ve,
    {
      [`${ve}--${S}`]: S
    }
  ]);
  M.enableRowSelection && Vt && (o = M.enableMultiRowSelection ? [
    {
      id: "row-selection",
      header: "Row selection",
      size: 25,
      meta: {
        cellType: "rowSelection",
        rowSelectionAriaLabels: h
      }
    },
    ...o
  ] : [
    {
      id: "row-toggle",
      header: "Row toggle",
      size: 25,
      meta: {
        cellType: "rowToggle",
        rowSelectionAriaLabels: h
      }
    },
    ...o
  ]);
  const { filterFns: mn, sortingFns: dt, ...kp } = M, B = jd({
    columns: o,
    data: i,
    state: $,
    enableColumnFilters: pe,
    getRowId: O,
    filterFns: {
      ...mn,
      filterOnFilterKey: Lx
    },
    sortingFns: {
      ...dt,
      sortOnBadgeVariant: jx,
      sortOnBadgeValue: Ix
    },
    getCoreRowModel: Ed(),
    getSortedRowModel: M.enableSorting && !M.manualSorting ? Fd() : void 0,
    getFilteredRowModel: M.enableFilters && !M.manualFiltering ? Ad() : void 0,
    getPaginationRowModel: m && !M.manualPagination ? Md() : void 0,
    ...kp
  });
  le(() => {
    const L = () => {
      if (me.current) {
        const Ye = me.current.scrollLeft;
        gn(Ye > 0);
      }
    }, Se = me.current;
    return Se && Se.addEventListener("scroll", L), () => {
      Se && Se.removeEventListener("scroll", L);
    };
  }, []), le(() => {
    w ? (pt.current || B.setPageIndex(0), pt.current = w) : (pt.current && B.setPageIndex(0), pt.current = w);
  }, [w, B]), le(() => {
    k && k(B.getRowCount());
  }, [$, k, B]), le(() => {
    if ($ != null && $.rowSelection) {
      const L = Object.keys($.rowSelection).length;
      F(L), I(L > 0);
    }
  }, [$ == null ? void 0 : $.rowSelection]);
  const Op = () => {
    B.resetRowSelection(), T == null || T(!1);
  }, Ap = () => {
    T && T((L) => !L);
  }, Sr = (L) => M.enableRowSelection && Vt ? L <= 1 : L === 0, Mp = () => {
    B.resetColumnFilters();
  }, Fp = () => {
    typeof _ == "string" ? _i(_) : Ue((L) => !L);
  }, _i = (L) => {
    E == null || E(L);
  }, Dp = () => {
    It(!0), ct(!0), xr(!0), B.resetColumnVisibility();
  }, vn = (L) => Xe && Sr(L), wn = B.getRowModel().rows, yn = wn.length === 0 && !!t, Tp = f && y ? /* @__PURE__ */ d(
    qx,
    {
      rowCount: y,
      getStickyColumn: Sr,
      stickyFirstColumn: st,
      isScrolled: Xe,
      cellWidths: B.getAllColumns().map((L) => L.getSize() || "100%"),
      showBorder: vn
    }
  ) : yn && t && a ? /* @__PURE__ */ d(
    zx,
    {
      variant: S,
      tag: a,
      title: t.title,
      description: t.description,
      colSpan: B.getVisibleLeafColumns().length,
      icon: l
    }
  ) : wn.map((L, Se) => /* @__PURE__ */ d(Yr, { isSelected: L.getIsSelected(), children: L.getVisibleCells().map((Ye, Cr) => /* @__PURE__ */ d(
    Sp,
    {
      cell: Ye,
      isLastRow: Se === wn.length - 1,
      isFirstCell: Cr === 0,
      isLastCell: Cr === L.getVisibleCells().length - 1,
      stickyColumn: st && Sr(Cr),
      isScrolled: Xe,
      showBorder: vn(Cr)
    },
    Ye.id
  )) }, L.id));
  return /* @__PURE__ */ C("div", { id: `${De}-table`, className: hn, children: [
    c && /* @__PURE__ */ d(
      Tx,
      {
        "aria-controls": `${De}-table`,
        settingsDrawerAriaControls: `${De}-settings-drawer`,
        exportDrawerAriaControls: `${De}-export-drawer`,
        onSetDrawerIsOpen: jt,
        onResetColumnFilters: Mp,
        onToggleExpand: D,
        onExportData: Fp,
        totalRowCount: R ?? B.getRowCount(),
        visibleRowCount: B.getRowModel().rows.length,
        toolbarCopy: x,
        isSettingsDrawerOpen: ut,
        hasExportsDrawer: Array.isArray(_),
        isExportDrawerOpen: br,
        showFilters: pe,
        disableClearFilters: B.getState().columnFilters.length === 0
      }
    ),
    /* @__PURE__ */ d(
      "div",
      {
        className: Pt(`${ve}__container`, {
          [`${ve}__container--scrolled`]: Xe
        }),
        ref: me,
        children: /* @__PURE__ */ C(
          "table",
          {
            className: Pt([
              `${ve}__table`,
              { [`${ve}__table--full-width`]: g }
            ]),
            children: [
              /* @__PURE__ */ d(iy, { columnFiltersEnabled: pe, children: B.getHeaderGroups().map((L) => /* @__PURE__ */ d(Yr, { children: L.headers.map((Se, Ye) => /* @__PURE__ */ d(
                Hv,
                {
                  header: Se,
                  tanstackTable: B,
                  stickyColumn: !yn && st && Sr(Ye),
                  stickyHeaders: !yn && $r,
                  isScrolled: Xe,
                  showBorder: vn(Ye),
                  ...M.enableSorting && b ? { enableSorting: M.enableSorting, sortingAriaLabels: b } : { enableSorting: !1 }
                },
                Se.id
              )) }, L.id)) }),
              /* @__PURE__ */ d(xg, { children: Tp })
            ]
          }
        )
      }
    ),
    m,
    u && n && e && A && /* @__PURE__ */ d(
      yg,
      {
        rowCount: n,
        selectedRowsCount: Z,
        copy: e,
        isVisible: H,
        onCancelSelection: Op,
        onToggleSelected: Ap,
        onPrimaryButtonClick: A,
        onSecondaryButtonClick: ee
      }
    ),
    c && v && /* @__PURE__ */ d(
      Nx,
      {
        id: `${De}-settings-drawer`,
        setDrawerIsOpen: jt,
        setShowColumnFiltersEnabled: It,
        setStickyFirstColumn: ct,
        setStickyHeaders: xr,
        getAllColumns: B.getAllColumns,
        isDrawerOpen: ut,
        showColumnFilters: pe,
        stickyFirstColumn: st,
        stickyHeaders: $r,
        copy: v,
        onResetSettings: Dp,
        columnFiltersEnabled: !!M.enableFilters,
        enableRowSelection: !!M.enableRowSelection,
        rowSelectionEnabled: Vt,
        setRowSelectionEnabled: _n
      }
    ),
    Array.isArray(_) && p && /* @__PURE__ */ d(
      ny,
      {
        id: `${De}-export-drawer`,
        isOpen: br,
        setDrawerIsOpen: Ue,
        exportFormats: _,
        copy: p,
        onExportData: _i
      }
    )
  ] });
};
Vx.displayName = "Table";
const zx = ({ variant: e, tag: n, title: r, description: o, colSpan: i, icon: t }) => /* @__PURE__ */ d(Yr, { children: /* @__PURE__ */ d(Sp, { colSpan: i, isLastRow: !0, isFirstCell: !0, isLastCell: !0, children: /* @__PURE__ */ C(
  "div",
  {
    className: Pt([
      `${ve}__empty-section`,
      `${ve}__empty-section--${e}`
    ]),
    children: [
      t && /* @__PURE__ */ d("div", { className: Pt(`${ve}__empty-section__icon`), children: t }),
      /* @__PURE__ */ C("div", { className: Pt(`${ve}__empty-section__texts`), children: [
        /* @__PURE__ */ d(rn, { "data-testid": "purpur-table-empty-table-title", variant: "title-100", tag: n, children: r }),
        /* @__PURE__ */ d(se, { "data-testid": "purpur-table-empty-table-description", children: o })
      ] })
    ]
  }
) }) }), qx = ({
  rowCount: e,
  getStickyColumn: n,
  stickyFirstColumn: r,
  isScrolled: o,
  cellWidths: i,
  showBorder: t
}) => /* @__PURE__ */ d(q, { children: Array.from({ length: e }, (a, l) => l).map((a, l) => /* @__PURE__ */ d(Yr, { children: i.map((u, c) => /* @__PURE__ */ d(
  Cx,
  {
    isLastRow: l === e - 1,
    isFirstCell: c === 0,
    isLastCell: c === i.length - 1,
    stickyColumn: r && n(c),
    isScrolled: o,
    showBorder: t(c),
    cellWidth: u
  },
  `skeleton-cell-${c}`
)) }, `skeleton-row-${a}`)) });
export {
  Vx as Table,
  Zx as createColumnHelper
};
//# sourceMappingURL=table.es.js.map
